/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * Flo Recruit Web API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from 'react-query';

import { customInstance } from './custom-axios';
export interface AddEmployerRequest {
  contacts?: EmployerContactDTO[];
  description?: string;
  employerName?: string;
  industry?: string;
  newEmployer?: boolean;
  universityEmployerId?: number;
}

export interface AdminAnalyticsFilters {
  endDate?: string;
  eventIds?: number[];
  orgTagIds?: number[];
  qualifyingQuestionAnswerFilters?: QualifyingQuestionAnswerFilter[];
  startDate?: string;
}

export type AdminAnalyticsPageDtoEthnicityPercentages = {[key: string]: number};

export type AdminAnalyticsPageDtoGenderIdentityPercentages = {[key: string]: number};

export interface AdminAnalyticsPageDto {
  ethnicityPercentages?: AdminAnalyticsPageDtoEthnicityPercentages;
  genderIdentityPercentages?: AdminAnalyticsPageDtoGenderIdentityPercentages;
  numOfCandidatesRepresentedEthnicity?: number;
  numOfCandidatesRepresentedGender?: number;
  numOfEvents?: number;
  numOfFeedbacks?: number;
  numOfRegisteredCandidates?: number;
  orgFeedbackDataAnalyticsDtoList?: OrgFeedbackDataAnalyticsDto[];
  percentageCandidatesWithFeedback?: number;
  percentageMembersLeavingFeedback?: number;
  qualifyingQuestionDataAnalyticsDtoList?: QualifyingQuestionDataAnalyticsDto[];
}

export interface AdminEventDto {
  date?: string;
  description?: string;
  employerRegistrationEndDate?: string;
  employerRegistrationEndTime?: string;
  endDate?: string;
  endTime?: string;
  endTimezone?: string;
  feedbackOff?: number;
  feedbackReminder?: string;
  id?: number;
  includeCandidatePhotoForFeedback?: boolean;
  name?: string;
  orgId?: number;
  ownerUid?: number;
  shared?: number;
  startTime?: string;
  studentRegistrationEndDate?: string;
  studentRegistrationEndTime?: string;
  timezone?: string;
  virtualEventType?: number;
}

export interface AdminUserDTO {
  fname?: string;
  id?: number;
  lname?: string;
  oid?: number;
  uemail?: string;
}

export interface AgencyAndAgencyContactRequestWrapper {
  agencyContactRequest?: AgencyContactRequest;
  agencyRequest?: AgencyRequest;
}

export type AgencyCandidateFilterSegmentCriteria = typeof AgencyCandidateFilterSegmentCriteria[keyof typeof AgencyCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface AgencyCandidateFilterSegment {
  agencyIds?: number[];
  criteria?: AgencyCandidateFilterSegmentCriteria;
}

export type AgencyContactCandidateFilterSegmentCriteria = typeof AgencyContactCandidateFilterSegmentCriteria[keyof typeof AgencyContactCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgencyContactCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface AgencyContactCandidateFilterSegment {
  agencyContactIds?: number[];
  criteria?: AgencyContactCandidateFilterSegmentCriteria;
}

export interface AgencyContactGetMagicLinkRequest {
  email?: string;
  orgFriendlyName?: string;
  redirectUrl?: string;
}

export interface AgencyContactJobAuthorizationNode {
  agencyContactId?: number;
  agencyJobAuthorizationId?: number;
  id?: number;
}

export interface AgencyContactJobAuthorizationRequest {
  agencyContactId?: number;
}

export interface AgencyContactRequest {
  email?: string;
  firstName?: string;
  id?: number;
  lastName?: string;
  phoneNumber?: string;
}

export interface AgencyContactResponse {
  agencyContactId?: number;
  agencyId?: number;
  agencyName?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  unregisteredAgency?: boolean;
}

export interface AgencyContactUpdateRequest {
  agencyId?: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
}

export interface AgencyContactWithAgencyInfoResponse {
  agencyContactId?: number;
  agencyId?: number;
  agencyName?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  unregisteredAgency?: boolean;
}

export interface AgencyJobAuthorizationNode {
  agencyContactJobAuthorizations?: AgencyContactJobAuthorizationNode[];
  agencyId?: number;
  id?: number;
  isEntireAgency?: boolean;
  jobId?: number;
}

export interface AgencyJobAuthorizationRequest {
  agencyContactJobAuthorizationRequests?: AgencyContactJobAuthorizationRequest[];
  agencyId?: number;
  isEntireAgency?: boolean;
}

export interface AgencyRequest {
  id?: number;
  isEnabled?: boolean;
  name?: string;
}

export type AllUniversityDegreesResponseUniversityDegrees = {[key: string]: string[]};

export interface AllUniversityDegreesResponse {
  universityDegrees?: AllUniversityDegreesResponseUniversityDegrees;
}

export interface AllowEmployerMultipleDatesChoiceRequest {
  enabled?: boolean;
  numberOfChoices?: number;
}

export interface AllowEmployerMultipleDatesChoiceResponse {
  enabled?: boolean;
  numberOfChoices?: number;
}

export interface AmILoggedInAgencyContactResponse {
  agencyName?: string;
  email?: string;
  firstName?: string;
  fname?: string;
  lastName?: string;
  lname?: string;
  oid?: number;
  orgFriendlyName?: string;
  orgId?: number;
  phoneNumber?: string;
  success?: boolean;
  uid?: number;
}

export interface AmILoggedInApplicantResponse {
  email?: string;
  fname?: string;
  id?: number;
  lname?: string;
  success?: boolean;
}

export interface AmILoggedInForwardResponse {
  email?: string;
  firstName?: string;
  hasAccount?: boolean;
  hasActiveAccount?: boolean;
  id?: number;
  lastName?: string;
  success?: boolean;
}

export interface AmILoggedInMemberResponse {
  email?: string;
  firstName?: string;
  fname?: string;
  lastName?: string;
  lname?: string;
  oid?: number;
  orgFriendlyName?: string;
  orgId?: number;
  phoneNumber?: string;
  success?: boolean;
  uid?: number;
}

export interface AmILoggedInResponse {
  email?: string;
  fname?: string;
  lname?: string;
  oid?: number;
  orgFriendlyName?: string;
  orgId?: number;
  phoneNumber?: string;
  success?: boolean;
  uid?: number;
}

export interface AmILoggedInWithRolesResponse {
  email?: string;
  fname?: string;
  lname?: string;
  oid?: number;
  orgFriendlyName?: string;
  phoneNumber?: string;
  roles?: string[];
  success?: boolean;
  uid?: number;
}

export type ApplicationQuestionAnswerSelectionCandidateFilterSegmentCriteria = typeof ApplicationQuestionAnswerSelectionCandidateFilterSegmentCriteria[keyof typeof ApplicationQuestionAnswerSelectionCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplicationQuestionAnswerSelectionCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface ApplicationQuestionAnswerSelectionCandidateFilterSegment {
  criteria?: ApplicationQuestionAnswerSelectionCandidateFilterSegmentCriteria;
  jobId?: number;
  orgOptionIds?: number[];
  orgQuestionId?: number;
}

export type ApplicationQuestionDateCandidateFilterSegmentCriteria = typeof ApplicationQuestionDateCandidateFilterSegmentCriteria[keyof typeof ApplicationQuestionDateCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplicationQuestionDateCandidateFilterSegmentCriteria = {
  ON: 'ON',
  BEFORE: 'BEFORE',
  AFTER: 'AFTER',
  ON_OR_BEFORE: 'ON_OR_BEFORE',
  ON_OR_AFTER: 'ON_OR_AFTER',
} as const;

export interface ApplicationQuestionDateCandidateFilterSegment {
  criteria?: ApplicationQuestionDateCandidateFilterSegmentCriteria;
  jobId?: number;
  orgQuestionId?: number;
  value?: string;
}

export type ApplicationQuestionFreeTextCandidateFilterSegmentCriteria = typeof ApplicationQuestionFreeTextCandidateFilterSegmentCriteria[keyof typeof ApplicationQuestionFreeTextCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplicationQuestionFreeTextCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  NOT_CONTAINS: 'NOT_CONTAINS',
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
  STARTS_WITH: 'STARTS_WITH',
} as const;

export interface ApplicationQuestionFreeTextCandidateFilterSegment {
  criteria?: ApplicationQuestionFreeTextCandidateFilterSegmentCriteria;
  jobId?: number;
  orgQuestionId?: number;
  value?: string;
}

export type ApplicationQuestionNumericalCandidateFilterSegmentCriteria = typeof ApplicationQuestionNumericalCandidateFilterSegmentCriteria[keyof typeof ApplicationQuestionNumericalCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplicationQuestionNumericalCandidateFilterSegmentCriteria = {
  GREATER_THAN: 'GREATER_THAN',
  LESS_THAN: 'LESS_THAN',
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL',
} as const;

export interface ApplicationQuestionNumericalCandidateFilterSegment {
  criteria?: ApplicationQuestionNumericalCandidateFilterSegmentCriteria;
  jobId?: number;
  orgQuestionId?: number;
  value?: number;
}

export interface AttendeeDTO {
  email?: string;
  firstName?: string;
  id?: number;
  isAttendee?: boolean;
  isContact?: boolean;
  jobTitle?: string;
  lastName?: string;
  universityEmployerId?: number;
}

export interface BasicAdminInfo {
  adminUserDTO?: AdminUserDTO;
  orgDTO?: OrgDTO;
}

export interface BulkUpdateAppsRequest {
  candidateIds?: number[];
  emailAutomationRequest?: EmailAutomationRequest;
  jobPipelineStatusId?: number;
}

export type BulkUpdateAppsSourcesRequestAppSource = typeof BulkUpdateAppsSourcesRequestAppSource[keyof typeof BulkUpdateAppsSourcesRequestAppSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BulkUpdateAppsSourcesRequestAppSource = {
  UNDEFINED: 'UNDEFINED',
  AGENCY: 'AGENCY',
  EMAIL_SUBMISSION: 'EMAIL_SUBMISSION',
  EMPLOYEE_REFERRAL: 'EMPLOYEE_REFERRAL',
  INTERNAL_HIRE: 'INTERNAL_HIRE',
  JOB_FAIR: 'JOB_FAIR',
  OCI: 'OCI',
  OTHER: 'OTHER',
  RESUME_COLLECT: 'RESUME_COLLECT',
  PREVIOUS_SUMMER_ASSOCIATE: 'PREVIOUS_SUMMER_ASSOCIATE',
  WRITE_IN: 'WRITE_IN',
  FORWARD: 'FORWARD',
  ADVERTISEMENT_OR_JOB_BOARD: 'ADVERTISEMENT_OR_JOB_BOARD',
  AUTOMATIC_CALLBACK: 'AUTOMATIC_CALLBACK',
  CONSORTIUM: 'CONSORTIUM',
  RECRUITING_EVENT: 'RECRUITING_EVENT',
  REFERRAL: 'REFERRAL',
  PRE_OCI: 'PRE_OCI',
  PREDICTIVE_TOOL: 'PREDICTIVE_TOOL',
  DIRECT_OUTREACH: 'DIRECT_OUTREACH',
} as const;

export interface BulkUpdateAppsSourcesRequest {
  appSource?: BulkUpdateAppsSourcesRequestAppSource;
  jobAppIds?: number[];
}

export type CallbackEventInterviewDateCandidateFilterSegmentCriteria = typeof CallbackEventInterviewDateCandidateFilterSegmentCriteria[keyof typeof CallbackEventInterviewDateCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CallbackEventInterviewDateCandidateFilterSegmentCriteria = {
  ON: 'ON',
  BEFORE: 'BEFORE',
  AFTER: 'AFTER',
  ON_OR_BEFORE: 'ON_OR_BEFORE',
  ON_OR_AFTER: 'ON_OR_AFTER',
} as const;

export interface CallbackEventInterviewDateCandidateFilterSegment {
  criteria?: CallbackEventInterviewDateCandidateFilterSegmentCriteria;
  eventId?: number;
  value?: string;
}

export interface CandidateDTO {
  email?: string;
  fname?: string;
  id?: number;
  imagepoint?: string;
  linkedin?: string;
  lname?: string;
  phone?: string;
  requestDocuments?: RequestDocument[];
  rid?: number;
}

export interface CandidateEvaluation {
  candidateId?: number;
  comment?: string;
  dateAdded?: string;
  dateUpdated?: string;
  eventId?: number;
  id?: number;
  multiSelectAnswers?: string[];
  orgFeedbackId?: number;
  ratingAnswer?: number;
  singleSelectAnswer?: string;
  user?: User;
  userId?: number;
  yesNoAnswer?: number;
}

export type CandidateFilterRequestCombinationMethod = typeof CandidateFilterRequestCombinationMethod[keyof typeof CandidateFilterRequestCombinationMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidateFilterRequestCombinationMethod = {
  ANY: 'ANY',
  ALL: 'ALL',
} as const;

export interface CandidateFilterRequest {
  agencyCandidateFilterSegments?: AgencyCandidateFilterSegment[];
  agencyContactCandidateFilterSegments?: AgencyContactCandidateFilterSegment[];
  applicationQuestionAnswerSelectionCandidateFilterSegments?: ApplicationQuestionAnswerSelectionCandidateFilterSegment[];
  applicationQuestionDateCandidateFilterSegments?: ApplicationQuestionDateCandidateFilterSegment[];
  applicationQuestionFreeTextCandidateFilterSegments?: ApplicationQuestionFreeTextCandidateFilterSegment[];
  applicationQuestionNumericalCandidateFilterSegments?: ApplicationQuestionNumericalCandidateFilterSegment[];
  callbackEventInterviewDateCandidateFilterSegments?: CallbackEventInterviewDateCandidateFilterSegment[];
  combinationMethod?: CandidateFilterRequestCombinationMethod;
  eventCustomDocumentsCandidateFilterSegments?: EventCustomDocumentsCandidateFilterSegment[];
  eventInterviewDateFilterSegments?: EventInterviewDateFilterSegment[];
  eventInterviewerFilterSegments?: EventInterviewerFilterSegment[];
  eventResumeCandidateFilterSegments?: EventResumeCandidateFilterSegment[];
  eventTranscriptCandidateFilterSegments?: EventTranscriptCandidateFilterSegment[];
  eventsCandidateFilterSegments?: EventsCandidateFilterSegment[];
  eventsDateCandidateFilterSegments?: EventsDateCandidateFilterSegment[];
  eventsRegistrationDateCandidateFilterSegments?: EventsRegistrationDateCandidateFilterSegment[];
  eventsStatusCandidateFilterSegments?: EventsStatusCandidateFilterSegment[];
  internalFieldAnswerSelectionCandidateFilterSegments?: InternalFieldAnswerSelectionCandidateFilterSegment[];
  internalFieldDateCandidateFilterSegments?: InternalFieldDateCandidateFilterSegment[];
  internalFieldFreeTextCandidateFilterSegments?: InternalFieldFreeTextCandidateFilterSegment[];
  internalFieldNumericalCandidateFilterSegments?: InternalFieldNumericalCandidateFilterSegment[];
  jobApplicationDateCandidateFilterSegments?: JobApplicationDateCandidateFilterSegment[];
  jobApplicationSourceCandidateFilterSegments?: JobApplicationSourceCandidateFilterSegment[];
  jobCandidateFilterSegments?: JobCandidateFilterSegment[];
  jobCustomDocumentsCandidateFilterSegments?: JobCustomDocumentsCandidateFilterSegment[];
  jobDepartmentCandidateFilterSegments?: JobDepartmentCandidateFilterSegment[];
  jobHiringLeadsCandidateFilterSegments?: JobHiringLeadsCandidateFilterSegment[];
  jobOfficeCandidateFilterSegments?: JobOfficeCandidateFilterSegment[];
  jobPositionStatusCandidateFilterSegments?: JobPositionStatusCandidateFilterSegment[];
  jobPositionTypeCandidateFilterSegments?: JobPositionTypeCandidateFilterSegment[];
  jobProcessYearCandidateFilterSegments?: JobProcessYearCandidateFilterSegment[];
  jobStatusCandidateFilterSegments?: JobStatusCandidateFilterSegment[];
  jobStatusHistoricalFilterSegments?: JobStatusHistoricalFilterSegment[];
  lastActivityDateCandidateFilterSegments?: LastActivityDateCandidateFilterSegment[];
  orgCustomDocumentsCandidateFilterSegments?: OrgCustomDocumentsCandidateFilterSegment[];
  qualifyingQuestionAnswerFilterSegments?: QualifyingQuestionAnswerFilterSegment[];
  qualifyingQuestionFreeTextAnswerFilterSegments?: QualifyingQuestionFreeTextAnswerFilterSegment[];
  specificJobCustomDocumentsCandidateFilterSegments?: SpecificJobCustomDocumentsCandidateFilterSegment[];
  userTimeZone?: string;
}

export interface CandidateJobAppDocumentUploadRequest {
  document?: Blob;
  isFinalStep?: boolean;
  jobAppId?: number;
  jobExtension?: string;
  orgFriendlyName?: string;
  orgcustomdocumentsId?: number;
}

export interface CandidateMergePreviewResponse {
  combinedRecruit?: FullRecruit;
  primaryRecruit?: FullRecruit;
  subordinateRecruit?: FullRecruit;
}

export type CandidatePageEventResponseEventTypeEnum = typeof CandidatePageEventResponseEventTypeEnum[keyof typeof CandidatePageEventResponseEventTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidatePageEventResponseEventTypeEnum = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
  NUMBER_5: '5',
  NUMBER_6: '6',
  NUMBER_7: '7',
  NUMBER_8: '8',
  NUMBER_9: '9',
  NUMBER_10: '10',
  NUMBER_11: '11',
  NUMBER_12: '12',
  NUMBER_13: '13',
  NUMBER_14: '14',
} as const;

export type CandidatePageEventResponseStatusListItem = typeof CandidatePageEventResponseStatusListItem[keyof typeof CandidatePageEventResponseStatusListItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidatePageEventResponseStatusListItem = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
  NUMBER_5: '5',
  NUMBER_6: '6',
} as const;

export interface CandidatePageEventResponse {
  dateRegistered?: string;
  eventEndDate?: string;
  eventId?: number;
  eventName?: string;
  eventStartDate?: string;
  eventTypeEnum?: CandidatePageEventResponseEventTypeEnum;
  statusList?: CandidatePageEventResponseStatusListItem[];
}

export type CandidatePageInternalFieldAnswerResponseType = typeof CandidatePageInternalFieldAnswerResponseType[keyof typeof CandidatePageInternalFieldAnswerResponseType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidatePageInternalFieldAnswerResponseType = {
  SINGLE_SELECT: 'SINGLE_SELECT',
  FREE_TEXT: 'FREE_TEXT',
  NUMERICAL: 'NUMERICAL',
  MONETARY: 'MONETARY',
  MULTI_SELECT: 'MULTI_SELECT',
  DATE: 'DATE',
  BOOLEAN: 'BOOLEAN',
} as const;

export interface CandidatePageInternalFieldAnswerResponse {
  hasAnswer?: boolean;
  questionId?: number;
  title?: string;
  type?: CandidatePageInternalFieldAnswerResponseType;
  values?: string[];
}

export type CandidatePageJobResponseAppSource = typeof CandidatePageJobResponseAppSource[keyof typeof CandidatePageJobResponseAppSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidatePageJobResponseAppSource = {
  UNDEFINED: 'UNDEFINED',
  AGENCY: 'AGENCY',
  EMAIL_SUBMISSION: 'EMAIL_SUBMISSION',
  EMPLOYEE_REFERRAL: 'EMPLOYEE_REFERRAL',
  INTERNAL_HIRE: 'INTERNAL_HIRE',
  JOB_FAIR: 'JOB_FAIR',
  OCI: 'OCI',
  OTHER: 'OTHER',
  RESUME_COLLECT: 'RESUME_COLLECT',
  PREVIOUS_SUMMER_ASSOCIATE: 'PREVIOUS_SUMMER_ASSOCIATE',
  WRITE_IN: 'WRITE_IN',
  FORWARD: 'FORWARD',
  ADVERTISEMENT_OR_JOB_BOARD: 'ADVERTISEMENT_OR_JOB_BOARD',
  AUTOMATIC_CALLBACK: 'AUTOMATIC_CALLBACK',
  CONSORTIUM: 'CONSORTIUM',
  RECRUITING_EVENT: 'RECRUITING_EVENT',
  REFERRAL: 'REFERRAL',
  PRE_OCI: 'PRE_OCI',
  PREDICTIVE_TOOL: 'PREDICTIVE_TOOL',
  DIRECT_OUTREACH: 'DIRECT_OUTREACH',
} as const;

export interface CandidatePageJobResponse {
  agencyContactId?: number;
  agencyId?: number;
  appSource?: CandidatePageJobResponseAppSource;
  dateApplied?: string;
  departments?: string[];
  hiringLeads?: string[];
  isOpen?: boolean;
  jobId?: number;
  jobTitle?: string;
  offices?: string[];
  positionTypes?: string[];
  processYear?: number;
  statusId?: number;
  statusLastUpdatedAt?: string;
  statusName?: string;
}

export interface CandidatePageResponse {
  email?: string;
  events?: CandidatePageEventResponse[];
  fname?: string;
  id?: number;
  imagePoint?: string;
  internalFieldAnswers?: CandidatePageInternalFieldAnswerResponse[];
  jobs?: CandidatePageJobResponse[];
  lname?: string;
  orgId?: number;
}

export interface CandidateProfileDocumentResponse {
  eventDocuments?: CandidateProfileEventDocumentResponse[];
  jobDocuments?: CandidateProfileJobDocumentResponse[];
}

export type CandidateProfileEventDocumentResponseDocumentType = typeof CandidateProfileEventDocumentResponseDocumentType[keyof typeof CandidateProfileEventDocumentResponseDocumentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidateProfileEventDocumentResponseDocumentType = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
} as const;

export interface CandidateProfileEventDocumentResponse {
  dateUploaded?: string;
  documentName?: string;
  documentType?: CandidateProfileEventDocumentResponseDocumentType;
  location?: string;
  orgCustomDocumentId?: number;
  recruitCustomDocumentId?: number;
}

export type CandidateProfileGeneralJobInfoResponseAppSource = typeof CandidateProfileGeneralJobInfoResponseAppSource[keyof typeof CandidateProfileGeneralJobInfoResponseAppSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidateProfileGeneralJobInfoResponseAppSource = {
  UNDEFINED: 'UNDEFINED',
  AGENCY: 'AGENCY',
  EMAIL_SUBMISSION: 'EMAIL_SUBMISSION',
  EMPLOYEE_REFERRAL: 'EMPLOYEE_REFERRAL',
  INTERNAL_HIRE: 'INTERNAL_HIRE',
  JOB_FAIR: 'JOB_FAIR',
  OCI: 'OCI',
  OTHER: 'OTHER',
  RESUME_COLLECT: 'RESUME_COLLECT',
  PREVIOUS_SUMMER_ASSOCIATE: 'PREVIOUS_SUMMER_ASSOCIATE',
  WRITE_IN: 'WRITE_IN',
  FORWARD: 'FORWARD',
  ADVERTISEMENT_OR_JOB_BOARD: 'ADVERTISEMENT_OR_JOB_BOARD',
  AUTOMATIC_CALLBACK: 'AUTOMATIC_CALLBACK',
  CONSORTIUM: 'CONSORTIUM',
  RECRUITING_EVENT: 'RECRUITING_EVENT',
  REFERRAL: 'REFERRAL',
  PRE_OCI: 'PRE_OCI',
  PREDICTIVE_TOOL: 'PREDICTIVE_TOOL',
  DIRECT_OUTREACH: 'DIRECT_OUTREACH',
} as const;

export interface CandidateProfileGeneralJobInfoResponse {
  agencyContactEmail?: string;
  answerResponses?: CandidateProfileJobInfoQuestionAnswerResponse[];
  appSource?: CandidateProfileGeneralJobInfoResponseAppSource;
  corePipelineBucketColor?: string;
  corePipelineBucketId?: number;
  corePipelineBucketName?: string;
  dateApplied?: string;
  departments?: string[];
  jobAppId?: number;
  jobId?: number;
  jobPipelineStatusId?: number;
  jobPipelineStatusName?: string;
  jobTitle?: string;
  missingInfoRequestToAgencyContact?: JobAppCandidateMissingInfoRequestResponse;
  missingInfoRequestToCandidate?: JobAppCandidateMissingInfoRequestResponse;
  offices?: string[];
}

export interface CandidateProfileInterviewSchedulingDocumentDownloadRequest {
  eventCustomDocumentId?: number;
  recruitId?: number;
  scheduleId?: number;
}

export interface CandidateProfileInterviewSchedulingDocumentInfoResponse {
  employerInterviewerSchedules?: EmployerInterviewSchedule[];
  eventDocuments?: CandidateProfileInterviewSchedulingEventDocument[];
  scheduleIdsForStudent?: number[];
}

export interface CandidateProfileInterviewSchedulingEventDocument {
  eventCustomDocId?: number;
  scheduleIdsSupportingDocumentIdPairs?: CandidateProfileInterviewSchedulingScheduleIdSupportingDocumentId[];
  supportingDocument?: SupportingDocumentResponse;
  uploadedDocuments?: CandidateProfileInterviewSchedulingUploadedDocument[];
}

export interface CandidateProfileInterviewSchedulingScheduleIdSupportingDocumentId {
  scheduleId?: number;
  supportingDocumentId?: number;
}

export interface CandidateProfileInterviewSchedulingUploadedDocument {
  eventCustomDocumentId?: number;
  recruitId?: number;
  scheduleId?: number;
  supportingDocumentId?: number;
  userFilename?: string;
}

export interface CandidateProfileJobDocumentJobInfoResponse {
  jobAppDocumentId?: number;
  jobAppId?: number;
  jobId?: number;
  jobTitle?: string;
  uploadDateTime?: string;
}

export interface CandidateProfileJobDocumentResponse {
  documentName?: string;
  jobInfoResponses?: CandidateProfileJobDocumentJobInfoResponse[];
  orgCustomDocumentId?: number;
}

export type CandidateProfileJobInfoQuestionAnswerResponseQuestionType = typeof CandidateProfileJobInfoQuestionAnswerResponseQuestionType[keyof typeof CandidateProfileJobInfoQuestionAnswerResponseQuestionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidateProfileJobInfoQuestionAnswerResponseQuestionType = {
  SINGLE_SELECT: 'SINGLE_SELECT',
  FREE_TEXT: 'FREE_TEXT',
  NUMERICAL: 'NUMERICAL',
  MULTI_SELECT: 'MULTI_SELECT',
  DATE: 'DATE',
} as const;

export interface CandidateProfileJobInfoQuestionAnswerResponse {
  dateValue?: string;
  jobAppQuestionAnswerSelections?: string[];
  label?: string;
  numericValue?: number;
  orgQuestionId?: number;
  questionType?: CandidateProfileJobInfoQuestionAnswerResponseQuestionType;
  textValue?: string;
}

export interface CandidateProfileOrgSelfIdQuestionAnswerResponse {
  appSource?: string;
  id?: number;
  label?: string;
  orgSelfIdQuestionAnswerSelections?: OrgSelfIdQuestionAnswerSelectionNode[];
  orgSelfIdQuestionId?: number;
  orgSelfIdQuestionOptions?: OrgSelfIdQuestionOptionNode[];
  recruitId?: number;
}

export interface CandidateResponse {
  email?: string;
  firstName: string;
  id?: number;
  imagePoint?: string;
  lastName: string;
  linkedIn?: string;
  organizationId?: number;
  phoneNumber?: string;
  registeredAt?: string;
  registeredTimezone?: string;
  resume?: string;
  resumeUpdatedAt?: string;
  transcript?: string;
  transcriptUpdatedAt?: string;
  unifiedCandidateId?: number;
}

export interface CandidateReviewPdfExportRequest {
  candidateReviewTemplateId?: number;
  clientTimezone?: string;
  includeVoting?: boolean;
  jobAppIds?: number[];
  recruitIds?: number[];
}

export interface CandidateSelfApplyJobAppRequest {
  addressInfo?: JobAppAddressInformationRequest;
  applicationQuestions?: JobAppQuestionAnswerRequest[];
  educationHistory?: JobAppEducationHistoryRequest[];
  isFinalStep?: boolean;
  jobExtension?: string;
  orgFriendlyName?: string;
  personalInfo?: JobAppPersonalInformationRequest;
  recruitId?: number;
  selfIdQuestionAnswers?: JobAppSelfIdQuestionAnswerRequest[];
  unregisteredAgencyInfo?: JobAppUnregisteredAgencyInformationRequest;
  workHistory?: JobAppWorkHistoryRequest[];
}

export type CandidateSortByEmail = typeof CandidateSortByEmail[keyof typeof CandidateSortByEmail];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidateSortByEmail = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type CandidateSortByLawSchool = typeof CandidateSortByLawSchool[keyof typeof CandidateSortByLawSchool];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidateSortByLawSchool = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type CandidateSortByName = typeof CandidateSortByName[keyof typeof CandidateSortByName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidateSortByName = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type CandidateSortByPhone = typeof CandidateSortByPhone[keyof typeof CandidateSortByPhone];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidateSortByPhone = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export interface CandidateSortBy {
  email?: CandidateSortByEmail;
  lawSchool?: CandidateSortByLawSchool;
  name?: CandidateSortByName;
  phone?: CandidateSortByPhone;
}

export interface CandidatesDataTableExportRequest {
  filteredRecruitIds?: string[];
  rids?: string[];
  selectAllChecked?: boolean;
  sortBy?: CandidateSortBy;
}

export interface CareersPageJobDetailsResponse {
  closeDate?: string;
  closeTimezone?: string;
  departments?: PublicJobDepartmentResponse[];
  description?: string;
  extension?: string;
  hiringLeads?: PublicHiringLeadResponse[];
  id?: number;
  isPublic?: boolean;
  jobEmploymentTypes?: PublicJobEmploymentTypeResponse[];
  jobId?: number;
  jobOffices?: PublicJobOfficeResponse[];
  openDate?: string;
  openTimezone?: string;
  positionTypes?: PublicJobPositionTypeResponse[];
  title?: string;
}

export interface CareersPageJobOverviewResponse {
  closeDate?: string;
  closeTimezone?: string;
  departments?: PublicJobDepartmentResponse[];
  extension?: string;
  hiringLeads?: PublicHiringLeadResponse[];
  id?: number;
  isPublic?: boolean;
  jobEmploymentTypes?: PublicJobEmploymentTypeResponse[];
  jobOffices?: PublicJobOfficeResponse[];
  openDate?: string;
  openTimezone?: string;
  positionTypes?: PublicJobPositionTypeResponse[];
  title?: string;
}

export interface ChangeStatusRequest {
  emailAutomationRequest?: EmailAutomationRequest;
  jobAppId?: number;
  jobPipelineStatusId?: number;
}

export interface CorePipelineBucketResponse {
  color?: string;
  description?: string;
  id?: number;
  name?: string;
  order?: number;
}

export interface CorePipelineStepRequest {
  corePipelineBucketId?: number;
  description?: string;
  id?: number;
  isActive?: boolean;
  name?: string;
}

export interface CorePipelineStepResponse {
  corePipelineBucketId?: number;
  description?: string;
  id?: number;
  isActive?: boolean;
  name?: string;
  orgId?: number;
  pipelineTemplateCount?: number;
}

export interface CreateEditNetworkingEmailsRequest {
  candidatereminderemail?: EmailsDTO;
  candidatereminderemailtime?: number;
  eid?: number;
  employerconfirmationuemail?: EmailsDTO;
  employerschedulecreateemailtime?: number;
  employerschedulecreateuemail?: EmailsDTO;
  studentregistrationconfirmationremail?: EmailsDTO;
}

export interface CreateEditNetworkingEmailsResponse {
  eid?: number;
  success?: boolean;
}

export interface CreateEditNetworkingEventRequest {
  addedRids?: number[];
  addedUids?: number[];
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  docIdsToDelete?: number[];
  eid?: number;
  employerRegistrationDeadlineDate?: string;
  employerRegistrationDeadlineTime?: LocalTime;
  employerRegistrationDeadlineTimezone?: string;
  eventDate?: string;
  eventEndTime?: LocalTime;
  eventStartTime?: LocalTime;
  eventTimezone?: string;
  isCreate?: boolean;
  /**
   * @minLength 0
   * @maxLength 200
   */
  name?: string;
  ownerId?: number;
  requestDocuments?: RequestDocument[];
  speakerRids?: number[];
  speakerUids?: number[];
  studentRegistrationDeadlineDate?: string;
  studentRegistrationDeadlineTime?: LocalTime;
  studentRegistrationDeadlineTimezone?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  webinarDescription?: string;
  webinarDurationMinutes?: number;
  webinarEnabled?: boolean;
  /**
   * @minLength 0
   * @maxLength 200
   */
  webinarName?: string;
}

export interface CreateEditNetworkingEventResponse {
  eid?: number;
  errorMsg?: string;
  success?: boolean;
}

export type CreateEditNetworkingRoomsRequestMapRidToTimeslotId = {[key: string]: number};

export type CreateEditNetworkingRoomsRequestMapRidToTimeslotIdOld = {[key: string]: number};

export type CreateEditNetworkingRoomsRequestMapUidToTimeslotId = {[key: string]: number};

export type CreateEditNetworkingRoomsRequestMapUidToTimeslotIdOld = {[key: string]: number};

export interface CreateEditNetworkingRoomsRequest {
  addedRids?: number[];
  addedUids?: number[];
  deletedRids?: number[];
  deletedUids?: number[];
  eid?: number;
  mapRidToTimeslotId?: CreateEditNetworkingRoomsRequestMapRidToTimeslotId;
  mapRidToTimeslotIdOld?: CreateEditNetworkingRoomsRequestMapRidToTimeslotIdOld;
  mapUidToTimeslotId?: CreateEditNetworkingRoomsRequestMapUidToTimeslotId;
  mapUidToTimeslotIdOld?: CreateEditNetworkingRoomsRequestMapUidToTimeslotIdOld;
  networkingTimeslots?: NetworkingTimeslot[];
  networkingTimeslotsOld?: NetworkingTimeslot[];
}

export interface CreateEditNetworkingRoomsResponse {
  eid?: number;
  success?: boolean;
}

export interface CreateOfficesRequest {
  officesToCreate?: string[];
}

export interface CreateUniversityEmployerResponse {
  primaryUserId?: number;
  universityEmployerId?: number;
}

export interface CreateUserRequest {
  email?: string;
  firstName?: string;
  jobTitle?: string;
  lastName?: string;
  lawSchool?: string;
  officeLocation?: string;
  practiceArea?: string;
}

export type CurrentParticipantsResponseRoomNameToCurrentRids = {[key: string]: number[]};

export type CurrentParticipantsResponseRoomNameToCurrentUids = {[key: string]: number[]};

export interface CurrentParticipantsResponse {
  roomNameToCurrentRids?: CurrentParticipantsResponseRoomNameToCurrentRids;
  roomNameToCurrentUids?: CurrentParticipantsResponseRoomNameToCurrentUids;
}

export interface CurrentWebinarParticipantsResponse {
  rids?: number[];
  uids?: number[];
}

export type CurrentWebinarStateResponseCurrentState = typeof CurrentWebinarStateResponseCurrentState[keyof typeof CurrentWebinarStateResponseCurrentState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CurrentWebinarStateResponseCurrentState = {
  ENDED: 'ENDED',
  STARTED: 'STARTED',
  NOT_STARTED: 'NOT_STARTED',
} as const;

export interface CurrentWebinarStateResponse {
  currentState?: CurrentWebinarStateResponseCurrentState;
}

export interface DailyMeetingTokenResponse {
  meetingToken?: string;
  success?: boolean;
}

export interface DepartmentRequest {
  id?: number;
  name?: string;
}

export interface DepartmentResponse {
  id?: number;
  name?: string;
}

export interface DownloadDocumentRequest {
  eid?: number;
  orgDocId?: number;
  rid?: number;
}

export interface EmailAutomationRequest {
  bccEmail?: string;
  body?: string;
  ccEmail?: string;
  fromEmail?: string;
  fromName?: string;
  id?: number;
  jobPipelineStepId?: number;
  markedForDeletion?: boolean;
  replyToEmail?: string;
  subject?: string;
  timeDelay?: number;
}

export interface EmailAutomationResponse {
  bccEmail?: string;
  body?: string;
  ccEmail?: string;
  emailAutomationTemplateId?: number;
  fromEmail?: string;
  id?: number;
  jobPipelineStepId?: number;
  markedForDeletion?: boolean;
  replyToEmail?: string;
  subject?: string;
  timeDelay?: number;
}

export interface EmailAutomationTemplateRequest {
  bccEmail?: string;
  body?: string;
  ccEmail?: string;
  fromEmail?: string;
  id?: number;
  markedForDeletion?: boolean;
  pipelineTemplateStepId?: number;
  replyToEmail?: string;
  subject?: string;
  timeDelay?: number;
}

export interface EmailAutomationTemplateResponse {
  bccEmail?: string;
  body?: string;
  ccEmail?: string;
  fromEmail?: string;
  id?: number;
  pipelineTemplateStepId?: number;
  replyToEmail?: string;
  subject?: string;
  timeDelay?: number;
}

export interface EmailDefaults {
  defaultBody?: string;
  defaultSubject?: string;
  id?: number;
  type?: string;
  variables?: EmailVariable[];
}

export type EmailPreviewRequestEmailType = typeof EmailPreviewRequestEmailType[keyof typeof EmailPreviewRequestEmailType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmailPreviewRequestEmailType = {
  INTERVIEW_SCHEDULING_EMPLOYER_REGISTRATION: 'INTERVIEW_SCHEDULING_EMPLOYER_REGISTRATION',
  INTERVIEW_SCHEDULING_EMPLOYER_REGISTRATION_REMINDER: 'INTERVIEW_SCHEDULING_EMPLOYER_REGISTRATION_REMINDER',
  INTERVIEW_SCHEDULING_EMPLOYER_SCHEDULE_REGISTRATION_SUBMITTED: 'INTERVIEW_SCHEDULING_EMPLOYER_SCHEDULE_REGISTRATION_SUBMITTED',
  INTERVIEW_SCHEDULING_EMPLOYER_INTERVIEWER_INFORMATION_REQUEST: 'INTERVIEW_SCHEDULING_EMPLOYER_INTERVIEWER_INFORMATION_REQUEST',
  INTERVIEW_SCHEDULING_EMPLOYER_SCHEDULE_ASSIGNMENT: 'INTERVIEW_SCHEDULING_EMPLOYER_SCHEDULE_ASSIGNMENT',
  INTERVIEW_SCHEDULING_EMPLOYER_STUDENT_APPLICATIONS_ARE_AVAILABLE: 'INTERVIEW_SCHEDULING_EMPLOYER_STUDENT_APPLICATIONS_ARE_AVAILABLE',
  INTERVIEW_SCHEDULING_EMPLOYER_FINAL_SCHEDULE_IS_AVAILABLE: 'INTERVIEW_SCHEDULING_EMPLOYER_FINAL_SCHEDULE_IS_AVAILABLE',
  INTERVIEW_SCHEDULING_STUDENT_YOUR_EVENT_PAGE_IS_AVAILABLE: 'INTERVIEW_SCHEDULING_STUDENT_YOUR_EVENT_PAGE_IS_AVAILABLE',
  INTERVIEW_SCHEDULING_STUDENT_APPLICATION_DEADLINE_REMINDER: 'INTERVIEW_SCHEDULING_STUDENT_APPLICATION_DEADLINE_REMINDER',
  INTERVIEW_SCHEDULING_STUDENT_EMPLOYER_DECISIONS_ARE_VISIBLE: 'INTERVIEW_SCHEDULING_STUDENT_EMPLOYER_DECISIONS_ARE_VISIBLE',
  INTERVIEW_SCHEDULING_STUDENT_ALTERNATE_PERIOD_HAS_STARTED: 'INTERVIEW_SCHEDULING_STUDENT_ALTERNATE_PERIOD_HAS_STARTED',
  INTERVIEW_SCHEDULING_STUDENT_FINAL_SCHEDULE_IS_AVAILABLE: 'INTERVIEW_SCHEDULING_STUDENT_FINAL_SCHEDULE_IS_AVAILABLE',
  LOTTERY_STUDENT_EVENT_PAGE: 'LOTTERY_STUDENT_EVENT_PAGE',
  LOTTERY_STUDENT_REVIEW_PERIOD_HAS_STARTED: 'LOTTERY_STUDENT_REVIEW_PERIOD_HAS_STARTED',
  LOTTERY_STUDENT_BIDDING_PERIOD_HAS_STARTED: 'LOTTERY_STUDENT_BIDDING_PERIOD_HAS_STARTED',
  LOTTERY_STUDENT_MATCHES_ARE_VISIBLE: 'LOTTERY_STUDENT_MATCHES_ARE_VISIBLE',
  LOTTERY_STUDENT_CANCELLATION_PERIOD_HAS_STARTED: 'LOTTERY_STUDENT_CANCELLATION_PERIOD_HAS_STARTED',
  LOTTERY_STUDENT_OPT_IN_PERIOD_HAS_STARTED: 'LOTTERY_STUDENT_OPT_IN_PERIOD_HAS_STARTED',
  LOTTERY_STUDENT_SELF_SCHEDULE_PERIOD_HAS_STARTED: 'LOTTERY_STUDENT_SELF_SCHEDULE_PERIOD_HAS_STARTED',
  LOTTERY_EMPLOYER_SCHEDULE_REGISTRATION_SUBMITTED: 'LOTTERY_EMPLOYER_SCHEDULE_REGISTRATION_SUBMITTED',
} as const;

export interface EmailPreviewRequest {
  body?: string;
  emailType?: EmailPreviewRequestEmailType;
  subject?: string;
}

export interface EmailPreviewResponse {
  bodyRawHtml?: string;
  fromEmailAddress?: string;
  fromName?: string;
  subject?: string;
  toEmailAddress?: string;
  toName?: string;
}

export interface EmailVariable {
  id?: number;
  identifier?: string;
  label?: string;
}

export interface EmailsDTO {
  bccemail?: string;
  body?: string;
  ccemail?: string;
  id?: number;
  oid?: number;
  sender?: string;
  sendername?: string;
  subject?: string;
}

export interface EmployerContactDTO {
  email?: string;
  firstName?: string;
  lastName?: string;
  newEmployerContact?: boolean;
  uid?: number;
}

export interface EmployerContactRequest {
  email?: string;
  firstName?: string;
  jobTitle?: string;
  lastName?: string;
  universityEmployerId?: number;
}

export interface EmployerCustomQuestionRequest {
  orgQuestionId?: number;
  required?: boolean;
}

export type EmployerCustomQuestionResponseQuestionType = typeof EmployerCustomQuestionResponseQuestionType[keyof typeof EmployerCustomQuestionResponseQuestionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerCustomQuestionResponseQuestionType = {
  SINGLE_SELECT: 'SINGLE_SELECT',
  FREE_TEXT: 'FREE_TEXT',
  NUMERICAL: 'NUMERICAL',
  MULTI_SELECT: 'MULTI_SELECT',
  DATE: 'DATE',
} as const;

export interface EmployerCustomQuestionResponse {
  eventQuestionId?: number;
  label?: string;
  orgQuestionId?: number;
  questionType?: EmployerCustomQuestionResponseQuestionType;
  required?: boolean;
  subText?: string;
}

export type EmployerCustomQuestionWithOptionsResponseQuestionType = typeof EmployerCustomQuestionWithOptionsResponseQuestionType[keyof typeof EmployerCustomQuestionWithOptionsResponseQuestionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerCustomQuestionWithOptionsResponseQuestionType = {
  SINGLE_SELECT: 'SINGLE_SELECT',
  FREE_TEXT: 'FREE_TEXT',
  NUMERICAL: 'NUMERICAL',
  MULTI_SELECT: 'MULTI_SELECT',
  DATE: 'DATE',
} as const;

export interface EmployerCustomQuestionWithOptionsResponse {
  eventQuestionId?: number;
  label?: string;
  options?: EmployerQuestionOptionResponse[];
  orgQuestionId?: number;
  questionType?: EmployerCustomQuestionWithOptionsResponseQuestionType;
  required?: boolean;
  subText?: string;
}

export interface EmployerFullScheduleResponse {
  employerAnswers?: EmployerInterviewScheduleQuestionAnswerResponse[];
  employerInterviewers?: EmployerInterviewScheduleInterviewerResponse[];
  interviewOptions?: EmployerScheduleInterviewOptionsResponse;
  interviewOptionsNew?: EmployerScheduleInterviewOptionsResponse[];
  jobInformation?: EmployerScheduleJobInformation;
  scheduleDetails?: EmployerScheduleDetailsResponse;
}

export type EmployerInterviewScheduleOfficeLocationsOption = typeof EmployerInterviewScheduleOfficeLocationsOption[keyof typeof EmployerInterviewScheduleOfficeLocationsOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerInterviewScheduleOfficeLocationsOption = {
  All_LOCATIONS: 'All_LOCATIONS',
  SELECTED_LOCATIONS: 'SELECTED_LOCATIONS',
  UNSET: 'UNSET',
} as const;

export type EmployerInterviewSchedulePracticeAreasOption = typeof EmployerInterviewSchedulePracticeAreasOption[keyof typeof EmployerInterviewSchedulePracticeAreasOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerInterviewSchedulePracticeAreasOption = {
  SPECIFIED: 'SPECIFIED',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  UNSET: 'UNSET',
} as const;

export type EmployerInterviewScheduleRegistrationStatus = typeof EmployerInterviewScheduleRegistrationStatus[keyof typeof EmployerInterviewScheduleRegistrationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerInterviewScheduleRegistrationStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  READY_TO_SUBMIT: 'READY_TO_SUBMIT',
  SUBMITTED: 'SUBMITTED',
  IN_REVIEW: 'IN_REVIEW',
  APPROVED: 'APPROVED',
} as const;

export type EmployerInterviewScheduleSelectionSubmissionStatus = typeof EmployerInterviewScheduleSelectionSubmissionStatus[keyof typeof EmployerInterviewScheduleSelectionSubmissionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerInterviewScheduleSelectionSubmissionStatus = {
  SUBMITTED: 'SUBMITTED',
} as const;

export interface EmployerInterviewSchedule {
  active?: boolean;
  additionalScheduleInformation?: string;
  atscustomer?: boolean;
  contactIds?: number[];
  documentCollectEnabled?: boolean;
  employerEventId?: number;
  employerName?: string;
  employerOrgId?: number;
  employerOrgLogoUrl?: string;
  forwardTier?: ForwardTier;
  interviewLocation?: string;
  jobDescription?: string;
  jobId?: number;
  jobTitle?: string;
  officeLocations?: string[];
  officeLocationsOption?: EmployerInterviewScheduleOfficeLocationsOption;
  officeLocationsWithIds?: GenericIdNamePairResponse[];
  percent1L?: number;
  percent2L?: number;
  percent3L?: number;
  percentLLM?: number;
  percentPostGrad?: number;
  positionName?: string;
  practiceAreas?: string[];
  practiceAreasOption?: EmployerInterviewSchedulePracticeAreasOption;
  practiceAreasWithIds?: GenericIdNamePairResponse[];
  registrationStatus?: EmployerInterviewScheduleRegistrationStatus;
  scheduleId?: number;
  selectionSubmissionStatus?: EmployerInterviewScheduleSelectionSubmissionStatus;
  supportingDocuments?: SupportingDocumentResponse[];
  universityEventId?: number;
  universityOrgId?: number;
}

export interface EmployerInterviewScheduleInterviewerRequest {
  scheduleOptionId?: number;
  tbd?: boolean;
  userId?: number;
}

export interface EmployerInterviewScheduleInterviewerResponse {
  tbd?: boolean;
  userId?: number;
}

export interface EmployerInterviewScheduleQuestionAnswerRequest {
  dateValue?: string;
  numericValue?: number;
  orgQuestionOptionIdSelectValues?: number[];
  textValue?: string;
  universityOrgQuestionId?: number;
}

export interface EmployerInterviewScheduleQuestionAnswerResponse {
  dateValue?: string;
  numericValue?: number;
  orgQuestionOptionIdSelectValues?: number[];
  textValue?: string;
  universityOrgQuestionId?: number;
}

export type EmployerInterviewScheduleStatusResponseStatus = typeof EmployerInterviewScheduleStatusResponseStatus[keyof typeof EmployerInterviewScheduleStatusResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerInterviewScheduleStatusResponseStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  READY_TO_SUBMIT: 'READY_TO_SUBMIT',
  IN_REVIEW: 'IN_REVIEW',
  APPROVED: 'APPROVED',
  SUBMITTED: 'SUBMITTED',
} as const;

export interface EmployerInterviewScheduleStatusResponse {
  employerQuestionsSubmitted?: string;
  id?: number;
  interviewOptionsSubmitted?: string;
  interviewerDetailsSubmitted?: string;
  jobInformationSubmitted?: string;
  lastApprovedAt?: string;
  lastSectionUpdatedAt?: string;
  scheduleDetailsSubmitted?: string;
  status?: EmployerInterviewScheduleStatusResponseStatus;
}

export interface EmployerInterviewSchedulingOptionToggleRequest {
  enabled?: boolean;
}

export interface EmployerInterviewSchedulingSubmittedOptionsResponse {
  collectDocsFromStudents?: boolean;
  multipleInterviewsForStudentsEnabled?: boolean;
}

export interface EmployerQuestionOptionResponse {
  deleted?: boolean;
  label?: string;
  order?: number;
  orgQuestionOptionId?: number;
}

export interface EmployerRegistrationSettingsRequest {
  allowEmployerMultipleDatesChoice?: AllowEmployerMultipleDatesChoiceRequest;
  allowEmployerToSelectInterviewFormat?: boolean;
  allowEmployerToSelectMultipleTimeBlocks?: boolean;
  allowEmployerToSelectPreferredTime?: boolean;
  allowEmployersToCreateDocumentCollectJobs?: boolean;
  allowEmployersToProvideVideoLink?: boolean;
  allowEmployersToSelectPreferredInterviewLength?: boolean;
  provideVideoLinkEnabled?: boolean;
  selectPreferredInterviewLengthEnabled?: boolean;
  studentInterviewOptions?: boolean;
  supplyInterviewInformation?: boolean;
  supplyJobInformation?: boolean;
}

export interface EmployerRegistrationSettingsResponse {
  allowEmployerMultipleDatesChoice?: AllowEmployerMultipleDatesChoiceResponse;
  allowEmployerToSelectInterviewFormat?: boolean;
  allowEmployerToSelectMultipleTimeBlocks?: boolean;
  allowEmployerToSelectPreferredTime?: boolean;
  allowEmployersToCreateDocumentCollectJobs?: boolean;
  hasDocumentCollectJobsCreated?: boolean;
  provideVideoLinkEnabled?: boolean;
  selectPreferredInterviewLengthEnabled?: boolean;
  studentInterviewOptions?: boolean;
  supplyInterviewInformation?: boolean;
  supplyJobInformation?: boolean;
}

export interface EmployerScheduleDetailsRequest {
  allOfficeLocationsSelected?: boolean;
  documentCollectEnabled?: boolean;
  employerContactIds?: number[];
  officeLocations?: string[];
  practiceAreas?: string[];
  practiceAreasNotSpecified?: boolean;
  scheduleId?: number;
}

export type EmployerScheduleDetailsResponseAllOfficeLocationsSelected = typeof EmployerScheduleDetailsResponseAllOfficeLocationsSelected[keyof typeof EmployerScheduleDetailsResponseAllOfficeLocationsSelected];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerScheduleDetailsResponseAllOfficeLocationsSelected = {
  All_LOCATIONS: 'All_LOCATIONS',
  SELECTED_LOCATIONS: 'SELECTED_LOCATIONS',
  UNSET: 'UNSET',
} as const;

export type EmployerScheduleDetailsResponseApplicationReviewPeriod = typeof EmployerScheduleDetailsResponseApplicationReviewPeriod[keyof typeof EmployerScheduleDetailsResponseApplicationReviewPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerScheduleDetailsResponseApplicationReviewPeriod = {
  PRE_REVIEW: 'PRE_REVIEW',
  REVIEW: 'REVIEW',
  POST_DECISION: 'POST_DECISION',
  POST_FINAL_SCHEDULE: 'POST_FINAL_SCHEDULE',
} as const;

export type EmployerScheduleDetailsResponsePracticeAreasNotSpecified = typeof EmployerScheduleDetailsResponsePracticeAreasNotSpecified[keyof typeof EmployerScheduleDetailsResponsePracticeAreasNotSpecified];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerScheduleDetailsResponsePracticeAreasNotSpecified = {
  SPECIFIED: 'SPECIFIED',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  UNSET: 'UNSET',
} as const;

export type EmployerScheduleDetailsResponseSelectionSubmissionStatus = typeof EmployerScheduleDetailsResponseSelectionSubmissionStatus[keyof typeof EmployerScheduleDetailsResponseSelectionSubmissionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerScheduleDetailsResponseSelectionSubmissionStatus = {
  SUBMITTED: 'SUBMITTED',
} as const;

export interface EmployerScheduleDetailsResponse {
  allOfficeLocationsSelected?: EmployerScheduleDetailsResponseAllOfficeLocationsSelected;
  applicationReviewPeriod?: EmployerScheduleDetailsResponseApplicationReviewPeriod;
  dateStudentApplicationsAreVisible?: string;
  documentCollectEnabled?: boolean;
  employerContactIds?: number[];
  employerDecisionDeadline?: string;
  maximumNumberOfTimeslots?: number;
  officeLocations?: string[];
  practiceAreas?: string[];
  practiceAreasNotSpecified?: EmployerScheduleDetailsResponsePracticeAreasNotSpecified;
  scheduleId?: number;
  selectionSubmissionStatus?: EmployerScheduleDetailsResponseSelectionSubmissionStatus;
}

export type EmployerScheduleInterviewOptionsResponseInterviewFormat = typeof EmployerScheduleInterviewOptionsResponseInterviewFormat[keyof typeof EmployerScheduleInterviewOptionsResponseInterviewFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerScheduleInterviewOptionsResponseInterviewFormat = {
  PHYSICAL: 'PHYSICAL',
  VIRTUAL: 'VIRTUAL',
} as const;

export type EmployerScheduleInterviewOptionsResponsePreferredTimeblock = typeof EmployerScheduleInterviewOptionsResponsePreferredTimeblock[keyof typeof EmployerScheduleInterviewOptionsResponsePreferredTimeblock];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerScheduleInterviewOptionsResponsePreferredTimeblock = {
  FULL_DAY: 'FULL_DAY',
  HALF_DAY_MORNING: 'HALF_DAY_MORNING',
  HALF_DAY_AFTERNOON: 'HALF_DAY_AFTERNOON',
} as const;

export interface EmployerScheduleInterviewOptionsResponse {
  assignedToTimeblock?: boolean;
  employerInterviewScheduleOptionId?: number;
  employerInterviewers?: EmployerInterviewScheduleInterviewerResponse[];
  hasTimeslotsAssociated?: boolean;
  interviewFormat?: EmployerScheduleInterviewOptionsResponseInterviewFormat;
  preferredDates?: string[];
  preferredTimeblock?: EmployerScheduleInterviewOptionsResponsePreferredTimeblock;
}

export interface EmployerScheduleJobInformation {
  description?: string;
  documents?: EmployerScheduleJobInformationDocument[];
  percentage1L?: number;
  percentage2L?: number;
  percentage3L?: number;
  percentageLLM?: number;
  percentagePostGrad?: number;
  positionTypeIds?: number[];
  title?: string;
}

export interface EmployerScheduleJobInformationDocument {
  employerOrgDocId?: number;
  eventDocId?: number;
  id?: number;
  isDeleted?: boolean;
  isRequired?: boolean;
  universityOrgDocId?: number;
}

export type EmployerScheduleOverviewResponseAllOfficeLocationsSelected = typeof EmployerScheduleOverviewResponseAllOfficeLocationsSelected[keyof typeof EmployerScheduleOverviewResponseAllOfficeLocationsSelected];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerScheduleOverviewResponseAllOfficeLocationsSelected = {
  All_LOCATIONS: 'All_LOCATIONS',
  SELECTED_LOCATIONS: 'SELECTED_LOCATIONS',
  UNSET: 'UNSET',
} as const;

export type EmployerScheduleOverviewResponsePracticeAreasNotSpecified = typeof EmployerScheduleOverviewResponsePracticeAreasNotSpecified[keyof typeof EmployerScheduleOverviewResponsePracticeAreasNotSpecified];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerScheduleOverviewResponsePracticeAreasNotSpecified = {
  SPECIFIED: 'SPECIFIED',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  UNSET: 'UNSET',
} as const;

export type EmployerScheduleOverviewResponseSelectionSubmissionStatus = typeof EmployerScheduleOverviewResponseSelectionSubmissionStatus[keyof typeof EmployerScheduleOverviewResponseSelectionSubmissionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerScheduleOverviewResponseSelectionSubmissionStatus = {
  SUBMITTED: 'SUBMITTED',
} as const;

export interface EmployerScheduleOverviewResponse {
  allOfficeLocationsSelected?: EmployerScheduleOverviewResponseAllOfficeLocationsSelected;
  documentCollectEnabled?: boolean;
  employerContactIds?: number[];
  employerInterviewers?: EmployerInterviewScheduleInterviewerResponse[];
  hasInterviewOptionsThatAreAssigned?: boolean;
  numberOfMatches?: number;
  numberOfStudentApplications?: number;
  officeLocations?: string[];
  percentage1L?: number;
  percentage2L?: number;
  percentage3L?: number;
  percentageLLM?: number;
  percentagePostGrad?: number;
  practiceAreas?: string[];
  practiceAreasNotSpecified?: EmployerScheduleOverviewResponsePracticeAreasNotSpecified;
  scheduleId?: number;
  selectionSubmissionStatus?: EmployerScheduleOverviewResponseSelectionSubmissionStatus;
  title?: string;
}

export type EmployerScheduleUpdateInterviewOptionsRequestInterviewFormat = typeof EmployerScheduleUpdateInterviewOptionsRequestInterviewFormat[keyof typeof EmployerScheduleUpdateInterviewOptionsRequestInterviewFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerScheduleUpdateInterviewOptionsRequestInterviewFormat = {
  PHYSICAL: 'PHYSICAL',
  VIRTUAL: 'VIRTUAL',
} as const;

export type EmployerScheduleUpdateInterviewOptionsRequestPreferredTimeblock = typeof EmployerScheduleUpdateInterviewOptionsRequestPreferredTimeblock[keyof typeof EmployerScheduleUpdateInterviewOptionsRequestPreferredTimeblock];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmployerScheduleUpdateInterviewOptionsRequestPreferredTimeblock = {
  FULL_DAY: 'FULL_DAY',
  HALF_DAY_MORNING: 'HALF_DAY_MORNING',
  HALF_DAY_AFTERNOON: 'HALF_DAY_AFTERNOON',
} as const;

export interface EmployerScheduleUpdateInterviewOptionsRequest {
  interviewFormat?: EmployerScheduleUpdateInterviewOptionsRequestInterviewFormat;
  preferredDates?: string[];
  preferredTimeblock?: EmployerScheduleUpdateInterviewOptionsRequestPreferredTimeblock;
}

export interface EmployerSettingsRequest {
  eventId?: number;
  questions?: EmployerCustomQuestionRequest[];
  registrationSettings?: EmployerRegistrationSettingsRequest;
  supportingDocuments?: SupportingDocumentRequest[];
  universityRecruitmentPolicyEnabled?: boolean;
}

export interface EmploymentTypeResponse {
  id?: number;
  name?: string;
}

export interface EventCustomDocumentsCandidateFilterSegment {
  eventCustomDocId?: number;
  exists?: boolean;
}

export type EventDateRequestTimezone = typeof EventDateRequestTimezone[keyof typeof EventDateRequestTimezone];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventDateRequestTimezone = {
  'America/Los_Angeles': 'America/Los_Angeles',
  'America/Denver': 'America/Denver',
  'America/Chicago': 'America/Chicago',
  'America/New_York': 'America/New_York',
  'Europe/London': 'Europe/London',
  'Asia/Hong_Kong': 'Asia/Hong_Kong',
  'Asia/Tokyo': 'Asia/Tokyo',
  'Australia/Sydney': 'Australia/Sydney',
  'Australia/Perth': 'Australia/Perth',
  'Australia/Darwin': 'Australia/Darwin',
  'Australia/Brisbane': 'Australia/Brisbane',
  'Australia/Melbourne': 'Australia/Melbourne',
  'Australia/Adelaide': 'Australia/Adelaide',
  'Australia/Hobart': 'Australia/Hobart',
  'Australia/Broken_Hill': 'Australia/Broken_Hill',
  'Australia/Lord_Howe': 'Australia/Lord_Howe',
  'Australia/Eucla': 'Australia/Eucla',
  'Australia/Lindeman': 'Australia/Lindeman',
  'Australia/Currie': 'Australia/Currie',
} as const;

export interface EventDateRequest {
  date?: string;
  timezone?: EventDateRequestTimezone;
}

export type EventDateResponseTimezone = typeof EventDateResponseTimezone[keyof typeof EventDateResponseTimezone];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventDateResponseTimezone = {
  'America/Los_Angeles': 'America/Los_Angeles',
  'America/Denver': 'America/Denver',
  'America/Chicago': 'America/Chicago',
  'America/New_York': 'America/New_York',
  'Europe/London': 'Europe/London',
  'Asia/Hong_Kong': 'Asia/Hong_Kong',
  'Asia/Tokyo': 'Asia/Tokyo',
  'Australia/Sydney': 'Australia/Sydney',
  'Australia/Perth': 'Australia/Perth',
  'Australia/Darwin': 'Australia/Darwin',
  'Australia/Brisbane': 'Australia/Brisbane',
  'Australia/Melbourne': 'Australia/Melbourne',
  'Australia/Adelaide': 'Australia/Adelaide',
  'Australia/Hobart': 'Australia/Hobart',
  'Australia/Broken_Hill': 'Australia/Broken_Hill',
  'Australia/Lord_Howe': 'Australia/Lord_Howe',
  'Australia/Eucla': 'Australia/Eucla',
  'Australia/Lindeman': 'Australia/Lindeman',
  'Australia/Currie': 'Australia/Currie',
} as const;

export interface EventDateResponse {
  date?: string;
  timezone?: EventDateResponseTimezone;
}

export interface EventDetailsNonAdminResponse {
  deadline?: EventDateResponse;
  endDate?: EventDateResponse;
  eventDescription?: string;
  name?: string;
  registrationStartDate?: EventDateResponse;
  startDate?: EventDateResponse;
}

export interface EventDetailsRequest {
  employerEventDescription?: string;
  eventId?: number;
  eventOrganizerUserId?: number;
  eventType?: string;
  name?: string;
  orgTagIds?: number[];
  studentEventDescription?: string;
}

export interface EventDetailsResponse {
  employerEventDescription?: string;
  endDate?: EventDateResponse;
  eventOrganizerUserId?: number;
  name?: string;
  startDate?: EventDateResponse;
  studentEventDescription?: string;
  tags?: OrgTagDto[];
}

export interface EventEmail {
  bcc?: string;
  body?: string;
  cc?: string;
  enabled?: boolean;
  id?: number;
  replyTo?: string;
  subject?: string;
}

export type EventEmployerContactResponseStatus = typeof EventEmployerContactResponseStatus[keyof typeof EventEmployerContactResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventEmployerContactResponseStatus = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
} as const;

export interface EventEmployerContactResponse {
  dateEmailSent?: EventDateResponse;
  email?: string;
  employerId?: number;
  employerName?: string;
  firstName?: string;
  lastName?: string;
  status?: EventEmployerContactResponseStatus;
  userId?: number;
}

export interface EventErrorInfoResponse {
  anyWeirdnessPresent?: boolean;
  interviewersErrorInfo?: UserEventErrorInfo[];
  recruitsErrorInfo?: UserEventErrorInfo[];
  weirdInterviewerEmails?: string[];
  weirdInterviewerIds?: number[];
  weirdRecruitEmails?: string[];
  weirdRecruitIds?: number[];
}

export interface EventFeedback {
  eventId?: number;
  id?: number;
  orgFeedback?: OrgFeedback;
  orgFeedbackId?: number;
  required?: boolean;
  sortOrder?: number;
}

export type EventInterviewDateFilterSegmentCriteria = typeof EventInterviewDateFilterSegmentCriteria[keyof typeof EventInterviewDateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventInterviewDateFilterSegmentCriteria = {
  ON: 'ON',
  BEFORE: 'BEFORE',
  AFTER: 'AFTER',
  ON_OR_BEFORE: 'ON_OR_BEFORE',
  ON_OR_AFTER: 'ON_OR_AFTER',
} as const;

export interface EventInterviewDateFilterSegment {
  criteria?: EventInterviewDateFilterSegmentCriteria;
  value?: string;
}

export type EventInterviewerFilterSegmentCriteria = typeof EventInterviewerFilterSegmentCriteria[keyof typeof EventInterviewerFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventInterviewerFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface EventInterviewerFilterSegment {
  criteria?: EventInterviewerFilterSegmentCriteria;
  userIds?: number[];
}

export interface EventResumeCandidateFilterSegment {
  exists?: boolean;
}

export interface EventTimelineResponse {
  alternateStudentDecisionDeadlineStudent?: EventDateResponse;
  alternatesEnabled?: boolean;
  dateEmployerDecisionsAreVisibleStudent?: EventDateResponse;
  dateStudentApplicationsAreVisibleEmployer?: EventDateResponse;
  employerDecisionsDeadlineEmployer?: EventDateResponse;
  employerRegistrationDeadline?: EventDateResponse;
  employerRegistrationStartDate?: EventDateResponse;
  finalScheduleAvailabilityDateEmployer?: EventDateResponse;
  finalScheduleAvailabilityDateStudent?: EventDateResponse;
  invitedStudentDecisionDeadlineStudent?: EventDateResponse;
  maxNumberOfAlternatesPerSchedule?: number;
  maxNumberOfInterviews?: number;
  maxNumberOfStudentApplications?: number;
  studentApplicationDeadline?: EventDateResponse;
  studentApplicationStartDate?: EventDateResponse;
  studentReviewPeriodStartDate?: EventDateResponse;
}

export interface EventTranscriptCandidateFilterSegment {
  exists?: boolean;
}

export interface EventUniversityRecruitmentPolicyResponse {
  enabled?: boolean;
}

export type EventsCandidateFilterSegmentCriteria = typeof EventsCandidateFilterSegmentCriteria[keyof typeof EventsCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventsCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface EventsCandidateFilterSegment {
  criteria?: EventsCandidateFilterSegmentCriteria;
  eventIds?: number[];
}

export interface EventsDTO {
  acceptremailid?: number;
  autogenchatlinks?: number;
  calinviteuemailid?: number;
  candidatefinalscheduleemailtime?: number;
  candidatefinalscheduleremailid?: number;
  candidatereminderemailid?: number;
  candidatereminderemailtime?: number;
  checkinevent?: number;
  closeregistrationtime?: number;
  confirmremailid?: number;
  csvuploaded?: number;
  date?: string;
  description?: string;
  employeracceptdeadlinedate?: string;
  employeracceptdeadlinetime?: LocalTime;
  employeracceptdeadlinetimezone?: string;
  employerconfirmationuemailid?: number;
  employerdescription?: string;
  employerfinalscheduleemailreceiver?: number;
  employerfinalscheduleemailtime?: number;
  employerfinalscheduleuemailid?: number;
  employerregdeadlinedate?: string;
  employerregdeadlinetime?: LocalTime;
  employerregdeadlinetimezone?: string;
  employerregistrationextension?: string;
  employerschedulecreateemailtime?: number;
  employerschedulecreateuemailid?: number;
  enddate?: string;
  endtime?: LocalTime;
  endtimezone?: string;
  eventtype?: number;
  feedbackoff?: number;
  feedbackreminder?: string;
  finalscheduleuemailid?: number;
  followup?: number;
  followuptime?: number;
  hybrid?: string;
  id?: number;
  isuniv?: number;
  lastsaved?: string;
  link?: string;
  location?: string;
  maxemployers?: number;
  maxtimeslots?: number;
  multifeedback?: number;
  name?: string;
  oid?: number;
  owner?: number;
  registrationclosed?: number;
  rejectremailid?: number;
  remailid?: number;
  reqlinkedin?: number;
  resume?: number;
  resumeisvisiblemembers?: string;
  resumeuploadtype?: number;
  scheduleremailid?: number;
  sendfinalscheduletime?: number;
  shared?: number;
  starttime?: LocalTime;
  stilluploadingtimeslots?: number;
  studentacceptedregdeadlinedate?: string;
  studentacceptedregdeadlinetime?: LocalTime;
  studentacceptedregdeadlinetimezone?: string;
  studentdescription?: string;
  studentfinalscheduleemailtime?: number;
  studentfinalscheduleremailid?: number;
  studentregdeadlinedate?: string;
  studentregdeadlinetime?: LocalTime;
  studentregdeadlinetimezone?: string;
  studentregistrationconfirmationremailid?: number;
  submitted?: number;
  timeblockuemailid?: number;
  timeslotcapacity?: number;
  timeslotlen?: number;
  timezone?: string;
  transcript?: number;
  transcriptisvisiblemembers?: string;
  transcriptuploadtype?: number;
  university?: string;
  universityowned?: number;
  universityownedeid?: number;
  virtual?: number;
  virtuallink?: string;
}

export type EventsDateCandidateFilterSegmentCriteria = typeof EventsDateCandidateFilterSegmentCriteria[keyof typeof EventsDateCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventsDateCandidateFilterSegmentCriteria = {
  ON: 'ON',
  BEFORE: 'BEFORE',
  AFTER: 'AFTER',
  ON_OR_BEFORE: 'ON_OR_BEFORE',
  ON_OR_AFTER: 'ON_OR_AFTER',
} as const;

export interface EventsDateCandidateFilterSegment {
  criteria?: EventsDateCandidateFilterSegmentCriteria;
  date?: string;
}

export type EventsRegistrationDateCandidateFilterSegmentCriteria = typeof EventsRegistrationDateCandidateFilterSegmentCriteria[keyof typeof EventsRegistrationDateCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventsRegistrationDateCandidateFilterSegmentCriteria = {
  ON: 'ON',
  BEFORE: 'BEFORE',
  AFTER: 'AFTER',
  ON_OR_BEFORE: 'ON_OR_BEFORE',
  ON_OR_AFTER: 'ON_OR_AFTER',
} as const;

export interface EventsRegistrationDateCandidateFilterSegment {
  criteria?: EventsRegistrationDateCandidateFilterSegmentCriteria;
  date?: string;
}

export type EventsStatusCandidateFilterSegmentCandidateEventStatusesItem = typeof EventsStatusCandidateFilterSegmentCandidateEventStatusesItem[keyof typeof EventsStatusCandidateFilterSegmentCandidateEventStatusesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventsStatusCandidateFilterSegmentCandidateEventStatusesItem = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
  NUMBER_5: '5',
  NUMBER_6: '6',
} as const;

export type EventsStatusCandidateFilterSegmentCriteria = typeof EventsStatusCandidateFilterSegmentCriteria[keyof typeof EventsStatusCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventsStatusCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface EventsStatusCandidateFilterSegment {
  candidateEventStatuses?: EventsStatusCandidateFilterSegmentCandidateEventStatusesItem[];
  criteria?: EventsStatusCandidateFilterSegmentCriteria;
  eventId?: number;
}

export interface EventsUnauthAttendeeDTO {
  date?: string;
  description?: string;
  employerregdeadlinedate?: string;
  employerregdeadlinetime?: LocalTime;
  employerregdeadlinetimezone?: string;
  enddate?: string;
  endtime?: LocalTime;
  endtimezone?: string;
  id?: number;
  location?: string;
  name?: string;
  oid?: number;
  starttime?: LocalTime;
  studentregdeadlinedate?: string;
  studentregdeadlinetime?: LocalTime;
  studentregdeadlinetimezone?: string;
  timezone?: string;
}

export type ExportJobAppWorkdayRequestCombinationMethod = typeof ExportJobAppWorkdayRequestCombinationMethod[keyof typeof ExportJobAppWorkdayRequestCombinationMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportJobAppWorkdayRequestCombinationMethod = {
  ANY: 'ANY',
  ALL: 'ALL',
} as const;

export interface ExportJobAppWorkdayRequest {
  combinationMethod?: ExportJobAppWorkdayRequestCombinationMethod;
  jobStatusHistoricalFilterSegments?: JobStatusHistoricalFilterSegment[];
  recruitIds?: number[];
  userTimeZone: string;
}

export interface ExternalJobImportUploadCsvApiKeyResponse {
  batchId?: string;
}

export interface ExternalJobImportUploadCsvSuperAdminResponse {
  batchId?: string;
}

export interface FirmProfileViewLimitResponse {
  aboveLimit?: boolean;
}

export interface ForwardActivateAccountResponse {
  redirectUrl?: string;
  success?: boolean;
}

export interface ForwardEventCreationResponse {
  success?: boolean;
}

export interface ForwardSignInRequest {
  accountSource?: string;
  email?: string;
  encodedRedirectUrl?: string;
}

export interface ForwardSignInResponse {
  emailSent?: boolean;
  hasAccount?: boolean;
  knownEmail?: boolean;
}

export interface ForwardSignUpRequest {
  email?: string;
  encodedRedirectUrl?: string;
}

export interface ForwardSignUpResponse {
  emailSent?: boolean;
  hasAccount?: boolean;
  knownEmail?: boolean;
}

export type ForwardTierAsEnum = typeof ForwardTierAsEnum[keyof typeof ForwardTierAsEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ForwardTierAsEnum = {
  STANDARD: 'STANDARD',
  PREMIUM: 'PREMIUM',
  SPOTLIGHT: 'SPOTLIGHT',
} as const;

export interface ForwardTier {
  asEnum?: ForwardTierAsEnum;
  id?: number;
  name?: string;
  order?: number;
}

export interface FullRecruit {
  adminNotes?: FullRecruitAdminNote[];
  candidateEvaluations?: FullRecruitCandidateEvaluation[];
  customDocuments?: FullRecruitCustomDocument[];
  email?: string;
  events?: FullRecruitEventAttendance[];
  firstName?: string;
  hometown?: string;
  image?: string;
  internalFieldCandidateProfileAnswers?: FullRecruitInternalFieldAnswer[];
  internalFieldJobApplicationAnswers?: FullRecruitInternalFieldAnswer[];
  jobApplications?: FullRecruitJobApplication[];
  lastName?: string;
  linkedInProfile?: string;
  phoneNumber?: string;
  qualifyingQuestionAnswers?: FullRecruitQualifyingQuestionAnswer[];
  recruitId?: number;
  selfIdAnswers?: FullRecruitSelfIdAnswer[];
}

export interface FullRecruitAdminNote {
  createdAt?: string;
  createdBy?: string;
  id?: number;
  note?: string;
  time?: string;
  updatedAt?: string;
  updatedBy?: string;
  userId?: number;
}

export interface FullRecruitCandidateEvaluation {
  candidateEvalId?: number;
  eventId?: number;
  recruitId?: number;
}

export type FullRecruitCustomDocumentDocumentType = typeof FullRecruitCustomDocumentDocumentType[keyof typeof FullRecruitCustomDocumentDocumentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullRecruitCustomDocumentDocumentType = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
} as const;

export interface FullRecruitCustomDocument {
  createdAt?: string;
  documentType?: FullRecruitCustomDocumentDocumentType;
  orgCustomDocumentId?: number;
  recruitCustomDocumentId?: number;
  s3Location?: string;
  updatedAt?: string;
  uploadDate?: string;
}

export interface FullRecruitEventAttendance {
  accepted?: number;
  checkin?: number;
  eventId?: number;
  eventRecruitTimeslots?: FullRecruitEventRecruitTimeslot[];
  extension?: string;
  preregister?: number;
  rattendeeId?: number;
  time?: string;
  timeslotHoldIds?: number[];
  virtualCallbackHoldIds?: number[];
}

export interface FullRecruitEventRecruitTimeslot {
  eventUserTimeslotId?: number;
  id?: number;
  recruitId?: number;
}

export type FullRecruitInternalFieldAnswerType = typeof FullRecruitInternalFieldAnswerType[keyof typeof FullRecruitInternalFieldAnswerType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullRecruitInternalFieldAnswerType = {
  FREE_TEXT: 'FREE_TEXT',
  DATE: 'DATE',
  NUMERICAL: 'NUMERICAL',
  MONETARY: 'MONETARY',
  SINGLE_SELECT: 'SINGLE_SELECT',
  MULTI_SELECT: 'MULTI_SELECT',
  BOOLEAN: 'BOOLEAN',
} as const;

export interface FullRecruitInternalFieldAnswer {
  answerId?: number;
  createdAt?: string;
  jobApplicationId?: number;
  questionId?: number;
  type?: FullRecruitInternalFieldAnswerType;
  updatedAt?: string;
  values?: string[];
}

export type FullRecruitJobApplicationAppSource = typeof FullRecruitJobApplicationAppSource[keyof typeof FullRecruitJobApplicationAppSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullRecruitJobApplicationAppSource = {
  UNDEFINED: 'UNDEFINED',
  AGENCY: 'AGENCY',
  EMAIL_SUBMISSION: 'EMAIL_SUBMISSION',
  EMPLOYEE_REFERRAL: 'EMPLOYEE_REFERRAL',
  INTERNAL_HIRE: 'INTERNAL_HIRE',
  JOB_FAIR: 'JOB_FAIR',
  OCI: 'OCI',
  OTHER: 'OTHER',
  RESUME_COLLECT: 'RESUME_COLLECT',
  PREVIOUS_SUMMER_ASSOCIATE: 'PREVIOUS_SUMMER_ASSOCIATE',
  WRITE_IN: 'WRITE_IN',
  FORWARD: 'FORWARD',
  ADVERTISEMENT_OR_JOB_BOARD: 'ADVERTISEMENT_OR_JOB_BOARD',
  AUTOMATIC_CALLBACK: 'AUTOMATIC_CALLBACK',
  CONSORTIUM: 'CONSORTIUM',
  RECRUITING_EVENT: 'RECRUITING_EVENT',
  REFERRAL: 'REFERRAL',
  PRE_OCI: 'PRE_OCI',
  PREDICTIVE_TOOL: 'PREDICTIVE_TOOL',
  DIRECT_OUTREACH: 'DIRECT_OUTREACH',
} as const;

export type FullRecruitJobApplicationCreationType = typeof FullRecruitJobApplicationCreationType[keyof typeof FullRecruitJobApplicationCreationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullRecruitJobApplicationCreationType = {
  UNDEFINED: 'UNDEFINED',
  MANUAL: 'MANUAL',
  SELF_APPLY: 'SELF_APPLY',
  AGENCY_APPLY: 'AGENCY_APPLY',
  FORWARD: 'FORWARD',
} as const;

export interface FullRecruitJobApplication {
  addressLine1?: string;
  addressLine2?: string;
  agencyContactId?: number;
  appSource?: FullRecruitJobApplicationAppSource;
  city?: string;
  complete?: boolean;
  country?: string;
  createdAt?: string;
  createdBy?: string;
  creationType?: FullRecruitJobApplicationCreationType;
  customQuestionAnswers?: FullRecruitJobApplicationCustomQuestionAnswer[];
  documents?: FullRecruitJobApplicationDocument[];
  educationHistory?: FullRecruitJobApplicationEducationHistory[];
  jobApplicationId?: number;
  jobId?: number;
  jobPipelineStatusId?: number;
  offerAffirmationDate?: string;
  offerDate?: string;
  offerExpirationDate?: string;
  selfIdAnswers?: FullRecruitJobApplicationSelfIdAnswer[];
  state?: string;
  statusLog?: FullRecruitJobApplicationStatusLogEntry[];
  updatedAt?: string;
  updatedBy?: string;
  workHistory?: FullRecruitJobApplicationWorkHistory[];
  zip?: string;
}

export interface FullRecruitJobApplicationCustomQuestionAnswer {
  createdAt?: string;
  createdBy?: string;
  dateValue?: string;
  numericValue?: number;
  orgQuestionId?: number;
  selections?: FullRecruitJobApplicationCustomQuestionAnswerSelection[];
  textValue?: string;
  updatedAt?: string;
  updatedBy?: string;
}

export interface FullRecruitJobApplicationCustomQuestionAnswerSelection {
  createdAt?: string;
  createdBy?: string;
  orgQuestionOptionId?: number;
  updatedAt?: string;
  updatedBy?: string;
}

export interface FullRecruitJobApplicationDocument {
  createdAt?: string;
  jobAppDocumentId?: number;
  jobAppId?: number;
  orgCustomDocumentId?: number;
  s3Location?: string;
  updatedAt?: string;
  uploadDate?: string;
  userFileName?: string;
}

export type FullRecruitJobApplicationEducationHistoryDegree = typeof FullRecruitJobApplicationEducationHistoryDegree[keyof typeof FullRecruitJobApplicationEducationHistoryDegree];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullRecruitJobApplicationEducationHistoryDegree = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
  NUMBER_5: '5',
  NUMBER_6: '6',
  NUMBER_7: '7',
  NUMBER_8: '8',
  NUMBER_9: '9',
  NUMBER_10: '10',
  NUMBER_11: '11',
  NUMBER_12: '12',
  NUMBER_13: '13',
  NUMBER_14: '14',
  NUMBER_15: '15',
  NUMBER_16: '16',
  NUMBER_17: '17',
  NUMBER_18: '18',
  NUMBER_19: '19',
  NUMBER_20: '20',
  NUMBER_21: '21',
  NUMBER_22: '22',
  NUMBER_23: '23',
  NUMBER_24: '24',
  NUMBER_25: '25',
  NUMBER_26: '26',
} as const;

export interface FullRecruitJobApplicationEducationHistory {
  createdAt?: string;
  createdBy?: string;
  degree?: FullRecruitJobApplicationEducationHistoryDegree;
  endDate?: string;
  university?: string;
  updatedAt?: string;
  updatedBy?: string;
}

export interface FullRecruitJobApplicationSelfIdAnswer {
  createdAt?: string;
  createdBy?: string;
  id?: number;
  lastUpdated?: string;
  orgSelfIdQuestionId?: number;
  selections?: FullRecruitJobApplicationSelfIdAnswerSelection[];
  text?: string;
  updatedAt?: string;
  updatedBy?: string;
}

export interface FullRecruitJobApplicationSelfIdAnswerSelection {
  createdAt?: string;
  createdBy?: string;
  orgSelfIdQuestionOptionId?: number;
  updatedAt?: string;
  updatedBy?: string;
}

export interface FullRecruitJobApplicationStatusLogEntry {
  createdAt?: string;
  jobPipelineStatusId?: number;
}

export interface FullRecruitJobApplicationWorkHistory {
  createdAt?: string;
  createdBy?: string;
  currentEmployer?: boolean;
  employer?: string;
  endDate?: string;
  position?: string;
  startDate?: string;
  updatedAt?: string;
  updatedBy?: string;
}

export type FullRecruitQualifyingQuestionAnswerType = typeof FullRecruitQualifyingQuestionAnswerType[keyof typeof FullRecruitQualifyingQuestionAnswerType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullRecruitQualifyingQuestionAnswerType = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
} as const;

export interface FullRecruitQualifyingQuestionAnswer {
  answer?: string;
  id?: number;
  qqId?: number;
  type?: FullRecruitQualifyingQuestionAnswerType;
  updatedAt?: string;
}

export type FullRecruitSelfIdAnswerQuestionType = typeof FullRecruitSelfIdAnswerQuestionType[keyof typeof FullRecruitSelfIdAnswerQuestionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullRecruitSelfIdAnswerQuestionType = {
  SINGLE_SELECT: 'SINGLE_SELECT',
  MULTI_SELECT: 'MULTI_SELECT',
  FREE_TEXT: 'FREE_TEXT',
} as const;

export type FullRecruitSelfIdAnswerSelfIdType = typeof FullRecruitSelfIdAnswerSelfIdType[keyof typeof FullRecruitSelfIdAnswerSelfIdType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullRecruitSelfIdAnswerSelfIdType = {
  GENDER_ID: 'GENDER_ID',
  VETERAN_STATUS: 'VETERAN_STATUS',
  ETHNICITY_ID: 'ETHNICITY_ID',
  DISABILITY_STATUS: 'DISABILITY_STATUS',
  SEXUAL_ORIENTATION: 'SEXUAL_ORIENTATION',
  DESCRIPTION: 'DESCRIPTION',
  CUSTOM_QUESTION: 'CUSTOM_QUESTION',
  GOV_OPT_OUT_1: 'GOV_OPT_OUT_1',
  GOV_DEMOGRAPHIC_1: 'GOV_DEMOGRAPHIC_1',
  GOV_DEMOGRAPHIC_2: 'GOV_DEMOGRAPHIC_2',
  GOV_DEMOGRAPHIC_3: 'GOV_DEMOGRAPHIC_3',
  GOV_DEMOGRAPHIC_3_1: 'GOV_DEMOGRAPHIC_3_1',
  GOV_DEMOGRAPHIC_3_2: 'GOV_DEMOGRAPHIC_3_2',
  GOV_VETERAN_1: 'GOV_VETERAN_1',
  GOV_DISABILITY_1: 'GOV_DISABILITY_1',
  GOV_DISABILITY_2: 'GOV_DISABILITY_2',
  GOV_DISABILITY_3: 'GOV_DISABILITY_3',
  GOV_DISABILITY_4: 'GOV_DISABILITY_4',
  NALP_ADDITIONAL: 'NALP_ADDITIONAL',
} as const;

export interface FullRecruitSelfIdAnswer {
  answerId?: number;
  createdAt?: string;
  createdBy?: string;
  lastModified?: string;
  orgSelfIdQuestionId?: number;
  orgSelfIdQuestionSelectionIds?: number[];
  questionType?: FullRecruitSelfIdAnswerQuestionType;
  selfIdType?: FullRecruitSelfIdAnswerSelfIdType;
  text?: string;
  updatedAt?: string;
  updatedBy?: string;
}

export interface GenericIdNamePairResponse {
  id?: number;
  name?: string;
}

export interface GenericResponse {
  success?: boolean;
}

export interface GetAdminUsersResponse {
  adminUsers?: UsersDTO[];
  success?: boolean;
}

export interface GetAllAttendees {
  employers?: UsersDTO[];
  students?: SerendipitousEventsRecruitsDTO[];
}

export interface GetAllAttendeesAsStudent {
  employers?: UsersDTO[];
  students?: RecruitsDTO[];
}

export interface GetAttendeeDetailsResponse {
  attendees?: AttendeeDTO[];
}

export interface GetEmployerDetailsResponse {
  description?: string;
  industry?: string;
  name?: string;
}

export interface GetEmployerUsersResponse {
  employerUsers?: UsersDTO[];
  success?: boolean;
}

export interface GetEventDetailsForEmployerResponse {
  event?: EventsUnauthAttendeeDTO;
  logoURL?: string;
  orgName?: string;
  receiveConfirmationEmail?: boolean;
}

export interface GetEventDetailsForStudentResponse {
  event?: EventsUnauthAttendeeDTO;
  eventDocExist?: boolean;
  logoURL?: string;
  orgName?: string;
  receiveConfirmationEmail?: boolean;
}

export type GetNetworkingEventAllAttendeesAllRoomsAllEmployersAllRooms = {[key: string]: number[]};

export type GetNetworkingEventAllAttendeesAllRoomsAllStudentsAllRooms = {[key: string]: number[]};

export interface GetNetworkingEventAllAttendeesAllRooms {
  allEmployersAllRooms?: GetNetworkingEventAllAttendeesAllRoomsAllEmployersAllRooms;
  allStudentsAllRooms?: GetNetworkingEventAllAttendeesAllRoomsAllStudentsAllRooms;
  event?: EventsUnauthAttendeeDTO;
  networkingTimeslots?: NetworkingTimeslotDTO[];
}

export type GetNetworkingEventResponseMapRidToTimeslotId = {[key: string]: number};

export type GetNetworkingEventResponseMapUidToTimeslotId = {[key: string]: number};

export interface GetNetworkingEventResponse {
  candidatereminderemail?: EmailsDTO;
  eid?: number;
  employerRegistrationLink?: string;
  employerconfirmationuemail?: EmailsDTO;
  employerschedulecreateuemail?: EmailsDTO;
  event?: EventsDTO;
  eventcustomdocuments?: RequestDocument[];
  mapRidToTimeslotId?: GetNetworkingEventResponseMapRidToTimeslotId;
  mapUidToTimeslotId?: GetNetworkingEventResponseMapUidToTimeslotId;
  networkingTimeslots?: NetworkingTimeslotDTO[];
  networkingWebinarDTO?: NetworkingWebinarDTO;
  speakerRids?: number[];
  speakerUids?: number[];
  studentRegistrationLink?: string;
  studentregistrationconfirmationremail?: EmailsDTO;
  success?: boolean;
  webinarDuration?: number;
  webinarEnabled?: boolean;
}

export type GetNetworkingEventResponseForAttendeeMapRidToTimeslotId = {[key: string]: number};

export type GetNetworkingEventResponseForAttendeeMapUidToTimeslotId = {[key: string]: number};

export interface GetNetworkingEventResponseForAttendee {
  event?: EventsUnauthAttendeeDTO;
  eventcustomdocuments?: RequestDocument[];
  mapRidToTimeslotId?: GetNetworkingEventResponseForAttendeeMapRidToTimeslotId;
  mapUidToTimeslotId?: GetNetworkingEventResponseForAttendeeMapUidToTimeslotId;
  networkingTimeslots?: NetworkingTimeslotDTO[];
  networkingWebinarDTO?: NetworkingWebinarDTO;
  speaker?: boolean;
  timeslotId?: number;
}

export interface GetStudentDocumentsResponse {
  documentName?: string;
  fileDate?: string;
  fileLocation?: string;
  orgDocId?: number;
  recruitId?: number;
}

export interface GetStudentsResponse {
  students?: RecruitsDTO[];
  success?: boolean;
}

export interface GetUniversityEmployersResponse {
  employerUsers?: UsersDTO[];
  employers?: UniversityEmployerDTO[];
}

export interface GetUserDetailsResponse {
  email?: string;
  fname?: string;
  id?: number;
  lname?: string;
}

export interface HistoricalCandidateDocumentUploadRequest {
  data?: Blob;
  name?: string;
}

export interface HistoricalCandidateUploadRequest {
  email?: string;
  firstName?: string;
  lastName?: string;
  rows?: string[];
}

export interface InternalFieldAnswer {
  createdAt?: string;
  hasAnswer?: boolean;
  id?: number;
  orgId?: number;
  questionId?: number;
  recruitId?: number;
  updatedAt?: string;
  values?: string[];
}

export type InternalFieldAnswerSelectionCandidateFilterSegmentCriteria = typeof InternalFieldAnswerSelectionCandidateFilterSegmentCriteria[keyof typeof InternalFieldAnswerSelectionCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalFieldAnswerSelectionCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface InternalFieldAnswerSelectionCandidateFilterSegment {
  answers?: string[];
  criteria?: InternalFieldAnswerSelectionCandidateFilterSegmentCriteria;
  internalFieldCustomQuestionId?: number;
}

export type InternalFieldDateCandidateFilterSegmentCriteria = typeof InternalFieldDateCandidateFilterSegmentCriteria[keyof typeof InternalFieldDateCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalFieldDateCandidateFilterSegmentCriteria = {
  ON: 'ON',
  BEFORE: 'BEFORE',
  AFTER: 'AFTER',
  ON_OR_BEFORE: 'ON_OR_BEFORE',
  ON_OR_AFTER: 'ON_OR_AFTER',
} as const;

export interface InternalFieldDateCandidateFilterSegment {
  criteria?: InternalFieldDateCandidateFilterSegmentCriteria;
  internalFieldCustomQuestionId?: number;
  value?: string;
}

export type InternalFieldFreeTextCandidateFilterSegmentCriteria = typeof InternalFieldFreeTextCandidateFilterSegmentCriteria[keyof typeof InternalFieldFreeTextCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalFieldFreeTextCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  NOT_CONTAINS: 'NOT_CONTAINS',
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
  STARTS_WITH: 'STARTS_WITH',
} as const;

export interface InternalFieldFreeTextCandidateFilterSegment {
  criteria?: InternalFieldFreeTextCandidateFilterSegmentCriteria;
  internalFieldCustomQuestionId?: number;
  value?: string;
}

export type InternalFieldNumericalCandidateFilterSegmentCriteria = typeof InternalFieldNumericalCandidateFilterSegmentCriteria[keyof typeof InternalFieldNumericalCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalFieldNumericalCandidateFilterSegmentCriteria = {
  GREATER_THAN: 'GREATER_THAN',
  LESS_THAN: 'LESS_THAN',
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL',
} as const;

export interface InternalFieldNumericalCandidateFilterSegment {
  criteria?: InternalFieldNumericalCandidateFilterSegmentCriteria;
  internalFieldCustomQuestionId?: number;
  value?: number;
}

export interface InterviewManagementCandidatePacketInformation {
  classYear?: string;
  documents?: InterviewPacketDocumentInformation[];
  email?: string;
  firstName?: string;
  graduationYear?: string;
  interviewEndTime?: string;
  interviewStartTime?: string;
  lastName?: string;
  officeLocationPreferences?: string[];
  practiceAreaPreferences?: string[];
  school?: string;
}

export interface InterviewManagementEmployerPacketRequest {
  emailRecipients: string[];
  jobApplicationIds?: number[];
  keyDocuments?: InterviewManagementPacketKeyDocumentsRequest;
  packetSettings?: InterviewManagementPacketSettingsRequest;
  recruitIds?: number[];
  studentDocuments?: InterviewManagementPacketStudentDocumentsRequest;
}

export interface InterviewManagementInterviewerScheduleInformation {
  employerName?: string;
  firstName?: string;
  interviewInformation?: InterviewerTimeBlockPacketInformation[];
  lastName?: string;
}

export interface InterviewManagementJobInterviewPacketMessage {
  emailRecipients?: string[];
  jobPacketMetadata?: InterviewManagementJobPacketMetadata;
  keyDocuments?: InterviewManagementPacketKeyDocuments;
  packetSettings?: InterviewPacketSettings;
}

export interface InterviewManagementJobPacketMetadata {
  destinationFileLocation?: string;
  destinationFileName?: string;
  jobTitle?: string;
  orgFriendlyName?: string;
  orgLogoUrl?: string;
  orgName?: string;
}

export interface InterviewManagementPacketCandidateDocuments {
  candidateInformation?: InterviewManagementCandidatePacketInformation[];
  sectionEnabled?: boolean;
}

export interface InterviewManagementPacketKeyDocuments {
  candidateDocuments?: InterviewManagementPacketCandidateDocuments;
  coverPagedEnabled?: boolean;
  interviewerSchedules?: InterviewManagementInterviewerScheduleInformation[];
  sectionEnabled?: boolean;
  tableOfContentsEnabled?: boolean;
}

export interface InterviewManagementPacketKeyDocumentsRequest {
  coverPagedEnabled?: boolean;
  interviewerScheduleEnabled?: boolean;
  sectionEnabled?: boolean;
  tableOfContentsEnabled?: boolean;
}

export type InterviewManagementPacketSettingsRequestTimezone = typeof InterviewManagementPacketSettingsRequestTimezone[keyof typeof InterviewManagementPacketSettingsRequestTimezone];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewManagementPacketSettingsRequestTimezone = {
  'America/Los_Angeles': 'America/Los_Angeles',
  'America/Denver': 'America/Denver',
  'America/Chicago': 'America/Chicago',
  'America/New_York': 'America/New_York',
  'Europe/London': 'Europe/London',
  'Asia/Hong_Kong': 'Asia/Hong_Kong',
  'Asia/Tokyo': 'Asia/Tokyo',
  'Australia/Sydney': 'Australia/Sydney',
  'Australia/Perth': 'Australia/Perth',
  'Australia/Darwin': 'Australia/Darwin',
  'Australia/Brisbane': 'Australia/Brisbane',
  'Australia/Melbourne': 'Australia/Melbourne',
  'Australia/Adelaide': 'Australia/Adelaide',
  'Australia/Hobart': 'Australia/Hobart',
  'Australia/Broken_Hill': 'Australia/Broken_Hill',
  'Australia/Lord_Howe': 'Australia/Lord_Howe',
  'Australia/Eucla': 'Australia/Eucla',
  'Australia/Lindeman': 'Australia/Lindeman',
  'Australia/Currie': 'Australia/Currie',
} as const;

export interface InterviewManagementPacketSettingsRequest {
  /**
   * @minLength 0
   * @maxLength 100
   */
  subtitle?: string;
  timezone: InterviewManagementPacketSettingsRequestTimezone;
  /**
   * @minLength 1
   * @maxLength 75
   */
  title: string;
}

export interface InterviewManagementPacketStudentDocumentRequest {
  order?: number;
  supportingDocumentId?: number;
}

export type InterviewManagementPacketStudentDocumentsRequestSortOption = typeof InterviewManagementPacketStudentDocumentsRequestSortOption[keyof typeof InterviewManagementPacketStudentDocumentsRequestSortOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewManagementPacketStudentDocumentsRequestSortOption = {
  BY_SCHEDULE: 'BY_SCHEDULE',
  BY_STUDENT_LAST_NAME: 'BY_STUDENT_LAST_NAME',
  BY_INTERVIEWER_LAST_NAME: 'BY_INTERVIEWER_LAST_NAME',
} as const;

export interface InterviewManagementPacketStudentDocumentsRequest {
  documents?: InterviewManagementPacketStudentDocumentRequest[];
  enabled?: boolean;
  sortOption?: InterviewManagementPacketStudentDocumentsRequestSortOption;
}

export interface InterviewPacketDocumentInformation {
  documentLocation?: string;
  documentName?: string;
  documentOrder?: number;
}

export interface InterviewPacketSettings {
  subtitle?: string;
  title?: string;
}

export interface InterviewSchedulingAddContactsRequest {
  sendRegistrationEmail?: boolean;
  userIds?: number[];
}

export type InterviewSchedulingBlockRequestBreakBetween = typeof InterviewSchedulingBlockRequestBreakBetween[keyof typeof InterviewSchedulingBlockRequestBreakBetween];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingBlockRequestBreakBetween = {
  NONE: 'NONE',
  BETWEEN_EVERY: 'BETWEEN_EVERY',
  BETWEEN_EVERY_OTHER: 'BETWEEN_EVERY_OTHER',
  AFTER_1: 'AFTER_1',
  AFTER_2: 'AFTER_2',
  AFTER_3: 'AFTER_3',
} as const;

export interface InterviewSchedulingBlockRequest {
  breakBetween: InterviewSchedulingBlockRequestBreakBetween;
  breakLength?: number;
  customBreaks: InterviewSchedulingCustomBreakRequest[];
  date: string;
  endTime: LocalTime;
  id?: number;
  interviewLength: number;
  startTime: LocalTime;
  timezone: string;
}

export type InterviewSchedulingBlockResponseBreakBetween = typeof InterviewSchedulingBlockResponseBreakBetween[keyof typeof InterviewSchedulingBlockResponseBreakBetween];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingBlockResponseBreakBetween = {
  NONE: 'NONE',
  BETWEEN_EVERY: 'BETWEEN_EVERY',
  BETWEEN_EVERY_OTHER: 'BETWEEN_EVERY_OTHER',
  AFTER_1: 'AFTER_1',
  AFTER_2: 'AFTER_2',
  AFTER_3: 'AFTER_3',
} as const;

export interface InterviewSchedulingBlockResponse {
  actualEndTime?: LocalTime;
  breakBetween?: InterviewSchedulingBlockResponseBreakBetween;
  breakLengthMinutes?: number;
  customBreaks?: InterviewSchedulingCustomBreakResponse[];
  date?: string;
  endTime?: LocalTime;
  id?: number;
  interviewLengthMinutes?: number;
  numberOfInterviews?: number;
  startTime?: LocalTime;
  timezone?: string;
}

export interface InterviewSchedulingBulkExportEventJobApplicationDocumentsForInterviewerRequest {
  jobApplicationIds?: number[];
}

export interface InterviewSchedulingBulkExportStudentJobApplicationDocumentsRequest {
  candidateIds?: number[];
}

export type InterviewSchedulingCreateEmployerSchedulesRequestAllOfficeLocations = typeof InterviewSchedulingCreateEmployerSchedulesRequestAllOfficeLocations[keyof typeof InterviewSchedulingCreateEmployerSchedulesRequestAllOfficeLocations];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingCreateEmployerSchedulesRequestAllOfficeLocations = {
  All_LOCATIONS: 'All_LOCATIONS',
  SELECTED_LOCATIONS: 'SELECTED_LOCATIONS',
  UNSET: 'UNSET',
} as const;

export type InterviewSchedulingCreateEmployerSchedulesRequestDocumentCollectOnly = typeof InterviewSchedulingCreateEmployerSchedulesRequestDocumentCollectOnly[keyof typeof InterviewSchedulingCreateEmployerSchedulesRequestDocumentCollectOnly];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingCreateEmployerSchedulesRequestDocumentCollectOnly = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
} as const;

export type InterviewSchedulingCreateEmployerSchedulesRequestPracticeAreasSpecified = typeof InterviewSchedulingCreateEmployerSchedulesRequestPracticeAreasSpecified[keyof typeof InterviewSchedulingCreateEmployerSchedulesRequestPracticeAreasSpecified];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingCreateEmployerSchedulesRequestPracticeAreasSpecified = {
  SPECIFIED: 'SPECIFIED',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  UNSET: 'UNSET',
} as const;

export type InterviewSchedulingCreateEmployerSchedulesRequestScheduleType = typeof InterviewSchedulingCreateEmployerSchedulesRequestScheduleType[keyof typeof InterviewSchedulingCreateEmployerSchedulesRequestScheduleType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingCreateEmployerSchedulesRequestScheduleType = {
  FULL_DAY: 'FULL_DAY',
  HALF_DAY_MORNING: 'HALF_DAY_MORNING',
  HALF_DAY_AFTERNOON: 'HALF_DAY_AFTERNOON',
} as const;

export interface InterviewSchedulingCreateEmployerSchedulesRequest {
  allOfficeLocations?: InterviewSchedulingCreateEmployerSchedulesRequestAllOfficeLocations;
  documentCollectOnly?: InterviewSchedulingCreateEmployerSchedulesRequestDocumentCollectOnly;
  firstDateChoice?: string;
  name?: string;
  numberOfSchedules?: number;
  numberOfSchedulesToCreate?: number;
  officeLocations?: string[];
  practiceAreas?: string[];
  practiceAreasSpecified?: InterviewSchedulingCreateEmployerSchedulesRequestPracticeAreasSpecified;
  preferredDate?: string;
  scheduleType?: InterviewSchedulingCreateEmployerSchedulesRequestScheduleType;
  secondDateChoice?: string;
  thirdDateChoice?: string;
}

export interface InterviewSchedulingCreateEmployerSchedulesResponse {
  scheduleIds?: number[];
}

export interface InterviewSchedulingCustomBreakRequest {
  breakPosition?: number;
  lengthMinutes?: number;
}

export interface InterviewSchedulingCustomBreakResponse {
  breakPosition?: number;
  lengthMinutes?: number;
  startTime?: LocalTime;
}

export interface InterviewSchedulingDefaultEmailsResponse {
  employerFinalScheduleEmail?: EmailDefaults;
  employerInterviewerInformationRequestEmail?: EmailDefaults;
  employerLotteryScheduleRegistrationSubmittedEmail?: EmailDefaults;
  employerRegistrationEmail?: EmailDefaults;
  employerRegistrationReminderEmail?: EmailDefaults;
  employerScheduleAssignmentEmail?: EmailDefaults;
  employerScheduleRegistrationSubmittedEmail?: EmailDefaults;
  employerStudentApplicationsAreAvailableEmail?: EmailDefaults;
  eventOrganizerEmail?: string;
  studentAlternatePeriodHasStartedEmail?: EmailDefaults;
  studentApplicationDeadlineReminderEmail?: EmailDefaults;
  studentBiddingPeriodHasStartedEmail?: EmailDefaults;
  studentCancellationPeriodHasStartedEmail?: EmailDefaults;
  studentEmployerDecisionsAreAvailableEmail?: EmailDefaults;
  studentFinalScheduleEmail?: EmailDefaults;
  studentLotteryMatchReviewHasStartedEmail?: EmailDefaults;
  studentLotteryYourEventPageEmail?: EmailDefaults;
  studentOptInPeriodHasStartedEmail?: EmailDefaults;
  studentSelfSchedulePeriodHasStartedEmail?: EmailDefaults;
  studentYourEventPageEmail?: EmailDefaults;
}

export interface InterviewSchedulingDeleteEmployerSchedulesRequest {
  scheduleIds?: number[];
}

export type InterviewSchedulingEmailsRequestEmployerFinalScheduleRecipientOption = typeof InterviewSchedulingEmailsRequestEmployerFinalScheduleRecipientOption[keyof typeof InterviewSchedulingEmailsRequestEmployerFinalScheduleRecipientOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmailsRequestEmployerFinalScheduleRecipientOption = {
  EMPLOYER_CONTACT: 'EMPLOYER_CONTACT',
  INTERVIEWER: 'INTERVIEWER',
  BOTH: 'BOTH',
} as const;

export type InterviewSchedulingEmailsRequestEmployerFinalScheduleWhenOption = typeof InterviewSchedulingEmailsRequestEmployerFinalScheduleWhenOption[keyof typeof InterviewSchedulingEmailsRequestEmployerFinalScheduleWhenOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmailsRequestEmployerFinalScheduleWhenOption = {
  FINAL_SCHEDULE_AVAILABILITY: 'FINAL_SCHEDULE_AVAILABILITY',
  MANUAL: 'MANUAL',
} as const;

export type InterviewSchedulingEmailsRequestStudentFinalScheduleWhenOption = typeof InterviewSchedulingEmailsRequestStudentFinalScheduleWhenOption[keyof typeof InterviewSchedulingEmailsRequestStudentFinalScheduleWhenOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmailsRequestStudentFinalScheduleWhenOption = {
  FINAL_SCHEDULE_AVAILABILITY: 'FINAL_SCHEDULE_AVAILABILITY',
  MANUAL: 'MANUAL',
} as const;

export interface InterviewSchedulingEmailsRequest {
  employerFinalScheduleEmail?: EventEmail;
  employerFinalScheduleRecipientOption?: InterviewSchedulingEmailsRequestEmployerFinalScheduleRecipientOption;
  employerFinalScheduleWhenOption?: InterviewSchedulingEmailsRequestEmployerFinalScheduleWhenOption;
  employerInterviewerInformationRequestEmail?: EventEmail;
  employerLotteryScheduleRegistrationSubmittedEmail?: EventEmail;
  employerRegistrationEmail?: EventEmail;
  employerRegistrationReminderEmail?: EventEmail;
  employerScheduleAssignmentEmail?: EventEmail;
  employerScheduleRegistrationSubmittedEmail?: EventEmail;
  employerStudentApplicationsAreAvailableEmail?: EventEmail;
  studentAlternatePeriodHasStartedEmail?: EventEmail;
  studentApplicationDeadlineReminderEmail?: EventEmail;
  studentBiddingPeriodHasStartedEmail?: EventEmail;
  studentCancellationPeriodHasStartedEmail?: EventEmail;
  studentEmployerDecisionsAreAvailableEmail?: EventEmail;
  studentFinalScheduleEmail?: EventEmail;
  studentFinalScheduleWhenOption?: InterviewSchedulingEmailsRequestStudentFinalScheduleWhenOption;
  studentLotteryMatchReviewHasStartedEmail?: EventEmail;
  studentLotteryYourEventPageEmail?: EventEmail;
  studentOptInPeriodHasStartedEmail?: EventEmail;
  studentSelfSchedulePeriodHasStartedEmail?: EventEmail;
  studentYourEventPageEmail?: EventEmail;
}

export type InterviewSchedulingEmailsResponseEmployerFinalScheduleRecipientOption = typeof InterviewSchedulingEmailsResponseEmployerFinalScheduleRecipientOption[keyof typeof InterviewSchedulingEmailsResponseEmployerFinalScheduleRecipientOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmailsResponseEmployerFinalScheduleRecipientOption = {
  EMPLOYER_CONTACT: 'EMPLOYER_CONTACT',
  INTERVIEWER: 'INTERVIEWER',
  BOTH: 'BOTH',
} as const;

export type InterviewSchedulingEmailsResponseEmployerFinalScheduleWhenOption = typeof InterviewSchedulingEmailsResponseEmployerFinalScheduleWhenOption[keyof typeof InterviewSchedulingEmailsResponseEmployerFinalScheduleWhenOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmailsResponseEmployerFinalScheduleWhenOption = {
  FINAL_SCHEDULE_AVAILABILITY: 'FINAL_SCHEDULE_AVAILABILITY',
  MANUAL: 'MANUAL',
} as const;

export type InterviewSchedulingEmailsResponseStudentFinalScheduleWhenOption = typeof InterviewSchedulingEmailsResponseStudentFinalScheduleWhenOption[keyof typeof InterviewSchedulingEmailsResponseStudentFinalScheduleWhenOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmailsResponseStudentFinalScheduleWhenOption = {
  FINAL_SCHEDULE_AVAILABILITY: 'FINAL_SCHEDULE_AVAILABILITY',
  MANUAL: 'MANUAL',
} as const;

export interface InterviewSchedulingEmailsResponse {
  alternatesEnabled?: boolean;
  cancellationsEnabled?: boolean;
  employerFinalScheduleEmail?: EventEmail;
  employerFinalScheduleRecipientOption?: InterviewSchedulingEmailsResponseEmployerFinalScheduleRecipientOption;
  employerFinalScheduleWhenOption?: InterviewSchedulingEmailsResponseEmployerFinalScheduleWhenOption;
  employerInterviewerInformationRequestEmail?: EventEmail;
  employerLotteryScheduleRegistrationSubmittedEmail?: EventEmail;
  employerRegistrationEmail?: EventEmail;
  employerRegistrationReminderEmail?: EventEmail;
  employerScheduleAssignmentEmail?: EventEmail;
  employerScheduleRegistrationSubmittedEmail?: EventEmail;
  employerStudentApplicationsAreAvailableEmail?: EventEmail;
  optInsEnabled?: boolean;
  selfScheduleEnabled?: boolean;
  studentAlternatePeriodHasStartedEmail?: EventEmail;
  studentApplicationDeadlineReminderEmail?: EventEmail;
  studentBiddingPeriodHasStartedEmail?: EventEmail;
  studentCancellationPeriodHasStartedEmail?: EventEmail;
  studentEmployerDecisionsAreAvailableEmail?: EventEmail;
  studentFinalScheduleEmail?: EventEmail;
  studentFinalScheduleWhenOption?: InterviewSchedulingEmailsResponseStudentFinalScheduleWhenOption;
  studentLotteryEventPageEmail?: EventEmail;
  studentLotteryMatchReviewHasStartedEmail?: EventEmail;
  studentOptInPeriodHasStartedEmail?: EventEmail;
  studentSelfSchedulePeriodHasStartedEmail?: EventEmail;
  studentYourEventPageEmail?: EventEmail;
}

export type InterviewSchedulingEmployerApplicationListDetailsResponseApplicationReviewPeriod = typeof InterviewSchedulingEmployerApplicationListDetailsResponseApplicationReviewPeriod[keyof typeof InterviewSchedulingEmployerApplicationListDetailsResponseApplicationReviewPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmployerApplicationListDetailsResponseApplicationReviewPeriod = {
  PRE_REVIEW: 'PRE_REVIEW',
  REVIEW: 'REVIEW',
  POST_DECISION: 'POST_DECISION',
  POST_FINAL_SCHEDULE: 'POST_FINAL_SCHEDULE',
} as const;

export type InterviewSchedulingEmployerApplicationListDetailsResponseEmployerMatchReviewPeriod = typeof InterviewSchedulingEmployerApplicationListDetailsResponseEmployerMatchReviewPeriod[keyof typeof InterviewSchedulingEmployerApplicationListDetailsResponseEmployerMatchReviewPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmployerApplicationListDetailsResponseEmployerMatchReviewPeriod = {
  PRE_REVIEW: 'PRE_REVIEW',
  POST_FINAL_SCHEDULE: 'POST_FINAL_SCHEDULE',
} as const;

export type InterviewSchedulingEmployerApplicationListDetailsResponseOfficeLocationsOption = typeof InterviewSchedulingEmployerApplicationListDetailsResponseOfficeLocationsOption[keyof typeof InterviewSchedulingEmployerApplicationListDetailsResponseOfficeLocationsOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmployerApplicationListDetailsResponseOfficeLocationsOption = {
  All_LOCATIONS: 'All_LOCATIONS',
  SELECTED_LOCATIONS: 'SELECTED_LOCATIONS',
  UNSET: 'UNSET',
} as const;

export type InterviewSchedulingEmployerApplicationListDetailsResponsePracticeAreasOption = typeof InterviewSchedulingEmployerApplicationListDetailsResponsePracticeAreasOption[keyof typeof InterviewSchedulingEmployerApplicationListDetailsResponsePracticeAreasOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmployerApplicationListDetailsResponsePracticeAreasOption = {
  SPECIFIED: 'SPECIFIED',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  UNSET: 'UNSET',
} as const;

export type InterviewSchedulingEmployerApplicationListDetailsResponseSelectionSubmissionStatus = typeof InterviewSchedulingEmployerApplicationListDetailsResponseSelectionSubmissionStatus[keyof typeof InterviewSchedulingEmployerApplicationListDetailsResponseSelectionSubmissionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmployerApplicationListDetailsResponseSelectionSubmissionStatus = {
  SUBMITTED: 'SUBMITTED',
} as const;

export type InterviewSchedulingEmployerApplicationListDetailsResponseStudentSelectionPeriod = typeof InterviewSchedulingEmployerApplicationListDetailsResponseStudentSelectionPeriod[keyof typeof InterviewSchedulingEmployerApplicationListDetailsResponseStudentSelectionPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmployerApplicationListDetailsResponseStudentSelectionPeriod = {
  PRE_SELECTION: 'PRE_SELECTION',
  INVITED_INTERVIEW_SELECTION: 'INVITED_INTERVIEW_SELECTION',
  ALTERNATE_INTERVIEW_SELECTION: 'ALTERNATE_INTERVIEW_SELECTION',
  POST_SELECTION: 'POST_SELECTION',
  POST_FINAL_SCHEDULE: 'POST_FINAL_SCHEDULE',
} as const;

export interface InterviewSchedulingEmployerApplicationListDetailsResponse {
  alternatesEnabled?: boolean;
  applicationReviewPeriod?: InterviewSchedulingEmployerApplicationListDetailsResponseApplicationReviewPeriod;
  documentCollect?: boolean;
  employerDecisionDeadline?: EventDateResponse;
  employerMatchReviewPeriod?: InterviewSchedulingEmployerApplicationListDetailsResponseEmployerMatchReviewPeriod;
  interviewLocation?: string;
  jobTitle?: string;
  limitedNumberOfAlternates?: boolean;
  maximumNumberOfAlternates?: number;
  maximumNumberOfTimeslots?: number;
  officeLocations?: string[];
  officeLocationsOption?: InterviewSchedulingEmployerApplicationListDetailsResponseOfficeLocationsOption;
  practiceAreas?: string[];
  practiceAreasOption?: InterviewSchedulingEmployerApplicationListDetailsResponsePracticeAreasOption;
  scheduleId?: number;
  selectionSubmissionStatus?: InterviewSchedulingEmployerApplicationListDetailsResponseSelectionSubmissionStatus;
  studentSelectionPeriod?: InterviewSchedulingEmployerApplicationListDetailsResponseStudentSelectionPeriod;
}

export type InterviewSchedulingEmployerEventDetailsResponseApplicationReviewPeriod = typeof InterviewSchedulingEmployerEventDetailsResponseApplicationReviewPeriod[keyof typeof InterviewSchedulingEmployerEventDetailsResponseApplicationReviewPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmployerEventDetailsResponseApplicationReviewPeriod = {
  PRE_REVIEW: 'PRE_REVIEW',
  REVIEW: 'REVIEW',
  POST_DECISION: 'POST_DECISION',
  POST_FINAL_SCHEDULE: 'POST_FINAL_SCHEDULE',
} as const;

export interface InterviewSchedulingEmployerEventDetailsResponse {
  applicationReviewPeriod?: InterviewSchedulingEmployerEventDetailsResponseApplicationReviewPeriod;
  dateOptions?: string[];
  dateStudentApplicationsAreVisible?: EventDateResponse;
  documentCollectSettingEnabled?: boolean;
  employerCustomQuestions?: EmployerCustomQuestionWithOptionsResponse[];
  employerDecisionDeadline?: EventDateResponse;
  employerDescription?: string;
  employerName?: string;
  employerRegistrationDeadline?: EventDateResponse;
  employerRegistrationSettingsResponse?: EmployerRegistrationSettingsResponse;
  eventId?: number;
  isLottery?: boolean;
  name?: string;
  schoolName?: string;
  universityContact?: AdminUserDTO;
  universityRecruitmentPolicy?: string;
}

export interface InterviewSchedulingEmployerScheduleContactResponse {
  email?: string;
  firstName?: string;
  lastName?: string;
}

export type InterviewSchedulingEmployerScheduleInvitationStatusResponseEmployerInvitationStatus = typeof InterviewSchedulingEmployerScheduleInvitationStatusResponseEmployerInvitationStatus[keyof typeof InterviewSchedulingEmployerScheduleInvitationStatusResponseEmployerInvitationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmployerScheduleInvitationStatusResponseEmployerInvitationStatus = {
  NO_RESPONSE: 'NO_RESPONSE',
  INVITED: 'INVITED',
  ALTERNATE: 'ALTERNATE',
  NOT_INVITED: 'NOT_INVITED',
} as const;

export interface InterviewSchedulingEmployerScheduleInvitationStatusResponse {
  employerInvitationStatus?: InterviewSchedulingEmployerScheduleInvitationStatusResponseEmployerInvitationStatus;
  recruitId?: number;
}

export type InterviewSchedulingEmployerScheduleResponseApplicationSelectionStatus = typeof InterviewSchedulingEmployerScheduleResponseApplicationSelectionStatus[keyof typeof InterviewSchedulingEmployerScheduleResponseApplicationSelectionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmployerScheduleResponseApplicationSelectionStatus = {
  SUBMITTED: 'SUBMITTED',
  NO_RESPONSE: 'NO_RESPONSE',
} as const;

export type InterviewSchedulingEmployerScheduleResponseAssignedInterviewType = typeof InterviewSchedulingEmployerScheduleResponseAssignedInterviewType[keyof typeof InterviewSchedulingEmployerScheduleResponseAssignedInterviewType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmployerScheduleResponseAssignedInterviewType = {
  VIRTUAL_AUTO: 'VIRTUAL_AUTO',
  VIRTUAL_CUSTOM: 'VIRTUAL_CUSTOM',
  PHYSICAL: 'PHYSICAL',
} as const;

export type InterviewSchedulingEmployerScheduleResponseOfficeLocationsOption = typeof InterviewSchedulingEmployerScheduleResponseOfficeLocationsOption[keyof typeof InterviewSchedulingEmployerScheduleResponseOfficeLocationsOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmployerScheduleResponseOfficeLocationsOption = {
  All_LOCATIONS: 'All_LOCATIONS',
  SELECTED_LOCATIONS: 'SELECTED_LOCATIONS',
  UNSET: 'UNSET',
} as const;

export type InterviewSchedulingEmployerScheduleResponsePracticeAreasOption = typeof InterviewSchedulingEmployerScheduleResponsePracticeAreasOption[keyof typeof InterviewSchedulingEmployerScheduleResponsePracticeAreasOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmployerScheduleResponsePracticeAreasOption = {
  SPECIFIED: 'SPECIFIED',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  UNSET: 'UNSET',
} as const;

export type InterviewSchedulingEmployerScheduleResponsePreferredInterviewType = typeof InterviewSchedulingEmployerScheduleResponsePreferredInterviewType[keyof typeof InterviewSchedulingEmployerScheduleResponsePreferredInterviewType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmployerScheduleResponsePreferredInterviewType = {
  PHYSICAL: 'PHYSICAL',
  VIRTUAL: 'VIRTUAL',
} as const;

export type InterviewSchedulingEmployerScheduleResponsePreferredTimeblock = typeof InterviewSchedulingEmployerScheduleResponsePreferredTimeblock[keyof typeof InterviewSchedulingEmployerScheduleResponsePreferredTimeblock];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmployerScheduleResponsePreferredTimeblock = {
  FULL_DAY: 'FULL_DAY',
  HALF_DAY_MORNING: 'HALF_DAY_MORNING',
  HALF_DAY_AFTERNOON: 'HALF_DAY_AFTERNOON',
} as const;

export type InterviewSchedulingEmployerScheduleResponseRegistrationStatus = typeof InterviewSchedulingEmployerScheduleResponseRegistrationStatus[keyof typeof InterviewSchedulingEmployerScheduleResponseRegistrationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingEmployerScheduleResponseRegistrationStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  READY_TO_SUBMIT: 'READY_TO_SUBMIT',
  SUBMITTED: 'SUBMITTED',
  IN_REVIEW: 'IN_REVIEW',
  APPROVED: 'APPROVED',
} as const;

export interface InterviewSchedulingEmployerScheduleResponse {
  applicationSelectionStatus?: InterviewSchedulingEmployerScheduleResponseApplicationSelectionStatus;
  assignedInterviewType?: InterviewSchedulingEmployerScheduleResponseAssignedInterviewType;
  contactIds?: number[];
  documentCollect?: boolean;
  employerEventId?: number;
  employerOrgId?: number;
  hasMultipleInterviewsEnabled?: boolean;
  jobTitle?: string;
  lastApprovedAt?: string;
  lastSectionUpdatedAt?: string;
  officeLocations?: string[];
  officeLocationsOption?: InterviewSchedulingEmployerScheduleResponseOfficeLocationsOption;
  percent1L?: number;
  percent2L?: number;
  percent3L?: number;
  percentLLM?: number;
  percentPostGrad?: number;
  practiceAreas?: string[];
  practiceAreasOption?: InterviewSchedulingEmployerScheduleResponsePracticeAreasOption;
  preferredDates?: string[];
  preferredInterviewType?: InterviewSchedulingEmployerScheduleResponsePreferredInterviewType;
  preferredTimeblock?: InterviewSchedulingEmployerScheduleResponsePreferredTimeblock;
  registrationStatus?: InterviewSchedulingEmployerScheduleResponseRegistrationStatus;
  scheduleId?: number;
  supportingDocuments?: SupportingDocumentResponse[];
  universityEventId?: number;
}

export type InterviewSchedulingEmployerSchedulesResponseContacts = {[key: string]: InterviewSchedulingEmployerScheduleContactResponse};

export type InterviewSchedulingEmployerSchedulesResponseEmployers = {[key: string]: InterviewSchedulingUniversityEmployerResponse};

export type InterviewSchedulingEmployerSchedulesResponseInterviewers = {[key: string]: EmployerInterviewScheduleInterviewerResponse[]};

export interface InterviewSchedulingEmployerSchedulesResponse {
  contacts?: InterviewSchedulingEmployerSchedulesResponseContacts;
  employers?: InterviewSchedulingEmployerSchedulesResponseEmployers;
  interviewers?: InterviewSchedulingEmployerSchedulesResponseInterviewers;
  schedules?: InterviewSchedulingEmployerScheduleResponse[];
}

export interface InterviewSchedulingEventTimelineRequest {
  alternateStudentDecisionDeadlineStudent?: EventDateRequest;
  alternatesEnabled?: boolean;
  dateEmployerDecisionsAreVisibleStudent?: EventDateRequest;
  dateStudentApplicationsAreVisibleEmployer?: EventDateRequest;
  employerDecisionsDeadlineEmployer?: EventDateRequest;
  employerRegistrationDeadline?: EventDateRequest;
  employerRegistrationStartDate?: EventDateRequest;
  eventId?: number;
  finalScheduleAvailabilityDateEmployer?: EventDateRequest;
  finalScheduleAvailabilityDateStudent?: EventDateRequest;
  invitedStudentDecisionDeadlineStudent?: EventDateRequest;
  maxNumberOfAlternatesPerSchedule?: number;
  maxNumberOfInterviews?: number;
  maxNumberOfStudentApplications?: number;
  studentApplicationDeadline?: EventDateRequest;
  studentApplicationStartDate?: EventDateRequest;
  studentReviewPeriodStartDate?: EventDateRequest;
}

export type InterviewSchedulingGenerateTimeslotsResponseAllBreaks = {[key: string]: ZonedDateTimeInterval};

export type InterviewSchedulingGenerateTimeslotsResponseCustomBreaks = {[key: string]: ZonedDateTimeInterval};

export interface InterviewSchedulingGenerateTimeslotsResponse {
  actualEndTime?: string;
  allBreaks?: InterviewSchedulingGenerateTimeslotsResponseAllBreaks;
  customBreaks?: InterviewSchedulingGenerateTimeslotsResponseCustomBreaks;
  isValid?: boolean;
  message?: string;
  valid?: boolean;
  zonedDateTimeIntervals?: ZonedDateTimeInterval[];
}

export interface InterviewSchedulingIdToNotificationStatusResponse {
  id?: number;
  lastNotifiedAt?: string;
  outOfDate?: boolean;
}

export interface InterviewSchedulingInterviewerScheduleLink {
  firstName?: string;
  lastName?: string;
  link?: string;
  userId?: number;
}

export interface InterviewSchedulingJobApplicationDocumentUploadRequest {
  file?: Blob;
  scheduleIds?: string;
  supportingDocumentIds?: string;
}

export interface InterviewSchedulingJobInformationForInterviewer {
  employerName?: string;
  id?: number;
  jobTitle?: string;
  officeLocations?: string[];
  practiceAreas?: string[];
  scheduleId?: number;
}

export interface InterviewSchedulingLotteryBidResponse {
  matched?: boolean;
  scheduleId?: number;
}

export interface InterviewSchedulingLotteryRecruitResultResponse {
  numberOfMatches?: number;
  numberOfUnmatched?: number;
  recruitId?: number;
  scheduleIdPreferences?: InterviewSchedulingLotteryBidResponse[];
}

export type InterviewSchedulingLotteryResultResponseLotteryConfirmStatus = typeof InterviewSchedulingLotteryResultResponseLotteryConfirmStatus[keyof typeof InterviewSchedulingLotteryResultResponseLotteryConfirmStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingLotteryResultResponseLotteryConfirmStatus = {
  UNCONFIRMED: 'UNCONFIRMED',
  CONFIRMING_IN_PROGRESS: 'CONFIRMING_IN_PROGRESS',
  CONFIRMING_FINISHED: 'CONFIRMING_FINISHED',
  CONFIRMING_FAILED: 'CONFIRMING_FAILED',
} as const;

export type InterviewSchedulingLotteryResultResponseLotteryRunStatus = typeof InterviewSchedulingLotteryResultResponseLotteryRunStatus[keyof typeof InterviewSchedulingLotteryResultResponseLotteryRunStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingLotteryResultResponseLotteryRunStatus = {
  NOT_STARTED: 'NOT_STARTED',
  RUNNING: 'RUNNING',
  FAILED: 'FAILED',
  COMPLETE: 'COMPLETE',
} as const;

export type InterviewSchedulingLotteryResultResponseLotteryType = typeof InterviewSchedulingLotteryResultResponseLotteryType[keyof typeof InterviewSchedulingLotteryResultResponseLotteryType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingLotteryResultResponseLotteryType = {
  MINI: 'MINI',
  NORMAL: 'NORMAL',
} as const;

export interface InterviewSchedulingLotteryResultResponse {
  confirmed?: boolean;
  lotteryConfirmStatus?: InterviewSchedulingLotteryResultResponseLotteryConfirmStatus;
  lotteryId?: number;
  lotteryRunStatus?: InterviewSchedulingLotteryResultResponseLotteryRunStatus;
  lotteryType?: InterviewSchedulingLotteryResultResponseLotteryType;
  matchedWith1?: number;
  matchedWith1Percentage?: number;
  matchedWithTop10?: number;
  matchedWithTop10Percentage?: number;
  matchedWithTop5?: number;
  matchedWithTop5Percentage?: number;
  recruitResults?: InterviewSchedulingLotteryRecruitResultResponse[];
  totalMatches?: number;
}

export type InterviewSchedulingLotteryStatusResponseLotteryConfirmStatus = typeof InterviewSchedulingLotteryStatusResponseLotteryConfirmStatus[keyof typeof InterviewSchedulingLotteryStatusResponseLotteryConfirmStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingLotteryStatusResponseLotteryConfirmStatus = {
  UNCONFIRMED: 'UNCONFIRMED',
  CONFIRMING_IN_PROGRESS: 'CONFIRMING_IN_PROGRESS',
  CONFIRMING_FINISHED: 'CONFIRMING_FINISHED',
  CONFIRMING_FAILED: 'CONFIRMING_FAILED',
} as const;

export type InterviewSchedulingLotteryStatusResponseLotteryRunStatus = typeof InterviewSchedulingLotteryStatusResponseLotteryRunStatus[keyof typeof InterviewSchedulingLotteryStatusResponseLotteryRunStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingLotteryStatusResponseLotteryRunStatus = {
  NOT_STARTED: 'NOT_STARTED',
  RUNNING: 'RUNNING',
  FAILED: 'FAILED',
  COMPLETE: 'COMPLETE',
} as const;

export type InterviewSchedulingLotteryStatusResponseLotteryType = typeof InterviewSchedulingLotteryStatusResponseLotteryType[keyof typeof InterviewSchedulingLotteryStatusResponseLotteryType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingLotteryStatusResponseLotteryType = {
  MINI: 'MINI',
  NORMAL: 'NORMAL',
} as const;

export interface InterviewSchedulingLotteryStatusResponse {
  lotteryConfirmStatus?: InterviewSchedulingLotteryStatusResponseLotteryConfirmStatus;
  lotteryId?: number;
  lotteryRunStatus?: InterviewSchedulingLotteryStatusResponseLotteryRunStatus;
  lotteryType?: InterviewSchedulingLotteryStatusResponseLotteryType;
}

export interface InterviewSchedulingLotteryStatusSummaryResponse {
  anyLotteriesConfirmed?: boolean;
  anyLotteriesConfirming?: boolean;
  anyLotteriesRun?: boolean;
  anyLotteriesRunning?: boolean;
  anyLotteriesWithConfirmErrors?: boolean;
  anyLotteriesWithRunErrors?: boolean;
  lotteryResponses?: InterviewSchedulingLotteryStatusResponse[];
}

export interface InterviewSchedulingNotificationStatusesResponse {
  interviewerNotifications?: InterviewSchedulingIdToNotificationStatusResponse[];
  scheduleNotifications?: InterviewSchedulingIdToNotificationStatusResponse[];
  studentNotifications?: InterviewSchedulingIdToNotificationStatusResponse[];
}

export type InterviewSchedulingStepStatusResponseAutomatedEmails = typeof InterviewSchedulingStepStatusResponseAutomatedEmails[keyof typeof InterviewSchedulingStepStatusResponseAutomatedEmails];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStepStatusResponseAutomatedEmails = {
  UNAVAILABLE: 'UNAVAILABLE',
  AVAILABLE: 'AVAILABLE',
  COMPLETE: 'COMPLETE',
} as const;

export type InterviewSchedulingStepStatusResponseEmployerSettings = typeof InterviewSchedulingStepStatusResponseEmployerSettings[keyof typeof InterviewSchedulingStepStatusResponseEmployerSettings];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStepStatusResponseEmployerSettings = {
  UNAVAILABLE: 'UNAVAILABLE',
  AVAILABLE: 'AVAILABLE',
  COMPLETE: 'COMPLETE',
} as const;

export type InterviewSchedulingStepStatusResponseEventDetails = typeof InterviewSchedulingStepStatusResponseEventDetails[keyof typeof InterviewSchedulingStepStatusResponseEventDetails];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStepStatusResponseEventDetails = {
  UNAVAILABLE: 'UNAVAILABLE',
  AVAILABLE: 'AVAILABLE',
  COMPLETE: 'COMPLETE',
} as const;

export type InterviewSchedulingStepStatusResponseEventSchedule = typeof InterviewSchedulingStepStatusResponseEventSchedule[keyof typeof InterviewSchedulingStepStatusResponseEventSchedule];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStepStatusResponseEventSchedule = {
  UNAVAILABLE: 'UNAVAILABLE',
  AVAILABLE: 'AVAILABLE',
  COMPLETE: 'COMPLETE',
} as const;

export type InterviewSchedulingStepStatusResponseEventTimeline = typeof InterviewSchedulingStepStatusResponseEventTimeline[keyof typeof InterviewSchedulingStepStatusResponseEventTimeline];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStepStatusResponseEventTimeline = {
  UNAVAILABLE: 'UNAVAILABLE',
  AVAILABLE: 'AVAILABLE',
  COMPLETE: 'COMPLETE',
} as const;

export interface InterviewSchedulingStepStatusResponse {
  automatedEmails?: InterviewSchedulingStepStatusResponseAutomatedEmails;
  employerSettings?: InterviewSchedulingStepStatusResponseEmployerSettings;
  eventDetails?: InterviewSchedulingStepStatusResponseEventDetails;
  eventSchedule?: InterviewSchedulingStepStatusResponseEventSchedule;
  eventTimeline?: InterviewSchedulingStepStatusResponseEventTimeline;
}

export type InterviewSchedulingStudentApplicationDocumentForInterviewerVisibilityOption = typeof InterviewSchedulingStudentApplicationDocumentForInterviewerVisibilityOption[keyof typeof InterviewSchedulingStudentApplicationDocumentForInterviewerVisibilityOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentApplicationDocumentForInterviewerVisibilityOption = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
} as const;

export interface InterviewSchedulingStudentApplicationDocumentForInterviewer {
  link?: string;
  name?: string;
  supportingDocumentId?: number;
  uploadDate?: string;
  visibilityOption?: InterviewSchedulingStudentApplicationDocumentForInterviewerVisibilityOption;
  visibilityTime?: EventDateResponse;
}

export type InterviewSchedulingStudentApplicationDocumentResponseVisibilityOption = typeof InterviewSchedulingStudentApplicationDocumentResponseVisibilityOption[keyof typeof InterviewSchedulingStudentApplicationDocumentResponseVisibilityOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentApplicationDocumentResponseVisibilityOption = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
} as const;

export interface InterviewSchedulingStudentApplicationDocumentResponse {
  link?: string;
  name?: string;
  supportingDocumentId?: number;
  uploadDate?: string;
  visibilityOption?: InterviewSchedulingStudentApplicationDocumentResponseVisibilityOption;
  visibilityTime?: EventDateResponse;
}

export type InterviewSchedulingStudentApplicationForInterviewerDocumentStatus = typeof InterviewSchedulingStudentApplicationForInterviewerDocumentStatus[keyof typeof InterviewSchedulingStudentApplicationForInterviewerDocumentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentApplicationForInterviewerDocumentStatus = {
  COMPLETE: 'COMPLETE',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED',
} as const;

export type InterviewSchedulingStudentApplicationForInterviewerEmployerSelectedOfficeOption = typeof InterviewSchedulingStudentApplicationForInterviewerEmployerSelectedOfficeOption[keyof typeof InterviewSchedulingStudentApplicationForInterviewerEmployerSelectedOfficeOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentApplicationForInterviewerEmployerSelectedOfficeOption = {
  All_LOCATIONS: 'All_LOCATIONS',
  SELECTED_LOCATIONS: 'SELECTED_LOCATIONS',
  UNSET: 'UNSET',
} as const;

export type InterviewSchedulingStudentApplicationForInterviewerEmployerSelectedPracticeAreasOption = typeof InterviewSchedulingStudentApplicationForInterviewerEmployerSelectedPracticeAreasOption[keyof typeof InterviewSchedulingStudentApplicationForInterviewerEmployerSelectedPracticeAreasOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentApplicationForInterviewerEmployerSelectedPracticeAreasOption = {
  SPECIFIED: 'SPECIFIED',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  UNSET: 'UNSET',
} as const;

export type InterviewSchedulingStudentApplicationForInterviewerStudentResponse = typeof InterviewSchedulingStudentApplicationForInterviewerStudentResponse[keyof typeof InterviewSchedulingStudentApplicationForInterviewerStudentResponse];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentApplicationForInterviewerStudentResponse = {
  NO_RESPONSE: 'NO_RESPONSE',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
} as const;

export interface InterviewSchedulingStudentApplicationForInterviewer {
  candidateId?: number;
  documentStatus?: InterviewSchedulingStudentApplicationForInterviewerDocumentStatus;
  employerSelectedOfficeOption?: InterviewSchedulingStudentApplicationForInterviewerEmployerSelectedOfficeOption;
  employerSelectedPracticeAreasOption?: InterviewSchedulingStudentApplicationForInterviewerEmployerSelectedPracticeAreasOption;
  hasScheduledSlot?: boolean;
  id?: number;
  interviewLocation?: string;
  jobInformation?: InterviewSchedulingJobInformationForInterviewer;
  officeLocationPreferences?: InterviewSchedulingStudentOfficePreference[];
  practiceAreaPreferences?: InterviewSchedulingStudentPracticeAreaPreference[];
  recruitId?: number;
  scheduleId?: number;
  scheduledSlotEndTime?: EventDateResponse;
  scheduledSlotStartTime?: EventDateResponse;
  studentDocuments?: InterviewSchedulingStudentApplicationDocumentForInterviewer[];
  studentInformation?: InterviewSchedulingStudentInformationForInterviewer;
  studentResponse?: InterviewSchedulingStudentApplicationForInterviewerStudentResponse;
}

export type InterviewSchedulingStudentApplicationResponseClassYear = typeof InterviewSchedulingStudentApplicationResponseClassYear[keyof typeof InterviewSchedulingStudentApplicationResponseClassYear];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentApplicationResponseClassYear = {
  FIRST_YEAR: 'FIRST_YEAR',
  SECOND_YEAR: 'SECOND_YEAR',
  THIRD_YEAR: 'THIRD_YEAR',
  MASTER_OF_LAWS: 'MASTER_OF_LAWS',
  POST_GRADUATE: 'POST_GRADUATE',
} as const;

export type InterviewSchedulingStudentApplicationResponseDocumentStatus = typeof InterviewSchedulingStudentApplicationResponseDocumentStatus[keyof typeof InterviewSchedulingStudentApplicationResponseDocumentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentApplicationResponseDocumentStatus = {
  COMPLETE: 'COMPLETE',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED',
} as const;

export type InterviewSchedulingStudentApplicationResponseStudentResponse = typeof InterviewSchedulingStudentApplicationResponseStudentResponse[keyof typeof InterviewSchedulingStudentApplicationResponseStudentResponse];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentApplicationResponseStudentResponse = {
  NO_RESPONSE: 'NO_RESPONSE',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
} as const;

export interface InterviewSchedulingStudentApplicationResponse {
  candidateId?: number;
  classYear?: InterviewSchedulingStudentApplicationResponseClassYear;
  documentStatus?: InterviewSchedulingStudentApplicationResponseDocumentStatus;
  documents?: InterviewSchedulingStudentApplicationDocumentResponse[];
  email?: string;
  employerOrgId?: number;
  firstName?: string;
  graduationYear?: number;
  interviewLocation?: string;
  jobApplicationId?: number;
  lastName?: string;
  lawSchool?: string;
  phoneNumber?: string;
  profileImageLink?: string;
  recruitId?: number;
  studentResponse?: InterviewSchedulingStudentApplicationResponseStudentResponse;
}

export type InterviewSchedulingStudentEventSummaryApplicationPeriod = typeof InterviewSchedulingStudentEventSummaryApplicationPeriod[keyof typeof InterviewSchedulingStudentEventSummaryApplicationPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentEventSummaryApplicationPeriod = {
  PRE_REVIEW: 'PRE_REVIEW',
  REVIEW: 'REVIEW',
  APPLICATION: 'APPLICATION',
  POST_APPLICATION: 'POST_APPLICATION',
} as const;

export type InterviewSchedulingStudentEventSummarySelectionPeriod = typeof InterviewSchedulingStudentEventSummarySelectionPeriod[keyof typeof InterviewSchedulingStudentEventSummarySelectionPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentEventSummarySelectionPeriod = {
  PRE_SELECTION: 'PRE_SELECTION',
  INVITED_INTERVIEW_SELECTION: 'INVITED_INTERVIEW_SELECTION',
  ALTERNATE_INTERVIEW_SELECTION: 'ALTERNATE_INTERVIEW_SELECTION',
  POST_SELECTION: 'POST_SELECTION',
  POST_FINAL_SCHEDULE: 'POST_FINAL_SCHEDULE',
} as const;

export interface InterviewSchedulingStudentEventSummary {
  alternateStudentDecisionDeadline?: EventDateResponse;
  alternatesEnabled?: boolean;
  applicationDeadline?: EventDateResponse;
  applicationPeriod?: InterviewSchedulingStudentEventSummaryApplicationPeriod;
  applicationStartDate?: EventDateResponse;
  applicationVisibilityDate?: EventDateResponse;
  autoSchedulerHasRun?: boolean;
  dateEmployerDecisionsAreVisible?: EventDateResponse;
  eventDescription?: string;
  eventName?: string;
  invitedStudentDecisionDeadline?: EventDateResponse;
  limitedNumberOfInterviews?: boolean;
  limitedStudentApplications?: boolean;
  maxNumberOfAlternatesPerSchedule?: number;
  maxNumberOfInterviews?: number;
  maxNumberOfStudentApplications?: number;
  reviewPeriodStartDate?: EventDateResponse;
  selectionPeriod?: InterviewSchedulingStudentEventSummarySelectionPeriod;
  universityName?: string;
}

export type InterviewSchedulingStudentInformationForInterviewerClassYear = typeof InterviewSchedulingStudentInformationForInterviewerClassYear[keyof typeof InterviewSchedulingStudentInformationForInterviewerClassYear];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentInformationForInterviewerClassYear = {
  FIRST_YEAR: 'FIRST_YEAR',
  SECOND_YEAR: 'SECOND_YEAR',
  THIRD_YEAR: 'THIRD_YEAR',
  MASTER_OF_LAWS: 'MASTER_OF_LAWS',
  POST_GRADUATE: 'POST_GRADUATE',
} as const;

export interface InterviewSchedulingStudentInformationForInterviewer {
  classYear?: InterviewSchedulingStudentInformationForInterviewerClassYear;
  email?: string;
  firstName?: string;
  graduationYear?: number;
  id?: number;
  lastName?: string;
  lawSchool?: string;
  phoneNumber?: string;
}

export type InterviewSchedulingStudentJobDetailDocumentResponseVisibilityOption = typeof InterviewSchedulingStudentJobDetailDocumentResponseVisibilityOption[keyof typeof InterviewSchedulingStudentJobDetailDocumentResponseVisibilityOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentJobDetailDocumentResponseVisibilityOption = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
} as const;

export interface InterviewSchedulingStudentJobDetailDocumentResponse {
  eventCustomDocumentId?: number;
  name?: string;
  orgCustomDocumentId?: number;
  required?: boolean;
  s3FileLocation?: string;
  supportingDocumentId?: number;
  uploadDate?: string;
  userFilename?: string;
  visibilityOption?: InterviewSchedulingStudentJobDetailDocumentResponseVisibilityOption;
  visibilityTime?: EventDateResponse;
}

export type InterviewSchedulingStudentJobDetailResponseOfficeLocationsOption = typeof InterviewSchedulingStudentJobDetailResponseOfficeLocationsOption[keyof typeof InterviewSchedulingStudentJobDetailResponseOfficeLocationsOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentJobDetailResponseOfficeLocationsOption = {
  All_LOCATIONS: 'All_LOCATIONS',
  SELECTED_LOCATIONS: 'SELECTED_LOCATIONS',
  UNSET: 'UNSET',
} as const;

export type InterviewSchedulingStudentJobDetailResponsePracticeAreasOption = typeof InterviewSchedulingStudentJobDetailResponsePracticeAreasOption[keyof typeof InterviewSchedulingStudentJobDetailResponsePracticeAreasOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentJobDetailResponsePracticeAreasOption = {
  SPECIFIED: 'SPECIFIED',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  UNSET: 'UNSET',
} as const;

export interface InterviewSchedulingStudentJobDetailResponse {
  additionalScheduleInformation?: string;
  allowMultipleApplications?: boolean;
  documentCollect?: boolean;
  documents?: InterviewSchedulingStudentJobDetailDocumentResponse[];
  employerName?: string;
  employerOrgId?: number;
  employerOrgLogoUrl?: string;
  employerOrgLogoVisibleToStudent?: boolean;
  jobDescription?: string;
  jobTitle?: string;
  officeLocations?: string[];
  officeLocationsOption?: InterviewSchedulingStudentJobDetailResponseOfficeLocationsOption;
  officeLocationsWithIds?: GenericIdNamePairResponse[];
  positionName?: string;
  practiceAreas?: string[];
  practiceAreasOption?: InterviewSchedulingStudentJobDetailResponsePracticeAreasOption;
  practiceAreasWithIds?: GenericIdNamePairResponse[];
  scheduleId?: number;
  submissionDate?: string;
}

export type InterviewSchedulingStudentJobInListResponseOfficeLocationsOption = typeof InterviewSchedulingStudentJobInListResponseOfficeLocationsOption[keyof typeof InterviewSchedulingStudentJobInListResponseOfficeLocationsOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentJobInListResponseOfficeLocationsOption = {
  All_LOCATIONS: 'All_LOCATIONS',
  SELECTED_LOCATIONS: 'SELECTED_LOCATIONS',
  UNSET: 'UNSET',
} as const;

export type InterviewSchedulingStudentJobInListResponsePracticeAreasOption = typeof InterviewSchedulingStudentJobInListResponsePracticeAreasOption[keyof typeof InterviewSchedulingStudentJobInListResponsePracticeAreasOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentJobInListResponsePracticeAreasOption = {
  SPECIFIED: 'SPECIFIED',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  UNSET: 'UNSET',
} as const;

export interface InterviewSchedulingStudentJobInListResponse {
  additionalScheduleInformation?: string;
  allowMultipleApplications?: boolean;
  documentCollect?: boolean;
  documents?: InterviewSchedulingStudentJobDetailDocumentResponse[];
  employerName?: string;
  employerOrgId?: number;
  employerOrgLogoUrl?: string;
  employerOrgLogoVisibleToStudent?: boolean;
  jobDescription?: string;
  jobTitle?: string;
  officeLocations?: string[];
  officeLocationsOption?: InterviewSchedulingStudentJobInListResponseOfficeLocationsOption;
  officeLocationsWithIds?: GenericIdNamePairResponse[];
  positionName?: string;
  practiceAreas?: string[];
  practiceAreasOption?: InterviewSchedulingStudentJobInListResponsePracticeAreasOption;
  practiceAreasWithIds?: GenericIdNamePairResponse[];
  scheduleId?: number;
}

export type InterviewSchedulingStudentJobStatusResponseApplicationStatus = typeof InterviewSchedulingStudentJobStatusResponseApplicationStatus[keyof typeof InterviewSchedulingStudentJobStatusResponseApplicationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentJobStatusResponseApplicationStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
} as const;

export type InterviewSchedulingStudentJobStatusResponseEmployerInvitationStatus = typeof InterviewSchedulingStudentJobStatusResponseEmployerInvitationStatus[keyof typeof InterviewSchedulingStudentJobStatusResponseEmployerInvitationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentJobStatusResponseEmployerInvitationStatus = {
  NO_RESPONSE: 'NO_RESPONSE',
  INVITED: 'INVITED',
  ALTERNATE: 'ALTERNATE',
  NOT_INVITED: 'NOT_INVITED',
} as const;

export type InterviewSchedulingStudentJobStatusResponseStudentResponseStatus = typeof InterviewSchedulingStudentJobStatusResponseStudentResponseStatus[keyof typeof InterviewSchedulingStudentJobStatusResponseStudentResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingStudentJobStatusResponseStudentResponseStatus = {
  NO_RESPONSE: 'NO_RESPONSE',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
} as const;

export interface InterviewSchedulingStudentJobStatusResponse {
  applicationStatus?: InterviewSchedulingStudentJobStatusResponseApplicationStatus;
  documentCollect?: boolean;
  employerInvitationStatus?: InterviewSchedulingStudentJobStatusResponseEmployerInvitationStatus;
  employerOrgId?: number;
  hasReachedMaxResponseLimitForTimeslot?: boolean;
  scheduleId?: number;
  studentResponseStatus?: InterviewSchedulingStudentJobStatusResponseStudentResponseStatus;
  submissionDate?: string;
}

export interface InterviewSchedulingStudentOfficePreference {
  officeLocationId?: number;
  officeLocationName?: string;
  orgOfficeId?: number;
  preferenceId?: number;
  rank?: number;
}

export interface InterviewSchedulingStudentPracticeAreaPreference {
  practiceAreaId?: number;
  practiceAreaName?: string;
  preferenceId?: number;
  rank?: number;
}

export interface InterviewSchedulingStudentScheduleConflictRequest {
  endTime?: string;
  startTime?: string;
  timezone?: string;
}

export interface InterviewSchedulingStudentScheduleConflictResponse {
  endTime?: string;
  startTime?: string;
  timezone?: string;
}

export interface InterviewSchedulingStudentScheduleConflictsListRequest {
  conflicts?: InterviewSchedulingStudentScheduleConflictsRequest[];
}

export interface InterviewSchedulingStudentScheduleConflictsRequest {
  conflicts?: InterviewSchedulingStudentScheduleConflictRequest[];
  eventDate?: string;
}

export interface InterviewSchedulingStudentScheduleConflictsResponse {
  conflicts?: InterviewSchedulingStudentScheduleConflictResponse[];
  eventDate?: string;
}

export interface InterviewSchedulingStudentScheduledInterviewResponse {
  date?: string;
  endTime?: string;
  scheduleId?: number;
  startTime?: string;
  timezone?: string;
}

export interface InterviewSchedulingStudentSelfScheduleClaimTimeslotRequest {
  eutid?: number;
}

export interface InterviewSchedulingSubmitBlocksRequest {
  blocks?: InterviewSchedulingBlockRequest[];
  deletedBlockIds?: number[];
}

export interface InterviewSchedulingUniversityEditTimeslotsRequest {
  deletedTimeslotIds?: number[];
  editedTimeslotRequests?: InterviewSchedulingUniversityTimeslotRequest[];
}

export interface InterviewSchedulingUniversityEmployerAssignSchedulesRequest {
  assignments: InterviewSchedulingUniversityEmployerScheduleAssignment[];
}

export interface InterviewSchedulingUniversityEmployerNotifySchedulesRequest {
  employerScheduleIds: number[];
}

export interface InterviewSchedulingUniversityEmployerResponse {
  eventId?: number;
  name?: string;
  orgFriendlyName?: string;
  orgId?: number;
}

export type InterviewSchedulingUniversityEmployerScheduleAssignmentAssignedInterviewType = typeof InterviewSchedulingUniversityEmployerScheduleAssignmentAssignedInterviewType[keyof typeof InterviewSchedulingUniversityEmployerScheduleAssignmentAssignedInterviewType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityEmployerScheduleAssignmentAssignedInterviewType = {
  VIRTUAL_AUTO: 'VIRTUAL_AUTO',
  VIRTUAL_CUSTOM: 'VIRTUAL_CUSTOM',
  PHYSICAL: 'PHYSICAL',
} as const;

export interface InterviewSchedulingUniversityEmployerScheduleAssignment {
  assignedInterviewType?: InterviewSchedulingUniversityEmployerScheduleAssignmentAssignedInterviewType;
  employerScheduleId?: number;
  employerScheduleOptionId?: number;
  interviewLocation?: string;
  interviewSchedulingBlockId?: number;
}

export type InterviewSchedulingUniversityEmployerScheduleAssignmentResponseAssignedInterviewType = typeof InterviewSchedulingUniversityEmployerScheduleAssignmentResponseAssignedInterviewType[keyof typeof InterviewSchedulingUniversityEmployerScheduleAssignmentResponseAssignedInterviewType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityEmployerScheduleAssignmentResponseAssignedInterviewType = {
  VIRTUAL_AUTO: 'VIRTUAL_AUTO',
  VIRTUAL_CUSTOM: 'VIRTUAL_CUSTOM',
  PHYSICAL: 'PHYSICAL',
} as const;

export interface InterviewSchedulingUniversityEmployerScheduleAssignmentResponse {
  assignedInterviewType?: InterviewSchedulingUniversityEmployerScheduleAssignmentResponseAssignedInterviewType;
  employerScheduleId?: number;
  employerScheduleOptionId?: number;
  interviewLocation?: string;
  interviewSchedulingBlockId?: number;
}

export interface InterviewSchedulingUniversityEmployerScheduleNotificationResponse {
  employerScheduleId?: number;
  lastNotifiedAt?: string;
  notificationUpToDate?: boolean;
}

export type InterviewSchedulingUniversityEmployerScheduleOverviewResponseOfficeLocationsOption = typeof InterviewSchedulingUniversityEmployerScheduleOverviewResponseOfficeLocationsOption[keyof typeof InterviewSchedulingUniversityEmployerScheduleOverviewResponseOfficeLocationsOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityEmployerScheduleOverviewResponseOfficeLocationsOption = {
  All_LOCATIONS: 'All_LOCATIONS',
  SELECTED_LOCATIONS: 'SELECTED_LOCATIONS',
  UNSET: 'UNSET',
} as const;

export type InterviewSchedulingUniversityEmployerScheduleOverviewResponsePracticeAreasOption = typeof InterviewSchedulingUniversityEmployerScheduleOverviewResponsePracticeAreasOption[keyof typeof InterviewSchedulingUniversityEmployerScheduleOverviewResponsePracticeAreasOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityEmployerScheduleOverviewResponsePracticeAreasOption = {
  SPECIFIED: 'SPECIFIED',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  UNSET: 'UNSET',
} as const;

export type InterviewSchedulingUniversityEmployerScheduleOverviewResponsePreferredInterviewFormat = typeof InterviewSchedulingUniversityEmployerScheduleOverviewResponsePreferredInterviewFormat[keyof typeof InterviewSchedulingUniversityEmployerScheduleOverviewResponsePreferredInterviewFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityEmployerScheduleOverviewResponsePreferredInterviewFormat = {
  PHYSICAL: 'PHYSICAL',
  VIRTUAL: 'VIRTUAL',
} as const;

export type InterviewSchedulingUniversityEmployerScheduleOverviewResponsePreferredTime = typeof InterviewSchedulingUniversityEmployerScheduleOverviewResponsePreferredTime[keyof typeof InterviewSchedulingUniversityEmployerScheduleOverviewResponsePreferredTime];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityEmployerScheduleOverviewResponsePreferredTime = {
  FULL_DAY: 'FULL_DAY',
  HALF_DAY_MORNING: 'HALF_DAY_MORNING',
  HALF_DAY_AFTERNOON: 'HALF_DAY_AFTERNOON',
} as const;

export type InterviewSchedulingUniversityEmployerScheduleOverviewResponseStatus = typeof InterviewSchedulingUniversityEmployerScheduleOverviewResponseStatus[keyof typeof InterviewSchedulingUniversityEmployerScheduleOverviewResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityEmployerScheduleOverviewResponseStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  READY_TO_SUBMIT: 'READY_TO_SUBMIT',
  SUBMITTED: 'SUBMITTED',
  IN_REVIEW: 'IN_REVIEW',
  APPROVED: 'APPROVED',
} as const;

export interface InterviewSchedulingUniversityEmployerScheduleOverviewResponse {
  documentCollectEnabled?: boolean;
  employerContacts?: InterviewSchedulingEmployerScheduleContactResponse[];
  employerName?: string;
  employerOrgId?: number;
  jobTitle?: string;
  officeLocations?: string[];
  officeLocationsOption?: InterviewSchedulingUniversityEmployerScheduleOverviewResponseOfficeLocationsOption;
  practiceAreas?: string[];
  practiceAreasOption?: InterviewSchedulingUniversityEmployerScheduleOverviewResponsePracticeAreasOption;
  preferredDates?: string[];
  preferredInterviewFormat?: InterviewSchedulingUniversityEmployerScheduleOverviewResponsePreferredInterviewFormat;
  preferredTime?: InterviewSchedulingUniversityEmployerScheduleOverviewResponsePreferredTime;
  scheduleId?: number;
  scheduleOptionId?: number;
  status?: InterviewSchedulingUniversityEmployerScheduleOverviewResponseStatus;
}

export type InterviewSchedulingUniversityEmployerScheduleResponseOfficeLocationsOption = typeof InterviewSchedulingUniversityEmployerScheduleResponseOfficeLocationsOption[keyof typeof InterviewSchedulingUniversityEmployerScheduleResponseOfficeLocationsOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityEmployerScheduleResponseOfficeLocationsOption = {
  All_LOCATIONS: 'All_LOCATIONS',
  SELECTED_LOCATIONS: 'SELECTED_LOCATIONS',
  UNSET: 'UNSET',
} as const;

export type InterviewSchedulingUniversityEmployerScheduleResponsePracticeAreasOption = typeof InterviewSchedulingUniversityEmployerScheduleResponsePracticeAreasOption[keyof typeof InterviewSchedulingUniversityEmployerScheduleResponsePracticeAreasOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityEmployerScheduleResponsePracticeAreasOption = {
  SPECIFIED: 'SPECIFIED',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  UNSET: 'UNSET',
} as const;

export interface InterviewSchedulingUniversityEmployerScheduleResponse {
  documentCollect?: boolean;
  officeLocations?: string[];
  officeLocationsOption?: InterviewSchedulingUniversityEmployerScheduleResponseOfficeLocationsOption;
  practiceAreas?: string[];
  practiceAreasOption?: InterviewSchedulingUniversityEmployerScheduleResponsePracticeAreasOption;
  scheduleId?: number;
}

export interface InterviewSchedulingUniversityEmployerScheduleStatusResponse {
  employerHasCreatedASchedule?: boolean;
}

export type InterviewSchedulingUniversityEmployerScheduleWithAssignmentResponseOfficeLocationsOption = typeof InterviewSchedulingUniversityEmployerScheduleWithAssignmentResponseOfficeLocationsOption[keyof typeof InterviewSchedulingUniversityEmployerScheduleWithAssignmentResponseOfficeLocationsOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityEmployerScheduleWithAssignmentResponseOfficeLocationsOption = {
  All_LOCATIONS: 'All_LOCATIONS',
  SELECTED_LOCATIONS: 'SELECTED_LOCATIONS',
  UNSET: 'UNSET',
} as const;

export type InterviewSchedulingUniversityEmployerScheduleWithAssignmentResponsePracticeAreasOption = typeof InterviewSchedulingUniversityEmployerScheduleWithAssignmentResponsePracticeAreasOption[keyof typeof InterviewSchedulingUniversityEmployerScheduleWithAssignmentResponsePracticeAreasOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityEmployerScheduleWithAssignmentResponsePracticeAreasOption = {
  SPECIFIED: 'SPECIFIED',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  UNSET: 'UNSET',
} as const;

export interface InterviewSchedulingUniversityEmployerScheduleWithAssignmentResponse {
  employerName?: string;
  employerOrgId?: number;
  jobTitle?: string;
  officeLocations?: string[];
  officeLocationsOption?: InterviewSchedulingUniversityEmployerScheduleWithAssignmentResponseOfficeLocationsOption;
  practiceAreas?: string[];
  practiceAreasOption?: InterviewSchedulingUniversityEmployerScheduleWithAssignmentResponsePracticeAreasOption;
  scheduleId?: number;
  scheduleOptionIds?: number[];
  timeblockId?: number;
}

export interface InterviewSchedulingUniversityEmployerUnassignSchedulesRequest {
  employerScheduleIdsToUnassign?: number[];
  employerScheduleOptionIdsToUnassign: number[];
}

export type InterviewSchedulingUniversityEventSummaryResponseEmployerApplicationReviewPeriod = typeof InterviewSchedulingUniversityEventSummaryResponseEmployerApplicationReviewPeriod[keyof typeof InterviewSchedulingUniversityEventSummaryResponseEmployerApplicationReviewPeriod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityEventSummaryResponseEmployerApplicationReviewPeriod = {
  PRE_REVIEW: 'PRE_REVIEW',
  REVIEW: 'REVIEW',
  POST_DECISION: 'POST_DECISION',
  POST_FINAL_SCHEDULE: 'POST_FINAL_SCHEDULE',
} as const;

export interface InterviewSchedulingUniversityEventSummaryResponse {
  alternateStudentDecisionDeadline?: EventDateResponse;
  draft?: boolean;
  employerApplicationReviewPeriod?: InterviewSchedulingUniversityEventSummaryResponseEmployerApplicationReviewPeriod;
  employerFinalScheduleAvailabilityDate?: EventDateResponse;
  employerFinalScheduleEmailEnabled?: boolean;
  employerRegistrationEmailEnabled?: boolean;
  employerRegistrationReminderEmailEnabled?: boolean;
  endDate?: EventDateResponse;
  interviewerInformationRequestEmailEnabled?: boolean;
  invitedStudentDecisionDeadline?: EventDateResponse;
  name?: string;
  startDate?: EventDateResponse;
  studentApplicationDeadlineReminderEmailEnabled?: boolean;
  studentFinalScheduleAvailabilityDate?: EventDateResponse;
  studentFinalScheduleEmailEnabled?: boolean;
  tags?: OrgTagDto[];
}

export interface InterviewSchedulingUniversityGetTimeslotsResponse {
  timeslots?: InterviewSchedulingUniversityTimeslotResponse[];
  unmatchedStudents?: InterviewSchedulingUnmatchedStudentResponse[];
}

export interface InterviewSchedulingUniversityIdToLinkResponse {
  id?: number;
  link?: string;
}

export interface InterviewSchedulingUniversityInterviewerResponse {
  assignedEmployerInterviewScheduleOptionIds?: number[];
  assignedScheduleIds?: number[];
  firstName?: string;
  lastName?: string;
  orgIds?: number[];
  userId?: number;
}

export interface InterviewSchedulingUniversityLinksResponse {
  eutidsToGuestLinks?: InterviewSchedulingUniversityIdToLinkResponse[];
  recruitIdsToLinks?: InterviewSchedulingUniversityIdToLinkResponse[];
  userIdsToLinks?: InterviewSchedulingUniversityIdToLinkResponse[];
}

export type InterviewSchedulingUniversityNotifyGroupRequestSendType = typeof InterviewSchedulingUniversityNotifyGroupRequestSendType[keyof typeof InterviewSchedulingUniversityNotifyGroupRequestSendType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityNotifyGroupRequestSendType = {
  ALL_STUDENTS: 'ALL_STUDENTS',
  ALL_EMPLOYERS: 'ALL_EMPLOYERS',
  ALL: 'ALL',
  OUTDATED_STUDENTS: 'OUTDATED_STUDENTS',
  OUTDATED_EMPLOYERS: 'OUTDATED_EMPLOYERS',
  ALL_OUTDATED: 'ALL_OUTDATED',
} as const;

export interface InterviewSchedulingUniversityNotifyGroupRequest {
  sendType?: InterviewSchedulingUniversityNotifyGroupRequestSendType;
}

export interface InterviewSchedulingUniversityNotifyIdsRequest {
  ids?: number[];
}

export type InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequestEmployerRequestType = typeof InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequestEmployerRequestType[keyof typeof InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequestEmployerRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequestEmployerRequestType = {
  INTERVIEWERS: 'INTERVIEWERS',
  EMPLOYER_CONTACTS: 'EMPLOYER_CONTACTS',
  BOTH: 'BOTH',
  NONE: 'NONE',
  OTHER: 'OTHER',
} as const;

export type InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequestStudentRequestType = typeof InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequestStudentRequestType[keyof typeof InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequestStudentRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequestStudentRequestType = {
  STUDENTS: 'STUDENTS',
  NONE: 'NONE',
  OTHER: 'OTHER',
} as const;

export interface InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequest {
  employerRequestType?: InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequestEmployerRequestType;
  otherEmails?: string[];
  scheduleIds: number[];
  studentRequestType?: InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequestStudentRequestType;
}

export interface InterviewSchedulingUniversitySendEmailsToOthersRequest {
  emails?: string[];
  ids?: number[];
}

export type InterviewSchedulingUniversityStudentApplicationListResponseEmployers = {[key: string]: InterviewSchedulingUniversityEmployerResponse};

export type InterviewSchedulingUniversityStudentApplicationListResponseSchedules = {[key: string]: InterviewSchedulingUniversityEmployerScheduleResponse};

export type InterviewSchedulingUniversityStudentApplicationListResponseStudents = {[key: string]: InterviewSchedulingUniversityStudentResponse};

export interface InterviewSchedulingUniversityStudentApplicationListResponse {
  applications?: InterviewSchedulingUniversityStudentApplicationResponse[];
  employers?: InterviewSchedulingUniversityStudentApplicationListResponseEmployers;
  schedules?: InterviewSchedulingUniversityStudentApplicationListResponseSchedules;
  students?: InterviewSchedulingUniversityStudentApplicationListResponseStudents;
}

export type InterviewSchedulingUniversityStudentApplicationResponseDocumentStatus = typeof InterviewSchedulingUniversityStudentApplicationResponseDocumentStatus[keyof typeof InterviewSchedulingUniversityStudentApplicationResponseDocumentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityStudentApplicationResponseDocumentStatus = {
  COMPLETE: 'COMPLETE',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED',
} as const;

export type InterviewSchedulingUniversityStudentApplicationResponseEmployerInvitationStatus = typeof InterviewSchedulingUniversityStudentApplicationResponseEmployerInvitationStatus[keyof typeof InterviewSchedulingUniversityStudentApplicationResponseEmployerInvitationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityStudentApplicationResponseEmployerInvitationStatus = {
  NO_RESPONSE: 'NO_RESPONSE',
  INVITED: 'INVITED',
  ALTERNATE: 'ALTERNATE',
  NOT_INVITED: 'NOT_INVITED',
} as const;

export type InterviewSchedulingUniversityStudentApplicationResponseLastAdminActionType = typeof InterviewSchedulingUniversityStudentApplicationResponseLastAdminActionType[keyof typeof InterviewSchedulingUniversityStudentApplicationResponseLastAdminActionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityStudentApplicationResponseLastAdminActionType = {
  ADDED: 'ADDED',
  DELETED: 'DELETED',
  NO_ACTION: 'NO_ACTION',
} as const;

export type InterviewSchedulingUniversityStudentApplicationResponseLastStudentActionType = typeof InterviewSchedulingUniversityStudentApplicationResponseLastStudentActionType[keyof typeof InterviewSchedulingUniversityStudentApplicationResponseLastStudentActionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityStudentApplicationResponseLastStudentActionType = {
  ADDED: 'ADDED',
  DELETED: 'DELETED',
  NO_ACTION: 'NO_ACTION',
} as const;

export type InterviewSchedulingUniversityStudentApplicationResponseMatchedInInitialLotteryStatus = typeof InterviewSchedulingUniversityStudentApplicationResponseMatchedInInitialLotteryStatus[keyof typeof InterviewSchedulingUniversityStudentApplicationResponseMatchedInInitialLotteryStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityStudentApplicationResponseMatchedInInitialLotteryStatus = {
  MATCHED: 'MATCHED',
  UNMATCHED: 'UNMATCHED',
  NOT_CONSIDERED: 'NOT_CONSIDERED',
} as const;

export type InterviewSchedulingUniversityStudentApplicationResponseStatus = typeof InterviewSchedulingUniversityStudentApplicationResponseStatus[keyof typeof InterviewSchedulingUniversityStudentApplicationResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityStudentApplicationResponseStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
} as const;

export type InterviewSchedulingUniversityStudentApplicationResponseStudentResponseStatus = typeof InterviewSchedulingUniversityStudentApplicationResponseStudentResponseStatus[keyof typeof InterviewSchedulingUniversityStudentApplicationResponseStudentResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityStudentApplicationResponseStudentResponseStatus = {
  NO_RESPONSE: 'NO_RESPONSE',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
} as const;

export interface InterviewSchedulingUniversityStudentApplicationResponse {
  dateApplied?: string;
  documentStatus?: InterviewSchedulingUniversityStudentApplicationResponseDocumentStatus;
  employerInvitationStatus?: InterviewSchedulingUniversityStudentApplicationResponseEmployerInvitationStatus;
  employerOrgId?: number;
  hasScheduledSlot?: boolean;
  initialLotteryResultConfirmed?: boolean;
  initialRanking?: number;
  interviewLocation?: string;
  interviewers?: InterviewerMemberWithEmail[];
  jobApplicationId?: number;
  jobTitle?: string;
  lastAdminActionTime?: string;
  lastAdminActionType?: InterviewSchedulingUniversityStudentApplicationResponseLastAdminActionType;
  lastStudentActionTime?: string;
  lastStudentActionType?: InterviewSchedulingUniversityStudentApplicationResponseLastStudentActionType;
  matchedInInitialLotteryStatus?: InterviewSchedulingUniversityStudentApplicationResponseMatchedInInitialLotteryStatus;
  miniLotteryResultConfirmed?: boolean;
  officePreferences?: InterviewSchedulingStudentOfficePreference[];
  optInRanking?: number;
  practiceAreaPreferences?: InterviewSchedulingStudentPracticeAreaPreference[];
  scheduleId?: number;
  scheduledSlotEndTime?: EventDateResponse;
  scheduledSlotStartTime?: EventDateResponse;
  status?: InterviewSchedulingUniversityStudentApplicationResponseStatus;
  studentCandidateId?: number;
  studentRecruitId?: number;
  studentResponseStatus?: InterviewSchedulingUniversityStudentApplicationResponseStudentResponseStatus;
}

export interface InterviewSchedulingUniversityStudentResponse {
  candidateId?: number;
  classYear?: string;
  email?: string;
  extension?: string;
  firstName?: string;
  graduationYear?: number;
  lastName?: string;
  lawSchool?: string;
  recruitId?: number;
}

export type InterviewSchedulingUniversityTimeslotRequestAssignedInterviewType = typeof InterviewSchedulingUniversityTimeslotRequestAssignedInterviewType[keyof typeof InterviewSchedulingUniversityTimeslotRequestAssignedInterviewType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityTimeslotRequestAssignedInterviewType = {
  VIRTUAL_AUTO: 'VIRTUAL_AUTO',
  VIRTUAL_CUSTOM: 'VIRTUAL_CUSTOM',
  PHYSICAL: 'PHYSICAL',
} as const;

export interface InterviewSchedulingUniversityTimeslotRequest {
  assignedInterviewType?: InterviewSchedulingUniversityTimeslotRequestAssignedInterviewType;
  endDateTime?: string;
  interviewerIds?: number[];
  location?: string;
  scheduleId?: number;
  scheduleOptionId?: number;
  startDateTime?: string;
  studentIds?: number[];
  timeslotId?: number;
  timezone?: string;
  videoLink?: string;
}

export type InterviewSchedulingUniversityTimeslotResponseAssignedInterviewType = typeof InterviewSchedulingUniversityTimeslotResponseAssignedInterviewType[keyof typeof InterviewSchedulingUniversityTimeslotResponseAssignedInterviewType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityTimeslotResponseAssignedInterviewType = {
  VIRTUAL_AUTO: 'VIRTUAL_AUTO',
  VIRTUAL_CUSTOM: 'VIRTUAL_CUSTOM',
  PHYSICAL: 'PHYSICAL',
} as const;

export type InterviewSchedulingUniversityTimeslotResponseSource = typeof InterviewSchedulingUniversityTimeslotResponseSource[keyof typeof InterviewSchedulingUniversityTimeslotResponseSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewSchedulingUniversityTimeslotResponseSource = {
  AUTO_SCHEDULER: 'AUTO_SCHEDULER',
  CUSTOM: 'CUSTOM',
} as const;

export interface InterviewSchedulingUniversityTimeslotResponse {
  assignedInterviewType?: InterviewSchedulingUniversityTimeslotResponseAssignedInterviewType;
  employerInterviewScheduleOptionId?: number;
  endDateTime?: string;
  interviewerIds?: number[];
  location?: string;
  scheduleId?: number;
  source?: InterviewSchedulingUniversityTimeslotResponseSource;
  startDateTime?: string;
  studentIds?: number[];
  timeslotId?: number;
  timezone?: string;
  videoLink?: string;
}

export interface InterviewSchedulingUnmatchedStudentResponse {
  recruitId?: number;
  scheduleIds?: number[];
}

export interface InterviewSchedulingUpdateEmployerSchedulesRequest {
  schedules?: EmployerScheduleDetailsRequest[];
}

export interface InterviewSchedulingUserDTO {
  admin?: boolean;
  email?: string;
  firstName?: string;
  jobTitle?: string;
  lastName?: string;
  lawSchool?: string;
  officeLocation?: string;
  practiceArea?: string;
  userId?: number;
}

export interface InterviewerMemberWithEmail {
  email?: string;
  firstName?: string;
  id?: number;
  lastName?: string;
  orgId?: number;
}

export interface InterviewerTimeBlockPacketInformation {
  candidateInformation?: InterviewManagementCandidatePacketInformation;
  interviewEndTime?: string;
  interviewStartTime?: string;
}

export interface IsEventExpiredResponse {
  eventExpired?: boolean;
}

export interface JobAppAddressInformationRequest {
  addressLineOne?: string;
  addressLineTwo?: string;
  city?: string;
  country?: string;
  state?: string;
  zipCode?: string;
}

export interface JobAppCandidateMissingInfoRequestResponse {
  fulfilledAt?: string;
  id?: number;
  sentAt?: string;
}

export interface JobAppDocumentListResponse {
  jobAppDocumentList?: JobAppDocumentResponse[];
}

export interface JobAppDocumentResponse {
  createdAt?: string;
  documentName?: string;
  jobAppDocumentId?: number;
  jobAppPrimaryDocumentResponse?: JobAppPrimaryDocumentResponse;
  location?: string;
  orgCustomDocName?: string;
  orgDocId?: number;
}

export interface JobAppDocumentUploadRequest {
  copyFromMostRecentDocument?: boolean;
  document?: Blob;
  jobAppId?: number;
  orgcustomdocumentsId?: number;
}

export type JobAppEducationHistoryRequestDegree = typeof JobAppEducationHistoryRequestDegree[keyof typeof JobAppEducationHistoryRequestDegree];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobAppEducationHistoryRequestDegree = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
  NUMBER_5: '5',
  NUMBER_6: '6',
  NUMBER_7: '7',
  NUMBER_8: '8',
  NUMBER_9: '9',
  NUMBER_10: '10',
  NUMBER_11: '11',
  NUMBER_12: '12',
  NUMBER_13: '13',
  NUMBER_14: '14',
  NUMBER_15: '15',
  NUMBER_16: '16',
  NUMBER_17: '17',
  NUMBER_18: '18',
  NUMBER_19: '19',
  NUMBER_20: '20',
  NUMBER_21: '21',
  NUMBER_22: '22',
  NUMBER_23: '23',
  NUMBER_24: '24',
  NUMBER_25: '25',
  NUMBER_26: '26',
} as const;

export interface JobAppEducationHistoryRequest {
  degree?: JobAppEducationHistoryRequestDegree;
  endDate?: string;
  id?: number;
  jobAppId?: number;
  startDate?: string;
  university?: string;
}

export type JobAppEducationHistoryResponseDegree = typeof JobAppEducationHistoryResponseDegree[keyof typeof JobAppEducationHistoryResponseDegree];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobAppEducationHistoryResponseDegree = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
  NUMBER_5: '5',
  NUMBER_6: '6',
  NUMBER_7: '7',
  NUMBER_8: '8',
  NUMBER_9: '9',
  NUMBER_10: '10',
  NUMBER_11: '11',
  NUMBER_12: '12',
  NUMBER_13: '13',
  NUMBER_14: '14',
  NUMBER_15: '15',
  NUMBER_16: '16',
  NUMBER_17: '17',
  NUMBER_18: '18',
  NUMBER_19: '19',
  NUMBER_20: '20',
  NUMBER_21: '21',
  NUMBER_22: '22',
  NUMBER_23: '23',
  NUMBER_24: '24',
  NUMBER_25: '25',
  NUMBER_26: '26',
} as const;

export interface JobAppEducationHistoryResponse {
  degree?: JobAppEducationHistoryResponseDegree;
  endDate?: string;
  id?: number;
  jobAppId?: number;
  startDate?: string;
  university?: string;
}

export type JobAppOverviewRequestAppSource = typeof JobAppOverviewRequestAppSource[keyof typeof JobAppOverviewRequestAppSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobAppOverviewRequestAppSource = {
  UNDEFINED: 'UNDEFINED',
  AGENCY: 'AGENCY',
  EMAIL_SUBMISSION: 'EMAIL_SUBMISSION',
  EMPLOYEE_REFERRAL: 'EMPLOYEE_REFERRAL',
  INTERNAL_HIRE: 'INTERNAL_HIRE',
  JOB_FAIR: 'JOB_FAIR',
  OCI: 'OCI',
  OTHER: 'OTHER',
  RESUME_COLLECT: 'RESUME_COLLECT',
  PREVIOUS_SUMMER_ASSOCIATE: 'PREVIOUS_SUMMER_ASSOCIATE',
  WRITE_IN: 'WRITE_IN',
  FORWARD: 'FORWARD',
  ADVERTISEMENT_OR_JOB_BOARD: 'ADVERTISEMENT_OR_JOB_BOARD',
  AUTOMATIC_CALLBACK: 'AUTOMATIC_CALLBACK',
  CONSORTIUM: 'CONSORTIUM',
  RECRUITING_EVENT: 'RECRUITING_EVENT',
  REFERRAL: 'REFERRAL',
  PRE_OCI: 'PRE_OCI',
  PREDICTIVE_TOOL: 'PREDICTIVE_TOOL',
  DIRECT_OUTREACH: 'DIRECT_OUTREACH',
} as const;

export type JobAppOverviewRequestCreationType = typeof JobAppOverviewRequestCreationType[keyof typeof JobAppOverviewRequestCreationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobAppOverviewRequestCreationType = {
  UNDEFINED: 'UNDEFINED',
  MANUAL: 'MANUAL',
  SELF_APPLY: 'SELF_APPLY',
  AGENCY_APPLY: 'AGENCY_APPLY',
  FORWARD: 'FORWARD',
} as const;

export interface JobAppOverviewRequest {
  addressLineOne?: string;
  addressLineTwo?: string;
  appSource?: JobAppOverviewRequestAppSource;
  city?: string;
  country?: string;
  creationType?: JobAppOverviewRequestCreationType;
  id?: number;
  jobId?: number;
  jobPipelineStatusId?: number;
  recruitId?: number;
  state?: string;
  status?: JobPipelineStepRequest;
  zipCode?: string;
}

export interface JobAppPersonalInformationRequest {
  /** @pattern ^$|.+\@.+\..+ */
  email?: string;
  firstName?: string;
  lastName?: string;
  /** @pattern ^$|^http(s)?:\/\/([\w]+\.)?linkedin\.com\/in\/[A-z0-9_-]+.*\/?$ */
  linkedIn?: string;
  phoneNumber?: string;
}

export type JobAppPrimaryDocumentResponseDocumentType = typeof JobAppPrimaryDocumentResponseDocumentType[keyof typeof JobAppPrimaryDocumentResponseDocumentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobAppPrimaryDocumentResponseDocumentType = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
} as const;

export interface JobAppPrimaryDocumentResponse {
  documentName?: string;
  documentType?: JobAppPrimaryDocumentResponseDocumentType;
  location?: string;
  name?: string;
  recruitId?: number;
  uploadDate?: string;
}

export interface JobAppQuestionAnswerRequest {
  dateValue?: string;
  id?: number;
  jobAppId?: number;
  jobAppQuestionAnswerSelections?: JobAppQuestionAnswerSelectionRequest[];
  numericValue?: number;
  orgQuestionId?: number;
  textValue?: string;
}

export type JobAppQuestionAnswerResponseQuestionType = typeof JobAppQuestionAnswerResponseQuestionType[keyof typeof JobAppQuestionAnswerResponseQuestionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobAppQuestionAnswerResponseQuestionType = {
  SINGLE_SELECT: 'SINGLE_SELECT',
  FREE_TEXT: 'FREE_TEXT',
  NUMERICAL: 'NUMERICAL',
  MULTI_SELECT: 'MULTI_SELECT',
  DATE: 'DATE',
} as const;

export interface JobAppQuestionAnswerResponse {
  dateValue?: string;
  id?: number;
  jobAppId?: number;
  jobAppQuestionAnswerSelections?: JobAppQuestionAnswerSelectionResponse[];
  label?: string;
  numericValue?: number;
  options?: OrgQuestionOptionResponse[];
  orgQuestionId?: number;
  questionType?: JobAppQuestionAnswerResponseQuestionType;
  subText?: string;
  textValue?: string;
}

export interface JobAppQuestionAnswerSelectionRequest {
  id?: number;
  jobAppQuestionAnswerId?: number;
  orgQuestionOptionId?: number;
}

export interface JobAppQuestionAnswerSelectionResponse {
  id?: number;
  jobAppQuestionAnswerId?: number;
  option?: string;
  orgQuestionOptionId?: number;
}

export type JobAppRequestAppSource = typeof JobAppRequestAppSource[keyof typeof JobAppRequestAppSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobAppRequestAppSource = {
  UNDEFINED: 'UNDEFINED',
  AGENCY: 'AGENCY',
  EMAIL_SUBMISSION: 'EMAIL_SUBMISSION',
  EMPLOYEE_REFERRAL: 'EMPLOYEE_REFERRAL',
  INTERNAL_HIRE: 'INTERNAL_HIRE',
  JOB_FAIR: 'JOB_FAIR',
  OCI: 'OCI',
  OTHER: 'OTHER',
  RESUME_COLLECT: 'RESUME_COLLECT',
  PREVIOUS_SUMMER_ASSOCIATE: 'PREVIOUS_SUMMER_ASSOCIATE',
  WRITE_IN: 'WRITE_IN',
  FORWARD: 'FORWARD',
  ADVERTISEMENT_OR_JOB_BOARD: 'ADVERTISEMENT_OR_JOB_BOARD',
  AUTOMATIC_CALLBACK: 'AUTOMATIC_CALLBACK',
  CONSORTIUM: 'CONSORTIUM',
  RECRUITING_EVENT: 'RECRUITING_EVENT',
  REFERRAL: 'REFERRAL',
  PRE_OCI: 'PRE_OCI',
  PREDICTIVE_TOOL: 'PREDICTIVE_TOOL',
  DIRECT_OUTREACH: 'DIRECT_OUTREACH',
} as const;

export type JobAppRequestCreationType = typeof JobAppRequestCreationType[keyof typeof JobAppRequestCreationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobAppRequestCreationType = {
  UNDEFINED: 'UNDEFINED',
  MANUAL: 'MANUAL',
  SELF_APPLY: 'SELF_APPLY',
  AGENCY_APPLY: 'AGENCY_APPLY',
  FORWARD: 'FORWARD',
} as const;

export interface JobAppRequest {
  addressLineOne?: string;
  addressLineTwo?: string;
  appSource?: JobAppRequestAppSource;
  city?: string;
  country?: string;
  creationType?: JobAppRequestCreationType;
  educationHistory?: JobAppEducationHistoryRequest[];
  id?: number;
  isComplete?: boolean;
  jobId?: number;
  jobPipelineStatusId?: number;
  postalCode?: string;
  recruitId?: number;
  state?: string;
  status?: JobPipelineStepRequest;
  workHistory?: JobAppWorkHistoryRequest[];
}

export type JobAppResponseAppSource = typeof JobAppResponseAppSource[keyof typeof JobAppResponseAppSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobAppResponseAppSource = {
  UNDEFINED: 'UNDEFINED',
  AGENCY: 'AGENCY',
  EMAIL_SUBMISSION: 'EMAIL_SUBMISSION',
  EMPLOYEE_REFERRAL: 'EMPLOYEE_REFERRAL',
  INTERNAL_HIRE: 'INTERNAL_HIRE',
  JOB_FAIR: 'JOB_FAIR',
  OCI: 'OCI',
  OTHER: 'OTHER',
  RESUME_COLLECT: 'RESUME_COLLECT',
  PREVIOUS_SUMMER_ASSOCIATE: 'PREVIOUS_SUMMER_ASSOCIATE',
  WRITE_IN: 'WRITE_IN',
  FORWARD: 'FORWARD',
  ADVERTISEMENT_OR_JOB_BOARD: 'ADVERTISEMENT_OR_JOB_BOARD',
  AUTOMATIC_CALLBACK: 'AUTOMATIC_CALLBACK',
  CONSORTIUM: 'CONSORTIUM',
  RECRUITING_EVENT: 'RECRUITING_EVENT',
  REFERRAL: 'REFERRAL',
  PRE_OCI: 'PRE_OCI',
  PREDICTIVE_TOOL: 'PREDICTIVE_TOOL',
  DIRECT_OUTREACH: 'DIRECT_OUTREACH',
} as const;

export type JobAppResponseCreationType = typeof JobAppResponseCreationType[keyof typeof JobAppResponseCreationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobAppResponseCreationType = {
  UNDEFINED: 'UNDEFINED',
  MANUAL: 'MANUAL',
  SELF_APPLY: 'SELF_APPLY',
  AGENCY_APPLY: 'AGENCY_APPLY',
  FORWARD: 'FORWARD',
} as const;

export interface JobAppResponse {
  addressLineOne?: string;
  addressLineTwo?: string;
  agencyContactId?: number;
  agencyContactInfo?: AgencyContactResponse;
  appSource?: JobAppResponseAppSource;
  candidate?: CandidateResponse;
  city?: string;
  country?: string;
  createdAt?: string;
  creationType?: JobAppResponseCreationType;
  id?: number;
  internalFieldAnswers?: InternalFieldAnswer[];
  isComplete?: boolean;
  jobId?: number;
  jobPipelineStatusId?: number;
  jobPipelineStatusName?: string;
  missingInfoRequestToAgencyContact?: JobAppCandidateMissingInfoRequestResponse;
  missingInfoRequestToCandidate?: JobAppCandidateMissingInfoRequestResponse;
  offerAffirmationDate?: string;
  offerDate?: string;
  offerExpirationDate?: string;
  previousOfferAffirmationDate?: string;
  previousOfferDate?: string;
  previousOfferExpirationDate?: string;
  recruitId?: number;
  sections?: JobAppSectionResponse[];
  state?: string;
  statusLastUpdatedAt?: string;
  zipCode?: string;
}

export type JobAppSectionResponseSectionType = typeof JobAppSectionResponseSectionType[keyof typeof JobAppSectionResponseSectionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobAppSectionResponseSectionType = {
  PERSONAL_INFO: 'PERSONAL_INFO',
  CANDIDATE_DOCUMENTS: 'CANDIDATE_DOCUMENTS',
  EEO_QUESTIONS: 'EEO_QUESTIONS',
  ADDRESS_INFORMATION: 'ADDRESS_INFORMATION',
  EDUCATION_HISTORY: 'EDUCATION_HISTORY',
  WORK_HISTORY: 'WORK_HISTORY',
  CUSTOM_QUESTIONS: 'CUSTOM_QUESTIONS',
  SELF_IDENTIFICATION: 'SELF_IDENTIFICATION',
  EXTERNAL: 'EXTERNAL',
} as const;

export interface JobAppSectionResponse {
  answers?: JobAppQuestionAnswerResponse[];
  educationHistory?: JobAppEducationHistoryResponse[];
  jobAppDocuments?: JobAppDocumentResponse[];
  order?: number;
  sectionDescription?: string;
  sectionId?: number;
  sectionName?: string;
  sectionType?: JobAppSectionResponseSectionType;
  selfIdAnswers?: JobAppSelfIdQuestionAnswerGraph[];
  workHistory?: JobAppWorkHistoryResponse[];
}

export interface JobAppSelfIdQuestionAnswerGraph {
  id?: string;
  jobAppId?: number;
  jobAppSelfIdQuestionAnswerSelections?: JobAppSelfIdQuestionAnswerSelectionGraph[];
  orgSelfIdQuestionId?: number;
  orgSelfIdQuestionOptions?: OrgSelfIdQuestionOptionNode[];
}

export interface JobAppSelfIdQuestionAnswerRequest {
  id?: number;
  jobAppSelfIdQuestionAnswerSelections?: JobAppSelfIdQuestionAnswerSelectionRequest[];
  orgSelfIdQuestionId?: number;
  text?: string;
}

export interface JobAppSelfIdQuestionAnswerSelectionGraph {
  id?: string;
  orgSelfIdQuestionOptionId?: number;
}

export interface JobAppSelfIdQuestionAnswerSelectionRequest {
  id?: number;
  orgSelfIdQuestionOptionId?: number;
}

export interface JobAppUnregisteredAgencyInformationRequest {
  agencyName?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  unregisteredAgency?: boolean;
}

export interface JobAppWorkHistoryRequest {
  employer?: string;
  endDate?: string;
  id?: number;
  isCurrentEmployer?: boolean;
  jobAppId?: number;
  position?: string;
  startDate?: string;
}

export interface JobAppWorkHistoryResponse {
  employer?: string;
  endDate?: string;
  id?: number;
  isCurrentEmployer?: boolean;
  jobAppId?: number;
  position?: string;
  startDate?: string;
}

export type JobApplicationDateCandidateFilterSegmentCriteria = typeof JobApplicationDateCandidateFilterSegmentCriteria[keyof typeof JobApplicationDateCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobApplicationDateCandidateFilterSegmentCriteria = {
  ON: 'ON',
  BEFORE: 'BEFORE',
  AFTER: 'AFTER',
  ON_OR_BEFORE: 'ON_OR_BEFORE',
  ON_OR_AFTER: 'ON_OR_AFTER',
} as const;

export interface JobApplicationDateCandidateFilterSegment {
  criteria?: JobApplicationDateCandidateFilterSegmentCriteria;
  date?: string;
}

export type JobApplicationSourceCandidateFilterSegmentAppSourceEnumsItem = typeof JobApplicationSourceCandidateFilterSegmentAppSourceEnumsItem[keyof typeof JobApplicationSourceCandidateFilterSegmentAppSourceEnumsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobApplicationSourceCandidateFilterSegmentAppSourceEnumsItem = {
  UNDEFINED: 'UNDEFINED',
  AGENCY: 'AGENCY',
  EMAIL_SUBMISSION: 'EMAIL_SUBMISSION',
  EMPLOYEE_REFERRAL: 'EMPLOYEE_REFERRAL',
  INTERNAL_HIRE: 'INTERNAL_HIRE',
  JOB_FAIR: 'JOB_FAIR',
  OCI: 'OCI',
  OTHER: 'OTHER',
  RESUME_COLLECT: 'RESUME_COLLECT',
  PREVIOUS_SUMMER_ASSOCIATE: 'PREVIOUS_SUMMER_ASSOCIATE',
  WRITE_IN: 'WRITE_IN',
  FORWARD: 'FORWARD',
  ADVERTISEMENT_OR_JOB_BOARD: 'ADVERTISEMENT_OR_JOB_BOARD',
  AUTOMATIC_CALLBACK: 'AUTOMATIC_CALLBACK',
  CONSORTIUM: 'CONSORTIUM',
  RECRUITING_EVENT: 'RECRUITING_EVENT',
  REFERRAL: 'REFERRAL',
  PRE_OCI: 'PRE_OCI',
  PREDICTIVE_TOOL: 'PREDICTIVE_TOOL',
  DIRECT_OUTREACH: 'DIRECT_OUTREACH',
} as const;

export type JobApplicationSourceCandidateFilterSegmentCriteria = typeof JobApplicationSourceCandidateFilterSegmentCriteria[keyof typeof JobApplicationSourceCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobApplicationSourceCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface JobApplicationSourceCandidateFilterSegment {
  appSourceEnums?: JobApplicationSourceCandidateFilterSegmentAppSourceEnumsItem[];
  criteria?: JobApplicationSourceCandidateFilterSegmentCriteria;
}

export interface JobCandidateDocumentRequest {
  docName?: string;
  id?: number;
  isDeleted?: boolean;
  isRequired?: boolean;
  jobSectionId?: number;
  orgDocId?: number;
}

export interface JobCandidateDocumentResponse {
  docName?: string;
  id?: number;
  isDeleted?: boolean;
  isRequired?: boolean;
  jobSectionId?: number;
  orgDocId?: number;
}

export type JobCandidateFilterSegmentCriteria = typeof JobCandidateFilterSegmentCriteria[keyof typeof JobCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface JobCandidateFilterSegment {
  criteria?: JobCandidateFilterSegmentCriteria;
  jobIds?: number[];
}

export interface JobCustomDocumentsCandidateFilterSegment {
  exists?: boolean;
  jobCustomDocId?: number;
}

export type JobDepartmentCandidateFilterSegmentCriteria = typeof JobDepartmentCandidateFilterSegmentCriteria[keyof typeof JobDepartmentCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobDepartmentCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface JobDepartmentCandidateFilterSegment {
  criteria?: JobDepartmentCandidateFilterSegmentCriteria;
  departments?: string[];
}

export interface JobDepartmentResponse {
  departmentId?: number;
  id?: number;
  jobId?: number;
  name?: string;
}

export interface JobDetailsResponse {
  description?: string;
  jobId?: number;
}

export interface JobEmploymentTypeResponse {
  employmentType?: string;
  employmentTypeId?: number;
  id?: number;
  jobId?: number;
}

export type JobHiringLeadsCandidateFilterSegmentCriteria = typeof JobHiringLeadsCandidateFilterSegmentCriteria[keyof typeof JobHiringLeadsCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobHiringLeadsCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface JobHiringLeadsCandidateFilterSegment {
  criteria?: JobHiringLeadsCandidateFilterSegmentCriteria;
  userIds?: number[];
}

export type JobOfficeCandidateFilterSegmentCriteria = typeof JobOfficeCandidateFilterSegmentCriteria[keyof typeof JobOfficeCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobOfficeCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface JobOfficeCandidateFilterSegment {
  criteria?: JobOfficeCandidateFilterSegmentCriteria;
  offices?: string[];
}

export interface JobOfficeResponse {
  id?: number;
  jobId?: number;
  name?: string;
  officeId?: number;
}

export type JobOverviewResponseEnabledAgenciesStatus = typeof JobOverviewResponseEnabledAgenciesStatus[keyof typeof JobOverviewResponseEnabledAgenciesStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobOverviewResponseEnabledAgenciesStatus = {
  ALL_REGISTERED_AGENCIES: 'ALL_REGISTERED_AGENCIES',
  ALL_REGISTERED_AND_UNREGISTERED_AGENCIES: 'ALL_REGISTERED_AND_UNREGISTERED_AGENCIES',
  SELECTED_AGENCIES: 'SELECTED_AGENCIES',
} as const;

export interface JobOverviewResponse {
  agencyApplyEnabled?: boolean;
  agencyJobAuthorizations?: AgencyJobAuthorizationNode[];
  closeDate?: string;
  closeTimezone?: string;
  createdAt?: string;
  departments?: JobDepartmentResponse[];
  enabledAgenciesStatus?: JobOverviewResponseEnabledAgenciesStatus;
  enabledForAllAgenciesAndContacts?: boolean;
  extension?: string;
  hiringLeads?: User[];
  id?: number;
  incomplete?: boolean;
  isPublic?: boolean;
  jobEmploymentTypes?: JobEmploymentTypeResponse[];
  jobOffices?: JobOfficeResponse[];
  jobPipelineId?: number;
  numberOfApps?: number;
  numberOfHires?: number;
  openDate?: string;
  openTimezone?: string;
  orgId?: number;
  positionTypes?: JobPositionTypeResponse[];
  processYear?: number;
  title?: string;
}

export interface JobPipelineBucketRequest {
  color?: string;
  corePipelineBucketId?: number;
  description?: string;
  id?: number;
  isActive?: boolean;
  jobPipelineId?: number;
  jobPipelineStepRequests?: JobPipelineStepRequest[];
  name?: string;
  order?: number;
}

export interface JobPipelineBucketResponse {
  color?: string;
  corePipelineBucketId?: number;
  description?: string;
  id?: number;
  isActive?: boolean;
  jobPipelineId?: number;
  jobPipelineStepResponses?: JobPipelineStepResponse[];
  name?: string;
  order?: number;
}

export interface JobPipelineRequest {
  id?: number;
  jobId: number;
  jobPipelineBucketRequests?: JobPipelineBucketRequest[];
  pipelineTemplateId?: number;
}

export interface JobPipelineResponse {
  hasApplications?: boolean;
  id?: number;
  jobId: number;
  jobPipelineBucketResponses?: JobPipelineBucketResponse[];
  pipelineTemplateId?: number;
}

export interface JobPipelineStepRequest {
  corePipelineStepId?: number;
  description?: string;
  emailAutomationRequest?: EmailAutomationRequest;
  id?: number;
  jobPipelineBucketId?: number;
  markedForDeletion?: boolean;
  name?: string;
  order?: number;
}

export interface JobPipelineStepResponse {
  corePipelineBucketId?: number;
  corePipelineStepId?: number;
  description?: string;
  emailAutomationResponse?: EmailAutomationResponse;
  id?: number;
  jobPipelineBucketId?: number;
  markedForDeletion?: boolean;
  name?: string;
  order?: number;
  pipelineTemplateStepId?: number;
}

export type JobPositionStatusCandidateFilterSegmentCriteria = typeof JobPositionStatusCandidateFilterSegmentCriteria[keyof typeof JobPositionStatusCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobPositionStatusCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface JobPositionStatusCandidateFilterSegment {
  criteria?: JobPositionStatusCandidateFilterSegmentCriteria;
  isOpen?: boolean;
}

export type JobPositionTypeCandidateFilterSegmentCriteria = typeof JobPositionTypeCandidateFilterSegmentCriteria[keyof typeof JobPositionTypeCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobPositionTypeCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface JobPositionTypeCandidateFilterSegment {
  criteria?: JobPositionTypeCandidateFilterSegmentCriteria;
  positionTypes?: string[];
}

export interface JobPositionTypeResponse {
  id?: number;
  jobId?: number;
  name?: string;
  positionTypeId?: number;
}

export type JobProcessYearCandidateFilterSegmentCriteria = typeof JobProcessYearCandidateFilterSegmentCriteria[keyof typeof JobProcessYearCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobProcessYearCandidateFilterSegmentCriteria = {
  GREATER_THAN: 'GREATER_THAN',
  LESS_THAN: 'LESS_THAN',
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL',
} as const;

export interface JobProcessYearCandidateFilterSegment {
  criteria?: JobProcessYearCandidateFilterSegmentCriteria;
  processYear?: number;
}

export interface JobQuestionOptionRequest {
  id?: number;
  isDeleted?: boolean;
  jobQuestionId?: number;
  orgQuestionOptionId?: number;
}

export interface JobQuestionOptionResponse {
  id?: number;
  isDeleted?: boolean;
  jobQuestionId?: number;
  option?: string;
  orgQuestionOptionId?: number;
}

export interface JobQuestionRequest {
  id?: number;
  isDeleted?: boolean;
  isRequired?: boolean;
  jobQuestionOptions?: JobQuestionOptionRequest[];
  jobSectionId?: number;
  order?: number;
  orgQuestionId?: number;
}

export type JobQuestionResponseQuestionType = typeof JobQuestionResponseQuestionType[keyof typeof JobQuestionResponseQuestionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobQuestionResponseQuestionType = {
  SINGLE_SELECT: 'SINGLE_SELECT',
  FREE_TEXT: 'FREE_TEXT',
  NUMERICAL: 'NUMERICAL',
  MULTI_SELECT: 'MULTI_SELECT',
  DATE: 'DATE',
} as const;

export interface JobQuestionResponse {
  id?: number;
  isDeleted?: boolean;
  isRequired?: boolean;
  jobQuestionOptions?: JobQuestionOptionResponse[];
  jobSectionId?: number;
  label?: string;
  order?: number;
  orgQuestionId?: number;
  questionType?: JobQuestionResponseQuestionType;
  subText?: string;
}

export type JobRequestEnabledAgenciesStatus = typeof JobRequestEnabledAgenciesStatus[keyof typeof JobRequestEnabledAgenciesStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobRequestEnabledAgenciesStatus = {
  ALL_REGISTERED_AGENCIES: 'ALL_REGISTERED_AGENCIES',
  ALL_REGISTERED_AND_UNREGISTERED_AGENCIES: 'ALL_REGISTERED_AND_UNREGISTERED_AGENCIES',
  SELECTED_AGENCIES: 'SELECTED_AGENCIES',
} as const;

export type JobRequestJobType = typeof JobRequestJobType[keyof typeof JobRequestJobType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobRequestJobType = {
  ATS: 'ATS',
  INTERVIEW_SCHEDULING: 'INTERVIEW_SCHEDULING',
  MANUAL_ENTRY: 'MANUAL_ENTRY',
} as const;

export interface JobRequest {
  agencyApplyEnabled?: boolean;
  agencyJobAuthorizationRequests?: AgencyJobAuthorizationRequest[];
  closeDate?: string;
  closeTimezone?: string;
  departmentIds?: number[];
  description?: string;
  employmentTypeIds?: number[];
  enabledAgenciesStatus?: JobRequestEnabledAgenciesStatus;
  enabledForAllAgenciesAndContacts?: boolean;
  id?: number;
  isPublic?: boolean;
  jobHiringLeadIds?: number[];
  jobType?: JobRequestJobType;
  numberOfHires?: number;
  officeIds?: number[];
  openDate?: string;
  openTimezone?: string;
  orgId?: number;
  positionTypeIds?: number[];
  processYear?: number;
  title?: string;
}

export interface JobSchemaRequest {
  jobId?: number;
  jobSections?: JobSectionRequest[];
}

export interface JobSchemaResponse {
  hasJobPipeline?: boolean;
  jobDetailsResponse?: JobDetailsResponse;
  jobOverviewResponse?: JobOverviewResponse;
  sections?: JobSectionResponse[];
}

export type JobSectionRequestJobSectionType = typeof JobSectionRequestJobSectionType[keyof typeof JobSectionRequestJobSectionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobSectionRequestJobSectionType = {
  PERSONAL_INFO: 'PERSONAL_INFO',
  CANDIDATE_DOCUMENTS: 'CANDIDATE_DOCUMENTS',
  EEO_QUESTIONS: 'EEO_QUESTIONS',
  ADDRESS_INFORMATION: 'ADDRESS_INFORMATION',
  EDUCATION_HISTORY: 'EDUCATION_HISTORY',
  WORK_HISTORY: 'WORK_HISTORY',
  CUSTOM_QUESTIONS: 'CUSTOM_QUESTIONS',
  SELF_IDENTIFICATION: 'SELF_IDENTIFICATION',
  EXTERNAL: 'EXTERNAL',
} as const;

export interface JobSectionRequest {
  description?: string;
  id?: number;
  isDeleted?: boolean;
  isRequired?: boolean;
  jobCandidateDocuments?: JobCandidateDocumentRequest[];
  jobId?: number;
  jobQuestions?: JobQuestionRequest[];
  jobSectionType?: JobSectionRequestJobSectionType;
  name?: string;
  order?: number;
}

export type JobSectionResponseJobSectionType = typeof JobSectionResponseJobSectionType[keyof typeof JobSectionResponseJobSectionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobSectionResponseJobSectionType = {
  PERSONAL_INFO: 'PERSONAL_INFO',
  CANDIDATE_DOCUMENTS: 'CANDIDATE_DOCUMENTS',
  EEO_QUESTIONS: 'EEO_QUESTIONS',
  ADDRESS_INFORMATION: 'ADDRESS_INFORMATION',
  EDUCATION_HISTORY: 'EDUCATION_HISTORY',
  WORK_HISTORY: 'WORK_HISTORY',
  CUSTOM_QUESTIONS: 'CUSTOM_QUESTIONS',
  SELF_IDENTIFICATION: 'SELF_IDENTIFICATION',
  EXTERNAL: 'EXTERNAL',
} as const;

export interface JobSectionResponse {
  description?: string;
  id?: number;
  isDeleted?: boolean;
  isRequired?: boolean;
  jobCandidateDocuments?: JobCandidateDocumentResponse[];
  jobId?: number;
  jobQuestions?: JobQuestionResponse[];
  jobSectionType?: JobSectionResponseJobSectionType;
  name?: string;
  order?: number;
  orgSelfIdQuestions?: OrgSelfIdQuestionNode[];
}

export type JobStatusCandidateFilterSegmentCriteria = typeof JobStatusCandidateFilterSegmentCriteria[keyof typeof JobStatusCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobStatusCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface JobStatusCandidateFilterSegment {
  coreStatusIds?: number[];
  criteria?: JobStatusCandidateFilterSegmentCriteria;
  jobId?: number;
}

export interface JobStatusHistoricalFilterSegment {
  coreStatusId?: number;
  endDate?: string;
  jobIds?: number[];
  startDate?: string;
}

export type LastActivityDateCandidateFilterSegmentCriteria = typeof LastActivityDateCandidateFilterSegmentCriteria[keyof typeof LastActivityDateCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LastActivityDateCandidateFilterSegmentCriteria = {
  ON: 'ON',
  BEFORE: 'BEFORE',
  AFTER: 'AFTER',
  ON_OR_BEFORE: 'ON_OR_BEFORE',
  ON_OR_AFTER: 'ON_OR_AFTER',
} as const;

export interface LastActivityDateCandidateFilterSegment {
  criteria?: LastActivityDateCandidateFilterSegmentCriteria;
  date?: string;
}

export interface LocalTime {
  hour?: number;
  minute?: number;
  nano?: number;
  second?: number;
}

export interface LotteryMatchForEmployerScheduleInterviewerResponse {
  email?: string;
  firstName?: string;
  lastName?: string;
  userId?: number;
}

export type LotteryMatchForEmployerScheduleResponseDocumentStatus = typeof LotteryMatchForEmployerScheduleResponseDocumentStatus[keyof typeof LotteryMatchForEmployerScheduleResponseDocumentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LotteryMatchForEmployerScheduleResponseDocumentStatus = {
  COMPLETE: 'COMPLETE',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED',
} as const;

export interface LotteryMatchForEmployerScheduleResponse {
  documentStatus?: LotteryMatchForEmployerScheduleResponseDocumentStatus;
  interviewEndUtc?: string;
  interviewStartUtc?: string;
  interviewers?: LotteryMatchForEmployerScheduleInterviewerResponse[];
  matchId?: number;
  officePreferences?: LotteryMatchForEmployerScheduleStudentOfficePreferenceResponse[];
  practiceAreaPreferences?: LotteryMatchForEmployerScheduleStudentPracticeAreaPreferenceResponse[];
  scheduleId?: number;
  universityRecruitId?: number;
}

export interface LotteryMatchForEmployerScheduleStudentOfficePreferenceResponse {
  officeLocationId?: number;
  officeLocationName?: string;
  orgOfficeId?: number;
  preferenceId?: number;
  rank?: number;
}

export interface LotteryMatchForEmployerScheduleStudentPracticeAreaPreferenceResponse {
  practiceAreaId?: number;
  practiceAreaName?: string;
  preferenceId?: number;
  rank?: number;
}

export type LotteryUnmatchedBidsForEmployerScheduleResponseDocumentStatus = typeof LotteryUnmatchedBidsForEmployerScheduleResponseDocumentStatus[keyof typeof LotteryUnmatchedBidsForEmployerScheduleResponseDocumentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LotteryUnmatchedBidsForEmployerScheduleResponseDocumentStatus = {
  COMPLETE: 'COMPLETE',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED',
} as const;

export interface LotteryUnmatchedBidsForEmployerScheduleResponse {
  documentStatus?: LotteryUnmatchedBidsForEmployerScheduleResponseDocumentStatus;
  officePreferences?: LotteryMatchForEmployerScheduleStudentOfficePreferenceResponse[];
  practiceAreaPreferences?: LotteryMatchForEmployerScheduleStudentPracticeAreaPreferenceResponse[];
  scheduleId?: number;
  studentInformation?: Student;
  universityRecruitId?: number;
}

export interface NetworkingTimeslot {
  capacity?: number;
  createdAt?: string;
  dailyname?: string;
  deletedAt?: string;
  id?: number;
  imageUrl?: string;
  lockedByEmployers?: number;
  networkingBlockId?: number;
  roomDescription?: string;
  roomName?: string;
  updatedAt?: string;
}

export interface NetworkingTimeslotDTO {
  capacity?: number;
  createdAt?: string;
  dailyname?: string;
  deletedAt?: string;
  id?: number;
  imageUrl?: string;
  lockedByEmployers?: number;
  networkingBlockId?: number;
  roomDescription?: string;
  roomName?: string;
  updatedAt?: string;
}

export interface NetworkingWebinarDTO {
  dailyName?: string;
  description?: string;
  eid?: number;
  endTime?: LocalTime;
  id?: number;
  name?: string;
  speakerRids?: number[];
  speakerUids?: number[];
  startTime?: LocalTime;
}

export interface NewCandidateDTO {
  email?: string;
  firstName?: string;
  lastName?: string;
  linkedin?: string;
  phone?: string;
}

export interface NewMemberRequest {
  eventId?: number;
  firstName?: string;
  lastName?: string;
  temporaryEmployerRegistrantExtension?: string;
}

export interface NewOrgRequest {
  description?: string;
  eventId?: number;
  orgName?: string;
  tempEmployerRegistrantExtension?: string;
}

export interface OfficeResponse {
  description?: string;
  id?: number;
  name?: string;
}

export type OrgCustomDocumentsCandidateFilterSegmentCriteria = typeof OrgCustomDocumentsCandidateFilterSegmentCriteria[keyof typeof OrgCustomDocumentsCandidateFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrgCustomDocumentsCandidateFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface OrgCustomDocumentsCandidateFilterSegment {
  criteria?: OrgCustomDocumentsCandidateFilterSegmentCriteria;
  orgCustomDocIds?: number[];
}

export type OrgDTOTimezoneplan = typeof OrgDTOTimezoneplan[keyof typeof OrgDTOTimezoneplan];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrgDTOTimezoneplan = {
  NORTH_AMERICA: 'NORTH_AMERICA',
  INTERNATIONAL: 'INTERNATIONAL',
  EUROPE: 'EUROPE',
} as const;

export interface OrgDTO {
  active?: number;
  ats?: boolean;
  color?: string;
  dni?: number;
  domain?: string;
  friendlyname?: string;
  id?: number;
  industry?: string;
  logo?: string;
  name?: string;
  timezoneplan?: OrgDTOTimezoneplan;
  university?: boolean;
}

export type OrgFeedbackEvaluationType = typeof OrgFeedbackEvaluationType[keyof typeof OrgFeedbackEvaluationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrgFeedbackEvaluationType = {
  EVENT: 'EVENT',
  WORK_ALLOCATION: 'WORK_ALLOCATION',
} as const;

export type OrgFeedbackType = typeof OrgFeedbackType[keyof typeof OrgFeedbackType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrgFeedbackType = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
  NUMBER_5: '5',
} as const;

export interface OrgFeedback {
  candidateEvaluations?: CandidateEvaluation[];
  commentsEnabled?: boolean;
  evaluationType?: OrgFeedbackEvaluationType;
  highLabel?: string;
  highScale?: number;
  id?: number;
  label?: string;
  lowLabel?: string;
  lowScale?: number;
  orgId?: number;
  selectOptions?: string[];
  subtext?: string;
  type?: OrgFeedbackType;
}

export type OrgFeedbackDataAnalyticsDtoAnswerCounts = {[key: string]: number};

export type OrgFeedbackDataAnalyticsDtoRatingCounts = {[key: string]: number};

export type OrgFeedbackDataAnalyticsDtoType = typeof OrgFeedbackDataAnalyticsDtoType[keyof typeof OrgFeedbackDataAnalyticsDtoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrgFeedbackDataAnalyticsDtoType = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
  NUMBER_5: '5',
} as const;

export interface OrgFeedbackDataAnalyticsDto {
  answerCounts?: OrgFeedbackDataAnalyticsDtoAnswerCounts;
  highLabel?: string;
  highScale?: number;
  id?: number;
  label?: string;
  lowLabel?: string;
  lowScale?: number;
  ratingCounts?: OrgFeedbackDataAnalyticsDtoRatingCounts;
  type?: OrgFeedbackDataAnalyticsDtoType;
}

export interface OrgForwardPrivilegesResponse {
  carouselEventPublishing?: boolean;
  directoryEventPublishing?: boolean;
  lawSchoolTargeting?: boolean;
  orgId?: number;
}

export interface OrgQuestionOptionRequest {
  coreQuestionOptionId?: number;
  id?: number;
  isDeleted?: boolean;
  option?: string;
  order?: number;
  orgQuestionId?: number;
}

export interface OrgQuestionOptionResponse {
  coreQuestionOptionId?: number;
  id?: number;
  isDeleted?: boolean;
  option?: string;
  order?: number;
  orgQuestionId?: number;
}

export type OrgQuestionRequestJobSectionType = typeof OrgQuestionRequestJobSectionType[keyof typeof OrgQuestionRequestJobSectionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrgQuestionRequestJobSectionType = {
  PERSONAL_INFO: 'PERSONAL_INFO',
  CANDIDATE_DOCUMENTS: 'CANDIDATE_DOCUMENTS',
  EEO_QUESTIONS: 'EEO_QUESTIONS',
  ADDRESS_INFORMATION: 'ADDRESS_INFORMATION',
  EDUCATION_HISTORY: 'EDUCATION_HISTORY',
  WORK_HISTORY: 'WORK_HISTORY',
  CUSTOM_QUESTIONS: 'CUSTOM_QUESTIONS',
  SELF_IDENTIFICATION: 'SELF_IDENTIFICATION',
  EXTERNAL: 'EXTERNAL',
} as const;

export type OrgQuestionRequestQuestionType = typeof OrgQuestionRequestQuestionType[keyof typeof OrgQuestionRequestQuestionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrgQuestionRequestQuestionType = {
  SINGLE_SELECT: 'SINGLE_SELECT',
  FREE_TEXT: 'FREE_TEXT',
  NUMERICAL: 'NUMERICAL',
  MULTI_SELECT: 'MULTI_SELECT',
  DATE: 'DATE',
} as const;

export interface OrgQuestionRequest {
  coreQuestionId?: number;
  id?: number;
  jobSectionType?: OrgQuestionRequestJobSectionType;
  label?: string;
  orgQuestionOptionRequests?: OrgQuestionOptionRequest[];
  questionType?: OrgQuestionRequestQuestionType;
  subText?: string;
}

export type OrgQuestionResponseJobSectionType = typeof OrgQuestionResponseJobSectionType[keyof typeof OrgQuestionResponseJobSectionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrgQuestionResponseJobSectionType = {
  PERSONAL_INFO: 'PERSONAL_INFO',
  CANDIDATE_DOCUMENTS: 'CANDIDATE_DOCUMENTS',
  EEO_QUESTIONS: 'EEO_QUESTIONS',
  ADDRESS_INFORMATION: 'ADDRESS_INFORMATION',
  EDUCATION_HISTORY: 'EDUCATION_HISTORY',
  WORK_HISTORY: 'WORK_HISTORY',
  CUSTOM_QUESTIONS: 'CUSTOM_QUESTIONS',
  SELF_IDENTIFICATION: 'SELF_IDENTIFICATION',
  EXTERNAL: 'EXTERNAL',
} as const;

export type OrgQuestionResponseQuestionType = typeof OrgQuestionResponseQuestionType[keyof typeof OrgQuestionResponseQuestionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrgQuestionResponseQuestionType = {
  SINGLE_SELECT: 'SINGLE_SELECT',
  FREE_TEXT: 'FREE_TEXT',
  NUMERICAL: 'NUMERICAL',
  MULTI_SELECT: 'MULTI_SELECT',
  DATE: 'DATE',
} as const;

export interface OrgQuestionResponse {
  coreQuestionId?: number;
  id?: number;
  jobSectionType?: OrgQuestionResponseJobSectionType;
  label?: string;
  orgId?: number;
  orgQuestionOptionResponses?: OrgQuestionOptionResponse[];
  questionType?: OrgQuestionResponseQuestionType;
  subText?: string;
}

export interface OrgRecruitCustomDocumentViewWithAvailableTime {
  availableDate?: string;
  availableTime?: string;
  availableTimezone?: string;
  createdat?: string;
  customDocumentName?: string;
  isDocumentAvailableImmediately?: boolean;
  location?: string;
  orgDocId?: number;
  recruitCustomDocumentId?: number;
  recruitId?: number;
  updatedAt?: string;
}

export interface OrgSelfIdQuestionAnswerSelectionNode {
  id?: number;
  orgSelfIdQuestionAnswerId?: number;
  orgSelfIdQuestionOptionId?: number;
}

export interface OrgSelfIdQuestionNode {
  description?: string;
  enabled?: boolean;
  id?: string;
  isGovernment?: boolean;
  label?: string;
  name?: string;
  orgSelfIdQuestionOptions?: OrgSelfIdQuestionOptionNode[];
  questionType?: string;
  selfIdDefaultId?: number;
  selfIdType?: string;
}

export interface OrgSelfIdQuestionOptionNode {
  deletedAt?: string;
  id?: string;
  name?: string;
}

export interface OrgSelfIdQuestionOptionRequest {
  id?: number;
  name?: string;
  orgSelfIdQuestionId?: number;
}

export type OrgSelfIdQuestionRequestQuestionType = typeof OrgSelfIdQuestionRequestQuestionType[keyof typeof OrgSelfIdQuestionRequestQuestionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrgSelfIdQuestionRequestQuestionType = {
  SINGLE_SELECT: 'SINGLE_SELECT',
  FREE_TEXT: 'FREE_TEXT',
  NUMERICAL: 'NUMERICAL',
  MULTI_SELECT: 'MULTI_SELECT',
  DATE: 'DATE',
} as const;

export type OrgSelfIdQuestionRequestSelfIdType = typeof OrgSelfIdQuestionRequestSelfIdType[keyof typeof OrgSelfIdQuestionRequestSelfIdType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrgSelfIdQuestionRequestSelfIdType = {
  GENDER_ID: 'GENDER_ID',
  VETERAN_STATUS: 'VETERAN_STATUS',
  ETHNICITY_ID: 'ETHNICITY_ID',
  DISABILITY_STATUS: 'DISABILITY_STATUS',
  SEXUAL_ORIENTATION: 'SEXUAL_ORIENTATION',
  DESCRIPTION: 'DESCRIPTION',
  CUSTOM_QUESTION: 'CUSTOM_QUESTION',
  GOV_OPT_OUT_1: 'GOV_OPT_OUT_1',
  GOV_DEMOGRAPHIC_1: 'GOV_DEMOGRAPHIC_1',
  GOV_DEMOGRAPHIC_2: 'GOV_DEMOGRAPHIC_2',
  GOV_DEMOGRAPHIC_3: 'GOV_DEMOGRAPHIC_3',
  GOV_DEMOGRAPHIC_3_1: 'GOV_DEMOGRAPHIC_3_1',
  GOV_DEMOGRAPHIC_3_2: 'GOV_DEMOGRAPHIC_3_2',
  GOV_VETERAN_1: 'GOV_VETERAN_1',
  GOV_DISABILITY_1: 'GOV_DISABILITY_1',
  GOV_DISABILITY_2: 'GOV_DISABILITY_2',
  GOV_DISABILITY_3: 'GOV_DISABILITY_3',
  GOV_DISABILITY_4: 'GOV_DISABILITY_4',
  NALP_ADDITIONAL: 'NALP_ADDITIONAL',
} as const;

export interface OrgSelfIdQuestionRequest {
  enabled?: boolean;
  id?: number;
  label?: string;
  name?: string;
  orgSelfIdQuestionOptions?: OrgSelfIdQuestionOptionRequest[];
  questionType?: OrgSelfIdQuestionRequestQuestionType;
  selfIdDefaultId?: number;
  selfIdType?: OrgSelfIdQuestionRequestSelfIdType;
}

export interface OrgTagDto {
  custom?: number;
  id?: number;
  oid?: number;
  tag?: string;
}

export interface OrgTagRequest {
  id?: number;
  tag?: string;
}

export interface Orgcustomdocuments {
  documentType?: number;
  id?: number;
  name?: string;
  oid?: number;
}

export interface ParticipantsByRoomRequest {
  dailyRooms?: string[];
}

export interface Pet {
  id?: number;
  matterId?: number;
  petName?: string;
}

export type PipelineTemplateAutomationRequestAutomationType = typeof PipelineTemplateAutomationRequestAutomationType[keyof typeof PipelineTemplateAutomationRequestAutomationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PipelineTemplateAutomationRequestAutomationType = {
  UNDEFINED: 'UNDEFINED',
  PIPELINE_EMAIL: 'PIPELINE_EMAIL',
  PIPELINE_STATUS: 'PIPELINE_STATUS',
} as const;

export type PipelineTemplateAutomationRequestTrigger = typeof PipelineTemplateAutomationRequestTrigger[keyof typeof PipelineTemplateAutomationRequestTrigger];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PipelineTemplateAutomationRequestTrigger = {
  UNDEFINED: 'UNDEFINED',
  CANDIDATE_EVENT_REGISTERED: 'CANDIDATE_EVENT_REGISTERED',
  CANDIDATE_EVENT_INTERVIEW_SCHEDULED: 'CANDIDATE_EVENT_INTERVIEW_SCHEDULED',
} as const;

export interface PipelineTemplateAutomationRequest {
  automationType?: PipelineTemplateAutomationRequestAutomationType;
  body?: string;
  fromUserId?: number;
  id?: number;
  markedForDeletion?: boolean;
  moveToPipelineTemplateStepId?: number;
  name?: string;
  pipelineTemplateStepId?: number;
  subject?: string;
  timeDelay?: number;
  trigger?: PipelineTemplateAutomationRequestTrigger;
}

export interface PipelineTemplateBucketRequest {
  color?: string;
  corePipelineBucketId?: number;
  description?: string;
  id?: number;
  isActive?: boolean;
  order?: number;
  pipelineTemplateId?: number;
  pipelineTemplateStepRequests?: PipelineTemplateStepRequest[];
}

export interface PipelineTemplateBucketResponse {
  availableSteps?: CorePipelineStepResponse[];
  color?: string;
  corePipelineBucketId?: number;
  description?: string;
  id?: number;
  isActive?: boolean;
  name?: string;
  order?: number;
  pipelineTemplateId?: number;
  pipelineTemplateSteps?: PipelineTemplateStepResponse[];
}

export interface PipelineTemplateJobPipelineDiffRequest {
  allJobs?: boolean;
  jobIds?: number[];
  pipelineTemplateId?: number;
}

export interface PipelineTemplateJobPipelineDiffResponse {
  corePipelineStepsMissingFromJobPipelines?: CorePipelineStepResponse[];
  corePipelineStepsMissingFromPipelineTemplate?: CorePipelineStepResponse[];
  differencesFound?: boolean;
}

export interface PipelineTemplateOverviewResponse {
  containsArchivedStatus?: boolean;
  deletedAt?: string;
  description?: string;
  id?: number;
  isActive?: boolean;
  jobCount?: number;
  name?: string;
}

export interface PipelineTemplateRequest {
  description?: string;
  id?: number;
  isActive?: boolean;
  name?: string;
  orgId?: number;
}

export interface PipelineTemplateResponse {
  description?: string;
  id?: number;
  jobPostCount?: number;
  name?: string;
  pipelineTemplateBucketResponses?: PipelineTemplateBucketResponse[];
}

export interface PipelineTemplateSearchRequest {
  corePipelineStepIds?: number[];
}

export interface PipelineTemplateStepRequest {
  corePipelineStepId?: number;
  description?: string;
  emailAutomationTemplateRequest?: EmailAutomationTemplateRequest;
  id?: number;
  markedForDeletion?: boolean;
  offerAffirmationDateEnabled?: boolean;
  offerDateEnabled?: boolean;
  offerExpirationDateEnabled?: boolean;
  order?: number;
  pipelineTemplateAutomationRequests?: PipelineTemplateAutomationRequest[];
  pipelineTemplateBucketId?: number;
}

export interface PipelineTemplateStepResponse {
  corePipelineStepId?: number;
  corePipelineStepIsActive?: boolean;
  description?: string;
  emailAutomationTemplateResponse?: EmailAutomationTemplateResponse;
  id?: number;
  name?: string;
  offerAffirmationDateEnabled?: boolean;
  offerDateEnabled?: boolean;
  offerExpirationDateEnabled?: boolean;
  order?: number;
  pipelineTemplateBucketId?: number;
}

export interface PipelineTemplateSyncRequest {
  jobIds?: number[];
  pipelineTemplateId?: number;
  pipelineTemplateSyncStepResolutions?: PipelineTemplateSyncStepResolution[];
  updateAllJobs?: boolean;
}

export interface PipelineTemplateSyncStepResolution {
  newCorePipelineStepId?: number;
  previousCorePipelineStepId?: number;
}

export interface PositionRequest {
  createdAt?: string;
  deletedAt?: string;
  id?: number;
  name?: string;
  orgId?: number;
  updatedAt?: string;
}

export interface PositionResponse {
  createdAt?: string;
  createdBy?: string;
  deletedAt?: string;
  deletedBy?: string;
  id?: number;
  name?: string;
  orgId?: number;
  updatedAt?: string;
  updatedBy?: string;
}

export interface PreselectEmployerScheduleInterviewerResponse {
  email?: string;
  firstName?: string;
  lastName?: string;
  userId?: number;
}

export interface PreselectEmployerScheduleStudentOfficePreferenceResponse {
  officeLocationId?: number;
  officeLocationName?: string;
  orgOfficeId?: number;
}

export interface PreselectEmployerScheduleStudentPracticeAreaPreferenceResponse {
  practiceAreaId?: number;
  practiceAreaName?: string;
}

export type PreselectMatchedUnmatchedForEmployerScheduleResponseDocumentStatus = typeof PreselectMatchedUnmatchedForEmployerScheduleResponseDocumentStatus[keyof typeof PreselectMatchedUnmatchedForEmployerScheduleResponseDocumentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreselectMatchedUnmatchedForEmployerScheduleResponseDocumentStatus = {
  COMPLETE: 'COMPLETE',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED',
} as const;

export type PreselectMatchedUnmatchedForEmployerScheduleResponseOfficePreferencesScheduleSetting = typeof PreselectMatchedUnmatchedForEmployerScheduleResponseOfficePreferencesScheduleSetting[keyof typeof PreselectMatchedUnmatchedForEmployerScheduleResponseOfficePreferencesScheduleSetting];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreselectMatchedUnmatchedForEmployerScheduleResponseOfficePreferencesScheduleSetting = {
  All_LOCATIONS: 'All_LOCATIONS',
  SELECTED_LOCATIONS: 'SELECTED_LOCATIONS',
  UNSET: 'UNSET',
} as const;

export type PreselectMatchedUnmatchedForEmployerScheduleResponsePracticeAreasScheduleSetting = typeof PreselectMatchedUnmatchedForEmployerScheduleResponsePracticeAreasScheduleSetting[keyof typeof PreselectMatchedUnmatchedForEmployerScheduleResponsePracticeAreasScheduleSetting];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreselectMatchedUnmatchedForEmployerScheduleResponsePracticeAreasScheduleSetting = {
  SPECIFIED: 'SPECIFIED',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
  UNSET: 'UNSET',
} as const;

export interface PreselectMatchedUnmatchedForEmployerScheduleResponse {
  documentCollect?: boolean;
  documentStatus?: PreselectMatchedUnmatchedForEmployerScheduleResponseDocumentStatus;
  interviewEndUtc?: string;
  interviewLocation?: string;
  interviewStartUtc?: string;
  interviewers?: PreselectEmployerScheduleInterviewerResponse[];
  jobApplicationId?: number;
  jobTitle?: string;
  matched?: boolean;
  officePreferences?: PreselectEmployerScheduleStudentOfficePreferenceResponse[];
  officePreferencesScheduleSetting?: PreselectMatchedUnmatchedForEmployerScheduleResponseOfficePreferencesScheduleSetting;
  practiceAreaPreferences?: PreselectEmployerScheduleStudentPracticeAreaPreferenceResponse[];
  practiceAreasScheduleSetting?: PreselectMatchedUnmatchedForEmployerScheduleResponsePracticeAreasScheduleSetting;
  scheduleId?: number;
  studentInformation?: Student;
  universityRecruitId?: number;
}

export type PublicEventResponseVirtualEventTypeEnum = typeof PublicEventResponseVirtualEventTypeEnum[keyof typeof PublicEventResponseVirtualEventTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublicEventResponseVirtualEventTypeEnum = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
  NUMBER_5: '5',
  NUMBER_6: '6',
  NUMBER_7: '7',
  NUMBER_8: '8',
  NUMBER_9: '9',
  NUMBER_10: '10',
  NUMBER_11: '11',
  NUMBER_12: '12',
  NUMBER_13: '13',
  NUMBER_14: '14',
} as const;

export interface PublicEventResponse {
  description?: string;
  endDateTime?: string;
  id?: number;
  name?: string;
  registrationEndDateTime?: string;
  registrationStartDateTime?: string;
  startDateTime?: string;
  virtualEventTypeEnum?: PublicEventResponseVirtualEventTypeEnum;
}

export interface PublicHiringLeadResponse {
  email?: string;
  fname?: string;
  id?: number;
  lname?: string;
}

export interface PublicJobDepartmentResponse {
  departmentId?: number;
  id?: number;
  jobId?: number;
  name?: string;
}

export interface PublicJobEmploymentTypeResponse {
  employmentType?: string;
  employmentTypeId?: number;
  id?: number;
  jobId?: number;
}

export interface PublicJobOfficeResponse {
  id?: number;
  jobId?: number;
  name?: string;
  officeId?: number;
}

export interface PublicJobPositionTypeResponse {
  id?: number;
  jobId?: number;
  name?: string;
  positionTypeId?: number;
}

export type QualifyingQuestionAnswerFilterCriteria = typeof QualifyingQuestionAnswerFilterCriteria[keyof typeof QualifyingQuestionAnswerFilterCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QualifyingQuestionAnswerFilterCriteria = {
  CONTAINS: 'CONTAINS',
  NOT_CONTAINS: 'NOT_CONTAINS',
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
  STARTS_WITH: 'STARTS_WITH',
} as const;

export interface QualifyingQuestionAnswerFilter {
  answer?: string;
  criteria?: QualifyingQuestionAnswerFilterCriteria;
  qualifyingQuestionId?: number;
}

export type QualifyingQuestionAnswerFilterSegmentCriteria = typeof QualifyingQuestionAnswerFilterSegmentCriteria[keyof typeof QualifyingQuestionAnswerFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QualifyingQuestionAnswerFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  CONTAINS_ANY: 'CONTAINS_ANY',
  DOES_NOT_CONTAIN_ANY: 'DOES_NOT_CONTAIN_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  DOES_NOT_CONTAIN_ALL: 'DOES_NOT_CONTAIN_ALL',
} as const;

export interface QualifyingQuestionAnswerFilterSegment {
  answers?: string[];
  criteria?: QualifyingQuestionAnswerFilterSegmentCriteria;
  qualifyingQuestionId?: number;
}

export type QualifyingQuestionDataAnalyticsDtoAnswerCounts = {[key: string]: number};

export type QualifyingQuestionDataAnalyticsDtoQualifyingQuestionType = typeof QualifyingQuestionDataAnalyticsDtoQualifyingQuestionType[keyof typeof QualifyingQuestionDataAnalyticsDtoQualifyingQuestionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QualifyingQuestionDataAnalyticsDtoQualifyingQuestionType = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
} as const;

export interface QualifyingQuestionDataAnalyticsDto {
  answerCounts?: QualifyingQuestionDataAnalyticsDtoAnswerCounts;
  id?: number;
  qualifyingQuestionType?: QualifyingQuestionDataAnalyticsDtoQualifyingQuestionType;
  question?: string;
}

export type QualifyingQuestionFreeTextAnswerFilterSegmentCriteria = typeof QualifyingQuestionFreeTextAnswerFilterSegmentCriteria[keyof typeof QualifyingQuestionFreeTextAnswerFilterSegmentCriteria];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QualifyingQuestionFreeTextAnswerFilterSegmentCriteria = {
  CONTAINS: 'CONTAINS',
  NOT_CONTAINS: 'NOT_CONTAINS',
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
  STARTS_WITH: 'STARTS_WITH',
} as const;

export interface QualifyingQuestionFreeTextAnswerFilterSegment {
  answer?: string;
  criteria?: QualifyingQuestionFreeTextAnswerFilterSegmentCriteria;
  qualifyingQuestionId?: number;
}

export type QualifyingQuestionWithCandidateAnswersDtoLocked = typeof QualifyingQuestionWithCandidateAnswersDtoLocked[keyof typeof QualifyingQuestionWithCandidateAnswersDtoLocked];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QualifyingQuestionWithCandidateAnswersDtoLocked = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
} as const;

export type QualifyingQuestionWithCandidateAnswersDtoType = typeof QualifyingQuestionWithCandidateAnswersDtoType[keyof typeof QualifyingQuestionWithCandidateAnswersDtoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QualifyingQuestionWithCandidateAnswersDtoType = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
} as const;

export interface QualifyingQuestionWithCandidateAnswersDto {
  answerPresetOptions?: string[];
  candidateAnswers?: string[];
  id?: number;
  locked?: QualifyingQuestionWithCandidateAnswersDtoLocked;
  question?: string;
  type?: QualifyingQuestionWithCandidateAnswersDtoType;
}

export type RecruitsDTOUserRecruitType = typeof RecruitsDTOUserRecruitType[keyof typeof RecruitsDTOUserRecruitType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecruitsDTOUserRecruitType = {
  STUDENT: 'STUDENT',
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  EMPLOYER: 'EMPLOYER',
  ASSOCIATE: 'ASSOCIATE',
} as const;

export interface RecruitsDTO {
  email?: string;
  fname?: string;
  id?: number;
  imagepoint?: string;
  linkedin?: string;
  lname?: string;
  phone?: string;
  userRecruitType?: RecruitsDTOUserRecruitType;
  videoChatLink?: string;
}

export interface RegisterCandidateForEventResponse {
  registrationUrl?: string;
  success?: boolean;
}

export interface RegistrationLinksResponse {
  employerRegistrationLink?: string;
  studentRegistrationLink?: string;
}

export interface ReminderEmailRequest {
  windowTime?: number;
}

export interface RequestDocument {
  customDate?: string;
  customTime?: string;
  customTimezone?: string;
  docName?: string;
  id?: number;
  orgDocId?: number;
  required?: boolean;
  visibleImmediately?: boolean;
}

export interface SaveStudentInfoRequest {
  classYear?: string;
  eventId?: number;
  firstName?: string;
  gradYear?: string;
  lastName?: string;
  lawSchool?: string;
  orgFriendlyName?: string;
  phone?: string;
  shouldSendStudentEventEmail?: boolean;
}

export type SavedFilterRequestPage = typeof SavedFilterRequestPage[keyof typeof SavedFilterRequestPage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SavedFilterRequestPage = {
  JOB_DETAILS: 'JOB_DETAILS',
  JOB_LIST: 'JOB_LIST',
  CANIDATE_LIST: 'CANIDATE_LIST',
  ADD_CANDIDATE: 'ADD_CANDIDATE',
  BETTER_CANDIDATE_LIST_PAGE: 'BETTER_CANDIDATE_LIST_PAGE',
} as const;

export interface SavedFilterRequest {
  filterJson?: string;
  id?: number;
  isDefault?: boolean;
  name?: string;
  page?: SavedFilterRequestPage;
}

export type SavedFilterResponsePage = typeof SavedFilterResponsePage[keyof typeof SavedFilterResponsePage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SavedFilterResponsePage = {
  JOB_DETAILS: 'JOB_DETAILS',
  JOB_LIST: 'JOB_LIST',
  CANIDATE_LIST: 'CANIDATE_LIST',
  ADD_CANDIDATE: 'ADD_CANDIDATE',
  BETTER_CANDIDATE_LIST_PAGE: 'BETTER_CANDIDATE_LIST_PAGE',
} as const;

export interface SavedFilterResponse {
  filterJson?: string;
  id?: number;
  isDefault?: boolean;
  name?: string;
  page?: SavedFilterResponsePage;
}

export type ScheduleSettingsInterviewOptionRequestPreferredInterviewType = typeof ScheduleSettingsInterviewOptionRequestPreferredInterviewType[keyof typeof ScheduleSettingsInterviewOptionRequestPreferredInterviewType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScheduleSettingsInterviewOptionRequestPreferredInterviewType = {
  PHYSICAL: 'PHYSICAL',
  VIRTUAL: 'VIRTUAL',
} as const;

export interface ScheduleSettingsInterviewOptionRequest {
  interviewers?: EmployerInterviewScheduleInterviewerRequest[];
  preferredInterviewType?: ScheduleSettingsInterviewOptionRequestPreferredInterviewType;
  scheduleOptionId?: number;
}

export type ScheduleSettingsRequestPreferredTimeblock = typeof ScheduleSettingsRequestPreferredTimeblock[keyof typeof ScheduleSettingsRequestPreferredTimeblock];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScheduleSettingsRequestPreferredTimeblock = {
  FULL_DAY: 'FULL_DAY',
  HALF_DAY_MORNING: 'HALF_DAY_MORNING',
  HALF_DAY_AFTERNOON: 'HALF_DAY_AFTERNOON',
} as const;

export interface ScheduleSettingsRequest {
  firstDateChoice?: string;
  preferredDate?: string[];
  preferredTimeblock?: ScheduleSettingsRequestPreferredTimeblock;
  scheduleOptions?: ScheduleSettingsInterviewOptionRequest[];
  secondDateChoice?: string;
  thirdDateChoice?: string;
}

export interface SendCandidateReminderEmailRequest {
  recruitIds?: number[];
}

export interface SendEmailRequest {
  email?: string;
}

export interface SendEmployerRegistrationReminderEmailRequest {
  scheduleIds?: number[];
}

export interface SendInterviewInformationEmailRequest {
  scheduleIds?: number[];
}

export interface SendInterviewSchedulingEmailRequest {
  userIds?: number[];
}

export type SendMemberFeedbackReminderEmailRequestEmailVariant = typeof SendMemberFeedbackReminderEmailRequestEmailVariant[keyof typeof SendMemberFeedbackReminderEmailRequestEmailVariant];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SendMemberFeedbackReminderEmailRequestEmailVariant = {
  ONE_HOUR_BEFORE: 'ONE_HOUR_BEFORE',
  TEN_MINUTES_BEFORE: 'TEN_MINUTES_BEFORE',
  THIRTY_MINUTES_AFTER: 'THIRTY_MINUTES_AFTER',
  ONE_DAY_AFTER: 'ONE_DAY_AFTER',
} as const;

export interface SendMemberFeedbackReminderEmailRequest {
  emailVariant?: SendMemberFeedbackReminderEmailRequestEmailVariant;
  memberUserIds?: number[];
}

export interface SendStudentApplicationDeadlineReminderEmailRequest {
  recruitIds?: number[];
}

export type SerendipitousEventsRecruitsDTOUserRecruitType = typeof SerendipitousEventsRecruitsDTOUserRecruitType[keyof typeof SerendipitousEventsRecruitsDTOUserRecruitType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SerendipitousEventsRecruitsDTOUserRecruitType = {
  STUDENT: 'STUDENT',
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  EMPLOYER: 'EMPLOYER',
  ASSOCIATE: 'ASSOCIATE',
} as const;

export interface SerendipitousEventsRecruitsDTO {
  email?: string;
  fname?: string;
  id?: number;
  imagepoint?: string;
  linkedin?: string;
  lname?: string;
  phone?: string;
  recruitDocuments?: OrgRecruitCustomDocumentViewWithAvailableTime[];
  resume?: string;
  resumeAvailableDate?: string;
  resumeAvailableTime?: string;
  resumeAvailableTimezone?: string;
  resumeImmediately?: string;
  resumeOrgDocId?: number;
  transcript?: string;
  transcriptAvailableDate?: string;
  transcriptAvailableTime?: string;
  transcriptAvailableTimezone?: string;
  transcriptImmediately?: string;
  transcriptOrgDocId?: number;
  userRecruitType?: SerendipitousEventsRecruitsDTOUserRecruitType;
  videoChatLink?: string;
}

export interface SetWebinarStatusRequest {
  stopWebinar?: boolean;
}

export interface SpecificJobCustomDocumentsCandidateFilterSegment {
  exists?: boolean;
  jobCustomDocId?: number;
  jobId?: number;
}

export interface StatusActivityReportExportRequest {
  rids?: number[];
  timeZoneId?: string;
}

export type StudentClassification = typeof StudentClassification[keyof typeof StudentClassification];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentClassification = {
  FIRST_YEAR: 'FIRST_YEAR',
  SECOND_YEAR: 'SECOND_YEAR',
  THIRD_YEAR: 'THIRD_YEAR',
  MASTER_OF_LAWS: 'MASTER_OF_LAWS',
  POST_GRADUATE: 'POST_GRADUATE',
} as const;

export interface Student {
  candidateId?: number;
  classification?: StudentClassification;
  email?: string;
  encodedExtension?: string;
  firstName?: string;
  graduationYear?: number;
  imagePoint?: string;
  lastName?: string;
  lawSchool?: string;
  phoneNumber?: string;
  recruitId?: number;
  universityEventId?: number;
  universityOrgId?: number;
}

export interface StudentDetailsRequest {
  deleteImage?: boolean;
  document?: Blob;
  firstName?: string;
  lastName?: string;
  linkedin?: string;
  phone?: string;
  sendConfirmationEmail?: boolean;
}

export interface StudentEventDetailsNonAdminResponse {
  applicationStartDate?: EventDateResponse;
  biddingStartDate?: EventDateResponse;
  deadline?: EventDateResponse;
  endDate?: EventDateResponse;
  eventDescription?: string;
  name?: string;
  reviewPeriodStartDate?: EventDateResponse;
  startDate?: EventDateResponse;
}

export interface StudentInfoResponse {
  classYear?: string;
  email?: string;
  firstName?: string;
  gradYear?: string;
  lastName?: string;
  lawSchool?: string;
  phoneNumber?: string;
}

export interface SubmitAttendeeDetailsRequest {
  editedAttendees?: AttendeeDTO[];
}

export interface SubmitEmployerDetailsRequest {
  description?: string;
  employerName?: string;
  industry?: string;
  updateEmployerContact?: boolean;
}

export interface SubmitUserDetailsRequest {
  firstName?: string;
  lastName?: string;
}

export type SupportingDocumentInterviewerResponseVisibilityOption = typeof SupportingDocumentInterviewerResponseVisibilityOption[keyof typeof SupportingDocumentInterviewerResponseVisibilityOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportingDocumentInterviewerResponseVisibilityOption = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
} as const;

export interface SupportingDocumentInterviewerResponse {
  documentName?: string;
  eventCustomDocId?: number;
  id?: number;
  orgDocId?: number;
  required?: boolean;
  uploaded?: boolean;
  visibilityOption?: SupportingDocumentInterviewerResponseVisibilityOption;
  visibilityTime?: EventDateResponse;
  visible?: boolean;
}

export type SupportingDocumentRequestVisibilityOption = typeof SupportingDocumentRequestVisibilityOption[keyof typeof SupportingDocumentRequestVisibilityOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportingDocumentRequestVisibilityOption = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
} as const;

export interface SupportingDocumentRequest {
  deleted?: boolean;
  eventDocId?: number;
  orgDocId?: number;
  required?: boolean;
  visibilityOption?: SupportingDocumentRequestVisibilityOption;
  visibilityTime?: EventDateRequest;
}

export type SupportingDocumentResponseVisibilityOption = typeof SupportingDocumentResponseVisibilityOption[keyof typeof SupportingDocumentResponseVisibilityOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportingDocumentResponseVisibilityOption = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_3: '3',
  NUMBER_4: '4',
} as const;

export interface SupportingDocumentResponse {
  documentName?: string;
  eventDocId?: number;
  id?: number;
  orgDocId?: number;
  required?: boolean;
  visibilityOption?: SupportingDocumentResponseVisibilityOption;
  visibilityTime?: EventDateResponse;
}

export interface UniversityEmployerDTO {
  description?: string;
  domain?: string;
  employeroid?: number;
  id?: number;
  industry?: string;
  name?: string;
  universityoid?: number;
}

export interface UniversityEmployerRequest {
  contactEmail?: string;
  contactFirstName?: string;
  contactJobTitle?: string;
  contactLastName?: string;
  description?: string;
  industry?: string;
  name?: string;
}

export interface UniversityManuallyAddEmployerRequest {
  email?: string;
}

export interface UniversityManuallyAddStudentRequest {
  email?: string;
  firstName?: string;
  lastName?: string;
}

export interface UniversityNetworkingEmailsRequest {
  employerCandidateFollowUpEmail?: EmailsDTO;
  employerCandidateFollowUpEmailEnabled?: boolean;
  employerCandidateFollowUpEmailTime?: number;
  employerFinalScheduleEmail?: EmailsDTO;
  employerFinalScheduleEmailTime?: number;
  enabled?: boolean;
}

export interface UniversityNetworkingEmailsResponse {
  employerCandidateFollowUpEmail?: EmailsDTO;
  employerCandidateFollowUpEmailTime?: number;
  employerFinalScheduleEmail?: EmailsDTO;
  employerFinalScheduleEmailTime?: number;
}

export interface UniversityNetworkingFeedbackRequest {
  candidatePhotoEnabled?: boolean;
  enabled?: boolean;
  eventFeedbacks?: EventFeedback[];
  reminderEmailEnabled?: boolean;
}

export interface UniversityRecruitmentPolicyRequest {
  text?: string;
}

export interface UniversityRecruitmentPolicyResponse {
  text?: string;
}

export interface UpdateInterviewSchedulingAdditionalScheduleInformationSection {
  additionalScheduleInformation?: string;
}

export type UpdateInterviewSchedulingEmployerScheduleInvitationStatusEmployerInvitationStatus = typeof UpdateInterviewSchedulingEmployerScheduleInvitationStatusEmployerInvitationStatus[keyof typeof UpdateInterviewSchedulingEmployerScheduleInvitationStatusEmployerInvitationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateInterviewSchedulingEmployerScheduleInvitationStatusEmployerInvitationStatus = {
  NO_RESPONSE: 'NO_RESPONSE',
  INVITED: 'INVITED',
  ALTERNATE: 'ALTERNATE',
  NOT_INVITED: 'NOT_INVITED',
} as const;

export interface UpdateInterviewSchedulingEmployerScheduleInvitationStatus {
  employerInvitationStatus?: UpdateInterviewSchedulingEmployerScheduleInvitationStatusEmployerInvitationStatus;
  jobApplicationId?: number;
  recruitId?: number;
}

export type UpdateInterviewSchedulingEmployerScheduleStatusNewStatus = typeof UpdateInterviewSchedulingEmployerScheduleStatusNewStatus[keyof typeof UpdateInterviewSchedulingEmployerScheduleStatusNewStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateInterviewSchedulingEmployerScheduleStatusNewStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  READY_TO_SUBMIT: 'READY_TO_SUBMIT',
  IN_REVIEW: 'IN_REVIEW',
  APPROVED: 'APPROVED',
  SUBMITTED: 'SUBMITTED',
} as const;

export interface UpdateInterviewSchedulingEmployerScheduleStatus {
  newStatus: UpdateInterviewSchedulingEmployerScheduleStatusNewStatus;
}

export interface UpdateNetworkingEventRoomLogoRequest {
  imageFile?: Blob;
}

export type UpdateStudentInterviewInvitationResponseStatusStudentResponseStatus = typeof UpdateStudentInterviewInvitationResponseStatusStudentResponseStatus[keyof typeof UpdateStudentInterviewInvitationResponseStatusStudentResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateStudentInterviewInvitationResponseStatusStudentResponseStatus = {
  NO_RESPONSE: 'NO_RESPONSE',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
} as const;

export interface UpdateStudentInterviewInvitationResponseStatus {
  studentResponseStatus?: UpdateStudentInterviewInvitationResponseStatusStudentResponseStatus;
}

export interface UploadDocumentForEventRequest {
  file?: Blob;
  orgDocId?: number;
}

export interface UploadDocumentForEventResponse {
  path?: string;
  success?: boolean;
}

export interface UploadDocumentRequestDTO {
  eventCustomDocId?: number;
  file?: Blob;
  orgDocId?: number;
}

export interface UploadFirmProfileBannerImageRequest {
  imageFile?: Blob;
  orgId?: number;
}

export interface UploadForwardProfilePhotoRequest {
  imageFile?: Blob;
}

export interface UploadHeadshotForEventRequest {
  file?: Blob;
}

export interface UploadHeadshotForEventResponse {
  path?: string;
  success?: boolean;
}

export interface UploadMatterDocumentRequest {
  documentFileName?: string;
  file?: Blob;
  userFileName?: string;
}

export interface User {
  admin?: boolean;
  email?: string;
  fname?: string;
  id?: number;
  lname?: string;
  organizationId?: number;
  password?: string;
  pwChange?: string;
}

export interface UserAnalyticsInfoResponse {
  email?: string;
  fullName?: string;
  id?: number;
  isAdmin?: boolean;
  isAnonymous?: boolean;
  isPaying?: boolean;
  orgId?: number;
  orgName?: string;
}

export type UserEventErrorInfoIdToExtensions = {[key: string]: string[]};

export type UserEventErrorInfoIdToFirstName = {[key: string]: string};

export type UserEventErrorInfoIdToLastName = {[key: string]: string};

export type UserEventErrorInfoIdToTimeslots = {[key: string]: InterviewSchedulingUniversityTimeslotResponse[]};

export type UserEventErrorInfoUserType = typeof UserEventErrorInfoUserType[keyof typeof UserEventErrorInfoUserType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserEventErrorInfoUserType = {
  RECRUIT: 'RECRUIT',
  INTERVIEWER: 'INTERVIEWER',
} as const;

export interface UserEventErrorInfo {
  duplicateScheduleIds?: boolean;
  email?: string;
  extensionsDeleted?: boolean;
  idToExtensions?: UserEventErrorInfoIdToExtensions;
  idToFirstName?: UserEventErrorInfoIdToFirstName;
  idToLastName?: UserEventErrorInfoIdToLastName;
  idToTimeslots?: UserEventErrorInfoIdToTimeslots;
  moreThanOneUserIdForEmail?: boolean;
  multipleExtensionsForSameUser?: boolean;
  namesMismatch?: boolean;
  scheduleIdsUserIsPartOf?: number[];
  timeslotConflicts?: boolean;
  userIds?: number[];
  userIdsExist?: boolean;
  userType?: UserEventErrorInfoUserType;
}

export interface UserJwtResponse {
  jwt?: string;
}

export interface UserLoginRequest {
  email?: string;
  orgFriendlyName?: string;
  password?: string;
}

export interface UserLogoutRequest { [key: string]: unknown }

export interface UserLogoutResponse {
  success?: boolean;
}

export interface UserOverviewResponse {
  email?: string;
  fname?: string;
  id?: number;
  lname?: string;
}

export type UsersDTOUserRecruitType = typeof UsersDTOUserRecruitType[keyof typeof UsersDTOUserRecruitType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsersDTOUserRecruitType = {
  STUDENT: 'STUDENT',
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  EMPLOYER: 'EMPLOYER',
  ASSOCIATE: 'ASSOCIATE',
} as const;

export interface UsersDTO {
  employerName?: string;
  fname?: string;
  id?: number;
  industry?: string;
  lname?: string;
  uemail?: string;
  universityEmployerId?: number;
  userRecruitType?: UsersDTOUserRecruitType;
  userType?: number;
  videoChatLink?: string;
}

export interface ValidateEmployerContactEmailRequest {
  email?: string;
}

export interface ValidateEmployerRequest {
  email?: string;
  employerRegistrationExtension?: string;
}

export interface ValidateEmployerResponse {
  emailSent?: boolean;
  isAuthorized?: boolean;
}

export interface WorkAllocationEvaluationExportRequest {
  associateIds?: number[];
  endDate?: string;
  programId?: number;
  selectedExportOption?: string;
  startDate?: string;
}

export interface ZonedDateTimeInterval {
  end?: string;
  endDate?: string;
  endDateTime?: string;
  endTime?: LocalTime;
  midpoint?: string;
  start?: string;
  startDate?: string;
  startDateTime?: string;
  startTime?: LocalTime;
}

export type CheckEventForErrorsParams = {
onlyShowIssues?: string;
};

export type SendCareersPageSigninMagicLinkParams = {
email: string;
orgFriendlyName: string;
redirectUrl: string;
jobExtension?: string;
};

export type SendSigninMagicLinkEventRegistrationParams = {
email: string;
orgFriendlyName: string;
eventId: number;
};

export type SendForwardSigninMagicLinkParams = {
email: string;
encodedRedirectUrl?: string;
};

export type SendSigninMagicLinkParams = {
email: string;
orgFriendlyName: string;
redirectUrl: string;
jobExtension?: string;
};

export type SendAssociateSignInMagicLinkParams = {
email: string;
orgFriendlyName: string;
redirectUrl: string;
extendSession: boolean;
};

export type GetMergePreviewParams = {
jobApplicationStatusSelections: {[key: string]: string};
};

export type UploadCandidateCustomDocumentsBody = {
  file?: Blob;
};

export type UploadCandidateProfileImageBody = {
  photoImageFile?: Blob;
};

export type ExternalJobImportUploadCsvApiKeyBody = {
  file: Blob;
};

export type ExternalJobImportUploadCsvSuperAdminBody = {
  file: Blob;
};

export type ActivateAccountParams = {
afterActivationRedirectUrl?: string;
};

export type AddEmailToForwardAccountParams = {
encodedMagicLink: string;
email: string;
};

export type UploadInterviewSchedulingJobApplicationDocumentFromStudentBody = {
  file: Blob;
  'schedule-ids': string;
  'supporting-document-ids': string;
};

export type GetInterviewSchedulingLotteryConfirmStatus200 = typeof GetInterviewSchedulingLotteryConfirmStatus200[keyof typeof GetInterviewSchedulingLotteryConfirmStatus200];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetInterviewSchedulingLotteryConfirmStatus200 = {
  UNCONFIRMED: 'UNCONFIRMED',
  CONFIRMING_IN_PROGRESS: 'CONFIRMING_IN_PROGRESS',
  CONFIRMING_FINISHED: 'CONFIRMING_FINISHED',
  CONFIRMING_FAILED: 'CONFIRMING_FAILED',
} as const;

export type GetInterviewSchedulingLotteryRunStatus200 = typeof GetInterviewSchedulingLotteryRunStatus200[keyof typeof GetInterviewSchedulingLotteryRunStatus200];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetInterviewSchedulingLotteryRunStatus200 = {
  NOT_STARTED: 'NOT_STARTED',
  RUNNING: 'RUNNING',
  FAILED: 'FAILED',
  COMPLETE: 'COMPLETE',
} as const;

export type GetInterviewSchedulingAutoSchedulerStatus200 = typeof GetInterviewSchedulingAutoSchedulerStatus200[keyof typeof GetInterviewSchedulingAutoSchedulerStatus200];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetInterviewSchedulingAutoSchedulerStatus200 = {
  NOT_STARTED: 'NOT_STARTED',
  RUNNING: 'RUNNING',
  FAILED: 'FAILED',
  COMPLETE: 'COMPLETE',
} as const;

export type ValidateInterviewSchedulingEmployerContactEmail200 = typeof ValidateInterviewSchedulingEmployerContactEmail200[keyof typeof ValidateInterviewSchedulingEmployerContactEmail200];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ValidateInterviewSchedulingEmployerContactEmail200 = {
  UNACCEPTABLE_EMAIL_DOMAIN: 'UNACCEPTABLE_EMAIL_DOMAIN',
  UNIVERSITY_EMAIL: 'UNIVERSITY_EMAIL',
  EMAIL_ALREADY_EXISTS: 'EMAIL_ALREADY_EXISTS',
  INVALID_EMAIL: 'INVALID_EMAIL',
  VALID_EMAIL: 'VALID_EMAIL',
} as const;

export type SendSignInMagicLinkParams = {
email: string;
orgFriendlyName: string;
redirectUrl: string;
extendSession: boolean;
programExtension?: string;
};

export type GetSerendipitousEventParams = {
eid: string;
};

export type FetchOrgAtsEnabledParams = {
orgFriendlyName: string;
};

export type FetchOrgColorParams = {
orgFriendlyName: string;
};

export type FetchOrgDisplayNameParams = {
orgFriendlyName: string;
};

export type FetchOrgIsGovernmentContractorParams = {
orgFriendlyName: string;
};

export type FetchOrgLogoLinkv2Params = {
orgFriendlyName: string;
};

export type GetPetParams = {
matterID: number;
};

export type UpsertPetParams = {
petName: string;
matterID: number;
};

export const fetchAnalyticsData = (
    adminAnalyticsFilters: AdminAnalyticsFilters,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminAnalyticsPageDto>(
      {url: `/admin-analytics/data`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminAnalyticsFilters, signal
    },
      );
    }
  


export const getFetchAnalyticsDataMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fetchAnalyticsData>>, TError,{data: AdminAnalyticsFilters}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof fetchAnalyticsData>>, TError,{data: AdminAnalyticsFilters}, TContext> => {
    
const mutationKey = ['fetchAnalyticsData'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fetchAnalyticsData>>, {data: AdminAnalyticsFilters}> = (props) => {
          const {data} = props ?? {};

          return  fetchAnalyticsData(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FetchAnalyticsDataMutationResult = NonNullable<Awaited<ReturnType<typeof fetchAnalyticsData>>>
    export type FetchAnalyticsDataMutationBody = AdminAnalyticsFilters
    export type FetchAnalyticsDataMutationError = unknown

    export const useFetchAnalyticsData = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fetchAnalyticsData>>, TError,{data: AdminAnalyticsFilters}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof fetchAnalyticsData>>,
        TError,
        {data: AdminAnalyticsFilters},
        TContext
      > => {

      const mutationOptions = getFetchAnalyticsDataMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchAdminEvents = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminEventDto[]>(
      {url: `/admin-events/data`, method: 'GET', signal
    },
      );
    }
  

export const getFetchAdminEventsQueryKey = () => {
    return [`/admin-events/data`] as const;
    }

    
export const getFetchAdminEventsQueryOptions = <TData = Awaited<ReturnType<typeof fetchAdminEvents>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchAdminEvents>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchAdminEventsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchAdminEvents>>> = ({ signal }) => fetchAdminEvents(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchAdminEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchAdminEventsQueryResult = NonNullable<Awaited<ReturnType<typeof fetchAdminEvents>>>
export type FetchAdminEventsQueryError = unknown



export function useFetchAdminEvents<TData = Awaited<ReturnType<typeof fetchAdminEvents>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchAdminEvents>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchAdminEventsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const fetchAdminEvent = (
    eventId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminEventDto>(
      {url: `/admin-events/data/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getFetchAdminEventQueryKey = (eventId: string,) => {
    return [`/admin-events/data/${eventId}`] as const;
    }

    
export const getFetchAdminEventQueryOptions = <TData = Awaited<ReturnType<typeof fetchAdminEvent>>, TError = unknown>(eventId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchAdminEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchAdminEventQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchAdminEvent>>> = ({ signal }) => fetchAdminEvent(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchAdminEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchAdminEventQueryResult = NonNullable<Awaited<ReturnType<typeof fetchAdminEvent>>>
export type FetchAdminEventQueryError = unknown



export function useFetchAdminEvent<TData = Awaited<ReturnType<typeof fetchAdminEvent>>, TError = unknown>(
 eventId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchAdminEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchAdminEventQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const checkEventForErrors = (
    eventId: number,
    params?: CheckEventForErrorsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EventErrorInfoResponse>(
      {url: `/admin-events/eventErrorCheck/${eventId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCheckEventForErrorsQueryKey = (eventId: number,
    params?: CheckEventForErrorsParams,) => {
    return [`/admin-events/eventErrorCheck/${eventId}`, ...(params ? [params]: [])] as const;
    }

    
export const getCheckEventForErrorsQueryOptions = <TData = Awaited<ReturnType<typeof checkEventForErrors>>, TError = unknown>(eventId: number,
    params?: CheckEventForErrorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkEventForErrors>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckEventForErrorsQueryKey(eventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkEventForErrors>>> = ({ signal }) => checkEventForErrors(eventId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkEventForErrors>>, TError, TData> & { queryKey: QueryKey }
}

export type CheckEventForErrorsQueryResult = NonNullable<Awaited<ReturnType<typeof checkEventForErrors>>>
export type CheckEventForErrorsQueryError = unknown



export function useCheckEventForErrors<TData = Awaited<ReturnType<typeof checkEventForErrors>>, TError = unknown>(
 eventId: number,
    params?: CheckEventForErrorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkEventForErrors>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCheckEventForErrorsQueryOptions(eventId,params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const syncDocumentsForEvent = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/admin-events/sync/${eventId}/syncDocuments`, method: 'POST', signal
    },
      );
    }
  


export const getSyncDocumentsForEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncDocumentsForEvent>>, TError,{eventId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof syncDocumentsForEvent>>, TError,{eventId: number}, TContext> => {
    
const mutationKey = ['syncDocumentsForEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncDocumentsForEvent>>, {eventId: number}> = (props) => {
          const {eventId} = props ?? {};

          return  syncDocumentsForEvent(eventId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SyncDocumentsForEventMutationResult = NonNullable<Awaited<ReturnType<typeof syncDocumentsForEvent>>>
    
    export type SyncDocumentsForEventMutationError = unknown

    export const useSyncDocumentsForEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncDocumentsForEvent>>, TError,{eventId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncDocumentsForEvent>>,
        TError,
        {eventId: number},
        TContext
      > => {

      const mutationOptions = getSyncDocumentsForEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const upsertAgency = (
    agencyRequest: AgencyRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/admin/agencies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: agencyRequest, signal
    },
      );
    }
  


export const getUpsertAgencyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAgency>>, TError,{data: AgencyRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertAgency>>, TError,{data: AgencyRequest}, TContext> => {
    
const mutationKey = ['upsertAgency'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertAgency>>, {data: AgencyRequest}> = (props) => {
          const {data} = props ?? {};

          return  upsertAgency(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertAgencyMutationResult = NonNullable<Awaited<ReturnType<typeof upsertAgency>>>
    export type UpsertAgencyMutationBody = AgencyRequest
    export type UpsertAgencyMutationError = unknown

    export const useUpsertAgency = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAgency>>, TError,{data: AgencyRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertAgency>>,
        TError,
        {data: AgencyRequest},
        TContext
      > => {

      const mutationOptions = getUpsertAgencyMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const upsertAgencyAndAgencyContact = (
    agencyAndAgencyContactRequestWrapper: AgencyAndAgencyContactRequestWrapper,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AgencyContactWithAgencyInfoResponse>(
      {url: `/admin/agencies/update-agency-and-agency-contact`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: agencyAndAgencyContactRequestWrapper, signal
    },
      );
    }
  


export const getUpsertAgencyAndAgencyContactMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAgencyAndAgencyContact>>, TError,{data: AgencyAndAgencyContactRequestWrapper}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertAgencyAndAgencyContact>>, TError,{data: AgencyAndAgencyContactRequestWrapper}, TContext> => {
    
const mutationKey = ['upsertAgencyAndAgencyContact'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertAgencyAndAgencyContact>>, {data: AgencyAndAgencyContactRequestWrapper}> = (props) => {
          const {data} = props ?? {};

          return  upsertAgencyAndAgencyContact(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertAgencyAndAgencyContactMutationResult = NonNullable<Awaited<ReturnType<typeof upsertAgencyAndAgencyContact>>>
    export type UpsertAgencyAndAgencyContactMutationBody = AgencyAndAgencyContactRequestWrapper
    export type UpsertAgencyAndAgencyContactMutationError = unknown

    export const useUpsertAgencyAndAgencyContact = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAgencyAndAgencyContact>>, TError,{data: AgencyAndAgencyContactRequestWrapper}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertAgencyAndAgencyContact>>,
        TError,
        {data: AgencyAndAgencyContactRequestWrapper},
        TContext
      > => {

      const mutationOptions = getUpsertAgencyAndAgencyContactMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const upsertAgencyContact = (
    agencyId: number,
    agencyContactRequest: AgencyContactRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/admin/agencies/${agencyId}/agency-contacts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: agencyContactRequest, signal
    },
      );
    }
  


export const getUpsertAgencyContactMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAgencyContact>>, TError,{agencyId: number;data: AgencyContactRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertAgencyContact>>, TError,{agencyId: number;data: AgencyContactRequest}, TContext> => {
    
const mutationKey = ['upsertAgencyContact'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertAgencyContact>>, {agencyId: number;data: AgencyContactRequest}> = (props) => {
          const {agencyId,data} = props ?? {};

          return  upsertAgencyContact(agencyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertAgencyContactMutationResult = NonNullable<Awaited<ReturnType<typeof upsertAgencyContact>>>
    export type UpsertAgencyContactMutationBody = AgencyContactRequest
    export type UpsertAgencyContactMutationError = unknown

    export const useUpsertAgencyContact = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAgencyContact>>, TError,{agencyId: number;data: AgencyContactRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertAgencyContact>>,
        TError,
        {agencyId: number;data: AgencyContactRequest},
        TContext
      > => {

      const mutationOptions = getUpsertAgencyContactMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const bulkUpsertAgencyContacts = (
    agencyId: number,
    agencyContactRequest: AgencyContactRequest[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/admin/agencies/${agencyId}/agency-contacts/bulk-upsert`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: agencyContactRequest, signal
    },
      );
    }
  


export const getBulkUpsertAgencyContactsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpsertAgencyContacts>>, TError,{agencyId: number;data: AgencyContactRequest[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkUpsertAgencyContacts>>, TError,{agencyId: number;data: AgencyContactRequest[]}, TContext> => {
    
const mutationKey = ['bulkUpsertAgencyContacts'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkUpsertAgencyContacts>>, {agencyId: number;data: AgencyContactRequest[]}> = (props) => {
          const {agencyId,data} = props ?? {};

          return  bulkUpsertAgencyContacts(agencyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkUpsertAgencyContactsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkUpsertAgencyContacts>>>
    export type BulkUpsertAgencyContactsMutationBody = AgencyContactRequest[]
    export type BulkUpsertAgencyContactsMutationError = unknown

    export const useBulkUpsertAgencyContacts = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpsertAgencyContacts>>, TError,{agencyId: number;data: AgencyContactRequest[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkUpsertAgencyContacts>>,
        TError,
        {agencyId: number;data: AgencyContactRequest[]},
        TContext
      > => {

      const mutationOptions = getBulkUpsertAgencyContactsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const bulkDeleteAgencyContacts = (
    bulkDeleteAgencyContactsBody: number[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/admin/agency-contacts/bulk-delete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkDeleteAgencyContactsBody, signal
    },
      );
    }
  


export const getBulkDeleteAgencyContactsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteAgencyContacts>>, TError,{data: number[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteAgencyContacts>>, TError,{data: number[]}, TContext> => {
    
const mutationKey = ['bulkDeleteAgencyContacts'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDeleteAgencyContacts>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  bulkDeleteAgencyContacts(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkDeleteAgencyContactsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDeleteAgencyContacts>>>
    export type BulkDeleteAgencyContactsMutationBody = number[]
    export type BulkDeleteAgencyContactsMutationError = unknown

    export const useBulkDeleteAgencyContacts = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteAgencyContacts>>, TError,{data: number[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkDeleteAgencyContacts>>,
        TError,
        {data: number[]},
        TContext
      > => {

      const mutationOptions = getBulkDeleteAgencyContactsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const bulkDeleteAgencyContacts1 = (
    agencyContactId: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/admin/agency-contacts/${agencyContactId}`, method: 'DELETE'
    },
      );
    }
  


export const getBulkDeleteAgencyContacts1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteAgencyContacts1>>, TError,{agencyContactId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteAgencyContacts1>>, TError,{agencyContactId: number}, TContext> => {
    
const mutationKey = ['bulkDeleteAgencyContacts1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDeleteAgencyContacts1>>, {agencyContactId: number}> = (props) => {
          const {agencyContactId} = props ?? {};

          return  bulkDeleteAgencyContacts1(agencyContactId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkDeleteAgencyContacts1MutationResult = NonNullable<Awaited<ReturnType<typeof bulkDeleteAgencyContacts1>>>
    
    export type BulkDeleteAgencyContacts1MutationError = unknown

    export const useBulkDeleteAgencyContacts1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteAgencyContacts1>>, TError,{agencyContactId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkDeleteAgencyContacts1>>,
        TError,
        {agencyContactId: number},
        TContext
      > => {

      const mutationOptions = getBulkDeleteAgencyContacts1MutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const updateExistingAgencyContact = (
    agencyContactId: number,
    agencyContactUpdateRequest: AgencyContactUpdateRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/admin/agency-contacts/${agencyContactId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: agencyContactUpdateRequest, signal
    },
      );
    }
  


export const getUpdateExistingAgencyContactMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateExistingAgencyContact>>, TError,{agencyContactId: number;data: AgencyContactUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateExistingAgencyContact>>, TError,{agencyContactId: number;data: AgencyContactUpdateRequest}, TContext> => {
    
const mutationKey = ['updateExistingAgencyContact'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateExistingAgencyContact>>, {agencyContactId: number;data: AgencyContactUpdateRequest}> = (props) => {
          const {agencyContactId,data} = props ?? {};

          return  updateExistingAgencyContact(agencyContactId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateExistingAgencyContactMutationResult = NonNullable<Awaited<ReturnType<typeof updateExistingAgencyContact>>>
    export type UpdateExistingAgencyContactMutationBody = AgencyContactUpdateRequest
    export type UpdateExistingAgencyContactMutationError = unknown

    export const useUpdateExistingAgencyContact = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateExistingAgencyContact>>, TError,{agencyContactId: number;data: AgencyContactUpdateRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateExistingAgencyContact>>,
        TError,
        {agencyContactId: number;data: AgencyContactUpdateRequest},
        TContext
      > => {

      const mutationOptions = getUpdateExistingAgencyContactMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getSuggestedAgencyForContact = (
    agencyContactId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/admin/agency-contacts/${agencyContactId}/suggested-agency`, method: 'GET', signal
    },
      );
    }
  

export const getGetSuggestedAgencyForContactQueryKey = (agencyContactId: number,) => {
    return [`/admin/agency-contacts/${agencyContactId}/suggested-agency`] as const;
    }

    
export const getGetSuggestedAgencyForContactQueryOptions = <TData = Awaited<ReturnType<typeof getSuggestedAgencyForContact>>, TError = unknown>(agencyContactId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSuggestedAgencyForContact>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSuggestedAgencyForContactQueryKey(agencyContactId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuggestedAgencyForContact>>> = ({ signal }) => getSuggestedAgencyForContact(agencyContactId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(agencyContactId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSuggestedAgencyForContact>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSuggestedAgencyForContactQueryResult = NonNullable<Awaited<ReturnType<typeof getSuggestedAgencyForContact>>>
export type GetSuggestedAgencyForContactQueryError = unknown



export function useGetSuggestedAgencyForContact<TData = Awaited<ReturnType<typeof getSuggestedAgencyForContact>>, TError = unknown>(
 agencyContactId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSuggestedAgencyForContact>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSuggestedAgencyForContactQueryOptions(agencyContactId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const fetchSavedFiltersForUser = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<SavedFilterResponse[]>(
      {url: `/admin/saved-filters`, method: 'GET', signal
    },
      );
    }
  

export const getFetchSavedFiltersForUserQueryKey = () => {
    return [`/admin/saved-filters`] as const;
    }

    
export const getFetchSavedFiltersForUserQueryOptions = <TData = Awaited<ReturnType<typeof fetchSavedFiltersForUser>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchSavedFiltersForUser>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchSavedFiltersForUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchSavedFiltersForUser>>> = ({ signal }) => fetchSavedFiltersForUser(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchSavedFiltersForUser>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchSavedFiltersForUserQueryResult = NonNullable<Awaited<ReturnType<typeof fetchSavedFiltersForUser>>>
export type FetchSavedFiltersForUserQueryError = unknown



export function useFetchSavedFiltersForUser<TData = Awaited<ReturnType<typeof fetchSavedFiltersForUser>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchSavedFiltersForUser>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchSavedFiltersForUserQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const upsertSavedFilter = (
    savedFilterRequest: SavedFilterRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/admin/saved-filters`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: savedFilterRequest, signal
    },
      );
    }
  


export const getUpsertSavedFilterMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertSavedFilter>>, TError,{data: SavedFilterRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertSavedFilter>>, TError,{data: SavedFilterRequest}, TContext> => {
    
const mutationKey = ['upsertSavedFilter'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertSavedFilter>>, {data: SavedFilterRequest}> = (props) => {
          const {data} = props ?? {};

          return  upsertSavedFilter(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertSavedFilterMutationResult = NonNullable<Awaited<ReturnType<typeof upsertSavedFilter>>>
    export type UpsertSavedFilterMutationBody = SavedFilterRequest
    export type UpsertSavedFilterMutationError = unknown

    export const useUpsertSavedFilter = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertSavedFilter>>, TError,{data: SavedFilterRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertSavedFilter>>,
        TError,
        {data: SavedFilterRequest},
        TContext
      > => {

      const mutationOptions = getUpsertSavedFilterMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const deleteSavedFilter = (
    savedFilterId: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/admin/saved-filters/${savedFilterId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteSavedFilterMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSavedFilter>>, TError,{savedFilterId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSavedFilter>>, TError,{savedFilterId: number}, TContext> => {
    
const mutationKey = ['deleteSavedFilter'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSavedFilter>>, {savedFilterId: number}> = (props) => {
          const {savedFilterId} = props ?? {};

          return  deleteSavedFilter(savedFilterId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSavedFilterMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSavedFilter>>>
    
    export type DeleteSavedFilterMutationError = unknown

    export const useDeleteSavedFilter = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSavedFilter>>, TError,{savedFilterId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSavedFilter>>,
        TError,
        {savedFilterId: number},
        TContext
      > => {

      const mutationOptions = getDeleteSavedFilterMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendAgencyContactSigninMagicLink = (
    agencyContactGetMagicLinkRequest: AgencyContactGetMagicLinkRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/agency-contact-signin/send-signin-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: agencyContactGetMagicLinkRequest, signal
    },
      );
    }
  


export const getSendAgencyContactSigninMagicLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAgencyContactSigninMagicLink>>, TError,{data: AgencyContactGetMagicLinkRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendAgencyContactSigninMagicLink>>, TError,{data: AgencyContactGetMagicLinkRequest}, TContext> => {
    
const mutationKey = ['sendAgencyContactSigninMagicLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendAgencyContactSigninMagicLink>>, {data: AgencyContactGetMagicLinkRequest}> = (props) => {
          const {data} = props ?? {};

          return  sendAgencyContactSigninMagicLink(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendAgencyContactSigninMagicLinkMutationResult = NonNullable<Awaited<ReturnType<typeof sendAgencyContactSigninMagicLink>>>
    export type SendAgencyContactSigninMagicLinkMutationBody = AgencyContactGetMagicLinkRequest
    export type SendAgencyContactSigninMagicLinkMutationError = unknown

    export const useSendAgencyContactSigninMagicLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAgencyContactSigninMagicLink>>, TError,{data: AgencyContactGetMagicLinkRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendAgencyContactSigninMagicLink>>,
        TError,
        {data: AgencyContactGetMagicLinkRequest},
        TContext
      > => {

      const mutationOptions = getSendAgencyContactSigninMagicLinkMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const agencyContactSignin = (
    magicLinkId: number,
    agencyContactId: number,
    magicLinkGuid: string,
    redirectUrl: string,
    orgFriendlyName: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/agency-contact-signin/signin/${magicLinkId}/${agencyContactId}/${magicLinkGuid}/${redirectUrl}/${orgFriendlyName}`, method: 'GET', signal
    },
      );
    }
  

export const getAgencyContactSigninQueryKey = (magicLinkId: number,
    agencyContactId: number,
    magicLinkGuid: string,
    redirectUrl: string,
    orgFriendlyName: string,) => {
    return [`/agency-contact-signin/signin/${magicLinkId}/${agencyContactId}/${magicLinkGuid}/${redirectUrl}/${orgFriendlyName}`] as const;
    }

    
export const getAgencyContactSigninQueryOptions = <TData = Awaited<ReturnType<typeof agencyContactSignin>>, TError = unknown>(magicLinkId: number,
    agencyContactId: number,
    magicLinkGuid: string,
    redirectUrl: string,
    orgFriendlyName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof agencyContactSignin>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgencyContactSigninQueryKey(magicLinkId,agencyContactId,magicLinkGuid,redirectUrl,orgFriendlyName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof agencyContactSignin>>> = ({ signal }) => agencyContactSignin(magicLinkId,agencyContactId,magicLinkGuid,redirectUrl,orgFriendlyName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(magicLinkId && agencyContactId && magicLinkGuid && redirectUrl && orgFriendlyName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agencyContactSignin>>, TError, TData> & { queryKey: QueryKey }
}

export type AgencyContactSigninQueryResult = NonNullable<Awaited<ReturnType<typeof agencyContactSignin>>>
export type AgencyContactSigninQueryError = unknown



export function useAgencyContactSignin<TData = Awaited<ReturnType<typeof agencyContactSignin>>, TError = unknown>(
 magicLinkId: number,
    agencyContactId: number,
    magicLinkGuid: string,
    redirectUrl: string,
    orgFriendlyName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof agencyContactSignin>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAgencyContactSigninQueryOptions(magicLinkId,agencyContactId,magicLinkGuid,redirectUrl,orgFriendlyName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const upsertAgencyContactJobApp = (
    candidateSelfApplyJobAppRequest: CandidateSelfApplyJobAppRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/agency-contact/job-app-submit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: candidateSelfApplyJobAppRequest, signal
    },
      );
    }
  


export const getUpsertAgencyContactJobAppMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAgencyContactJobApp>>, TError,{data: CandidateSelfApplyJobAppRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertAgencyContactJobApp>>, TError,{data: CandidateSelfApplyJobAppRequest}, TContext> => {
    
const mutationKey = ['upsertAgencyContactJobApp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertAgencyContactJobApp>>, {data: CandidateSelfApplyJobAppRequest}> = (props) => {
          const {data} = props ?? {};

          return  upsertAgencyContactJobApp(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertAgencyContactJobAppMutationResult = NonNullable<Awaited<ReturnType<typeof upsertAgencyContactJobApp>>>
    export type UpsertAgencyContactJobAppMutationBody = CandidateSelfApplyJobAppRequest
    export type UpsertAgencyContactJobAppMutationError = unknown

    export const useUpsertAgencyContactJobApp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAgencyContactJobApp>>, TError,{data: CandidateSelfApplyJobAppRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertAgencyContactJobApp>>,
        TError,
        {data: CandidateSelfApplyJobAppRequest},
        TContext
      > => {

      const mutationOptions = getUpsertAgencyContactJobAppMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const uploadAgencyContactJobAppDocument = (
    candidateJobAppDocumentUploadRequest: CandidateJobAppDocumentUploadRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(candidateJobAppDocumentUploadRequest.document !== undefined) {
 formData.append('document', candidateJobAppDocumentUploadRequest.document)
 }
if(candidateJobAppDocumentUploadRequest.isFinalStep !== undefined) {
 formData.append('isFinalStep', candidateJobAppDocumentUploadRequest.isFinalStep.toString())
 }
if(candidateJobAppDocumentUploadRequest.jobAppId !== undefined) {
 formData.append('jobAppId', candidateJobAppDocumentUploadRequest.jobAppId.toString())
 }
if(candidateJobAppDocumentUploadRequest.jobExtension !== undefined) {
 formData.append('jobExtension', candidateJobAppDocumentUploadRequest.jobExtension)
 }
if(candidateJobAppDocumentUploadRequest.orgFriendlyName !== undefined) {
 formData.append('orgFriendlyName', candidateJobAppDocumentUploadRequest.orgFriendlyName)
 }
if(candidateJobAppDocumentUploadRequest.orgcustomdocumentsId !== undefined) {
 formData.append('orgcustomdocumentsId', candidateJobAppDocumentUploadRequest.orgcustomdocumentsId.toString())
 }

      return customInstance<GenericResponse>(
      {url: `/agency-contact/job-app-upload-document`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadAgencyContactJobAppDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAgencyContactJobAppDocument>>, TError,{data: CandidateJobAppDocumentUploadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadAgencyContactJobAppDocument>>, TError,{data: CandidateJobAppDocumentUploadRequest}, TContext> => {
    
const mutationKey = ['uploadAgencyContactJobAppDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadAgencyContactJobAppDocument>>, {data: CandidateJobAppDocumentUploadRequest}> = (props) => {
          const {data} = props ?? {};

          return  uploadAgencyContactJobAppDocument(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadAgencyContactJobAppDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadAgencyContactJobAppDocument>>>
    export type UploadAgencyContactJobAppDocumentMutationBody = CandidateJobAppDocumentUploadRequest
    export type UploadAgencyContactJobAppDocumentMutationError = unknown

    export const useUploadAgencyContactJobAppDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAgencyContactJobAppDocument>>, TError,{data: CandidateJobAppDocumentUploadRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadAgencyContactJobAppDocument>>,
        TError,
        {data: CandidateJobAppDocumentUploadRequest},
        TContext
      > => {

      const mutationOptions = getUploadAgencyContactJobAppDocumentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendCareersPageSigninMagicLink = (
    params: SendCareersPageSigninMagicLinkParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/applicant-signin/careers-page/send-signin-email`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getSendCareersPageSigninMagicLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCareersPageSigninMagicLink>>, TError,{params: SendCareersPageSigninMagicLinkParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendCareersPageSigninMagicLink>>, TError,{params: SendCareersPageSigninMagicLinkParams}, TContext> => {
    
const mutationKey = ['sendCareersPageSigninMagicLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendCareersPageSigninMagicLink>>, {params: SendCareersPageSigninMagicLinkParams}> = (props) => {
          const {params} = props ?? {};

          return  sendCareersPageSigninMagicLink(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendCareersPageSigninMagicLinkMutationResult = NonNullable<Awaited<ReturnType<typeof sendCareersPageSigninMagicLink>>>
    
    export type SendCareersPageSigninMagicLinkMutationError = unknown

    export const useSendCareersPageSigninMagicLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCareersPageSigninMagicLink>>, TError,{params: SendCareersPageSigninMagicLinkParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendCareersPageSigninMagicLink>>,
        TError,
        {params: SendCareersPageSigninMagicLinkParams},
        TContext
      > => {

      const mutationOptions = getSendCareersPageSigninMagicLinkMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendSigninMagicLinkEventRegistration = (
    params: SendSigninMagicLinkEventRegistrationParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/applicant-signin/events/send-signin-email`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getSendSigninMagicLinkEventRegistrationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSigninMagicLinkEventRegistration>>, TError,{params: SendSigninMagicLinkEventRegistrationParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendSigninMagicLinkEventRegistration>>, TError,{params: SendSigninMagicLinkEventRegistrationParams}, TContext> => {
    
const mutationKey = ['sendSigninMagicLinkEventRegistration'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendSigninMagicLinkEventRegistration>>, {params: SendSigninMagicLinkEventRegistrationParams}> = (props) => {
          const {params} = props ?? {};

          return  sendSigninMagicLinkEventRegistration(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendSigninMagicLinkEventRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof sendSigninMagicLinkEventRegistration>>>
    
    export type SendSigninMagicLinkEventRegistrationMutationError = unknown

    export const useSendSigninMagicLinkEventRegistration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSigninMagicLinkEventRegistration>>, TError,{params: SendSigninMagicLinkEventRegistrationParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendSigninMagicLinkEventRegistration>>,
        TError,
        {params: SendSigninMagicLinkEventRegistrationParams},
        TContext
      > => {

      const mutationOptions = getSendSigninMagicLinkEventRegistrationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const recruitEventsSignin = (
    magicLinkId: number,
    unifiedCandidateId: number,
    redirectUrl: string,
    token: string,
    signInEmail: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/applicant-signin/events/signin/${magicLinkId}/${unifiedCandidateId}/${redirectUrl}/${token}/${signInEmail}`, method: 'GET', signal
    },
      );
    }
  

export const getRecruitEventsSigninQueryKey = (magicLinkId: number,
    unifiedCandidateId: number,
    redirectUrl: string,
    token: string,
    signInEmail: string,) => {
    return [`/applicant-signin/events/signin/${magicLinkId}/${unifiedCandidateId}/${redirectUrl}/${token}/${signInEmail}`] as const;
    }

    
export const getRecruitEventsSigninQueryOptions = <TData = Awaited<ReturnType<typeof recruitEventsSignin>>, TError = unknown>(magicLinkId: number,
    unifiedCandidateId: number,
    redirectUrl: string,
    token: string,
    signInEmail: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof recruitEventsSignin>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecruitEventsSigninQueryKey(magicLinkId,unifiedCandidateId,redirectUrl,token,signInEmail);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof recruitEventsSignin>>> = ({ signal }) => recruitEventsSignin(magicLinkId,unifiedCandidateId,redirectUrl,token,signInEmail, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(magicLinkId && unifiedCandidateId && redirectUrl && token && signInEmail), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recruitEventsSignin>>, TError, TData> & { queryKey: QueryKey }
}

export type RecruitEventsSigninQueryResult = NonNullable<Awaited<ReturnType<typeof recruitEventsSignin>>>
export type RecruitEventsSigninQueryError = unknown



export function useRecruitEventsSignin<TData = Awaited<ReturnType<typeof recruitEventsSignin>>, TError = unknown>(
 magicLinkId: number,
    unifiedCandidateId: number,
    redirectUrl: string,
    token: string,
    signInEmail: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof recruitEventsSignin>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRecruitEventsSigninQueryOptions(magicLinkId,unifiedCandidateId,redirectUrl,token,signInEmail,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sendForwardSigninMagicLink = (
    params: SendForwardSigninMagicLinkParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/applicant-signin/forward/send-signin-email`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getSendForwardSigninMagicLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendForwardSigninMagicLink>>, TError,{params: SendForwardSigninMagicLinkParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendForwardSigninMagicLink>>, TError,{params: SendForwardSigninMagicLinkParams}, TContext> => {
    
const mutationKey = ['sendForwardSigninMagicLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendForwardSigninMagicLink>>, {params: SendForwardSigninMagicLinkParams}> = (props) => {
          const {params} = props ?? {};

          return  sendForwardSigninMagicLink(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendForwardSigninMagicLinkMutationResult = NonNullable<Awaited<ReturnType<typeof sendForwardSigninMagicLink>>>
    
    export type SendForwardSigninMagicLinkMutationError = unknown

    export const useSendForwardSigninMagicLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendForwardSigninMagicLink>>, TError,{params: SendForwardSigninMagicLinkParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendForwardSigninMagicLink>>,
        TError,
        {params: SendForwardSigninMagicLinkParams},
        TContext
      > => {

      const mutationOptions = getSendForwardSigninMagicLinkMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendSigninMagicLink = (
    params: SendSigninMagicLinkParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/applicant-signin/send-signin-email`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getSendSigninMagicLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSigninMagicLink>>, TError,{params: SendSigninMagicLinkParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendSigninMagicLink>>, TError,{params: SendSigninMagicLinkParams}, TContext> => {
    
const mutationKey = ['sendSigninMagicLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendSigninMagicLink>>, {params: SendSigninMagicLinkParams}> = (props) => {
          const {params} = props ?? {};

          return  sendSigninMagicLink(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendSigninMagicLinkMutationResult = NonNullable<Awaited<ReturnType<typeof sendSigninMagicLink>>>
    
    export type SendSigninMagicLinkMutationError = unknown

    export const useSendSigninMagicLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSigninMagicLink>>, TError,{params: SendSigninMagicLinkParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendSigninMagicLink>>,
        TError,
        {params: SendSigninMagicLinkParams},
        TContext
      > => {

      const mutationOptions = getSendSigninMagicLinkMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const applicantSignin = (
    magicLinkId: number,
    unifiedCandidateId: number,
    redirectUrl: string,
    token: string,
    signInEmail: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/applicant-signin/signin/${magicLinkId}/${unifiedCandidateId}/${redirectUrl}/${token}/${signInEmail}`, method: 'GET', signal
    },
      );
    }
  

export const getApplicantSigninQueryKey = (magicLinkId: number,
    unifiedCandidateId: number,
    redirectUrl: string,
    token: string,
    signInEmail: string,) => {
    return [`/applicant-signin/signin/${magicLinkId}/${unifiedCandidateId}/${redirectUrl}/${token}/${signInEmail}`] as const;
    }

    
export const getApplicantSigninQueryOptions = <TData = Awaited<ReturnType<typeof applicantSignin>>, TError = unknown>(magicLinkId: number,
    unifiedCandidateId: number,
    redirectUrl: string,
    token: string,
    signInEmail: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof applicantSignin>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApplicantSigninQueryKey(magicLinkId,unifiedCandidateId,redirectUrl,token,signInEmail);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof applicantSignin>>> = ({ signal }) => applicantSignin(magicLinkId,unifiedCandidateId,redirectUrl,token,signInEmail, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(magicLinkId && unifiedCandidateId && redirectUrl && token && signInEmail), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof applicantSignin>>, TError, TData> & { queryKey: QueryKey }
}

export type ApplicantSigninQueryResult = NonNullable<Awaited<ReturnType<typeof applicantSignin>>>
export type ApplicantSigninQueryError = unknown



export function useApplicantSignin<TData = Awaited<ReturnType<typeof applicantSignin>>, TError = unknown>(
 magicLinkId: number,
    unifiedCandidateId: number,
    redirectUrl: string,
    token: string,
    signInEmail: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof applicantSignin>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApplicantSigninQueryOptions(magicLinkId,unifiedCandidateId,redirectUrl,token,signInEmail,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const upsertCandidateJobApp = (
    candidateSelfApplyJobAppRequest: CandidateSelfApplyJobAppRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/applicants/candidate-job-app/submit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: candidateSelfApplyJobAppRequest, signal
    },
      );
    }
  


export const getUpsertCandidateJobAppMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertCandidateJobApp>>, TError,{data: CandidateSelfApplyJobAppRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertCandidateJobApp>>, TError,{data: CandidateSelfApplyJobAppRequest}, TContext> => {
    
const mutationKey = ['upsertCandidateJobApp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertCandidateJobApp>>, {data: CandidateSelfApplyJobAppRequest}> = (props) => {
          const {data} = props ?? {};

          return  upsertCandidateJobApp(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertCandidateJobAppMutationResult = NonNullable<Awaited<ReturnType<typeof upsertCandidateJobApp>>>
    export type UpsertCandidateJobAppMutationBody = CandidateSelfApplyJobAppRequest
    export type UpsertCandidateJobAppMutationError = unknown

    export const useUpsertCandidateJobApp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertCandidateJobApp>>, TError,{data: CandidateSelfApplyJobAppRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertCandidateJobApp>>,
        TError,
        {data: CandidateSelfApplyJobAppRequest},
        TContext
      > => {

      const mutationOptions = getUpsertCandidateJobAppMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const uploadCandidateJobAppDocument = (
    candidateJobAppDocumentUploadRequest: CandidateJobAppDocumentUploadRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(candidateJobAppDocumentUploadRequest.document !== undefined) {
 formData.append('document', candidateJobAppDocumentUploadRequest.document)
 }
if(candidateJobAppDocumentUploadRequest.isFinalStep !== undefined) {
 formData.append('isFinalStep', candidateJobAppDocumentUploadRequest.isFinalStep.toString())
 }
if(candidateJobAppDocumentUploadRequest.jobAppId !== undefined) {
 formData.append('jobAppId', candidateJobAppDocumentUploadRequest.jobAppId.toString())
 }
if(candidateJobAppDocumentUploadRequest.jobExtension !== undefined) {
 formData.append('jobExtension', candidateJobAppDocumentUploadRequest.jobExtension)
 }
if(candidateJobAppDocumentUploadRequest.orgFriendlyName !== undefined) {
 formData.append('orgFriendlyName', candidateJobAppDocumentUploadRequest.orgFriendlyName)
 }
if(candidateJobAppDocumentUploadRequest.orgcustomdocumentsId !== undefined) {
 formData.append('orgcustomdocumentsId', candidateJobAppDocumentUploadRequest.orgcustomdocumentsId.toString())
 }

      return customInstance<GenericResponse>(
      {url: `/applicants/candidate-job-app/upload-document`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadCandidateJobAppDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadCandidateJobAppDocument>>, TError,{data: CandidateJobAppDocumentUploadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadCandidateJobAppDocument>>, TError,{data: CandidateJobAppDocumentUploadRequest}, TContext> => {
    
const mutationKey = ['uploadCandidateJobAppDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadCandidateJobAppDocument>>, {data: CandidateJobAppDocumentUploadRequest}> = (props) => {
          const {data} = props ?? {};

          return  uploadCandidateJobAppDocument(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadCandidateJobAppDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadCandidateJobAppDocument>>>
    export type UploadCandidateJobAppDocumentMutationBody = CandidateJobAppDocumentUploadRequest
    export type UploadCandidateJobAppDocumentMutationError = unknown

    export const useUploadCandidateJobAppDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadCandidateJobAppDocument>>, TError,{data: CandidateJobAppDocumentUploadRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadCandidateJobAppDocument>>,
        TError,
        {data: CandidateJobAppDocumentUploadRequest},
        TContext
      > => {

      const mutationOptions = getUploadCandidateJobAppDocumentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const upsertForwardCandidateJobApp = (
    candidateSelfApplyJobAppRequest: CandidateSelfApplyJobAppRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/applicants/forward-candidate-job-app/submit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: candidateSelfApplyJobAppRequest, signal
    },
      );
    }
  


export const getUpsertForwardCandidateJobAppMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertForwardCandidateJobApp>>, TError,{data: CandidateSelfApplyJobAppRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertForwardCandidateJobApp>>, TError,{data: CandidateSelfApplyJobAppRequest}, TContext> => {
    
const mutationKey = ['upsertForwardCandidateJobApp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertForwardCandidateJobApp>>, {data: CandidateSelfApplyJobAppRequest}> = (props) => {
          const {data} = props ?? {};

          return  upsertForwardCandidateJobApp(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertForwardCandidateJobAppMutationResult = NonNullable<Awaited<ReturnType<typeof upsertForwardCandidateJobApp>>>
    export type UpsertForwardCandidateJobAppMutationBody = CandidateSelfApplyJobAppRequest
    export type UpsertForwardCandidateJobAppMutationError = unknown

    export const useUpsertForwardCandidateJobApp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertForwardCandidateJobApp>>, TError,{data: CandidateSelfApplyJobAppRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertForwardCandidateJobApp>>,
        TError,
        {data: CandidateSelfApplyJobAppRequest},
        TContext
      > => {

      const mutationOptions = getUpsertForwardCandidateJobAppMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const uploadForwardCandidateJobAppDocument = (
    candidateJobAppDocumentUploadRequest: CandidateJobAppDocumentUploadRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(candidateJobAppDocumentUploadRequest.document !== undefined) {
 formData.append('document', candidateJobAppDocumentUploadRequest.document)
 }
if(candidateJobAppDocumentUploadRequest.isFinalStep !== undefined) {
 formData.append('isFinalStep', candidateJobAppDocumentUploadRequest.isFinalStep.toString())
 }
if(candidateJobAppDocumentUploadRequest.jobAppId !== undefined) {
 formData.append('jobAppId', candidateJobAppDocumentUploadRequest.jobAppId.toString())
 }
if(candidateJobAppDocumentUploadRequest.jobExtension !== undefined) {
 formData.append('jobExtension', candidateJobAppDocumentUploadRequest.jobExtension)
 }
if(candidateJobAppDocumentUploadRequest.orgFriendlyName !== undefined) {
 formData.append('orgFriendlyName', candidateJobAppDocumentUploadRequest.orgFriendlyName)
 }
if(candidateJobAppDocumentUploadRequest.orgcustomdocumentsId !== undefined) {
 formData.append('orgcustomdocumentsId', candidateJobAppDocumentUploadRequest.orgcustomdocumentsId.toString())
 }

      return customInstance<GenericResponse>(
      {url: `/applicants/forward-candidate-job-app/upload-document`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadForwardCandidateJobAppDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadForwardCandidateJobAppDocument>>, TError,{data: CandidateJobAppDocumentUploadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadForwardCandidateJobAppDocument>>, TError,{data: CandidateJobAppDocumentUploadRequest}, TContext> => {
    
const mutationKey = ['uploadForwardCandidateJobAppDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadForwardCandidateJobAppDocument>>, {data: CandidateJobAppDocumentUploadRequest}> = (props) => {
          const {data} = props ?? {};

          return  uploadForwardCandidateJobAppDocument(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadForwardCandidateJobAppDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadForwardCandidateJobAppDocument>>>
    export type UploadForwardCandidateJobAppDocumentMutationBody = CandidateJobAppDocumentUploadRequest
    export type UploadForwardCandidateJobAppDocumentMutationError = unknown

    export const useUploadForwardCandidateJobAppDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadForwardCandidateJobAppDocument>>, TError,{data: CandidateJobAppDocumentUploadRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadForwardCandidateJobAppDocument>>,
        TError,
        {data: CandidateJobAppDocumentUploadRequest},
        TContext
      > => {

      const mutationOptions = getUploadForwardCandidateJobAppDocumentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendAssociateSignInMagicLink = (
    params: SendAssociateSignInMagicLinkParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/associate-signin/send-signin-email`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getSendAssociateSignInMagicLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAssociateSignInMagicLink>>, TError,{params: SendAssociateSignInMagicLinkParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendAssociateSignInMagicLink>>, TError,{params: SendAssociateSignInMagicLinkParams}, TContext> => {
    
const mutationKey = ['sendAssociateSignInMagicLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendAssociateSignInMagicLink>>, {params: SendAssociateSignInMagicLinkParams}> = (props) => {
          const {params} = props ?? {};

          return  sendAssociateSignInMagicLink(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendAssociateSignInMagicLinkMutationResult = NonNullable<Awaited<ReturnType<typeof sendAssociateSignInMagicLink>>>
    
    export type SendAssociateSignInMagicLinkMutationError = unknown

    export const useSendAssociateSignInMagicLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAssociateSignInMagicLink>>, TError,{params: SendAssociateSignInMagicLinkParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendAssociateSignInMagicLink>>,
        TError,
        {params: SendAssociateSignInMagicLinkParams},
        TContext
      > => {

      const mutationOptions = getSendAssociateSignInMagicLinkMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const associateSignIn = (
    orgFriendlyName: string,
    magicLinkId: number,
    userId: number,
    redirectUrl: string,
    token: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/associate-signin/signin/${orgFriendlyName}/${magicLinkId}/${userId}/${redirectUrl}/${token}`, method: 'GET', signal
    },
      );
    }
  

export const getAssociateSignInQueryKey = (orgFriendlyName: string,
    magicLinkId: number,
    userId: number,
    redirectUrl: string,
    token: string,) => {
    return [`/associate-signin/signin/${orgFriendlyName}/${magicLinkId}/${userId}/${redirectUrl}/${token}`] as const;
    }

    
export const getAssociateSignInQueryOptions = <TData = Awaited<ReturnType<typeof associateSignIn>>, TError = unknown>(orgFriendlyName: string,
    magicLinkId: number,
    userId: number,
    redirectUrl: string,
    token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof associateSignIn>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAssociateSignInQueryKey(orgFriendlyName,magicLinkId,userId,redirectUrl,token);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof associateSignIn>>> = ({ signal }) => associateSignIn(orgFriendlyName,magicLinkId,userId,redirectUrl,token, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgFriendlyName && magicLinkId && userId && redirectUrl && token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof associateSignIn>>, TError, TData> & { queryKey: QueryKey }
}

export type AssociateSignInQueryResult = NonNullable<Awaited<ReturnType<typeof associateSignIn>>>
export type AssociateSignInQueryError = unknown



export function useAssociateSignIn<TData = Awaited<ReturnType<typeof associateSignIn>>, TError = unknown>(
 orgFriendlyName: string,
    magicLinkId: number,
    userId: number,
    redirectUrl: string,
    token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof associateSignIn>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAssociateSignInQueryOptions(orgFriendlyName,magicLinkId,userId,redirectUrl,token,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const logoutAgencyContact = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserLogoutResponse>(
      {url: `/authentication/agency-contact-logout`, method: 'POST', signal
    },
      );
    }
  


export const getLogoutAgencyContactMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutAgencyContact>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof logoutAgencyContact>>, TError,void, TContext> => {
    
const mutationKey = ['logoutAgencyContact'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutAgencyContact>>, void> = () => {
          

          return  logoutAgencyContact()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutAgencyContactMutationResult = NonNullable<Awaited<ReturnType<typeof logoutAgencyContact>>>
    
    export type LogoutAgencyContactMutationError = unknown

    export const useLogoutAgencyContact = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutAgencyContact>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof logoutAgencyContact>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getLogoutAgencyContactMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const amILoggedInAgencyContact = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<AmILoggedInAgencyContactResponse>(
      {url: `/authentication/am-i-logged-in-agency-contact`, method: 'GET', signal
    },
      );
    }
  

export const getAmILoggedInAgencyContactQueryKey = () => {
    return [`/authentication/am-i-logged-in-agency-contact`] as const;
    }

    
export const getAmILoggedInAgencyContactQueryOptions = <TData = Awaited<ReturnType<typeof amILoggedInAgencyContact>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof amILoggedInAgencyContact>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAmILoggedInAgencyContactQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof amILoggedInAgencyContact>>> = ({ signal }) => amILoggedInAgencyContact(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof amILoggedInAgencyContact>>, TError, TData> & { queryKey: QueryKey }
}

export type AmILoggedInAgencyContactQueryResult = NonNullable<Awaited<ReturnType<typeof amILoggedInAgencyContact>>>
export type AmILoggedInAgencyContactQueryError = unknown



export function useAmILoggedInAgencyContact<TData = Awaited<ReturnType<typeof amILoggedInAgencyContact>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof amILoggedInAgencyContact>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAmILoggedInAgencyContactQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const amILoggedInApplicant = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<AmILoggedInApplicantResponse>(
      {url: `/authentication/am-i-logged-in-applicant`, method: 'GET', signal
    },
      );
    }
  

export const getAmILoggedInApplicantQueryKey = () => {
    return [`/authentication/am-i-logged-in-applicant`] as const;
    }

    
export const getAmILoggedInApplicantQueryOptions = <TData = Awaited<ReturnType<typeof amILoggedInApplicant>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof amILoggedInApplicant>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAmILoggedInApplicantQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof amILoggedInApplicant>>> = ({ signal }) => amILoggedInApplicant(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof amILoggedInApplicant>>, TError, TData> & { queryKey: QueryKey }
}

export type AmILoggedInApplicantQueryResult = NonNullable<Awaited<ReturnType<typeof amILoggedInApplicant>>>
export type AmILoggedInApplicantQueryError = unknown



export function useAmILoggedInApplicant<TData = Awaited<ReturnType<typeof amILoggedInApplicant>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof amILoggedInApplicant>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAmILoggedInApplicantQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const amILoggedInAssociate = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<AmILoggedInResponse>(
      {url: `/authentication/am-i-logged-in-associate`, method: 'GET', signal
    },
      );
    }
  

export const getAmILoggedInAssociateQueryKey = () => {
    return [`/authentication/am-i-logged-in-associate`] as const;
    }

    
export const getAmILoggedInAssociateQueryOptions = <TData = Awaited<ReturnType<typeof amILoggedInAssociate>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof amILoggedInAssociate>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAmILoggedInAssociateQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof amILoggedInAssociate>>> = ({ signal }) => amILoggedInAssociate(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof amILoggedInAssociate>>, TError, TData> & { queryKey: QueryKey }
}

export type AmILoggedInAssociateQueryResult = NonNullable<Awaited<ReturnType<typeof amILoggedInAssociate>>>
export type AmILoggedInAssociateQueryError = unknown



export function useAmILoggedInAssociate<TData = Awaited<ReturnType<typeof amILoggedInAssociate>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof amILoggedInAssociate>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAmILoggedInAssociateQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const amILoggedInForward = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<AmILoggedInForwardResponse>(
      {url: `/authentication/am-i-logged-in-forward`, method: 'GET', signal
    },
      );
    }
  

export const getAmILoggedInForwardQueryKey = () => {
    return [`/authentication/am-i-logged-in-forward`] as const;
    }

    
export const getAmILoggedInForwardQueryOptions = <TData = Awaited<ReturnType<typeof amILoggedInForward>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof amILoggedInForward>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAmILoggedInForwardQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof amILoggedInForward>>> = ({ signal }) => amILoggedInForward(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof amILoggedInForward>>, TError, TData> & { queryKey: QueryKey }
}

export type AmILoggedInForwardQueryResult = NonNullable<Awaited<ReturnType<typeof amILoggedInForward>>>
export type AmILoggedInForwardQueryError = unknown



export function useAmILoggedInForward<TData = Awaited<ReturnType<typeof amILoggedInForward>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof amILoggedInForward>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAmILoggedInForwardQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const amILoggedInMember = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<AmILoggedInMemberResponse>(
      {url: `/authentication/am-i-logged-in-member`, method: 'GET', signal
    },
      );
    }
  

export const getAmILoggedInMemberQueryKey = () => {
    return [`/authentication/am-i-logged-in-member`] as const;
    }

    
export const getAmILoggedInMemberQueryOptions = <TData = Awaited<ReturnType<typeof amILoggedInMember>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof amILoggedInMember>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAmILoggedInMemberQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof amILoggedInMember>>> = ({ signal }) => amILoggedInMember(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof amILoggedInMember>>, TError, TData> & { queryKey: QueryKey }
}

export type AmILoggedInMemberQueryResult = NonNullable<Awaited<ReturnType<typeof amILoggedInMember>>>
export type AmILoggedInMemberQueryError = unknown



export function useAmILoggedInMember<TData = Awaited<ReturnType<typeof amILoggedInMember>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof amILoggedInMember>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAmILoggedInMemberQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const amILoggedIn = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<AmILoggedInResponse>(
      {url: `/authentication/amILoggedIn`, method: 'GET', signal
    },
      );
    }
  

export const getAmILoggedInQueryKey = () => {
    return [`/authentication/amILoggedIn`] as const;
    }

    
export const getAmILoggedInQueryOptions = <TData = Awaited<ReturnType<typeof amILoggedIn>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof amILoggedIn>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAmILoggedInQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof amILoggedIn>>> = ({ signal }) => amILoggedIn(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof amILoggedIn>>, TError, TData> & { queryKey: QueryKey }
}

export type AmILoggedInQueryResult = NonNullable<Awaited<ReturnType<typeof amILoggedIn>>>
export type AmILoggedInQueryError = unknown



export function useAmILoggedIn<TData = Awaited<ReturnType<typeof amILoggedIn>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof amILoggedIn>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAmILoggedInQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const amILoggedInWithRoles = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<AmILoggedInWithRolesResponse>(
      {url: `/authentication/amILoggedInWithRoles`, method: 'GET', signal
    },
      );
    }
  

export const getAmILoggedInWithRolesQueryKey = () => {
    return [`/authentication/amILoggedInWithRoles`] as const;
    }

    
export const getAmILoggedInWithRolesQueryOptions = <TData = Awaited<ReturnType<typeof amILoggedInWithRoles>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof amILoggedInWithRoles>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAmILoggedInWithRolesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof amILoggedInWithRoles>>> = ({ signal }) => amILoggedInWithRoles(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof amILoggedInWithRoles>>, TError, TData> & { queryKey: QueryKey }
}

export type AmILoggedInWithRolesQueryResult = NonNullable<Awaited<ReturnType<typeof amILoggedInWithRoles>>>
export type AmILoggedInWithRolesQueryError = unknown



export function useAmILoggedInWithRoles<TData = Awaited<ReturnType<typeof amILoggedInWithRoles>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof amILoggedInWithRoles>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAmILoggedInWithRolesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const logoutApplicant = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserLogoutResponse>(
      {url: `/authentication/applicant-logout`, method: 'POST', signal
    },
      );
    }
  


export const getLogoutApplicantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutApplicant>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof logoutApplicant>>, TError,void, TContext> => {
    
const mutationKey = ['logoutApplicant'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutApplicant>>, void> = () => {
          

          return  logoutApplicant()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutApplicantMutationResult = NonNullable<Awaited<ReturnType<typeof logoutApplicant>>>
    
    export type LogoutApplicantMutationError = unknown

    export const useLogoutApplicant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutApplicant>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof logoutApplicant>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getLogoutApplicantMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const logoutAssociate = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserLogoutResponse>(
      {url: `/authentication/associate-logout`, method: 'POST', signal
    },
      );
    }
  


export const getLogoutAssociateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutAssociate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof logoutAssociate>>, TError,void, TContext> => {
    
const mutationKey = ['logoutAssociate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutAssociate>>, void> = () => {
          

          return  logoutAssociate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutAssociateMutationResult = NonNullable<Awaited<ReturnType<typeof logoutAssociate>>>
    
    export type LogoutAssociateMutationError = unknown

    export const useLogoutAssociate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutAssociate>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof logoutAssociate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getLogoutAssociateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const userLogin = (
    userLoginRequest: UserLoginRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserJwtResponse>(
      {url: `/authentication/user-login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userLoginRequest, signal
    },
      );
    }
  


export const getUserLoginMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userLogin>>, TError,{data: UserLoginRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userLogin>>, TError,{data: UserLoginRequest}, TContext> => {
    
const mutationKey = ['userLogin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userLogin>>, {data: UserLoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  userLogin(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserLoginMutationResult = NonNullable<Awaited<ReturnType<typeof userLogin>>>
    export type UserLoginMutationBody = UserLoginRequest
    export type UserLoginMutationError = unknown

    export const useUserLogin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userLogin>>, TError,{data: UserLoginRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof userLogin>>,
        TError,
        {data: UserLoginRequest},
        TContext
      > => {

      const mutationOptions = getUserLoginMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const logoutUser = (
    userLogoutRequest: UserLogoutRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserLogoutResponse>(
      {url: `/authentication/user-logout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userLogoutRequest, signal
    },
      );
    }
  


export const getLogoutUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutUser>>, TError,{data: UserLogoutRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof logoutUser>>, TError,{data: UserLogoutRequest}, TContext> => {
    
const mutationKey = ['logoutUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutUser>>, {data: UserLogoutRequest}> = (props) => {
          const {data} = props ?? {};

          return  logoutUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutUserMutationResult = NonNullable<Awaited<ReturnType<typeof logoutUser>>>
    export type LogoutUserMutationBody = UserLogoutRequest
    export type LogoutUserMutationError = unknown

    export const useLogoutUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutUser>>, TError,{data: UserLogoutRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof logoutUser>>,
        TError,
        {data: UserLogoutRequest},
        TContext
      > => {

      const mutationOptions = getLogoutUserMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const generateCandidateReviewPdfExportRest = (
    candidateReviewPdfExportRequest: CandidateReviewPdfExportRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/candidate-review-exports/pdf-export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: candidateReviewPdfExportRequest, signal
    },
      );
    }
  


export const getGenerateCandidateReviewPdfExportRestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCandidateReviewPdfExportRest>>, TError,{data: CandidateReviewPdfExportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateCandidateReviewPdfExportRest>>, TError,{data: CandidateReviewPdfExportRequest}, TContext> => {
    
const mutationKey = ['generateCandidateReviewPdfExportRest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateCandidateReviewPdfExportRest>>, {data: CandidateReviewPdfExportRequest}> = (props) => {
          const {data} = props ?? {};

          return  generateCandidateReviewPdfExportRest(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateCandidateReviewPdfExportRestMutationResult = NonNullable<Awaited<ReturnType<typeof generateCandidateReviewPdfExportRest>>>
    export type GenerateCandidateReviewPdfExportRestMutationBody = CandidateReviewPdfExportRequest
    export type GenerateCandidateReviewPdfExportRestMutationError = unknown

    export const useGenerateCandidateReviewPdfExportRest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCandidateReviewPdfExportRest>>, TError,{data: CandidateReviewPdfExportRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateCandidateReviewPdfExportRest>>,
        TError,
        {data: CandidateReviewPdfExportRequest},
        TContext
      > => {

      const mutationOptions = getGenerateCandidateReviewPdfExportRestMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const generateCandidateReviewPdfExportAsync = (
    candidateReviewPdfExportRequest: CandidateReviewPdfExportRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/candidate-review-exports/pdf-export-async`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: candidateReviewPdfExportRequest, signal
    },
      );
    }
  


export const getGenerateCandidateReviewPdfExportAsyncMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCandidateReviewPdfExportAsync>>, TError,{data: CandidateReviewPdfExportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateCandidateReviewPdfExportAsync>>, TError,{data: CandidateReviewPdfExportRequest}, TContext> => {
    
const mutationKey = ['generateCandidateReviewPdfExportAsync'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateCandidateReviewPdfExportAsync>>, {data: CandidateReviewPdfExportRequest}> = (props) => {
          const {data} = props ?? {};

          return  generateCandidateReviewPdfExportAsync(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateCandidateReviewPdfExportAsyncMutationResult = NonNullable<Awaited<ReturnType<typeof generateCandidateReviewPdfExportAsync>>>
    export type GenerateCandidateReviewPdfExportAsyncMutationBody = CandidateReviewPdfExportRequest
    export type GenerateCandidateReviewPdfExportAsyncMutationError = unknown

    export const useGenerateCandidateReviewPdfExportAsync = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCandidateReviewPdfExportAsync>>, TError,{data: CandidateReviewPdfExportRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateCandidateReviewPdfExportAsync>>,
        TError,
        {data: CandidateReviewPdfExportRequest},
        TContext
      > => {

      const mutationOptions = getGenerateCandidateReviewPdfExportAsyncMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getOrgCandidates = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<CandidateResponse[]>(
      {url: `/candidate/all`, method: 'GET', signal
    },
      );
    }
  

export const getGetOrgCandidatesQueryKey = () => {
    return [`/candidate/all`] as const;
    }

    
export const getGetOrgCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof getOrgCandidates>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgCandidates>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgCandidatesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgCandidates>>> = ({ signal }) => getOrgCandidates(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgCandidates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgCandidates>>>
export type GetOrgCandidatesQueryError = unknown



export function useGetOrgCandidates<TData = Awaited<ReturnType<typeof getOrgCandidates>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgCandidates>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrgCandidatesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCandidateProfileDocuments = (
    recruitId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CandidateProfileDocumentResponse>(
      {url: `/candidate/candidate-profile/${recruitId}/documents`, method: 'GET', signal
    },
      );
    }
  

export const getGetCandidateProfileDocumentsQueryKey = (recruitId: number,) => {
    return [`/candidate/candidate-profile/${recruitId}/documents`] as const;
    }

    
export const getGetCandidateProfileDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getCandidateProfileDocuments>>, TError = unknown>(recruitId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCandidateProfileDocuments>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidateProfileDocumentsQueryKey(recruitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidateProfileDocuments>>> = ({ signal }) => getCandidateProfileDocuments(recruitId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(recruitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCandidateProfileDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCandidateProfileDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidateProfileDocuments>>>
export type GetCandidateProfileDocumentsQueryError = unknown



export function useGetCandidateProfileDocuments<TData = Awaited<ReturnType<typeof getCandidateProfileDocuments>>, TError = unknown>(
 recruitId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCandidateProfileDocuments>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCandidateProfileDocumentsQueryOptions(recruitId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCandidateProfileJobList = (
    recruitId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CandidateProfileGeneralJobInfoResponse[]>(
      {url: `/candidate/candidate-profile/${recruitId}/jobList`, method: 'GET', signal
    },
      );
    }
  

export const getGetCandidateProfileJobListQueryKey = (recruitId: number,) => {
    return [`/candidate/candidate-profile/${recruitId}/jobList`] as const;
    }

    
export const getGetCandidateProfileJobListQueryOptions = <TData = Awaited<ReturnType<typeof getCandidateProfileJobList>>, TError = unknown>(recruitId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCandidateProfileJobList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidateProfileJobListQueryKey(recruitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidateProfileJobList>>> = ({ signal }) => getCandidateProfileJobList(recruitId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(recruitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCandidateProfileJobList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCandidateProfileJobListQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidateProfileJobList>>>
export type GetCandidateProfileJobListQueryError = unknown



export function useGetCandidateProfileJobList<TData = Awaited<ReturnType<typeof getCandidateProfileJobList>>, TError = unknown>(
 recruitId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCandidateProfileJobList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCandidateProfileJobListQueryOptions(recruitId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOrgCandidateList = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<CandidatePageResponse[]>(
      {url: `/candidate/candidateList`, method: 'GET', signal
    },
      );
    }
  

export const getGetOrgCandidateListQueryKey = () => {
    return [`/candidate/candidateList`] as const;
    }

    
export const getGetOrgCandidateListQueryOptions = <TData = Awaited<ReturnType<typeof getOrgCandidateList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgCandidateList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgCandidateListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgCandidateList>>> = ({ signal }) => getOrgCandidateList(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgCandidateList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgCandidateListQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgCandidateList>>>
export type GetOrgCandidateListQueryError = unknown



export function useGetOrgCandidateList<TData = Awaited<ReturnType<typeof getOrgCandidateList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgCandidateList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrgCandidateListQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOrgCandidateIdList = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<number[]>(
      {url: `/candidate/candidateList/onlyIds`, method: 'GET', signal
    },
      );
    }
  

export const getGetOrgCandidateIdListQueryKey = () => {
    return [`/candidate/candidateList/onlyIds`] as const;
    }

    
export const getGetOrgCandidateIdListQueryOptions = <TData = Awaited<ReturnType<typeof getOrgCandidateIdList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgCandidateIdList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgCandidateIdListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgCandidateIdList>>> = ({ signal }) => getOrgCandidateIdList(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgCandidateIdList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgCandidateIdListQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgCandidateIdList>>>
export type GetOrgCandidateIdListQueryError = unknown



export function useGetOrgCandidateIdList<TData = Awaited<ReturnType<typeof getOrgCandidateIdList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgCandidateIdList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrgCandidateIdListQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const exportCandidateEvaluations = (
    exportCandidateEvaluationsBody: string[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/candidate/evaluations/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportCandidateEvaluationsBody, signal
    },
      );
    }
  


export const getExportCandidateEvaluationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportCandidateEvaluations>>, TError,{data: string[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportCandidateEvaluations>>, TError,{data: string[]}, TContext> => {
    
const mutationKey = ['exportCandidateEvaluations'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportCandidateEvaluations>>, {data: string[]}> = (props) => {
          const {data} = props ?? {};

          return  exportCandidateEvaluations(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportCandidateEvaluationsMutationResult = NonNullable<Awaited<ReturnType<typeof exportCandidateEvaluations>>>
    export type ExportCandidateEvaluationsMutationBody = string[]
    export type ExportCandidateEvaluationsMutationError = unknown

    export const useExportCandidateEvaluations = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportCandidateEvaluations>>, TError,{data: string[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportCandidateEvaluations>>,
        TError,
        {data: string[]},
        TContext
      > => {

      const mutationOptions = getExportCandidateEvaluationsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const exportAdminNotes = (
    exportAdminNotesBody: string[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/candidate/export/adminNotes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportAdminNotesBody, signal
    },
      );
    }
  


export const getExportAdminNotesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportAdminNotes>>, TError,{data: string[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportAdminNotes>>, TError,{data: string[]}, TContext> => {
    
const mutationKey = ['exportAdminNotes'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportAdminNotes>>, {data: string[]}> = (props) => {
          const {data} = props ?? {};

          return  exportAdminNotes(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportAdminNotesMutationResult = NonNullable<Awaited<ReturnType<typeof exportAdminNotes>>>
    export type ExportAdminNotesMutationBody = string[]
    export type ExportAdminNotesMutationError = unknown

    export const useExportAdminNotes = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportAdminNotes>>, TError,{data: string[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportAdminNotes>>,
        TError,
        {data: string[]},
        TContext
      > => {

      const mutationOptions = getExportAdminNotesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const exportBclpCandidatesDataTable = (
    candidatesDataTableExportRequest: CandidatesDataTableExportRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/candidate/export/bclp-candidates-data-table`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: candidatesDataTableExportRequest, signal
    },
      );
    }
  


export const getExportBclpCandidatesDataTableMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportBclpCandidatesDataTable>>, TError,{data: CandidatesDataTableExportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportBclpCandidatesDataTable>>, TError,{data: CandidatesDataTableExportRequest}, TContext> => {
    
const mutationKey = ['exportBclpCandidatesDataTable'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportBclpCandidatesDataTable>>, {data: CandidatesDataTableExportRequest}> = (props) => {
          const {data} = props ?? {};

          return  exportBclpCandidatesDataTable(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportBclpCandidatesDataTableMutationResult = NonNullable<Awaited<ReturnType<typeof exportBclpCandidatesDataTable>>>
    export type ExportBclpCandidatesDataTableMutationBody = CandidatesDataTableExportRequest
    export type ExportBclpCandidatesDataTableMutationError = unknown

    export const useExportBclpCandidatesDataTable = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportBclpCandidatesDataTable>>, TError,{data: CandidatesDataTableExportRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportBclpCandidatesDataTable>>,
        TError,
        {data: CandidatesDataTableExportRequest},
        TContext
      > => {

      const mutationOptions = getExportBclpCandidatesDataTableMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const filterCandidates = (
    candidateFilterRequest: CandidateFilterRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number[]>(
      {url: `/candidate/filters`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: candidateFilterRequest, signal
    },
      );
    }
  


export const getFilterCandidatesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filterCandidates>>, TError,{data: CandidateFilterRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof filterCandidates>>, TError,{data: CandidateFilterRequest}, TContext> => {
    
const mutationKey = ['filterCandidates'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof filterCandidates>>, {data: CandidateFilterRequest}> = (props) => {
          const {data} = props ?? {};

          return  filterCandidates(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FilterCandidatesMutationResult = NonNullable<Awaited<ReturnType<typeof filterCandidates>>>
    export type FilterCandidatesMutationBody = CandidateFilterRequest
    export type FilterCandidatesMutationError = unknown

    export const useFilterCandidates = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filterCandidates>>, TError,{data: CandidateFilterRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof filterCandidates>>,
        TError,
        {data: CandidateFilterRequest},
        TContext
      > => {

      const mutationOptions = getFilterCandidatesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const deleteHistoricalCandidates = (
    deleteHistoricalCandidatesBody: number[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/candidate/historical/delete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: deleteHistoricalCandidatesBody, signal
    },
      );
    }
  


export const getDeleteHistoricalCandidatesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHistoricalCandidates>>, TError,{data: number[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteHistoricalCandidates>>, TError,{data: number[]}, TContext> => {
    
const mutationKey = ['deleteHistoricalCandidates'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHistoricalCandidates>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  deleteHistoricalCandidates(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteHistoricalCandidatesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHistoricalCandidates>>>
    export type DeleteHistoricalCandidatesMutationBody = number[]
    export type DeleteHistoricalCandidatesMutationError = unknown

    export const useDeleteHistoricalCandidates = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHistoricalCandidates>>, TError,{data: number[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteHistoricalCandidates>>,
        TError,
        {data: number[]},
        TContext
      > => {

      const mutationOptions = getDeleteHistoricalCandidatesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const importHistoricalCandidateData = (
    historicalCandidateUploadRequest: HistoricalCandidateUploadRequest[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/candidate/historical/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: historicalCandidateUploadRequest, signal
    },
      );
    }
  


export const getImportHistoricalCandidateDataMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importHistoricalCandidateData>>, TError,{data: HistoricalCandidateUploadRequest[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof importHistoricalCandidateData>>, TError,{data: HistoricalCandidateUploadRequest[]}, TContext> => {
    
const mutationKey = ['importHistoricalCandidateData'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importHistoricalCandidateData>>, {data: HistoricalCandidateUploadRequest[]}> = (props) => {
          const {data} = props ?? {};

          return  importHistoricalCandidateData(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportHistoricalCandidateDataMutationResult = NonNullable<Awaited<ReturnType<typeof importHistoricalCandidateData>>>
    export type ImportHistoricalCandidateDataMutationBody = HistoricalCandidateUploadRequest[]
    export type ImportHistoricalCandidateDataMutationError = unknown

    export const useImportHistoricalCandidateData = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importHistoricalCandidateData>>, TError,{data: HistoricalCandidateUploadRequest[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof importHistoricalCandidateData>>,
        TError,
        {data: HistoricalCandidateUploadRequest[]},
        TContext
      > => {

      const mutationOptions = getImportHistoricalCandidateDataMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const importHistoricalCandidateDocument = (
    id: number,
    historicalCandidateDocumentUploadRequest: HistoricalCandidateDocumentUploadRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(historicalCandidateDocumentUploadRequest.data !== undefined) {
 formData.append('data', historicalCandidateDocumentUploadRequest.data)
 }
if(historicalCandidateDocumentUploadRequest.name !== undefined) {
 formData.append('name', historicalCandidateDocumentUploadRequest.name)
 }

      return customInstance<void>(
      {url: `/candidate/historical/${id}/document/import`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getImportHistoricalCandidateDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importHistoricalCandidateDocument>>, TError,{id: number;data: HistoricalCandidateDocumentUploadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof importHistoricalCandidateDocument>>, TError,{id: number;data: HistoricalCandidateDocumentUploadRequest}, TContext> => {
    
const mutationKey = ['importHistoricalCandidateDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importHistoricalCandidateDocument>>, {id: number;data: HistoricalCandidateDocumentUploadRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  importHistoricalCandidateDocument(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportHistoricalCandidateDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof importHistoricalCandidateDocument>>>
    export type ImportHistoricalCandidateDocumentMutationBody = HistoricalCandidateDocumentUploadRequest
    export type ImportHistoricalCandidateDocumentMutationError = unknown

    export const useImportHistoricalCandidateDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importHistoricalCandidateDocument>>, TError,{id: number;data: HistoricalCandidateDocumentUploadRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof importHistoricalCandidateDocument>>,
        TError,
        {id: number;data: HistoricalCandidateDocumentUploadRequest},
        TContext
      > => {

      const mutationOptions = getImportHistoricalCandidateDocumentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const exportHistoricalCandidateDocuments = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/candidate/historical/${id}/documents/export`, method: 'POST', signal
    },
      );
    }
  


export const getExportHistoricalCandidateDocumentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportHistoricalCandidateDocuments>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportHistoricalCandidateDocuments>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['exportHistoricalCandidateDocuments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportHistoricalCandidateDocuments>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  exportHistoricalCandidateDocuments(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportHistoricalCandidateDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof exportHistoricalCandidateDocuments>>>
    
    export type ExportHistoricalCandidateDocumentsMutationError = unknown

    export const useExportHistoricalCandidateDocuments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportHistoricalCandidateDocuments>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportHistoricalCandidateDocuments>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getExportHistoricalCandidateDocumentsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const exportHistoricalCandidateDocument = (
    id: number,
    documentId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/candidate/historical/${id}/documents/${documentId}/export`, method: 'POST', signal
    },
      );
    }
  


export const getExportHistoricalCandidateDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportHistoricalCandidateDocument>>, TError,{id: number;documentId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportHistoricalCandidateDocument>>, TError,{id: number;documentId: number}, TContext> => {
    
const mutationKey = ['exportHistoricalCandidateDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportHistoricalCandidateDocument>>, {id: number;documentId: number}> = (props) => {
          const {id,documentId} = props ?? {};

          return  exportHistoricalCandidateDocument(id,documentId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportHistoricalCandidateDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof exportHistoricalCandidateDocument>>>
    
    export type ExportHistoricalCandidateDocumentMutationError = unknown

    export const useExportHistoricalCandidateDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportHistoricalCandidateDocument>>, TError,{id: number;documentId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportHistoricalCandidateDocument>>,
        TError,
        {id: number;documentId: number},
        TContext
      > => {

      const mutationOptions = getExportHistoricalCandidateDocumentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const exportJobAppDocumentsAllJobs = (
    orgDocumentId: number,
    exportJobAppDocumentsAllJobsBody: number[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/candidate/jobAppDocuments/${orgDocumentId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportJobAppDocumentsAllJobsBody, signal
    },
      );
    }
  


export const getExportJobAppDocumentsAllJobsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportJobAppDocumentsAllJobs>>, TError,{orgDocumentId: number;data: number[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportJobAppDocumentsAllJobs>>, TError,{orgDocumentId: number;data: number[]}, TContext> => {
    
const mutationKey = ['exportJobAppDocumentsAllJobs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportJobAppDocumentsAllJobs>>, {orgDocumentId: number;data: number[]}> = (props) => {
          const {orgDocumentId,data} = props ?? {};

          return  exportJobAppDocumentsAllJobs(orgDocumentId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportJobAppDocumentsAllJobsMutationResult = NonNullable<Awaited<ReturnType<typeof exportJobAppDocumentsAllJobs>>>
    export type ExportJobAppDocumentsAllJobsMutationBody = number[]
    export type ExportJobAppDocumentsAllJobsMutationError = unknown

    export const useExportJobAppDocumentsAllJobs = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportJobAppDocumentsAllJobs>>, TError,{orgDocumentId: number;data: number[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportJobAppDocumentsAllJobs>>,
        TError,
        {orgDocumentId: number;data: number[]},
        TContext
      > => {

      const mutationOptions = getExportJobAppDocumentsAllJobsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getMergePreview = (
    primaryRecruitId: number,
    subordinateRecruitId: number,
    params: GetMergePreviewParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CandidateMergePreviewResponse>(
      {url: `/candidate/mergePreview/${primaryRecruitId}/${subordinateRecruitId}`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getGetMergePreviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getMergePreview>>, TError,{primaryRecruitId: number;subordinateRecruitId: number;params: GetMergePreviewParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getMergePreview>>, TError,{primaryRecruitId: number;subordinateRecruitId: number;params: GetMergePreviewParams}, TContext> => {
    
const mutationKey = ['getMergePreview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getMergePreview>>, {primaryRecruitId: number;subordinateRecruitId: number;params: GetMergePreviewParams}> = (props) => {
          const {primaryRecruitId,subordinateRecruitId,params} = props ?? {};

          return  getMergePreview(primaryRecruitId,subordinateRecruitId,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetMergePreviewMutationResult = NonNullable<Awaited<ReturnType<typeof getMergePreview>>>
    
    export type GetMergePreviewMutationError = unknown

    export const useGetMergePreview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getMergePreview>>, TError,{primaryRecruitId: number;subordinateRecruitId: number;params: GetMergePreviewParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof getMergePreview>>,
        TError,
        {primaryRecruitId: number;subordinateRecruitId: number;params: GetMergePreviewParams},
        TContext
      > => {

      const mutationOptions = getGetMergePreviewMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getCandidateByEmail = (
    org: string,
    email: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CandidateResponse>(
      {url: `/candidate/${org}/${email}`, method: 'GET', signal
    },
      );
    }
  

export const getGetCandidateByEmailQueryKey = (org: string,
    email: string,) => {
    return [`/candidate/${org}/${email}`] as const;
    }

    
export const getGetCandidateByEmailQueryOptions = <TData = Awaited<ReturnType<typeof getCandidateByEmail>>, TError = unknown>(org: string,
    email: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCandidateByEmail>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidateByEmailQueryKey(org,email);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidateByEmail>>> = ({ signal }) => getCandidateByEmail(org,email, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && email), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCandidateByEmail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCandidateByEmailQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidateByEmail>>>
export type GetCandidateByEmailQueryError = unknown



export function useGetCandidateByEmail<TData = Awaited<ReturnType<typeof getCandidateByEmail>>, TError = unknown>(
 org: string,
    email: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCandidateByEmail>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCandidateByEmailQueryOptions(org,email,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const mostRecentDocumentDownloadLink = (
    recruitId: number,
    orgDocId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/candidate/${recruitId}/most-recent-documents/${orgDocId}`, method: 'GET', signal
    },
      );
    }
  

export const getMostRecentDocumentDownloadLinkQueryKey = (recruitId: number,
    orgDocId: number,) => {
    return [`/candidate/${recruitId}/most-recent-documents/${orgDocId}`] as const;
    }

    
export const getMostRecentDocumentDownloadLinkQueryOptions = <TData = Awaited<ReturnType<typeof mostRecentDocumentDownloadLink>>, TError = unknown>(recruitId: number,
    orgDocId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof mostRecentDocumentDownloadLink>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMostRecentDocumentDownloadLinkQueryKey(recruitId,orgDocId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof mostRecentDocumentDownloadLink>>> = ({ signal }) => mostRecentDocumentDownloadLink(recruitId,orgDocId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(recruitId && orgDocId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mostRecentDocumentDownloadLink>>, TError, TData> & { queryKey: QueryKey }
}

export type MostRecentDocumentDownloadLinkQueryResult = NonNullable<Awaited<ReturnType<typeof mostRecentDocumentDownloadLink>>>
export type MostRecentDocumentDownloadLinkQueryError = unknown



export function useMostRecentDocumentDownloadLink<TData = Awaited<ReturnType<typeof mostRecentDocumentDownloadLink>>, TError = unknown>(
 recruitId: number,
    orgDocId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof mostRecentDocumentDownloadLink>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMostRecentDocumentDownloadLinkQueryOptions(recruitId,orgDocId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const generateLinkForDocumentDownloadForInterviewSchedulingEvent = (
    eventId: number,
    candidateProfileInterviewSchedulingDocumentDownloadRequest: CandidateProfileInterviewSchedulingDocumentDownloadRequest[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/candidateProfileAdmin/generateLinkForDocumentDownloadForInterviewSchedulingEvent/${eventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: candidateProfileInterviewSchedulingDocumentDownloadRequest, signal
    },
      );
    }
  


export const getGenerateLinkForDocumentDownloadForInterviewSchedulingEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLinkForDocumentDownloadForInterviewSchedulingEvent>>, TError,{eventId: number;data: CandidateProfileInterviewSchedulingDocumentDownloadRequest[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateLinkForDocumentDownloadForInterviewSchedulingEvent>>, TError,{eventId: number;data: CandidateProfileInterviewSchedulingDocumentDownloadRequest[]}, TContext> => {
    
const mutationKey = ['generateLinkForDocumentDownloadForInterviewSchedulingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateLinkForDocumentDownloadForInterviewSchedulingEvent>>, {eventId: number;data: CandidateProfileInterviewSchedulingDocumentDownloadRequest[]}> = (props) => {
          const {eventId,data} = props ?? {};

          return  generateLinkForDocumentDownloadForInterviewSchedulingEvent(eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateLinkForDocumentDownloadForInterviewSchedulingEventMutationResult = NonNullable<Awaited<ReturnType<typeof generateLinkForDocumentDownloadForInterviewSchedulingEvent>>>
    export type GenerateLinkForDocumentDownloadForInterviewSchedulingEventMutationBody = CandidateProfileInterviewSchedulingDocumentDownloadRequest[]
    export type GenerateLinkForDocumentDownloadForInterviewSchedulingEventMutationError = unknown

    export const useGenerateLinkForDocumentDownloadForInterviewSchedulingEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLinkForDocumentDownloadForInterviewSchedulingEvent>>, TError,{eventId: number;data: CandidateProfileInterviewSchedulingDocumentDownloadRequest[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateLinkForDocumentDownloadForInterviewSchedulingEvent>>,
        TError,
        {eventId: number;data: CandidateProfileInterviewSchedulingDocumentDownloadRequest[]},
        TContext
      > => {

      const mutationOptions = getGenerateLinkForDocumentDownloadForInterviewSchedulingEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getDocumentsForInterviewSchedulingEventForCandidateProfile = (
    recruitId: number,
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CandidateProfileInterviewSchedulingDocumentInfoResponse>(
      {url: `/candidateProfileAdmin/getDocumentsForInterviewSchedulingEvent/${recruitId}/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetDocumentsForInterviewSchedulingEventForCandidateProfileQueryKey = (recruitId: number,
    eventId: number,) => {
    return [`/candidateProfileAdmin/getDocumentsForInterviewSchedulingEvent/${recruitId}/${eventId}`] as const;
    }

    
export const getGetDocumentsForInterviewSchedulingEventForCandidateProfileQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentsForInterviewSchedulingEventForCandidateProfile>>, TError = unknown>(recruitId: number,
    eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDocumentsForInterviewSchedulingEventForCandidateProfile>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentsForInterviewSchedulingEventForCandidateProfileQueryKey(recruitId,eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentsForInterviewSchedulingEventForCandidateProfile>>> = ({ signal }) => getDocumentsForInterviewSchedulingEventForCandidateProfile(recruitId,eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(recruitId && eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentsForInterviewSchedulingEventForCandidateProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDocumentsForInterviewSchedulingEventForCandidateProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentsForInterviewSchedulingEventForCandidateProfile>>>
export type GetDocumentsForInterviewSchedulingEventForCandidateProfileQueryError = unknown



export function useGetDocumentsForInterviewSchedulingEventForCandidateProfile<TData = Awaited<ReturnType<typeof getDocumentsForInterviewSchedulingEventForCandidateProfile>>, TError = unknown>(
 recruitId: number,
    eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDocumentsForInterviewSchedulingEventForCandidateProfile>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDocumentsForInterviewSchedulingEventForCandidateProfileQueryOptions(recruitId,eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const uploadCandidateCustomDocuments = (
    recruitId: number,
    orgDocId: number,
    uploadCandidateCustomDocumentsBody: UploadCandidateCustomDocumentsBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(uploadCandidateCustomDocumentsBody.file !== undefined) {
 formData.append('file', uploadCandidateCustomDocumentsBody.file)
 }

      return customInstance<string>(
      {url: `/candidateProfileAdmin/uploadCandidateCustomDocument/${recruitId}/${orgDocId}`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadCandidateCustomDocumentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadCandidateCustomDocuments>>, TError,{recruitId: number;orgDocId: number;data: UploadCandidateCustomDocumentsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadCandidateCustomDocuments>>, TError,{recruitId: number;orgDocId: number;data: UploadCandidateCustomDocumentsBody}, TContext> => {
    
const mutationKey = ['uploadCandidateCustomDocuments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadCandidateCustomDocuments>>, {recruitId: number;orgDocId: number;data: UploadCandidateCustomDocumentsBody}> = (props) => {
          const {recruitId,orgDocId,data} = props ?? {};

          return  uploadCandidateCustomDocuments(recruitId,orgDocId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadCandidateCustomDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof uploadCandidateCustomDocuments>>>
    export type UploadCandidateCustomDocumentsMutationBody = UploadCandidateCustomDocumentsBody
    export type UploadCandidateCustomDocumentsMutationError = unknown

    export const useUploadCandidateCustomDocuments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadCandidateCustomDocuments>>, TError,{recruitId: number;orgDocId: number;data: UploadCandidateCustomDocumentsBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadCandidateCustomDocuments>>,
        TError,
        {recruitId: number;orgDocId: number;data: UploadCandidateCustomDocumentsBody},
        TContext
      > => {

      const mutationOptions = getUploadCandidateCustomDocumentsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const uploadCandidateProfileImage = (
    recruitId: number,
    uploadCandidateProfileImageBody: UploadCandidateProfileImageBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(uploadCandidateProfileImageBody.photoImageFile !== undefined) {
 formData.append('photoImageFile', uploadCandidateProfileImageBody.photoImageFile)
 }

      return customInstance<string>(
      {url: `/candidateProfileAdmin/uploadCandidateProfileImage/${recruitId}`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadCandidateProfileImageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadCandidateProfileImage>>, TError,{recruitId: number;data: UploadCandidateProfileImageBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadCandidateProfileImage>>, TError,{recruitId: number;data: UploadCandidateProfileImageBody}, TContext> => {
    
const mutationKey = ['uploadCandidateProfileImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadCandidateProfileImage>>, {recruitId: number;data: UploadCandidateProfileImageBody}> = (props) => {
          const {recruitId,data} = props ?? {};

          return  uploadCandidateProfileImage(recruitId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadCandidateProfileImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadCandidateProfileImage>>>
    export type UploadCandidateProfileImageMutationBody = UploadCandidateProfileImageBody
    export type UploadCandidateProfileImageMutationError = unknown

    export const useUploadCandidateProfileImage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadCandidateProfileImage>>, TError,{recruitId: number;data: UploadCandidateProfileImageBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadCandidateProfileImage>>,
        TError,
        {recruitId: number;data: UploadCandidateProfileImageBody},
        TContext
      > => {

      const mutationOptions = getUploadCandidateProfileImageMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const uploadInterviewSchedulingJobApplicationDocumentFromCandidateProfile = (
    recruitId: number,
    eventId: number,
    interviewSchedulingJobApplicationDocumentUploadRequest: InterviewSchedulingJobApplicationDocumentUploadRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(interviewSchedulingJobApplicationDocumentUploadRequest.file !== undefined) {
 formData.append('file', interviewSchedulingJobApplicationDocumentUploadRequest.file)
 }
if(interviewSchedulingJobApplicationDocumentUploadRequest.scheduleIds !== undefined) {
 formData.append('scheduleIds', interviewSchedulingJobApplicationDocumentUploadRequest.scheduleIds)
 }
if(interviewSchedulingJobApplicationDocumentUploadRequest.supportingDocumentIds !== undefined) {
 formData.append('supportingDocumentIds', interviewSchedulingJobApplicationDocumentUploadRequest.supportingDocumentIds)
 }

      return customInstance<void>(
      {url: `/candidateProfileAdmin/uploadJobApplicationDocument/${recruitId}/${eventId}`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadInterviewSchedulingJobApplicationDocumentFromCandidateProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadInterviewSchedulingJobApplicationDocumentFromCandidateProfile>>, TError,{recruitId: number;eventId: number;data: InterviewSchedulingJobApplicationDocumentUploadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadInterviewSchedulingJobApplicationDocumentFromCandidateProfile>>, TError,{recruitId: number;eventId: number;data: InterviewSchedulingJobApplicationDocumentUploadRequest}, TContext> => {
    
const mutationKey = ['uploadInterviewSchedulingJobApplicationDocumentFromCandidateProfile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadInterviewSchedulingJobApplicationDocumentFromCandidateProfile>>, {recruitId: number;eventId: number;data: InterviewSchedulingJobApplicationDocumentUploadRequest}> = (props) => {
          const {recruitId,eventId,data} = props ?? {};

          return  uploadInterviewSchedulingJobApplicationDocumentFromCandidateProfile(recruitId,eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadInterviewSchedulingJobApplicationDocumentFromCandidateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof uploadInterviewSchedulingJobApplicationDocumentFromCandidateProfile>>>
    export type UploadInterviewSchedulingJobApplicationDocumentFromCandidateProfileMutationBody = InterviewSchedulingJobApplicationDocumentUploadRequest
    export type UploadInterviewSchedulingJobApplicationDocumentFromCandidateProfileMutationError = unknown

    export const useUploadInterviewSchedulingJobApplicationDocumentFromCandidateProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadInterviewSchedulingJobApplicationDocumentFromCandidateProfile>>, TError,{recruitId: number;eventId: number;data: InterviewSchedulingJobApplicationDocumentUploadRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadInterviewSchedulingJobApplicationDocumentFromCandidateProfile>>,
        TError,
        {recruitId: number;eventId: number;data: InterviewSchedulingJobApplicationDocumentUploadRequest},
        TContext
      > => {

      const mutationOptions = getUploadInterviewSchedulingJobApplicationDocumentFromCandidateProfileMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchCorePipelineBuckets = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<CorePipelineBucketResponse[]>(
      {url: `/core-pipeline-buckets`, method: 'GET', signal
    },
      );
    }
  

export const getFetchCorePipelineBucketsQueryKey = () => {
    return [`/core-pipeline-buckets`] as const;
    }

    
export const getFetchCorePipelineBucketsQueryOptions = <TData = Awaited<ReturnType<typeof fetchCorePipelineBuckets>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchCorePipelineBuckets>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchCorePipelineBucketsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchCorePipelineBuckets>>> = ({ signal }) => fetchCorePipelineBuckets(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchCorePipelineBuckets>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchCorePipelineBucketsQueryResult = NonNullable<Awaited<ReturnType<typeof fetchCorePipelineBuckets>>>
export type FetchCorePipelineBucketsQueryError = unknown



export function useFetchCorePipelineBuckets<TData = Awaited<ReturnType<typeof fetchCorePipelineBuckets>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchCorePipelineBuckets>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchCorePipelineBucketsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const fetchCorePipelineSteps = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<CorePipelineStepResponse[]>(
      {url: `/core-pipeline-steps`, method: 'GET', signal
    },
      );
    }
  

export const getFetchCorePipelineStepsQueryKey = () => {
    return [`/core-pipeline-steps`] as const;
    }

    
export const getFetchCorePipelineStepsQueryOptions = <TData = Awaited<ReturnType<typeof fetchCorePipelineSteps>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchCorePipelineSteps>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchCorePipelineStepsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchCorePipelineSteps>>> = ({ signal }) => fetchCorePipelineSteps(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchCorePipelineSteps>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchCorePipelineStepsQueryResult = NonNullable<Awaited<ReturnType<typeof fetchCorePipelineSteps>>>
export type FetchCorePipelineStepsQueryError = unknown



export function useFetchCorePipelineSteps<TData = Awaited<ReturnType<typeof fetchCorePipelineSteps>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchCorePipelineSteps>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchCorePipelineStepsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const upsertCorePipelineSteps = (
    corePipelineStepRequest: CorePipelineStepRequest[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<number[]>(
      {url: `/core-pipeline-steps`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: corePipelineStepRequest, signal
    },
      );
    }
  


export const getUpsertCorePipelineStepsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertCorePipelineSteps>>, TError,{data: CorePipelineStepRequest[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertCorePipelineSteps>>, TError,{data: CorePipelineStepRequest[]}, TContext> => {
    
const mutationKey = ['upsertCorePipelineSteps'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertCorePipelineSteps>>, {data: CorePipelineStepRequest[]}> = (props) => {
          const {data} = props ?? {};

          return  upsertCorePipelineSteps(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertCorePipelineStepsMutationResult = NonNullable<Awaited<ReturnType<typeof upsertCorePipelineSteps>>>
    export type UpsertCorePipelineStepsMutationBody = CorePipelineStepRequest[]
    export type UpsertCorePipelineStepsMutationError = unknown

    export const useUpsertCorePipelineSteps = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertCorePipelineSteps>>, TError,{data: CorePipelineStepRequest[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertCorePipelineSteps>>,
        TError,
        {data: CorePipelineStepRequest[]},
        TContext
      > => {

      const mutationOptions = getUpsertCorePipelineStepsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getCurrentTime = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/daily/currentTime`, method: 'GET', signal
    },
      );
    }
  

export const getGetCurrentTimeQueryKey = () => {
    return [`/daily/currentTime`] as const;
    }

    
export const getGetCurrentTimeQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentTime>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentTime>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentTimeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentTime>>> = ({ signal }) => getCurrentTime(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentTime>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentTimeQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentTime>>>
export type GetCurrentTimeQueryError = unknown



export function useGetCurrentTime<TData = Awaited<ReturnType<typeof getCurrentTime>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentTime>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCurrentTimeQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCurrentDailyParticipants = (
    participantsByRoomRequest: ParticipantsByRoomRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CurrentParticipantsResponse>(
      {url: `/daily/getParticipants`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: participantsByRoomRequest, signal
    },
      );
    }
  


export const getGetCurrentDailyParticipantsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCurrentDailyParticipants>>, TError,{data: ParticipantsByRoomRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getCurrentDailyParticipants>>, TError,{data: ParticipantsByRoomRequest}, TContext> => {
    
const mutationKey = ['getCurrentDailyParticipants'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCurrentDailyParticipants>>, {data: ParticipantsByRoomRequest}> = (props) => {
          const {data} = props ?? {};

          return  getCurrentDailyParticipants(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetCurrentDailyParticipantsMutationResult = NonNullable<Awaited<ReturnType<typeof getCurrentDailyParticipants>>>
    export type GetCurrentDailyParticipantsMutationBody = ParticipantsByRoomRequest
    export type GetCurrentDailyParticipantsMutationError = unknown

    export const useGetCurrentDailyParticipants = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCurrentDailyParticipants>>, TError,{data: ParticipantsByRoomRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof getCurrentDailyParticipants>>,
        TError,
        {data: ParticipantsByRoomRequest},
        TContext
      > => {

      const mutationOptions = getGetCurrentDailyParticipantsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchDepartments = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<DepartmentResponse[]>(
      {url: `/departments`, method: 'GET', signal
    },
      );
    }
  

export const getFetchDepartmentsQueryKey = () => {
    return [`/departments`] as const;
    }

    
export const getFetchDepartmentsQueryOptions = <TData = Awaited<ReturnType<typeof fetchDepartments>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchDepartments>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchDepartmentsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchDepartments>>> = ({ signal }) => fetchDepartments(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchDepartments>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchDepartmentsQueryResult = NonNullable<Awaited<ReturnType<typeof fetchDepartments>>>
export type FetchDepartmentsQueryError = unknown



export function useFetchDepartments<TData = Awaited<ReturnType<typeof fetchDepartments>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchDepartments>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchDepartmentsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createDepartment = (
    departmentRequest: DepartmentRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/departments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: departmentRequest, signal
    },
      );
    }
  


export const getCreateDepartmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: DepartmentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: DepartmentRequest}, TContext> => {
    
const mutationKey = ['createDepartment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDepartment>>, {data: DepartmentRequest}> = (props) => {
          const {data} = props ?? {};

          return  createDepartment(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof createDepartment>>>
    export type CreateDepartmentMutationBody = DepartmentRequest
    export type CreateDepartmentMutationError = unknown

    export const useCreateDepartment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: DepartmentRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDepartment>>,
        TError,
        {data: DepartmentRequest},
        TContext
      > => {

      const mutationOptions = getCreateDepartmentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const updateDepartment = (
    departmentRequest: DepartmentRequest,
 ) => {
      
      
      return customInstance<number>(
      {url: `/departments`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: departmentRequest
    },
      );
    }
  


export const getUpdateDepartmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDepartment>>, TError,{data: DepartmentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateDepartment>>, TError,{data: DepartmentRequest}, TContext> => {
    
const mutationKey = ['updateDepartment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDepartment>>, {data: DepartmentRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateDepartment(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateDepartment>>>
    export type UpdateDepartmentMutationBody = DepartmentRequest
    export type UpdateDepartmentMutationError = unknown

    export const useUpdateDepartment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDepartment>>, TError,{data: DepartmentRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDepartment>>,
        TError,
        {data: DepartmentRequest},
        TContext
      > => {

      const mutationOptions = getUpdateDepartmentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const deleteDepartment = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/departments/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteDepartmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDepartment>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDepartment>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['deleteDepartment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDepartment>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteDepartment(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDepartment>>>
    
    export type DeleteDepartmentMutationError = unknown

    export const useDeleteDepartment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDepartment>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDepartment>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteDepartmentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getOrgCustomDocuments = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<Orgcustomdocuments[]>(
      {url: `/documentsAdmin/orgCustomDocuments`, method: 'GET', signal
    },
      );
    }
  

export const getGetOrgCustomDocumentsQueryKey = () => {
    return [`/documentsAdmin/orgCustomDocuments`] as const;
    }

    
export const getGetOrgCustomDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getOrgCustomDocuments>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgCustomDocuments>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgCustomDocumentsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgCustomDocuments>>> = ({ signal }) => getOrgCustomDocuments(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgCustomDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgCustomDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgCustomDocuments>>>
export type GetOrgCustomDocumentsQueryError = unknown



export function useGetOrgCustomDocuments<TData = Awaited<ReturnType<typeof getOrgCustomDocuments>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgCustomDocuments>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrgCustomDocumentsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createOrgCustomDocument = (
    newDocumentName: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/documentsAdmin/orgCustomDocuments/${newDocumentName}`, method: 'POST', signal
    },
      );
    }
  


export const getCreateOrgCustomDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgCustomDocument>>, TError,{newDocumentName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createOrgCustomDocument>>, TError,{newDocumentName: string}, TContext> => {
    
const mutationKey = ['createOrgCustomDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrgCustomDocument>>, {newDocumentName: string}> = (props) => {
          const {newDocumentName} = props ?? {};

          return  createOrgCustomDocument(newDocumentName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateOrgCustomDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof createOrgCustomDocument>>>
    
    export type CreateOrgCustomDocumentMutationError = unknown

    export const useCreateOrgCustomDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgCustomDocument>>, TError,{newDocumentName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOrgCustomDocument>>,
        TError,
        {newDocumentName: string},
        TContext
      > => {

      const mutationOptions = getCreateOrgCustomDocumentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendCandidateFollowUpEmail = (
    orgId: number,
    eventId: number,
    sendCandidateReminderEmailRequest: SendCandidateReminderEmailRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number[]>(
      {url: `/emailAPI/sendCandidateFollowUpEmail/${orgId}/${eventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendCandidateReminderEmailRequest, signal
    },
      );
    }
  


export const getSendCandidateFollowUpEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCandidateFollowUpEmail>>, TError,{orgId: number;eventId: number;data: SendCandidateReminderEmailRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendCandidateFollowUpEmail>>, TError,{orgId: number;eventId: number;data: SendCandidateReminderEmailRequest}, TContext> => {
    
const mutationKey = ['sendCandidateFollowUpEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendCandidateFollowUpEmail>>, {orgId: number;eventId: number;data: SendCandidateReminderEmailRequest}> = (props) => {
          const {orgId,eventId,data} = props ?? {};

          return  sendCandidateFollowUpEmail(orgId,eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendCandidateFollowUpEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendCandidateFollowUpEmail>>>
    export type SendCandidateFollowUpEmailMutationBody = SendCandidateReminderEmailRequest
    export type SendCandidateFollowUpEmailMutationError = unknown

    export const useSendCandidateFollowUpEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCandidateFollowUpEmail>>, TError,{orgId: number;eventId: number;data: SendCandidateReminderEmailRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendCandidateFollowUpEmail>>,
        TError,
        {orgId: number;eventId: number;data: SendCandidateReminderEmailRequest},
        TContext
      > => {

      const mutationOptions = getSendCandidateFollowUpEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendCandidateFollowUpTestEmail = (
    orgId: number,
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/emailAPI/sendCandidateFollowUpTestEmail/${orgId}/${eventId}`, method: 'POST', signal
    },
      );
    }
  


export const getSendCandidateFollowUpTestEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCandidateFollowUpTestEmail>>, TError,{orgId: number;eventId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendCandidateFollowUpTestEmail>>, TError,{orgId: number;eventId: number}, TContext> => {
    
const mutationKey = ['sendCandidateFollowUpTestEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendCandidateFollowUpTestEmail>>, {orgId: number;eventId: number}> = (props) => {
          const {orgId,eventId} = props ?? {};

          return  sendCandidateFollowUpTestEmail(orgId,eventId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendCandidateFollowUpTestEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendCandidateFollowUpTestEmail>>>
    
    export type SendCandidateFollowUpTestEmailMutationError = unknown

    export const useSendCandidateFollowUpTestEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCandidateFollowUpTestEmail>>, TError,{orgId: number;eventId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendCandidateFollowUpTestEmail>>,
        TError,
        {orgId: number;eventId: number},
        TContext
      > => {

      const mutationOptions = getSendCandidateFollowUpTestEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendCandidateReminderEmail = (
    orgId: number,
    eventId: number,
    sendCandidateReminderEmailRequest: SendCandidateReminderEmailRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number[]>(
      {url: `/emailAPI/sendCandidateReminderEmail/${orgId}/${eventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendCandidateReminderEmailRequest, signal
    },
      );
    }
  


export const getSendCandidateReminderEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCandidateReminderEmail>>, TError,{orgId: number;eventId: number;data: SendCandidateReminderEmailRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendCandidateReminderEmail>>, TError,{orgId: number;eventId: number;data: SendCandidateReminderEmailRequest}, TContext> => {
    
const mutationKey = ['sendCandidateReminderEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendCandidateReminderEmail>>, {orgId: number;eventId: number;data: SendCandidateReminderEmailRequest}> = (props) => {
          const {orgId,eventId,data} = props ?? {};

          return  sendCandidateReminderEmail(orgId,eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendCandidateReminderEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendCandidateReminderEmail>>>
    export type SendCandidateReminderEmailMutationBody = SendCandidateReminderEmailRequest
    export type SendCandidateReminderEmailMutationError = unknown

    export const useSendCandidateReminderEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCandidateReminderEmail>>, TError,{orgId: number;eventId: number;data: SendCandidateReminderEmailRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendCandidateReminderEmail>>,
        TError,
        {orgId: number;eventId: number;data: SendCandidateReminderEmailRequest},
        TContext
      > => {

      const mutationOptions = getSendCandidateReminderEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendCandidateReminderTestEmail = (
    orgId: number,
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/emailAPI/sendCandidateReminderTestEmail/${orgId}/${eventId}`, method: 'POST', signal
    },
      );
    }
  


export const getSendCandidateReminderTestEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCandidateReminderTestEmail>>, TError,{orgId: number;eventId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendCandidateReminderTestEmail>>, TError,{orgId: number;eventId: number}, TContext> => {
    
const mutationKey = ['sendCandidateReminderTestEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendCandidateReminderTestEmail>>, {orgId: number;eventId: number}> = (props) => {
          const {orgId,eventId} = props ?? {};

          return  sendCandidateReminderTestEmail(orgId,eventId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendCandidateReminderTestEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendCandidateReminderTestEmail>>>
    
    export type SendCandidateReminderTestEmailMutationError = unknown

    export const useSendCandidateReminderTestEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCandidateReminderTestEmail>>, TError,{orgId: number;eventId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendCandidateReminderTestEmail>>,
        TError,
        {orgId: number;eventId: number},
        TContext
      > => {

      const mutationOptions = getSendCandidateReminderTestEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendMemberFeedbackReminderEmail = (
    orgId: number,
    eventId: number,
    sendMemberFeedbackReminderEmailRequest: SendMemberFeedbackReminderEmailRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number[]>(
      {url: `/emailAPI/sendMemberFeedbackReminderEmail/${orgId}/${eventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendMemberFeedbackReminderEmailRequest, signal
    },
      );
    }
  


export const getSendMemberFeedbackReminderEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMemberFeedbackReminderEmail>>, TError,{orgId: number;eventId: number;data: SendMemberFeedbackReminderEmailRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendMemberFeedbackReminderEmail>>, TError,{orgId: number;eventId: number;data: SendMemberFeedbackReminderEmailRequest}, TContext> => {
    
const mutationKey = ['sendMemberFeedbackReminderEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendMemberFeedbackReminderEmail>>, {orgId: number;eventId: number;data: SendMemberFeedbackReminderEmailRequest}> = (props) => {
          const {orgId,eventId,data} = props ?? {};

          return  sendMemberFeedbackReminderEmail(orgId,eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendMemberFeedbackReminderEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendMemberFeedbackReminderEmail>>>
    export type SendMemberFeedbackReminderEmailMutationBody = SendMemberFeedbackReminderEmailRequest
    export type SendMemberFeedbackReminderEmailMutationError = unknown

    export const useSendMemberFeedbackReminderEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMemberFeedbackReminderEmail>>, TError,{orgId: number;eventId: number;data: SendMemberFeedbackReminderEmailRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendMemberFeedbackReminderEmail>>,
        TError,
        {orgId: number;eventId: number;data: SendMemberFeedbackReminderEmailRequest},
        TContext
      > => {

      const mutationOptions = getSendMemberFeedbackReminderEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendMemberFeedbackReminderTestEmail = (
    orgId: number,
    eventId: number,
    sendMemberFeedbackReminderEmailRequest: SendMemberFeedbackReminderEmailRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/emailAPI/sendMemberFeedbackTestReminderEmail/${orgId}/${eventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendMemberFeedbackReminderEmailRequest, signal
    },
      );
    }
  


export const getSendMemberFeedbackReminderTestEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMemberFeedbackReminderTestEmail>>, TError,{orgId: number;eventId: number;data: SendMemberFeedbackReminderEmailRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendMemberFeedbackReminderTestEmail>>, TError,{orgId: number;eventId: number;data: SendMemberFeedbackReminderEmailRequest}, TContext> => {
    
const mutationKey = ['sendMemberFeedbackReminderTestEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendMemberFeedbackReminderTestEmail>>, {orgId: number;eventId: number;data: SendMemberFeedbackReminderEmailRequest}> = (props) => {
          const {orgId,eventId,data} = props ?? {};

          return  sendMemberFeedbackReminderTestEmail(orgId,eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendMemberFeedbackReminderTestEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendMemberFeedbackReminderTestEmail>>>
    export type SendMemberFeedbackReminderTestEmailMutationBody = SendMemberFeedbackReminderEmailRequest
    export type SendMemberFeedbackReminderTestEmailMutationError = unknown

    export const useSendMemberFeedbackReminderTestEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMemberFeedbackReminderTestEmail>>, TError,{orgId: number;eventId: number;data: SendMemberFeedbackReminderEmailRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendMemberFeedbackReminderTestEmail>>,
        TError,
        {orgId: number;eventId: number;data: SendMemberFeedbackReminderEmailRequest},
        TContext
      > => {

      const mutationOptions = getSendMemberFeedbackReminderTestEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendReminderEmails = (
    reminderEmailRequest: ReminderEmailRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/emailAPI/sendReminderEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reminderEmailRequest, signal
    },
      );
    }
  


export const getSendReminderEmailsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendReminderEmails>>, TError,{data: ReminderEmailRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendReminderEmails>>, TError,{data: ReminderEmailRequest}, TContext> => {
    
const mutationKey = ['sendReminderEmails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendReminderEmails>>, {data: ReminderEmailRequest}> = (props) => {
          const {data} = props ?? {};

          return  sendReminderEmails(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendReminderEmailsMutationResult = NonNullable<Awaited<ReturnType<typeof sendReminderEmails>>>
    export type SendReminderEmailsMutationBody = ReminderEmailRequest
    export type SendReminderEmailsMutationError = unknown

    export const useSendReminderEmails = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendReminderEmails>>, TError,{data: ReminderEmailRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendReminderEmails>>,
        TError,
        {data: ReminderEmailRequest},
        TContext
      > => {

      const mutationOptions = getSendReminderEmailsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const updateUniversityNetworkingEventFinalScheduleEmail = (
    eventId: number,
    universityNetworkingEmailsRequest: UniversityNetworkingEmailsRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/employer/universityNetworkingEvent/${eventId}/email/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: universityNetworkingEmailsRequest
    },
      );
    }
  


export const getUpdateUniversityNetworkingEventFinalScheduleEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUniversityNetworkingEventFinalScheduleEmail>>, TError,{eventId: number;data: UniversityNetworkingEmailsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateUniversityNetworkingEventFinalScheduleEmail>>, TError,{eventId: number;data: UniversityNetworkingEmailsRequest}, TContext> => {
    
const mutationKey = ['updateUniversityNetworkingEventFinalScheduleEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUniversityNetworkingEventFinalScheduleEmail>>, {eventId: number;data: UniversityNetworkingEmailsRequest}> = (props) => {
          const {eventId,data} = props ?? {};

          return  updateUniversityNetworkingEventFinalScheduleEmail(eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUniversityNetworkingEventFinalScheduleEmailMutationResult = NonNullable<Awaited<ReturnType<typeof updateUniversityNetworkingEventFinalScheduleEmail>>>
    export type UpdateUniversityNetworkingEventFinalScheduleEmailMutationBody = UniversityNetworkingEmailsRequest
    export type UpdateUniversityNetworkingEventFinalScheduleEmailMutationError = unknown

    export const useUpdateUniversityNetworkingEventFinalScheduleEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUniversityNetworkingEventFinalScheduleEmail>>, TError,{eventId: number;data: UniversityNetworkingEmailsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateUniversityNetworkingEventFinalScheduleEmail>>,
        TError,
        {eventId: number;data: UniversityNetworkingEmailsRequest},
        TContext
      > => {

      const mutationOptions = getUpdateUniversityNetworkingEventFinalScheduleEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getUniversityNetworkingEventEmails = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UniversityNetworkingEmailsResponse>(
      {url: `/employer/universityNetworkingEvent/${eventId}/emails`, method: 'GET', signal
    },
      );
    }
  

export const getGetUniversityNetworkingEventEmailsQueryKey = (eventId: number,) => {
    return [`/employer/universityNetworkingEvent/${eventId}/emails`] as const;
    }

    
export const getGetUniversityNetworkingEventEmailsQueryOptions = <TData = Awaited<ReturnType<typeof getUniversityNetworkingEventEmails>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityNetworkingEventEmails>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUniversityNetworkingEventEmailsQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUniversityNetworkingEventEmails>>> = ({ signal }) => getUniversityNetworkingEventEmails(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUniversityNetworkingEventEmails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUniversityNetworkingEventEmailsQueryResult = NonNullable<Awaited<ReturnType<typeof getUniversityNetworkingEventEmails>>>
export type GetUniversityNetworkingEventEmailsQueryError = unknown



export function useGetUniversityNetworkingEventEmails<TData = Awaited<ReturnType<typeof getUniversityNetworkingEventEmails>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityNetworkingEventEmails>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUniversityNetworkingEventEmailsQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUniversityNetworkingEventFeedback = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EventFeedback[]>(
      {url: `/employer/universityNetworkingEvent/${eventId}/feedback`, method: 'GET', signal
    },
      );
    }
  

export const getGetUniversityNetworkingEventFeedbackQueryKey = (eventId: number,) => {
    return [`/employer/universityNetworkingEvent/${eventId}/feedback`] as const;
    }

    
export const getGetUniversityNetworkingEventFeedbackQueryOptions = <TData = Awaited<ReturnType<typeof getUniversityNetworkingEventFeedback>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityNetworkingEventFeedback>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUniversityNetworkingEventFeedbackQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUniversityNetworkingEventFeedback>>> = ({ signal }) => getUniversityNetworkingEventFeedback(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUniversityNetworkingEventFeedback>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUniversityNetworkingEventFeedbackQueryResult = NonNullable<Awaited<ReturnType<typeof getUniversityNetworkingEventFeedback>>>
export type GetUniversityNetworkingEventFeedbackQueryError = unknown



export function useGetUniversityNetworkingEventFeedback<TData = Awaited<ReturnType<typeof getUniversityNetworkingEventFeedback>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityNetworkingEventFeedback>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUniversityNetworkingEventFeedbackQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateUniversityNetworkingEventFeedback = (
    eventId: number,
    universityNetworkingFeedbackRequest: UniversityNetworkingFeedbackRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/employer/universityNetworkingEvent/${eventId}/feedback`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: universityNetworkingFeedbackRequest
    },
      );
    }
  


export const getUpdateUniversityNetworkingEventFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUniversityNetworkingEventFeedback>>, TError,{eventId: number;data: UniversityNetworkingFeedbackRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateUniversityNetworkingEventFeedback>>, TError,{eventId: number;data: UniversityNetworkingFeedbackRequest}, TContext> => {
    
const mutationKey = ['updateUniversityNetworkingEventFeedback'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUniversityNetworkingEventFeedback>>, {eventId: number;data: UniversityNetworkingFeedbackRequest}> = (props) => {
          const {eventId,data} = props ?? {};

          return  updateUniversityNetworkingEventFeedback(eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUniversityNetworkingEventFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof updateUniversityNetworkingEventFeedback>>>
    export type UpdateUniversityNetworkingEventFeedbackMutationBody = UniversityNetworkingFeedbackRequest
    export type UpdateUniversityNetworkingEventFeedbackMutationError = unknown

    export const useUpdateUniversityNetworkingEventFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUniversityNetworkingEventFeedback>>, TError,{eventId: number;data: UniversityNetworkingFeedbackRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateUniversityNetworkingEventFeedback>>,
        TError,
        {eventId: number;data: UniversityNetworkingFeedbackRequest},
        TContext
      > => {

      const mutationOptions = getUpdateUniversityNetworkingEventFeedbackMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const exportMatterDocuments = (
    exportMatterDocumentsBody: number[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/employer/workAllocation/exportMatterDocuments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportMatterDocumentsBody, signal
    },
      );
    }
  


export const getExportMatterDocumentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportMatterDocuments>>, TError,{data: number[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportMatterDocuments>>, TError,{data: number[]}, TContext> => {
    
const mutationKey = ['exportMatterDocuments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportMatterDocuments>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  exportMatterDocuments(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportMatterDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof exportMatterDocuments>>>
    export type ExportMatterDocumentsMutationBody = number[]
    export type ExportMatterDocumentsMutationError = unknown

    export const useExportMatterDocuments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportMatterDocuments>>, TError,{data: number[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportMatterDocuments>>,
        TError,
        {data: number[]},
        TContext
      > => {

      const mutationOptions = getExportMatterDocumentsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const exportMatterDocumentsForAssociate = (
    matterId: number,
    exportMatterDocumentsForAssociateBody: number[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/employer/workAllocation/matter/${matterId}/exportMatterDocuments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportMatterDocumentsForAssociateBody, signal
    },
      );
    }
  


export const getExportMatterDocumentsForAssociateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportMatterDocumentsForAssociate>>, TError,{matterId: number;data: number[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportMatterDocumentsForAssociate>>, TError,{matterId: number;data: number[]}, TContext> => {
    
const mutationKey = ['exportMatterDocumentsForAssociate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportMatterDocumentsForAssociate>>, {matterId: number;data: number[]}> = (props) => {
          const {matterId,data} = props ?? {};

          return  exportMatterDocumentsForAssociate(matterId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportMatterDocumentsForAssociateMutationResult = NonNullable<Awaited<ReturnType<typeof exportMatterDocumentsForAssociate>>>
    export type ExportMatterDocumentsForAssociateMutationBody = number[]
    export type ExportMatterDocumentsForAssociateMutationError = unknown

    export const useExportMatterDocumentsForAssociate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportMatterDocumentsForAssociate>>, TError,{matterId: number;data: number[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportMatterDocumentsForAssociate>>,
        TError,
        {matterId: number;data: number[]},
        TContext
      > => {

      const mutationOptions = getExportMatterDocumentsForAssociateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchEmploymentTypes = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmploymentTypeResponse[]>(
      {url: `/employment-types`, method: 'GET', signal
    },
      );
    }
  

export const getFetchEmploymentTypesQueryKey = () => {
    return [`/employment-types`] as const;
    }

    
export const getFetchEmploymentTypesQueryOptions = <TData = Awaited<ReturnType<typeof fetchEmploymentTypes>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchEmploymentTypes>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchEmploymentTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchEmploymentTypes>>> = ({ signal }) => fetchEmploymentTypes(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchEmploymentTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchEmploymentTypesQueryResult = NonNullable<Awaited<ReturnType<typeof fetchEmploymentTypes>>>
export type FetchEmploymentTypesQueryError = unknown



export function useFetchEmploymentTypes<TData = Awaited<ReturnType<typeof fetchEmploymentTypes>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchEmploymentTypes>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchEmploymentTypesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const registerCandidateForEvent = (
    orgFriendlyName: string,
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<RegisterCandidateForEventResponse>(
      {url: `/event/registration/${orgFriendlyName}/${eventId}/candidate`, method: 'POST', signal
    },
      );
    }
  


export const getRegisterCandidateForEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerCandidateForEvent>>, TError,{orgFriendlyName: string;eventId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof registerCandidateForEvent>>, TError,{orgFriendlyName: string;eventId: number}, TContext> => {
    
const mutationKey = ['registerCandidateForEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerCandidateForEvent>>, {orgFriendlyName: string;eventId: number}> = (props) => {
          const {orgFriendlyName,eventId} = props ?? {};

          return  registerCandidateForEvent(orgFriendlyName,eventId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterCandidateForEventMutationResult = NonNullable<Awaited<ReturnType<typeof registerCandidateForEvent>>>
    
    export type RegisterCandidateForEventMutationError = unknown

    export const useRegisterCandidateForEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerCandidateForEvent>>, TError,{orgFriendlyName: string;eventId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof registerCandidateForEvent>>,
        TError,
        {orgFriendlyName: string;eventId: number},
        TContext
      > => {

      const mutationOptions = getRegisterCandidateForEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const uploadDocumentForEvent = (
    orgFriendlyName: string,
    eventId: number,
    uploadDocumentForEventRequest: UploadDocumentForEventRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(uploadDocumentForEventRequest.file !== undefined) {
 formData.append('file', uploadDocumentForEventRequest.file)
 }
if(uploadDocumentForEventRequest.orgDocId !== undefined) {
 formData.append('orgDocId', uploadDocumentForEventRequest.orgDocId.toString())
 }

      return customInstance<UploadDocumentForEventResponse>(
      {url: `/event/registration/${orgFriendlyName}/${eventId}/uploadDocument`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadDocumentForEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocumentForEvent>>, TError,{orgFriendlyName: string;eventId: number;data: UploadDocumentForEventRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadDocumentForEvent>>, TError,{orgFriendlyName: string;eventId: number;data: UploadDocumentForEventRequest}, TContext> => {
    
const mutationKey = ['uploadDocumentForEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadDocumentForEvent>>, {orgFriendlyName: string;eventId: number;data: UploadDocumentForEventRequest}> = (props) => {
          const {orgFriendlyName,eventId,data} = props ?? {};

          return  uploadDocumentForEvent(orgFriendlyName,eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadDocumentForEventMutationResult = NonNullable<Awaited<ReturnType<typeof uploadDocumentForEvent>>>
    export type UploadDocumentForEventMutationBody = UploadDocumentForEventRequest
    export type UploadDocumentForEventMutationError = unknown

    export const useUploadDocumentForEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocumentForEvent>>, TError,{orgFriendlyName: string;eventId: number;data: UploadDocumentForEventRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadDocumentForEvent>>,
        TError,
        {orgFriendlyName: string;eventId: number;data: UploadDocumentForEventRequest},
        TContext
      > => {

      const mutationOptions = getUploadDocumentForEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const uploadHeadshotForEvent = (
    orgFriendlyName: string,
    eventId: number,
    uploadHeadshotForEventRequest: UploadHeadshotForEventRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(uploadHeadshotForEventRequest.file !== undefined) {
 formData.append('file', uploadHeadshotForEventRequest.file)
 }

      return customInstance<UploadHeadshotForEventResponse>(
      {url: `/event/registration/${orgFriendlyName}/${eventId}/uploadHeadshot`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadHeadshotForEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadHeadshotForEvent>>, TError,{orgFriendlyName: string;eventId: number;data: UploadHeadshotForEventRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadHeadshotForEvent>>, TError,{orgFriendlyName: string;eventId: number;data: UploadHeadshotForEventRequest}, TContext> => {
    
const mutationKey = ['uploadHeadshotForEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadHeadshotForEvent>>, {orgFriendlyName: string;eventId: number;data: UploadHeadshotForEventRequest}> = (props) => {
          const {orgFriendlyName,eventId,data} = props ?? {};

          return  uploadHeadshotForEvent(orgFriendlyName,eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadHeadshotForEventMutationResult = NonNullable<Awaited<ReturnType<typeof uploadHeadshotForEvent>>>
    export type UploadHeadshotForEventMutationBody = UploadHeadshotForEventRequest
    export type UploadHeadshotForEventMutationError = unknown

    export const useUploadHeadshotForEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadHeadshotForEvent>>, TError,{orgFriendlyName: string;eventId: number;data: UploadHeadshotForEventRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadHeadshotForEvent>>,
        TError,
        {orgFriendlyName: string;eventId: number;data: UploadHeadshotForEventRequest},
        TContext
      > => {

      const mutationOptions = getUploadHeadshotForEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const externalJobImportUploadCsvApiKey = (
    externalJobImportUploadCsvApiKeyBody: ExternalJobImportUploadCsvApiKeyBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append('file', externalJobImportUploadCsvApiKeyBody.file)

      return customInstance<ExternalJobImportUploadCsvApiKeyResponse>(
      {url: `/external-job-import/upload-csv-api-key`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getExternalJobImportUploadCsvApiKeyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalJobImportUploadCsvApiKey>>, TError,{data: ExternalJobImportUploadCsvApiKeyBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof externalJobImportUploadCsvApiKey>>, TError,{data: ExternalJobImportUploadCsvApiKeyBody}, TContext> => {
    
const mutationKey = ['externalJobImportUploadCsvApiKey'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof externalJobImportUploadCsvApiKey>>, {data: ExternalJobImportUploadCsvApiKeyBody}> = (props) => {
          const {data} = props ?? {};

          return  externalJobImportUploadCsvApiKey(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExternalJobImportUploadCsvApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof externalJobImportUploadCsvApiKey>>>
    export type ExternalJobImportUploadCsvApiKeyMutationBody = ExternalJobImportUploadCsvApiKeyBody
    export type ExternalJobImportUploadCsvApiKeyMutationError = unknown

    export const useExternalJobImportUploadCsvApiKey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalJobImportUploadCsvApiKey>>, TError,{data: ExternalJobImportUploadCsvApiKeyBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof externalJobImportUploadCsvApiKey>>,
        TError,
        {data: ExternalJobImportUploadCsvApiKeyBody},
        TContext
      > => {

      const mutationOptions = getExternalJobImportUploadCsvApiKeyMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const externalJobImportUploadCsvSuperAdmin = (
    externalJobImportUploadCsvSuperAdminBody: ExternalJobImportUploadCsvSuperAdminBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append('file', externalJobImportUploadCsvSuperAdminBody.file)

      return customInstance<ExternalJobImportUploadCsvSuperAdminResponse>(
      {url: `/external-job-import/upload-csv-super-admin`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getExternalJobImportUploadCsvSuperAdminMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalJobImportUploadCsvSuperAdmin>>, TError,{data: ExternalJobImportUploadCsvSuperAdminBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof externalJobImportUploadCsvSuperAdmin>>, TError,{data: ExternalJobImportUploadCsvSuperAdminBody}, TContext> => {
    
const mutationKey = ['externalJobImportUploadCsvSuperAdmin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof externalJobImportUploadCsvSuperAdmin>>, {data: ExternalJobImportUploadCsvSuperAdminBody}> = (props) => {
          const {data} = props ?? {};

          return  externalJobImportUploadCsvSuperAdmin(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExternalJobImportUploadCsvSuperAdminMutationResult = NonNullable<Awaited<ReturnType<typeof externalJobImportUploadCsvSuperAdmin>>>
    export type ExternalJobImportUploadCsvSuperAdminMutationBody = ExternalJobImportUploadCsvSuperAdminBody
    export type ExternalJobImportUploadCsvSuperAdminMutationError = unknown

    export const useExternalJobImportUploadCsvSuperAdmin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalJobImportUploadCsvSuperAdmin>>, TError,{data: ExternalJobImportUploadCsvSuperAdminBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof externalJobImportUploadCsvSuperAdmin>>,
        TError,
        {data: ExternalJobImportUploadCsvSuperAdminBody},
        TContext
      > => {

      const mutationOptions = getExternalJobImportUploadCsvSuperAdminMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const rotateEventDirectory = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/firm-forward-rotation/rotate-event-directory`, method: 'POST', signal
    },
      );
    }
  


export const getRotateEventDirectoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateEventDirectory>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rotateEventDirectory>>, TError,void, TContext> => {
    
const mutationKey = ['rotateEventDirectory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateEventDirectory>>, void> = () => {
          

          return  rotateEventDirectory()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RotateEventDirectoryMutationResult = NonNullable<Awaited<ReturnType<typeof rotateEventDirectory>>>
    
    export type RotateEventDirectoryMutationError = unknown

    export const useRotateEventDirectory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateEventDirectory>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof rotateEventDirectory>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getRotateEventDirectoryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const rotateFirmCarousel = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/firm-forward-rotation/rotate-firm-carousel`, method: 'POST', signal
    },
      );
    }
  


export const getRotateFirmCarouselMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateFirmCarousel>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rotateFirmCarousel>>, TError,void, TContext> => {
    
const mutationKey = ['rotateFirmCarousel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateFirmCarousel>>, void> = () => {
          

          return  rotateFirmCarousel()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RotateFirmCarouselMutationResult = NonNullable<Awaited<ReturnType<typeof rotateFirmCarousel>>>
    
    export type RotateFirmCarouselMutationError = unknown

    export const useRotateFirmCarousel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateFirmCarousel>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof rotateFirmCarousel>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getRotateFirmCarouselMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const rotateFirmDirectory = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/firm-forward-rotation/rotate-firm-directory`, method: 'POST', signal
    },
      );
    }
  


export const getRotateFirmDirectoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateFirmDirectory>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rotateFirmDirectory>>, TError,void, TContext> => {
    
const mutationKey = ['rotateFirmDirectory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateFirmDirectory>>, void> = () => {
          

          return  rotateFirmDirectory()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RotateFirmDirectoryMutationResult = NonNullable<Awaited<ReturnType<typeof rotateFirmDirectory>>>
    
    export type RotateFirmDirectoryMutationError = unknown

    export const useRotateFirmDirectory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateFirmDirectory>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof rotateFirmDirectory>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getRotateFirmDirectoryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const rotateJobBoard = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/firm-forward-rotation/rotate-job-board`, method: 'POST', signal
    },
      );
    }
  


export const getRotateJobBoardMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateJobBoard>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rotateJobBoard>>, TError,void, TContext> => {
    
const mutationKey = ['rotateJobBoard'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateJobBoard>>, void> = () => {
          

          return  rotateJobBoard()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RotateJobBoardMutationResult = NonNullable<Awaited<ReturnType<typeof rotateJobBoard>>>
    
    export type RotateJobBoardMutationError = unknown

    export const useRotateJobBoard = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateJobBoard>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof rotateJobBoard>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getRotateJobBoardMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchFirmPracticeAreasList = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/firmPracticeAreasList`, method: 'GET', signal
    },
      );
    }
  

export const getFetchFirmPracticeAreasListQueryKey = () => {
    return [`/firmPracticeAreasList`] as const;
    }

    
export const getFetchFirmPracticeAreasListQueryOptions = <TData = Awaited<ReturnType<typeof fetchFirmPracticeAreasList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchFirmPracticeAreasList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchFirmPracticeAreasListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchFirmPracticeAreasList>>> = ({ signal }) => fetchFirmPracticeAreasList(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchFirmPracticeAreasList>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchFirmPracticeAreasListQueryResult = NonNullable<Awaited<ReturnType<typeof fetchFirmPracticeAreasList>>>
export type FetchFirmPracticeAreasListQueryError = unknown



export function useFetchFirmPracticeAreasList<TData = Awaited<ReturnType<typeof fetchFirmPracticeAreasList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchFirmPracticeAreasList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchFirmPracticeAreasListQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const forwardSignInV2 = (
    forwardSignInRequest: ForwardSignInRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ForwardSignInResponse>(
      {url: `/forward-entry/sign-in/v2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: forwardSignInRequest, signal
    },
      );
    }
  


export const getForwardSignInV2MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forwardSignInV2>>, TError,{data: ForwardSignInRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof forwardSignInV2>>, TError,{data: ForwardSignInRequest}, TContext> => {
    
const mutationKey = ['forwardSignInV2'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forwardSignInV2>>, {data: ForwardSignInRequest}> = (props) => {
          const {data} = props ?? {};

          return  forwardSignInV2(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ForwardSignInV2MutationResult = NonNullable<Awaited<ReturnType<typeof forwardSignInV2>>>
    export type ForwardSignInV2MutationBody = ForwardSignInRequest
    export type ForwardSignInV2MutationError = unknown

    export const useForwardSignInV2 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forwardSignInV2>>, TError,{data: ForwardSignInRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof forwardSignInV2>>,
        TError,
        {data: ForwardSignInRequest},
        TContext
      > => {

      const mutationOptions = getForwardSignInV2MutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const forwardSignUpV2 = (
    forwardSignUpRequest: ForwardSignUpRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ForwardSignUpResponse>(
      {url: `/forward-entry/sign-up/v2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: forwardSignUpRequest, signal
    },
      );
    }
  


export const getForwardSignUpV2MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forwardSignUpV2>>, TError,{data: ForwardSignUpRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof forwardSignUpV2>>, TError,{data: ForwardSignUpRequest}, TContext> => {
    
const mutationKey = ['forwardSignUpV2'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forwardSignUpV2>>, {data: ForwardSignUpRequest}> = (props) => {
          const {data} = props ?? {};

          return  forwardSignUpV2(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ForwardSignUpV2MutationResult = NonNullable<Awaited<ReturnType<typeof forwardSignUpV2>>>
    export type ForwardSignUpV2MutationBody = ForwardSignUpRequest
    export type ForwardSignUpV2MutationError = unknown

    export const useForwardSignUpV2 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forwardSignUpV2>>, TError,{data: ForwardSignUpRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof forwardSignUpV2>>,
        TError,
        {data: ForwardSignUpRequest},
        TContext
      > => {

      const mutationOptions = getForwardSignUpV2MutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getOrgForwardPrivileges = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrgForwardPrivilegesResponse>(
      {url: `/forward-firm/orgForwardPrivileges`, method: 'GET', signal
    },
      );
    }
  

export const getGetOrgForwardPrivilegesQueryKey = () => {
    return [`/forward-firm/orgForwardPrivileges`] as const;
    }

    
export const getGetOrgForwardPrivilegesQueryOptions = <TData = Awaited<ReturnType<typeof getOrgForwardPrivileges>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgForwardPrivileges>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgForwardPrivilegesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgForwardPrivileges>>> = ({ signal }) => getOrgForwardPrivileges(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgForwardPrivileges>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgForwardPrivilegesQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgForwardPrivileges>>>
export type GetOrgForwardPrivilegesQueryError = unknown



export function useGetOrgForwardPrivileges<TData = Awaited<ReturnType<typeof getOrgForwardPrivileges>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgForwardPrivileges>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrgForwardPrivilegesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const activateAccount = (
    params?: ActivateAccountParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ForwardActivateAccountResponse>(
      {url: `/forward/account/activation`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getActivateAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateAccount>>, TError,{params?: ActivateAccountParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activateAccount>>, TError,{params?: ActivateAccountParams}, TContext> => {
    
const mutationKey = ['activateAccount'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateAccount>>, {params?: ActivateAccountParams}> = (props) => {
          const {params} = props ?? {};

          return  activateAccount(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof activateAccount>>>
    
    export type ActivateAccountMutationError = unknown

    export const useActivateAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateAccount>>, TError,{params?: ActivateAccountParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof activateAccount>>,
        TError,
        {params?: ActivateAccountParams},
        TContext
      > => {

      const mutationOptions = getActivateAccountMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const accountActivationRedirectFromEventRegistration = (
    orgFriendlyName: string,
    eventId: number,
    recruitAttendeeExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/forward/account/activation/${orgFriendlyName}/${eventId}/${recruitAttendeeExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getAccountActivationRedirectFromEventRegistrationQueryKey = (orgFriendlyName: string,
    eventId: number,
    recruitAttendeeExtension: string,) => {
    return [`/forward/account/activation/${orgFriendlyName}/${eventId}/${recruitAttendeeExtension}`] as const;
    }

    
export const getAccountActivationRedirectFromEventRegistrationQueryOptions = <TData = Awaited<ReturnType<typeof accountActivationRedirectFromEventRegistration>>, TError = unknown>(orgFriendlyName: string,
    eventId: number,
    recruitAttendeeExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof accountActivationRedirectFromEventRegistration>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountActivationRedirectFromEventRegistrationQueryKey(orgFriendlyName,eventId,recruitAttendeeExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountActivationRedirectFromEventRegistration>>> = ({ signal }) => accountActivationRedirectFromEventRegistration(orgFriendlyName,eventId,recruitAttendeeExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgFriendlyName && eventId && recruitAttendeeExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accountActivationRedirectFromEventRegistration>>, TError, TData> & { queryKey: QueryKey }
}

export type AccountActivationRedirectFromEventRegistrationQueryResult = NonNullable<Awaited<ReturnType<typeof accountActivationRedirectFromEventRegistration>>>
export type AccountActivationRedirectFromEventRegistrationQueryError = unknown



export function useAccountActivationRedirectFromEventRegistration<TData = Awaited<ReturnType<typeof accountActivationRedirectFromEventRegistration>>, TError = unknown>(
 orgFriendlyName: string,
    eventId: number,
    recruitAttendeeExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof accountActivationRedirectFromEventRegistration>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAccountActivationRedirectFromEventRegistrationQueryOptions(orgFriendlyName,eventId,recruitAttendeeExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const addEmailToForwardAccount = (
    params: AddEmailToForwardAccountParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/forward/account/add-email`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getAddEmailToForwardAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEmailToForwardAccount>>, TError,{params: AddEmailToForwardAccountParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addEmailToForwardAccount>>, TError,{params: AddEmailToForwardAccountParams}, TContext> => {
    
const mutationKey = ['addEmailToForwardAccount'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addEmailToForwardAccount>>, {params: AddEmailToForwardAccountParams}> = (props) => {
          const {params} = props ?? {};

          return  addEmailToForwardAccount(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddEmailToForwardAccountMutationResult = NonNullable<Awaited<ReturnType<typeof addEmailToForwardAccount>>>
    
    export type AddEmailToForwardAccountMutationError = unknown

    export const useAddEmailToForwardAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEmailToForwardAccount>>, TError,{params: AddEmailToForwardAccountParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof addEmailToForwardAccount>>,
        TError,
        {params: AddEmailToForwardAccountParams},
        TContext
      > => {

      const mutationOptions = getAddEmailToForwardAccountMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const updateForwardProfilePhoto = (
    uploadForwardProfilePhotoRequest: UploadForwardProfilePhotoRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(uploadForwardProfilePhotoRequest.imageFile !== undefined) {
 formData.append('imageFile', uploadForwardProfilePhotoRequest.imageFile)
 }

      return customInstance<string>(
      {url: `/forward/account/profile/update-photo`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUpdateForwardProfilePhotoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateForwardProfilePhoto>>, TError,{data: UploadForwardProfilePhotoRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateForwardProfilePhoto>>, TError,{data: UploadForwardProfilePhotoRequest}, TContext> => {
    
const mutationKey = ['updateForwardProfilePhoto'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateForwardProfilePhoto>>, {data: UploadForwardProfilePhotoRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateForwardProfilePhoto(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateForwardProfilePhotoMutationResult = NonNullable<Awaited<ReturnType<typeof updateForwardProfilePhoto>>>
    export type UpdateForwardProfilePhotoMutationBody = UploadForwardProfilePhotoRequest
    export type UpdateForwardProfilePhotoMutationError = unknown

    export const useUpdateForwardProfilePhoto = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateForwardProfilePhoto>>, TError,{data: UploadForwardProfilePhotoRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateForwardProfilePhoto>>,
        TError,
        {data: UploadForwardProfilePhotoRequest},
        TContext
      > => {

      const mutationOptions = getUpdateForwardProfilePhotoMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const uploadForwardProfilePhoto = (
    uploadForwardProfilePhotoRequest: UploadForwardProfilePhotoRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(uploadForwardProfilePhotoRequest.imageFile !== undefined) {
 formData.append('imageFile', uploadForwardProfilePhotoRequest.imageFile)
 }

      return customInstance<string>(
      {url: `/forward/account/profile/upload-photo`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadForwardProfilePhotoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadForwardProfilePhoto>>, TError,{data: UploadForwardProfilePhotoRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadForwardProfilePhoto>>, TError,{data: UploadForwardProfilePhotoRequest}, TContext> => {
    
const mutationKey = ['uploadForwardProfilePhoto'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadForwardProfilePhoto>>, {data: UploadForwardProfilePhotoRequest}> = (props) => {
          const {data} = props ?? {};

          return  uploadForwardProfilePhoto(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadForwardProfilePhotoMutationResult = NonNullable<Awaited<ReturnType<typeof uploadForwardProfilePhoto>>>
    export type UploadForwardProfilePhotoMutationBody = UploadForwardProfilePhotoRequest
    export type UploadForwardProfilePhotoMutationError = unknown

    export const useUploadForwardProfilePhoto = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadForwardProfilePhoto>>, TError,{data: UploadForwardProfilePhotoRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadForwardProfilePhoto>>,
        TError,
        {data: UploadForwardProfilePhotoRequest},
        TContext
      > => {

      const mutationOptions = getUploadForwardProfilePhotoMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const addEventToForward = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ForwardEventCreationResponse>(
      {url: `/forward/event/${eventId}/publish`, method: 'POST', signal
    },
      );
    }
  


export const getAddEventToForwardMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEventToForward>>, TError,{eventId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addEventToForward>>, TError,{eventId: number}, TContext> => {
    
const mutationKey = ['addEventToForward'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addEventToForward>>, {eventId: number}> = (props) => {
          const {eventId} = props ?? {};

          return  addEventToForward(eventId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddEventToForwardMutationResult = NonNullable<Awaited<ReturnType<typeof addEventToForward>>>
    
    export type AddEventToForwardMutationError = unknown

    export const useAddEventToForward = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEventToForward>>, TError,{eventId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof addEventToForward>>,
        TError,
        {eventId: number},
        TContext
      > => {

      const mutationOptions = getAddEventToForwardMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getBasicAdminInfo = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<BasicAdminInfo>(
      {url: `/genericAdmin/info`, method: 'GET', signal
    },
      );
    }
  

export const getGetBasicAdminInfoQueryKey = () => {
    return [`/genericAdmin/info`] as const;
    }

    
export const getGetBasicAdminInfoQueryOptions = <TData = Awaited<ReturnType<typeof getBasicAdminInfo>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBasicAdminInfo>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBasicAdminInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBasicAdminInfo>>> = ({ signal }) => getBasicAdminInfo(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBasicAdminInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBasicAdminInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getBasicAdminInfo>>>
export type GetBasicAdminInfoQueryError = unknown



export function useGetBasicAdminInfo<TData = Awaited<ReturnType<typeof getBasicAdminInfo>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBasicAdminInfo>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBasicAdminInfoQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAllLawSchools = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/getLawSchools`, method: 'GET', signal
    },
      );
    }
  

export const getGetAllLawSchoolsQueryKey = () => {
    return [`/getLawSchools`] as const;
    }

    
export const getGetAllLawSchoolsQueryOptions = <TData = Awaited<ReturnType<typeof getAllLawSchools>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllLawSchools>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllLawSchoolsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllLawSchools>>> = ({ signal }) => getAllLawSchools(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllLawSchools>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllLawSchoolsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllLawSchools>>>
export type GetAllLawSchoolsQueryError = unknown



export function useGetAllLawSchools<TData = Awaited<ReturnType<typeof getAllLawSchools>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllLawSchools>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAllLawSchoolsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAllUniversityDegrees = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<AllUniversityDegreesResponse>(
      {url: `/getUniversityDegrees`, method: 'GET', signal
    },
      );
    }
  

export const getGetAllUniversityDegreesQueryKey = () => {
    return [`/getUniversityDegrees`] as const;
    }

    
export const getGetAllUniversityDegreesQueryOptions = <TData = Awaited<ReturnType<typeof getAllUniversityDegrees>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllUniversityDegrees>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllUniversityDegreesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllUniversityDegrees>>> = ({ signal }) => getAllUniversityDegrees(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllUniversityDegrees>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllUniversityDegreesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllUniversityDegrees>>>
export type GetAllUniversityDegreesQueryError = unknown



export function useGetAllUniversityDegrees<TData = Awaited<ReturnType<typeof getAllUniversityDegrees>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllUniversityDegrees>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAllUniversityDegreesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const healthcheck = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/healthCheck`, method: 'GET', signal
    },
      );
    }
  

export const getHealthcheckQueryKey = () => {
    return [`/healthCheck`] as const;
    }

    
export const getHealthcheckQueryOptions = <TData = Awaited<ReturnType<typeof healthcheck>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthcheckQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthcheck>>> = ({ signal }) => healthcheck(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthcheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthcheck>>>
export type HealthcheckQueryError = unknown



export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthcheckQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const requestEmployerInterviewJobPacketForEmployerAdmin = (
    employerOrgFriendlyName: string,
    employerEventId: number,
    scheduleId: number,
    interviewManagementEmployerPacketRequest: InterviewManagementEmployerPacketRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewManagementJobInterviewPacketMessage>(
      {url: `/interviewPacket/employer/${employerOrgFriendlyName}/${employerEventId}/${scheduleId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewManagementEmployerPacketRequest, signal
    },
      );
    }
  


export const getRequestEmployerInterviewJobPacketForEmployerAdminMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestEmployerInterviewJobPacketForEmployerAdmin>>, TError,{employerOrgFriendlyName: string;employerEventId: number;scheduleId: number;data: InterviewManagementEmployerPacketRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof requestEmployerInterviewJobPacketForEmployerAdmin>>, TError,{employerOrgFriendlyName: string;employerEventId: number;scheduleId: number;data: InterviewManagementEmployerPacketRequest}, TContext> => {
    
const mutationKey = ['requestEmployerInterviewJobPacketForEmployerAdmin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestEmployerInterviewJobPacketForEmployerAdmin>>, {employerOrgFriendlyName: string;employerEventId: number;scheduleId: number;data: InterviewManagementEmployerPacketRequest}> = (props) => {
          const {employerOrgFriendlyName,employerEventId,scheduleId,data} = props ?? {};

          return  requestEmployerInterviewJobPacketForEmployerAdmin(employerOrgFriendlyName,employerEventId,scheduleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestEmployerInterviewJobPacketForEmployerAdminMutationResult = NonNullable<Awaited<ReturnType<typeof requestEmployerInterviewJobPacketForEmployerAdmin>>>
    export type RequestEmployerInterviewJobPacketForEmployerAdminMutationBody = InterviewManagementEmployerPacketRequest
    export type RequestEmployerInterviewJobPacketForEmployerAdminMutationError = unknown

    export const useRequestEmployerInterviewJobPacketForEmployerAdmin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestEmployerInterviewJobPacketForEmployerAdmin>>, TError,{employerOrgFriendlyName: string;employerEventId: number;scheduleId: number;data: InterviewManagementEmployerPacketRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestEmployerInterviewJobPacketForEmployerAdmin>>,
        TError,
        {employerOrgFriendlyName: string;employerEventId: number;scheduleId: number;data: InterviewManagementEmployerPacketRequest},
        TContext
      > => {

      const mutationOptions = getRequestEmployerInterviewJobPacketForEmployerAdminMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const requestEmployerInterviewJobPacketForUniversityAdmin = (
    universityOrgFriendlyName: string,
    employerEventId: number,
    scheduleId: number,
    interviewManagementEmployerPacketRequest: InterviewManagementEmployerPacketRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewManagementJobInterviewPacketMessage>(
      {url: `/interviewPacket/university/${universityOrgFriendlyName}/${employerEventId}/${scheduleId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewManagementEmployerPacketRequest, signal
    },
      );
    }
  


export const getRequestEmployerInterviewJobPacketForUniversityAdminMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestEmployerInterviewJobPacketForUniversityAdmin>>, TError,{universityOrgFriendlyName: string;employerEventId: number;scheduleId: number;data: InterviewManagementEmployerPacketRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof requestEmployerInterviewJobPacketForUniversityAdmin>>, TError,{universityOrgFriendlyName: string;employerEventId: number;scheduleId: number;data: InterviewManagementEmployerPacketRequest}, TContext> => {
    
const mutationKey = ['requestEmployerInterviewJobPacketForUniversityAdmin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestEmployerInterviewJobPacketForUniversityAdmin>>, {universityOrgFriendlyName: string;employerEventId: number;scheduleId: number;data: InterviewManagementEmployerPacketRequest}> = (props) => {
          const {universityOrgFriendlyName,employerEventId,scheduleId,data} = props ?? {};

          return  requestEmployerInterviewJobPacketForUniversityAdmin(universityOrgFriendlyName,employerEventId,scheduleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestEmployerInterviewJobPacketForUniversityAdminMutationResult = NonNullable<Awaited<ReturnType<typeof requestEmployerInterviewJobPacketForUniversityAdmin>>>
    export type RequestEmployerInterviewJobPacketForUniversityAdminMutationBody = InterviewManagementEmployerPacketRequest
    export type RequestEmployerInterviewJobPacketForUniversityAdminMutationError = unknown

    export const useRequestEmployerInterviewJobPacketForUniversityAdmin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestEmployerInterviewJobPacketForUniversityAdmin>>, TError,{universityOrgFriendlyName: string;employerEventId: number;scheduleId: number;data: InterviewManagementEmployerPacketRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestEmployerInterviewJobPacketForUniversityAdmin>>,
        TError,
        {universityOrgFriendlyName: string;employerEventId: number;scheduleId: number;data: InterviewManagementEmployerPacketRequest},
        TContext
      > => {

      const mutationOptions = getRequestEmployerInterviewJobPacketForUniversityAdminMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getEventDetailsForInterviewers = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    interviewerExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EventDetailsNonAdminResponse>(
      {url: `/interviewScheduling/interviewer/eventDetails/${universityOrgFriendlyName}/${universityEventId}/${interviewerExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEventDetailsForInterviewersQueryKey = (universityOrgFriendlyName: string,
    universityEventId: number,
    interviewerExtension: string,) => {
    return [`/interviewScheduling/interviewer/eventDetails/${universityOrgFriendlyName}/${universityEventId}/${interviewerExtension}`] as const;
    }

    
export const getGetEventDetailsForInterviewersQueryOptions = <TData = Awaited<ReturnType<typeof getEventDetailsForInterviewers>>, TError = unknown>(universityOrgFriendlyName: string,
    universityEventId: number,
    interviewerExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventDetailsForInterviewers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventDetailsForInterviewersQueryKey(universityOrgFriendlyName,universityEventId,interviewerExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventDetailsForInterviewers>>> = ({ signal }) => getEventDetailsForInterviewers(universityOrgFriendlyName,universityEventId,interviewerExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityOrgFriendlyName && universityEventId && interviewerExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventDetailsForInterviewers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventDetailsForInterviewersQueryResult = NonNullable<Awaited<ReturnType<typeof getEventDetailsForInterviewers>>>
export type GetEventDetailsForInterviewersQueryError = unknown



export function useGetEventDetailsForInterviewers<TData = Awaited<ReturnType<typeof getEventDetailsForInterviewers>>, TError = unknown>(
 universityOrgFriendlyName: string,
    universityEventId: number,
    interviewerExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventDetailsForInterviewers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventDetailsForInterviewersQueryOptions(universityOrgFriendlyName,universityEventId,interviewerExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInterviewSchedulingInterviewerDownloadLink = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    scheduleId: number,
    eventCustomDocumentId: number,
    recruitId: number,
    interviewerExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewScheduling/interviewer/interviewSchedulingInterviewerDownloadLink/${universityOrgFriendlyName}/${universityEventId}/${scheduleId}/${eventCustomDocumentId}/${recruitId}/${interviewerExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingInterviewerDownloadLinkQueryKey = (universityOrgFriendlyName: string,
    universityEventId: number,
    scheduleId: number,
    eventCustomDocumentId: number,
    recruitId: number,
    interviewerExtension: string,) => {
    return [`/interviewScheduling/interviewer/interviewSchedulingInterviewerDownloadLink/${universityOrgFriendlyName}/${universityEventId}/${scheduleId}/${eventCustomDocumentId}/${recruitId}/${interviewerExtension}`] as const;
    }

    
export const getGetInterviewSchedulingInterviewerDownloadLinkQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingInterviewerDownloadLink>>, TError = unknown>(universityOrgFriendlyName: string,
    universityEventId: number,
    scheduleId: number,
    eventCustomDocumentId: number,
    recruitId: number,
    interviewerExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingInterviewerDownloadLink>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingInterviewerDownloadLinkQueryKey(universityOrgFriendlyName,universityEventId,scheduleId,eventCustomDocumentId,recruitId,interviewerExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingInterviewerDownloadLink>>> = ({ signal }) => getInterviewSchedulingInterviewerDownloadLink(universityOrgFriendlyName,universityEventId,scheduleId,eventCustomDocumentId,recruitId,interviewerExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityOrgFriendlyName && universityEventId && scheduleId && eventCustomDocumentId && recruitId && interviewerExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingInterviewerDownloadLink>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingInterviewerDownloadLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingInterviewerDownloadLink>>>
export type GetInterviewSchedulingInterviewerDownloadLinkQueryError = unknown



export function useGetInterviewSchedulingInterviewerDownloadLink<TData = Awaited<ReturnType<typeof getInterviewSchedulingInterviewerDownloadLink>>, TError = unknown>(
 universityOrgFriendlyName: string,
    universityEventId: number,
    scheduleId: number,
    eventCustomDocumentId: number,
    recruitId: number,
    interviewerExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingInterviewerDownloadLink>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingInterviewerDownloadLinkQueryOptions(universityOrgFriendlyName,universityEventId,scheduleId,eventCustomDocumentId,recruitId,interviewerExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInterviewSchedulingDocuments = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    scheduleId: number,
    recruitId: number,
    interviewerExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SupportingDocumentInterviewerResponse[]>(
      {url: `/interviewScheduling/interviewer/interviewSchedulingInterviewerGetDocuments/${universityOrgFriendlyName}/${universityEventId}/${scheduleId}/${recruitId}/${interviewerExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingDocumentsQueryKey = (universityOrgFriendlyName: string,
    universityEventId: number,
    scheduleId: number,
    recruitId: number,
    interviewerExtension: string,) => {
    return [`/interviewScheduling/interviewer/interviewSchedulingInterviewerGetDocuments/${universityOrgFriendlyName}/${universityEventId}/${scheduleId}/${recruitId}/${interviewerExtension}`] as const;
    }

    
export const getGetInterviewSchedulingDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingDocuments>>, TError = unknown>(universityOrgFriendlyName: string,
    universityEventId: number,
    scheduleId: number,
    recruitId: number,
    interviewerExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingDocuments>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingDocumentsQueryKey(universityOrgFriendlyName,universityEventId,scheduleId,recruitId,interviewerExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingDocuments>>> = ({ signal }) => getInterviewSchedulingDocuments(universityOrgFriendlyName,universityEventId,scheduleId,recruitId,interviewerExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityOrgFriendlyName && universityEventId && scheduleId && recruitId && interviewerExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingDocuments>>>
export type GetInterviewSchedulingDocumentsQueryError = unknown



export function useGetInterviewSchedulingDocuments<TData = Awaited<ReturnType<typeof getInterviewSchedulingDocuments>>, TError = unknown>(
 universityOrgFriendlyName: string,
    universityEventId: number,
    scheduleId: number,
    recruitId: number,
    interviewerExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingDocuments>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingDocumentsQueryOptions(universityOrgFriendlyName,universityEventId,scheduleId,recruitId,interviewerExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInterviewSchedulingStudentApplicationsForInterviewer = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    interviewerExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingStudentApplicationForInterviewer[]>(
      {url: `/interviewScheduling/interviewer/interviewSchedulingInterviewerGetEventDocuments/${universityOrgFriendlyName}/${universityEventId}/${interviewerExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingStudentApplicationsForInterviewerQueryKey = (universityOrgFriendlyName: string,
    universityEventId: number,
    interviewerExtension: string,) => {
    return [`/interviewScheduling/interviewer/interviewSchedulingInterviewerGetEventDocuments/${universityOrgFriendlyName}/${universityEventId}/${interviewerExtension}`] as const;
    }

    
export const getGetInterviewSchedulingStudentApplicationsForInterviewerQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentApplicationsForInterviewer>>, TError = unknown>(universityOrgFriendlyName: string,
    universityEventId: number,
    interviewerExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentApplicationsForInterviewer>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingStudentApplicationsForInterviewerQueryKey(universityOrgFriendlyName,universityEventId,interviewerExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingStudentApplicationsForInterviewer>>> = ({ signal }) => getInterviewSchedulingStudentApplicationsForInterviewer(universityOrgFriendlyName,universityEventId,interviewerExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityOrgFriendlyName && universityEventId && interviewerExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentApplicationsForInterviewer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingStudentApplicationsForInterviewerQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingStudentApplicationsForInterviewer>>>
export type GetInterviewSchedulingStudentApplicationsForInterviewerQueryError = unknown



export function useGetInterviewSchedulingStudentApplicationsForInterviewer<TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentApplicationsForInterviewer>>, TError = unknown>(
 universityOrgFriendlyName: string,
    universityEventId: number,
    interviewerExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentApplicationsForInterviewer>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingStudentApplicationsForInterviewerQueryOptions(universityOrgFriendlyName,universityEventId,interviewerExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const bulkDownloadStudentDocumentsForInterviewer = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    interviewerExtension: string,
    interviewSchedulingBulkExportEventJobApplicationDocumentsForInterviewerRequest: InterviewSchedulingBulkExportEventJobApplicationDocumentsForInterviewerRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewScheduling/interviewer/interviewSchedulingInterviewerGetEventDocuments/${universityOrgFriendlyName}/${universityEventId}/${interviewerExtension}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingBulkExportEventJobApplicationDocumentsForInterviewerRequest, signal
    },
      );
    }
  


export const getBulkDownloadStudentDocumentsForInterviewerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDownloadStudentDocumentsForInterviewer>>, TError,{universityOrgFriendlyName: string;universityEventId: number;interviewerExtension: string;data: InterviewSchedulingBulkExportEventJobApplicationDocumentsForInterviewerRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkDownloadStudentDocumentsForInterviewer>>, TError,{universityOrgFriendlyName: string;universityEventId: number;interviewerExtension: string;data: InterviewSchedulingBulkExportEventJobApplicationDocumentsForInterviewerRequest}, TContext> => {
    
const mutationKey = ['bulkDownloadStudentDocumentsForInterviewer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDownloadStudentDocumentsForInterviewer>>, {universityOrgFriendlyName: string;universityEventId: number;interviewerExtension: string;data: InterviewSchedulingBulkExportEventJobApplicationDocumentsForInterviewerRequest}> = (props) => {
          const {universityOrgFriendlyName,universityEventId,interviewerExtension,data} = props ?? {};

          return  bulkDownloadStudentDocumentsForInterviewer(universityOrgFriendlyName,universityEventId,interviewerExtension,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkDownloadStudentDocumentsForInterviewerMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDownloadStudentDocumentsForInterviewer>>>
    export type BulkDownloadStudentDocumentsForInterviewerMutationBody = InterviewSchedulingBulkExportEventJobApplicationDocumentsForInterviewerRequest
    export type BulkDownloadStudentDocumentsForInterviewerMutationError = unknown

    export const useBulkDownloadStudentDocumentsForInterviewer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDownloadStudentDocumentsForInterviewer>>, TError,{universityOrgFriendlyName: string;universityEventId: number;interviewerExtension: string;data: InterviewSchedulingBulkExportEventJobApplicationDocumentsForInterviewerRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkDownloadStudentDocumentsForInterviewer>>,
        TError,
        {universityOrgFriendlyName: string;universityEventId: number;interviewerExtension: string;data: InterviewSchedulingBulkExportEventJobApplicationDocumentsForInterviewerRequest},
        TContext
      > => {

      const mutationOptions = getBulkDownloadStudentDocumentsForInterviewerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getInterviewSchedulingStudentEventSummary = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingStudentEventSummary>(
      {url: `/interviewScheduling/student/eventSummary/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingStudentEventSummaryQueryKey = (universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,) => {
    return [`/interviewScheduling/student/eventSummary/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}`] as const;
    }

    
export const getGetInterviewSchedulingStudentEventSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentEventSummary>>, TError = unknown>(universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentEventSummary>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingStudentEventSummaryQueryKey(universityOrgFriendlyName,universityEventId,studentExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingStudentEventSummary>>> = ({ signal }) => getInterviewSchedulingStudentEventSummary(universityOrgFriendlyName,universityEventId,studentExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityOrgFriendlyName && universityEventId && studentExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentEventSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingStudentEventSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingStudentEventSummary>>>
export type GetInterviewSchedulingStudentEventSummaryQueryError = unknown



export function useGetInterviewSchedulingStudentEventSummary<TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentEventSummary>>, TError = unknown>(
 universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentEventSummary>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingStudentEventSummaryQueryOptions(universityOrgFriendlyName,universityEventId,studentExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInterviewSchedulingStudentJobs = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingStudentJobInListResponse[]>(
      {url: `/interviewScheduling/student/job/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingStudentJobsQueryKey = (universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,) => {
    return [`/interviewScheduling/student/job/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}`] as const;
    }

    
export const getGetInterviewSchedulingStudentJobsQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentJobs>>, TError = unknown>(universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentJobs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingStudentJobsQueryKey(universityOrgFriendlyName,universityEventId,studentExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingStudentJobs>>> = ({ signal }) => getInterviewSchedulingStudentJobs(universityOrgFriendlyName,universityEventId,studentExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityOrgFriendlyName && universityEventId && studentExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentJobs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingStudentJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingStudentJobs>>>
export type GetInterviewSchedulingStudentJobsQueryError = unknown



export function useGetInterviewSchedulingStudentJobs<TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentJobs>>, TError = unknown>(
 universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentJobs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingStudentJobsQueryOptions(universityOrgFriendlyName,universityEventId,studentExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInterviewSchedulingStudentJob = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,
    scheduleId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingStudentJobDetailResponse>(
      {url: `/interviewScheduling/student/job/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}/${scheduleId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingStudentJobQueryKey = (universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,
    scheduleId: number,) => {
    return [`/interviewScheduling/student/job/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}/${scheduleId}`] as const;
    }

    
export const getGetInterviewSchedulingStudentJobQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentJob>>, TError = unknown>(universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentJob>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingStudentJobQueryKey(universityOrgFriendlyName,universityEventId,studentExtension,scheduleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingStudentJob>>> = ({ signal }) => getInterviewSchedulingStudentJob(universityOrgFriendlyName,universityEventId,studentExtension,scheduleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityOrgFriendlyName && universityEventId && studentExtension && scheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentJob>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingStudentJobQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingStudentJob>>>
export type GetInterviewSchedulingStudentJobQueryError = unknown



export function useGetInterviewSchedulingStudentJob<TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentJob>>, TError = unknown>(
 universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentJob>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingStudentJobQueryOptions(universityOrgFriendlyName,universityEventId,studentExtension,scheduleId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateInterviewInvitationResponseStatus = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,
    scheduleId: number,
    updateStudentInterviewInvitationResponseStatus: UpdateStudentInterviewInvitationResponseStatus,
 ) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewScheduling/student/jobApplication/interviewInvitation/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}/${scheduleId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateStudentInterviewInvitationResponseStatus
    },
      );
    }
  


export const getUpdateInterviewInvitationResponseStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInterviewInvitationResponseStatus>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;scheduleId: number;data: UpdateStudentInterviewInvitationResponseStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateInterviewInvitationResponseStatus>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;scheduleId: number;data: UpdateStudentInterviewInvitationResponseStatus}, TContext> => {
    
const mutationKey = ['updateInterviewInvitationResponseStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInterviewInvitationResponseStatus>>, {universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;scheduleId: number;data: UpdateStudentInterviewInvitationResponseStatus}> = (props) => {
          const {universityOrgFriendlyName,universityEventId,studentExtension,scheduleId,data} = props ?? {};

          return  updateInterviewInvitationResponseStatus(universityOrgFriendlyName,universityEventId,studentExtension,scheduleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateInterviewInvitationResponseStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateInterviewInvitationResponseStatus>>>
    export type UpdateInterviewInvitationResponseStatusMutationBody = UpdateStudentInterviewInvitationResponseStatus
    export type UpdateInterviewInvitationResponseStatusMutationError = unknown

    export const useUpdateInterviewInvitationResponseStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInterviewInvitationResponseStatus>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;scheduleId: number;data: UpdateStudentInterviewInvitationResponseStatus}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInterviewInvitationResponseStatus>>,
        TError,
        {universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;scheduleId: number;data: UpdateStudentInterviewInvitationResponseStatus},
        TContext
      > => {

      const mutationOptions = getUpdateInterviewInvitationResponseStatusMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const deleteInterviewSchedulingJobApplication = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,
    scheduleId: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/interviewScheduling/student/jobApplication/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}/${scheduleId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteInterviewSchedulingJobApplicationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInterviewSchedulingJobApplication>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;scheduleId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteInterviewSchedulingJobApplication>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;scheduleId: number}, TContext> => {
    
const mutationKey = ['deleteInterviewSchedulingJobApplication'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInterviewSchedulingJobApplication>>, {universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;scheduleId: number}> = (props) => {
          const {universityOrgFriendlyName,universityEventId,studentExtension,scheduleId} = props ?? {};

          return  deleteInterviewSchedulingJobApplication(universityOrgFriendlyName,universityEventId,studentExtension,scheduleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteInterviewSchedulingJobApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInterviewSchedulingJobApplication>>>
    
    export type DeleteInterviewSchedulingJobApplicationMutationError = unknown

    export const useDeleteInterviewSchedulingJobApplication = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInterviewSchedulingJobApplication>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;scheduleId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteInterviewSchedulingJobApplication>>,
        TError,
        {universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;scheduleId: number},
        TContext
      > => {

      const mutationOptions = getDeleteInterviewSchedulingJobApplicationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const submitInterviewSchedulingJobApplication = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,
    scheduleId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewScheduling/student/jobApplication/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}/${scheduleId}`, method: 'POST', signal
    },
      );
    }
  


export const getSubmitInterviewSchedulingJobApplicationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitInterviewSchedulingJobApplication>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;scheduleId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitInterviewSchedulingJobApplication>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;scheduleId: number}, TContext> => {
    
const mutationKey = ['submitInterviewSchedulingJobApplication'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitInterviewSchedulingJobApplication>>, {universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;scheduleId: number}> = (props) => {
          const {universityOrgFriendlyName,universityEventId,studentExtension,scheduleId} = props ?? {};

          return  submitInterviewSchedulingJobApplication(universityOrgFriendlyName,universityEventId,studentExtension,scheduleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitInterviewSchedulingJobApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof submitInterviewSchedulingJobApplication>>>
    
    export type SubmitInterviewSchedulingJobApplicationMutationError = unknown

    export const useSubmitInterviewSchedulingJobApplication = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitInterviewSchedulingJobApplication>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;scheduleId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitInterviewSchedulingJobApplication>>,
        TError,
        {universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;scheduleId: number},
        TContext
      > => {

      const mutationOptions = getSubmitInterviewSchedulingJobApplicationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getInterviewSchedulingStudentJobStatuses = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingStudentJobStatusResponse[]>(
      {url: `/interviewScheduling/student/jobStatuses/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingStudentJobStatusesQueryKey = (universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,) => {
    return [`/interviewScheduling/student/jobStatuses/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}`] as const;
    }

    
export const getGetInterviewSchedulingStudentJobStatusesQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentJobStatuses>>, TError = unknown>(universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentJobStatuses>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingStudentJobStatusesQueryKey(universityOrgFriendlyName,universityEventId,studentExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingStudentJobStatuses>>> = ({ signal }) => getInterviewSchedulingStudentJobStatuses(universityOrgFriendlyName,universityEventId,studentExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityOrgFriendlyName && universityEventId && studentExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentJobStatuses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingStudentJobStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingStudentJobStatuses>>>
export type GetInterviewSchedulingStudentJobStatusesQueryError = unknown



export function useGetInterviewSchedulingStudentJobStatuses<TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentJobStatuses>>, TError = unknown>(
 universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentJobStatuses>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingStudentJobStatusesQueryOptions(universityOrgFriendlyName,universityEventId,studentExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInterviewSchedulingStudentScheduleConflicts = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingStudentScheduleConflictsResponse[]>(
      {url: `/interviewScheduling/student/scheduleConflicts/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingStudentScheduleConflictsQueryKey = (universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,) => {
    return [`/interviewScheduling/student/scheduleConflicts/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}`] as const;
    }

    
export const getGetInterviewSchedulingStudentScheduleConflictsQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentScheduleConflicts>>, TError = unknown>(universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentScheduleConflicts>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingStudentScheduleConflictsQueryKey(universityOrgFriendlyName,universityEventId,studentExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingStudentScheduleConflicts>>> = ({ signal }) => getInterviewSchedulingStudentScheduleConflicts(universityOrgFriendlyName,universityEventId,studentExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityOrgFriendlyName && universityEventId && studentExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentScheduleConflicts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingStudentScheduleConflictsQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingStudentScheduleConflicts>>>
export type GetInterviewSchedulingStudentScheduleConflictsQueryError = unknown



export function useGetInterviewSchedulingStudentScheduleConflicts<TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentScheduleConflicts>>, TError = unknown>(
 universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentScheduleConflicts>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingStudentScheduleConflictsQueryOptions(universityOrgFriendlyName,universityEventId,studentExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const submitInterviewSchedulingStudentScheduleConflicts = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,
    interviewSchedulingStudentScheduleConflictsListRequest: InterviewSchedulingStudentScheduleConflictsListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewScheduling/student/scheduleConflicts/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingStudentScheduleConflictsListRequest, signal
    },
      );
    }
  


export const getSubmitInterviewSchedulingStudentScheduleConflictsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitInterviewSchedulingStudentScheduleConflicts>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;data: InterviewSchedulingStudentScheduleConflictsListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitInterviewSchedulingStudentScheduleConflicts>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;data: InterviewSchedulingStudentScheduleConflictsListRequest}, TContext> => {
    
const mutationKey = ['submitInterviewSchedulingStudentScheduleConflicts'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitInterviewSchedulingStudentScheduleConflicts>>, {universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;data: InterviewSchedulingStudentScheduleConflictsListRequest}> = (props) => {
          const {universityOrgFriendlyName,universityEventId,studentExtension,data} = props ?? {};

          return  submitInterviewSchedulingStudentScheduleConflicts(universityOrgFriendlyName,universityEventId,studentExtension,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitInterviewSchedulingStudentScheduleConflictsMutationResult = NonNullable<Awaited<ReturnType<typeof submitInterviewSchedulingStudentScheduleConflicts>>>
    export type SubmitInterviewSchedulingStudentScheduleConflictsMutationBody = InterviewSchedulingStudentScheduleConflictsListRequest
    export type SubmitInterviewSchedulingStudentScheduleConflictsMutationError = unknown

    export const useSubmitInterviewSchedulingStudentScheduleConflicts = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitInterviewSchedulingStudentScheduleConflicts>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;data: InterviewSchedulingStudentScheduleConflictsListRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitInterviewSchedulingStudentScheduleConflicts>>,
        TError,
        {universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;data: InterviewSchedulingStudentScheduleConflictsListRequest},
        TContext
      > => {

      const mutationOptions = getSubmitInterviewSchedulingStudentScheduleConflictsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const claimInterviewSchedulingStudentSelfScheduleTimeslot = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,
    interviewSchedulingStudentSelfScheduleClaimTimeslotRequest: InterviewSchedulingStudentSelfScheduleClaimTimeslotRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewScheduling/student/selfSchedule/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}/claimTimeslot`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingStudentSelfScheduleClaimTimeslotRequest, signal
    },
      );
    }
  


export const getClaimInterviewSchedulingStudentSelfScheduleTimeslotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimInterviewSchedulingStudentSelfScheduleTimeslot>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;data: InterviewSchedulingStudentSelfScheduleClaimTimeslotRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof claimInterviewSchedulingStudentSelfScheduleTimeslot>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;data: InterviewSchedulingStudentSelfScheduleClaimTimeslotRequest}, TContext> => {
    
const mutationKey = ['claimInterviewSchedulingStudentSelfScheduleTimeslot'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimInterviewSchedulingStudentSelfScheduleTimeslot>>, {universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;data: InterviewSchedulingStudentSelfScheduleClaimTimeslotRequest}> = (props) => {
          const {universityOrgFriendlyName,universityEventId,studentExtension,data} = props ?? {};

          return  claimInterviewSchedulingStudentSelfScheduleTimeslot(universityOrgFriendlyName,universityEventId,studentExtension,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ClaimInterviewSchedulingStudentSelfScheduleTimeslotMutationResult = NonNullable<Awaited<ReturnType<typeof claimInterviewSchedulingStudentSelfScheduleTimeslot>>>
    export type ClaimInterviewSchedulingStudentSelfScheduleTimeslotMutationBody = InterviewSchedulingStudentSelfScheduleClaimTimeslotRequest
    export type ClaimInterviewSchedulingStudentSelfScheduleTimeslotMutationError = unknown

    export const useClaimInterviewSchedulingStudentSelfScheduleTimeslot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimInterviewSchedulingStudentSelfScheduleTimeslot>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;data: InterviewSchedulingStudentSelfScheduleClaimTimeslotRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof claimInterviewSchedulingStudentSelfScheduleTimeslot>>,
        TError,
        {universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;data: InterviewSchedulingStudentSelfScheduleClaimTimeslotRequest},
        TContext
      > => {

      const mutationOptions = getClaimInterviewSchedulingStudentSelfScheduleTimeslotMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getInterviewSchedulingStudentScheduledInterviews = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingStudentScheduledInterviewResponse[]>(
      {url: `/interviewScheduling/student/studentInterviews/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingStudentScheduledInterviewsQueryKey = (universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,) => {
    return [`/interviewScheduling/student/studentInterviews/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}`] as const;
    }

    
export const getGetInterviewSchedulingStudentScheduledInterviewsQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentScheduledInterviews>>, TError = unknown>(universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentScheduledInterviews>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingStudentScheduledInterviewsQueryKey(universityOrgFriendlyName,universityEventId,studentExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingStudentScheduledInterviews>>> = ({ signal }) => getInterviewSchedulingStudentScheduledInterviews(universityOrgFriendlyName,universityEventId,studentExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityOrgFriendlyName && universityEventId && studentExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentScheduledInterviews>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingStudentScheduledInterviewsQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingStudentScheduledInterviews>>>
export type GetInterviewSchedulingStudentScheduledInterviewsQueryError = unknown



export function useGetInterviewSchedulingStudentScheduledInterviews<TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentScheduledInterviews>>, TError = unknown>(
 universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentScheduledInterviews>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingStudentScheduledInterviewsQueryOptions(universityOrgFriendlyName,universityEventId,studentExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const uploadInterviewSchedulingJobApplicationDocumentFromStudent = (
    universityOrgFriendlyName: string,
    universityEventId: number,
    studentExtension: string,
    uploadInterviewSchedulingJobApplicationDocumentFromStudentBody: UploadInterviewSchedulingJobApplicationDocumentFromStudentBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append('file', uploadInterviewSchedulingJobApplicationDocumentFromStudentBody.file)
formData.append('schedule-ids', uploadInterviewSchedulingJobApplicationDocumentFromStudentBody['schedule-ids'])
formData.append('supporting-document-ids', uploadInterviewSchedulingJobApplicationDocumentFromStudentBody['supporting-document-ids'])

      return customInstance<void>(
      {url: `/interviewScheduling/student/uploadJobApplicationDocument/${universityOrgFriendlyName}/${universityEventId}/${studentExtension}`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadInterviewSchedulingJobApplicationDocumentFromStudentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadInterviewSchedulingJobApplicationDocumentFromStudent>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;data: UploadInterviewSchedulingJobApplicationDocumentFromStudentBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadInterviewSchedulingJobApplicationDocumentFromStudent>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;data: UploadInterviewSchedulingJobApplicationDocumentFromStudentBody}, TContext> => {
    
const mutationKey = ['uploadInterviewSchedulingJobApplicationDocumentFromStudent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadInterviewSchedulingJobApplicationDocumentFromStudent>>, {universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;data: UploadInterviewSchedulingJobApplicationDocumentFromStudentBody}> = (props) => {
          const {universityOrgFriendlyName,universityEventId,studentExtension,data} = props ?? {};

          return  uploadInterviewSchedulingJobApplicationDocumentFromStudent(universityOrgFriendlyName,universityEventId,studentExtension,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadInterviewSchedulingJobApplicationDocumentFromStudentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadInterviewSchedulingJobApplicationDocumentFromStudent>>>
    export type UploadInterviewSchedulingJobApplicationDocumentFromStudentMutationBody = UploadInterviewSchedulingJobApplicationDocumentFromStudentBody
    export type UploadInterviewSchedulingJobApplicationDocumentFromStudentMutationError = unknown

    export const useUploadInterviewSchedulingJobApplicationDocumentFromStudent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadInterviewSchedulingJobApplicationDocumentFromStudent>>, TError,{universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;data: UploadInterviewSchedulingJobApplicationDocumentFromStudentBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadInterviewSchedulingJobApplicationDocumentFromStudent>>,
        TError,
        {universityOrgFriendlyName: string;universityEventId: number;studentExtension: string;data: UploadInterviewSchedulingJobApplicationDocumentFromStudentBody},
        TContext
      > => {

      const mutationOptions = getUploadInterviewSchedulingJobApplicationDocumentFromStudentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * @summary Get existing time-block information for Step 2
 */
export const getInterviewSchedulingBlocks = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingBlockResponse[]>(
      {url: `/interviewSchedulingAdmin/blocks/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingBlocksQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/blocks/${eventId}`] as const;
    }

    
export const getGetInterviewSchedulingBlocksQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingBlocks>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingBlocks>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingBlocksQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingBlocks>>> = ({ signal }) => getInterviewSchedulingBlocks(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingBlocks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingBlocksQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingBlocks>>>
export type GetInterviewSchedulingBlocksQueryError = unknown


/**
 * @summary Get existing time-block information for Step 2
 */

export function useGetInterviewSchedulingBlocks<TData = Awaited<ReturnType<typeof getInterviewSchedulingBlocks>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingBlocks>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingBlocksQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Submit/Update Step 2
 */
export const submitInterviewSchedulingBlocks = (
    eventId: number,
    interviewSchedulingSubmitBlocksRequest: InterviewSchedulingSubmitBlocksRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/blocks/${eventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingSubmitBlocksRequest, signal
    },
      );
    }
  


export const getSubmitInterviewSchedulingBlocksMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitInterviewSchedulingBlocks>>, TError,{eventId: number;data: InterviewSchedulingSubmitBlocksRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitInterviewSchedulingBlocks>>, TError,{eventId: number;data: InterviewSchedulingSubmitBlocksRequest}, TContext> => {
    
const mutationKey = ['submitInterviewSchedulingBlocks'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitInterviewSchedulingBlocks>>, {eventId: number;data: InterviewSchedulingSubmitBlocksRequest}> = (props) => {
          const {eventId,data} = props ?? {};

          return  submitInterviewSchedulingBlocks(eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitInterviewSchedulingBlocksMutationResult = NonNullable<Awaited<ReturnType<typeof submitInterviewSchedulingBlocks>>>
    export type SubmitInterviewSchedulingBlocksMutationBody = InterviewSchedulingSubmitBlocksRequest
    export type SubmitInterviewSchedulingBlocksMutationError = unknown

    /**
 * @summary Submit/Update Step 2
 */
export const useSubmitInterviewSchedulingBlocks = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitInterviewSchedulingBlocks>>, TError,{eventId: number;data: InterviewSchedulingSubmitBlocksRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitInterviewSchedulingBlocks>>,
        TError,
        {eventId: number;data: InterviewSchedulingSubmitBlocksRequest},
        TContext
      > => {

      const mutationOptions = getSubmitInterviewSchedulingBlocksMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Submitting for the first time creates a new event in the `EVENTS` table. It also creates entries in the `INTERVIEW_SCHEDULING_EVENT_TIMELINE` and email tables
 * @summary Submit/Update Step 1
 */
export const submitEventDetails = (
    eventDetailsRequest: EventDetailsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/interviewSchedulingAdmin/details`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eventDetailsRequest, signal
    },
      );
    }
  


export const getSubmitEventDetailsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEventDetails>>, TError,{data: EventDetailsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitEventDetails>>, TError,{data: EventDetailsRequest}, TContext> => {
    
const mutationKey = ['submitEventDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitEventDetails>>, {data: EventDetailsRequest}> = (props) => {
          const {data} = props ?? {};

          return  submitEventDetails(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitEventDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof submitEventDetails>>>
    export type SubmitEventDetailsMutationBody = EventDetailsRequest
    export type SubmitEventDetailsMutationError = unknown

    /**
 * @summary Submit/Update Step 1
 */
export const useSubmitEventDetails = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEventDetails>>, TError,{data: EventDetailsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitEventDetails>>,
        TError,
        {data: EventDetailsRequest},
        TContext
      > => {

      const mutationOptions = getSubmitEventDetailsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * @summary Get existing event detail information for Step 1
 */
export const getEventDetails = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EventDetailsResponse>(
      {url: `/interviewSchedulingAdmin/details/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEventDetailsQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/details/${eventId}`] as const;
    }

    
export const getGetEventDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getEventDetails>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventDetails>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventDetailsQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventDetails>>> = ({ signal }) => getEventDetails(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getEventDetails>>>
export type GetEventDetailsQueryError = unknown


/**
 * @summary Get existing event detail information for Step 1
 */

export function useGetEventDetails<TData = Awaited<ReturnType<typeof getEventDetails>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventDetails>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventDetailsQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getEmailPreview = (
    eventId: number,
    emailPreviewRequest: EmailPreviewRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmailPreviewResponse>(
      {url: `/interviewSchedulingAdmin/emailPreview/${eventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailPreviewRequest, signal
    },
      );
    }
  


export const getGetEmailPreviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEmailPreview>>, TError,{eventId: number;data: EmailPreviewRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getEmailPreview>>, TError,{eventId: number;data: EmailPreviewRequest}, TContext> => {
    
const mutationKey = ['getEmailPreview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getEmailPreview>>, {eventId: number;data: EmailPreviewRequest}> = (props) => {
          const {eventId,data} = props ?? {};

          return  getEmailPreview(eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetEmailPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof getEmailPreview>>>
    export type GetEmailPreviewMutationBody = EmailPreviewRequest
    export type GetEmailPreviewMutationError = unknown

    export const useGetEmailPreview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEmailPreview>>, TError,{eventId: number;data: EmailPreviewRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof getEmailPreview>>,
        TError,
        {eventId: number;data: EmailPreviewRequest},
        TContext
      > => {

      const mutationOptions = getGetEmailPreviewMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * @summary Get default email information for step 5
 */
export const getInterviewSchedulingEmailDefaults = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingDefaultEmailsResponse>(
      {url: `/interviewSchedulingAdmin/emails/defaults/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingEmailDefaultsQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/emails/defaults/${eventId}`] as const;
    }

    
export const getGetInterviewSchedulingEmailDefaultsQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingEmailDefaults>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingEmailDefaults>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingEmailDefaultsQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingEmailDefaults>>> = ({ signal }) => getInterviewSchedulingEmailDefaults(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingEmailDefaults>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingEmailDefaultsQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingEmailDefaults>>>
export type GetInterviewSchedulingEmailDefaultsQueryError = unknown


/**
 * @summary Get default email information for step 5
 */

export function useGetInterviewSchedulingEmailDefaults<TData = Awaited<ReturnType<typeof getInterviewSchedulingEmailDefaults>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingEmailDefaults>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingEmailDefaultsQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sendInterviewSchedulingScheduledEmailsTest = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingAdmin/emails/sendScheduledEmailsTest/`, method: 'GET', signal
    },
      );
    }
  

export const getSendInterviewSchedulingScheduledEmailsTestQueryKey = () => {
    return [`/interviewSchedulingAdmin/emails/sendScheduledEmailsTest/`] as const;
    }

    
export const getSendInterviewSchedulingScheduledEmailsTestQueryOptions = <TData = Awaited<ReturnType<typeof sendInterviewSchedulingScheduledEmailsTest>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sendInterviewSchedulingScheduledEmailsTest>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSendInterviewSchedulingScheduledEmailsTestQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sendInterviewSchedulingScheduledEmailsTest>>> = ({ signal }) => sendInterviewSchedulingScheduledEmailsTest(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sendInterviewSchedulingScheduledEmailsTest>>, TError, TData> & { queryKey: QueryKey }
}

export type SendInterviewSchedulingScheduledEmailsTestQueryResult = NonNullable<Awaited<ReturnType<typeof sendInterviewSchedulingScheduledEmailsTest>>>
export type SendInterviewSchedulingScheduledEmailsTestQueryError = unknown



export function useSendInterviewSchedulingScheduledEmailsTest<TData = Awaited<ReturnType<typeof sendInterviewSchedulingScheduledEmailsTest>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sendInterviewSchedulingScheduledEmailsTest>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSendInterviewSchedulingScheduledEmailsTestQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get existing emails for step 5
 */
export const getInterviewSchedulingEmails = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingEmailsResponse>(
      {url: `/interviewSchedulingAdmin/emails/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingEmailsQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/emails/${eventId}`] as const;
    }

    
export const getGetInterviewSchedulingEmailsQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingEmails>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingEmails>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingEmailsQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingEmails>>> = ({ signal }) => getInterviewSchedulingEmails(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingEmails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingEmailsQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingEmails>>>
export type GetInterviewSchedulingEmailsQueryError = unknown


/**
 * @summary Get existing emails for step 5
 */

export function useGetInterviewSchedulingEmails<TData = Awaited<ReturnType<typeof getInterviewSchedulingEmails>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingEmails>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingEmailsQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Submit/Update step 5
 */
export const submitInterviewSchedulingEmails = (
    eventId: number,
    interviewSchedulingEmailsRequest: InterviewSchedulingEmailsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/emails/${eventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingEmailsRequest, signal
    },
      );
    }
  


export const getSubmitInterviewSchedulingEmailsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitInterviewSchedulingEmails>>, TError,{eventId: number;data: InterviewSchedulingEmailsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitInterviewSchedulingEmails>>, TError,{eventId: number;data: InterviewSchedulingEmailsRequest}, TContext> => {
    
const mutationKey = ['submitInterviewSchedulingEmails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitInterviewSchedulingEmails>>, {eventId: number;data: InterviewSchedulingEmailsRequest}> = (props) => {
          const {eventId,data} = props ?? {};

          return  submitInterviewSchedulingEmails(eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitInterviewSchedulingEmailsMutationResult = NonNullable<Awaited<ReturnType<typeof submitInterviewSchedulingEmails>>>
    export type SubmitInterviewSchedulingEmailsMutationBody = InterviewSchedulingEmailsRequest
    export type SubmitInterviewSchedulingEmailsMutationError = unknown

    /**
 * @summary Submit/Update step 5
 */
export const useSubmitInterviewSchedulingEmails = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitInterviewSchedulingEmails>>, TError,{eventId: number;data: InterviewSchedulingEmailsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitInterviewSchedulingEmails>>,
        TError,
        {eventId: number;data: InterviewSchedulingEmailsRequest},
        TContext
      > => {

      const mutationOptions = getSubmitInterviewSchedulingEmailsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const createUniversityEmployer = (
    universityEmployerRequest: UniversityEmployerRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateUniversityEmployerResponse>(
      {url: `/interviewSchedulingAdmin/employer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: universityEmployerRequest, signal
    },
      );
    }
  


export const getCreateUniversityEmployerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUniversityEmployer>>, TError,{data: UniversityEmployerRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createUniversityEmployer>>, TError,{data: UniversityEmployerRequest}, TContext> => {
    
const mutationKey = ['createUniversityEmployer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUniversityEmployer>>, {data: UniversityEmployerRequest}> = (props) => {
          const {data} = props ?? {};

          return  createUniversityEmployer(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUniversityEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof createUniversityEmployer>>>
    export type CreateUniversityEmployerMutationBody = UniversityEmployerRequest
    export type CreateUniversityEmployerMutationError = unknown

    export const useCreateUniversityEmployer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUniversityEmployer>>, TError,{data: UniversityEmployerRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createUniversityEmployer>>,
        TError,
        {data: UniversityEmployerRequest},
        TContext
      > => {

      const mutationOptions = getCreateUniversityEmployerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const createEmployerContact = (
    employerContactRequest: EmployerContactRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/interviewSchedulingAdmin/employerContact`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: employerContactRequest, signal
    },
      );
    }
  


export const getCreateEmployerContactMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployerContact>>, TError,{data: EmployerContactRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createEmployerContact>>, TError,{data: EmployerContactRequest}, TContext> => {
    
const mutationKey = ['createEmployerContact'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployerContact>>, {data: EmployerContactRequest}> = (props) => {
          const {data} = props ?? {};

          return  createEmployerContact(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployerContactMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployerContact>>>
    export type CreateEmployerContactMutationBody = EmployerContactRequest
    export type CreateEmployerContactMutationError = unknown

    export const useCreateEmployerContact = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployerContact>>, TError,{data: EmployerContactRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createEmployerContact>>,
        TError,
        {data: EmployerContactRequest},
        TContext
      > => {

      const mutationOptions = getCreateEmployerContactMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getEmployerContacts = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EventEmployerContactResponse[]>(
      {url: `/interviewSchedulingAdmin/employerContacts/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEmployerContactsQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/employerContacts/${eventId}`] as const;
    }

    
export const getGetEmployerContactsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerContacts>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerContacts>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerContactsQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerContacts>>> = ({ signal }) => getEmployerContacts(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerContacts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployerContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerContacts>>>
export type GetEmployerContactsQueryError = unknown



export function useGetEmployerContacts<TData = Awaited<ReturnType<typeof getEmployerContacts>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerContacts>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmployerContactsQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const addEmployerContactsToEvent = (
    eventId: number,
    interviewSchedulingAddContactsRequest: InterviewSchedulingAddContactsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number[]>(
      {url: `/interviewSchedulingAdmin/employerContacts/${eventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingAddContactsRequest, signal
    },
      );
    }
  


export const getAddEmployerContactsToEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEmployerContactsToEvent>>, TError,{eventId: number;data: InterviewSchedulingAddContactsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addEmployerContactsToEvent>>, TError,{eventId: number;data: InterviewSchedulingAddContactsRequest}, TContext> => {
    
const mutationKey = ['addEmployerContactsToEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addEmployerContactsToEvent>>, {eventId: number;data: InterviewSchedulingAddContactsRequest}> = (props) => {
          const {eventId,data} = props ?? {};

          return  addEmployerContactsToEvent(eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddEmployerContactsToEventMutationResult = NonNullable<Awaited<ReturnType<typeof addEmployerContactsToEvent>>>
    export type AddEmployerContactsToEventMutationBody = InterviewSchedulingAddContactsRequest
    export type AddEmployerContactsToEventMutationError = unknown

    export const useAddEmployerContactsToEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addEmployerContactsToEvent>>, TError,{eventId: number;data: InterviewSchedulingAddContactsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof addEmployerContactsToEvent>>,
        TError,
        {eventId: number;data: InterviewSchedulingAddContactsRequest},
        TContext
      > => {

      const mutationOptions = getAddEmployerContactsToEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * @summary Submit/Update step 4
 */
export const submitEmployerSettings = (
    employerSettingsRequest: EmployerSettingsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/interviewSchedulingAdmin/employerSettings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: employerSettingsRequest, signal
    },
      );
    }
  


export const getSubmitEmployerSettingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployerSettings>>, TError,{data: EmployerSettingsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitEmployerSettings>>, TError,{data: EmployerSettingsRequest}, TContext> => {
    
const mutationKey = ['submitEmployerSettings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitEmployerSettings>>, {data: EmployerSettingsRequest}> = (props) => {
          const {data} = props ?? {};

          return  submitEmployerSettings(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitEmployerSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof submitEmployerSettings>>>
    export type SubmitEmployerSettingsMutationBody = EmployerSettingsRequest
    export type SubmitEmployerSettingsMutationError = unknown

    /**
 * @summary Submit/Update step 4
 */
export const useSubmitEmployerSettings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployerSettings>>, TError,{data: EmployerSettingsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitEmployerSettings>>,
        TError,
        {data: EmployerSettingsRequest},
        TContext
      > => {

      const mutationOptions = getSubmitEmployerSettingsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * @summary Get existing custom questions for Step 4
 */
export const getEmployerCustomQuestions = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmployerCustomQuestionResponse[]>(
      {url: `/interviewSchedulingAdmin/employerSettings/customQuestions/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEmployerCustomQuestionsQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/employerSettings/customQuestions/${eventId}`] as const;
    }

    
export const getGetEmployerCustomQuestionsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerCustomQuestions>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerCustomQuestions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerCustomQuestionsQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerCustomQuestions>>> = ({ signal }) => getEmployerCustomQuestions(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerCustomQuestions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployerCustomQuestionsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerCustomQuestions>>>
export type GetEmployerCustomQuestionsQueryError = unknown


/**
 * @summary Get existing custom questions for Step 4
 */

export function useGetEmployerCustomQuestions<TData = Awaited<ReturnType<typeof getEmployerCustomQuestions>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerCustomQuestions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmployerCustomQuestionsQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get existing recruitment policy for Step 4
 */
export const getEventUniversityRecruitmentPolicy = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EventUniversityRecruitmentPolicyResponse>(
      {url: `/interviewSchedulingAdmin/employerSettings/recruitmentPolicy/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEventUniversityRecruitmentPolicyQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/employerSettings/recruitmentPolicy/${eventId}`] as const;
    }

    
export const getGetEventUniversityRecruitmentPolicyQueryOptions = <TData = Awaited<ReturnType<typeof getEventUniversityRecruitmentPolicy>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventUniversityRecruitmentPolicy>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventUniversityRecruitmentPolicyQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventUniversityRecruitmentPolicy>>> = ({ signal }) => getEventUniversityRecruitmentPolicy(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventUniversityRecruitmentPolicy>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventUniversityRecruitmentPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof getEventUniversityRecruitmentPolicy>>>
export type GetEventUniversityRecruitmentPolicyQueryError = unknown


/**
 * @summary Get existing recruitment policy for Step 4
 */

export function useGetEventUniversityRecruitmentPolicy<TData = Awaited<ReturnType<typeof getEventUniversityRecruitmentPolicy>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventUniversityRecruitmentPolicy>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventUniversityRecruitmentPolicyQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get existing registration settings for Step 4
 */
export const getEmployerRegistrationSettings = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmployerRegistrationSettingsResponse>(
      {url: `/interviewSchedulingAdmin/employerSettings/registrationSettings/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEmployerRegistrationSettingsQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/employerSettings/registrationSettings/${eventId}`] as const;
    }

    
export const getGetEmployerRegistrationSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerRegistrationSettings>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerRegistrationSettings>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerRegistrationSettingsQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerRegistrationSettings>>> = ({ signal }) => getEmployerRegistrationSettings(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerRegistrationSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployerRegistrationSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerRegistrationSettings>>>
export type GetEmployerRegistrationSettingsQueryError = unknown


/**
 * @summary Get existing registration settings for Step 4
 */

export function useGetEmployerRegistrationSettings<TData = Awaited<ReturnType<typeof getEmployerRegistrationSettings>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerRegistrationSettings>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmployerRegistrationSettingsQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get existing supporting documents for Step 4
 */
export const getSupportingDocuments = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SupportingDocumentResponse[]>(
      {url: `/interviewSchedulingAdmin/employerSettings/supportingDocuments/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetSupportingDocumentsQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/employerSettings/supportingDocuments/${eventId}`] as const;
    }

    
export const getGetSupportingDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getSupportingDocuments>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportingDocuments>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportingDocumentsQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportingDocuments>>> = ({ signal }) => getSupportingDocuments(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupportingDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupportingDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportingDocuments>>>
export type GetSupportingDocumentsQueryError = unknown


/**
 * @summary Get existing supporting documents for Step 4
 */

export function useGetSupportingDocuments<TData = Awaited<ReturnType<typeof getSupportingDocuments>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportingDocuments>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSupportingDocumentsQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * This currently is not wired up to anything, and would require work to trigger the AutoScheduler
 * @summary Confirms the selected Opt-In lottery run
 */
export const confirmInterviewSchedulingMiniLottery = (
    universityEventId: number,
    lotteryRunId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingAdmin/lottery/confirmMiniLottery/${universityEventId}/${lotteryRunId}`, method: 'POST', signal
    },
      );
    }
  


export const getConfirmInterviewSchedulingMiniLotteryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmInterviewSchedulingMiniLottery>>, TError,{universityEventId: number;lotteryRunId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmInterviewSchedulingMiniLottery>>, TError,{universityEventId: number;lotteryRunId: number}, TContext> => {
    
const mutationKey = ['confirmInterviewSchedulingMiniLottery'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmInterviewSchedulingMiniLottery>>, {universityEventId: number;lotteryRunId: number}> = (props) => {
          const {universityEventId,lotteryRunId} = props ?? {};

          return  confirmInterviewSchedulingMiniLottery(universityEventId,lotteryRunId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmInterviewSchedulingMiniLotteryMutationResult = NonNullable<Awaited<ReturnType<typeof confirmInterviewSchedulingMiniLottery>>>
    
    export type ConfirmInterviewSchedulingMiniLotteryMutationError = unknown

    /**
 * @summary Confirms the selected Opt-In lottery run
 */
export const useConfirmInterviewSchedulingMiniLottery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmInterviewSchedulingMiniLottery>>, TError,{universityEventId: number;lotteryRunId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmInterviewSchedulingMiniLottery>>,
        TError,
        {universityEventId: number;lotteryRunId: number},
        TContext
      > => {

      const mutationOptions = getConfirmInterviewSchedulingMiniLotteryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Confirming a lottery run will kickstart the AutoScheduler
 * @summary Confirms the selected lottery run
 */
export const confirmInterviewSchedulingRegularLottery = (
    universityEventId: number,
    lotteryRunId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingAdmin/lottery/confirmRegularLottery/${universityEventId}/${lotteryRunId}`, method: 'POST', signal
    },
      );
    }
  


export const getConfirmInterviewSchedulingRegularLotteryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmInterviewSchedulingRegularLottery>>, TError,{universityEventId: number;lotteryRunId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmInterviewSchedulingRegularLottery>>, TError,{universityEventId: number;lotteryRunId: number}, TContext> => {
    
const mutationKey = ['confirmInterviewSchedulingRegularLottery'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmInterviewSchedulingRegularLottery>>, {universityEventId: number;lotteryRunId: number}> = (props) => {
          const {universityEventId,lotteryRunId} = props ?? {};

          return  confirmInterviewSchedulingRegularLottery(universityEventId,lotteryRunId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmInterviewSchedulingRegularLotteryMutationResult = NonNullable<Awaited<ReturnType<typeof confirmInterviewSchedulingRegularLottery>>>
    
    export type ConfirmInterviewSchedulingRegularLotteryMutationError = unknown

    /**
 * @summary Confirms the selected lottery run
 */
export const useConfirmInterviewSchedulingRegularLottery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmInterviewSchedulingRegularLottery>>, TError,{universityEventId: number;lotteryRunId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmInterviewSchedulingRegularLottery>>,
        TError,
        {universityEventId: number;lotteryRunId: number},
        TContext
      > => {

      const mutationOptions = getConfirmInterviewSchedulingRegularLotteryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * Statuses include `UNCONFIRMED`, `CONFIRMING_IN_PROGRESS`, `CONFIRMING_FINISHED`, `CONFIRMING_FAILED`
 * @summary Returns the current confirm status for a lottery run
 */
export const getInterviewSchedulingLotteryConfirmStatus = (
    universityEventId: number,
    lotteryRunId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetInterviewSchedulingLotteryConfirmStatus200>(
      {url: `/interviewSchedulingAdmin/lottery/confirmStatus/${universityEventId}/${lotteryRunId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingLotteryConfirmStatusQueryKey = (universityEventId: number,
    lotteryRunId: number,) => {
    return [`/interviewSchedulingAdmin/lottery/confirmStatus/${universityEventId}/${lotteryRunId}`] as const;
    }

    
export const getGetInterviewSchedulingLotteryConfirmStatusQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingLotteryConfirmStatus>>, TError = unknown>(universityEventId: number,
    lotteryRunId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingLotteryConfirmStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingLotteryConfirmStatusQueryKey(universityEventId,lotteryRunId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingLotteryConfirmStatus>>> = ({ signal }) => getInterviewSchedulingLotteryConfirmStatus(universityEventId,lotteryRunId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityEventId && lotteryRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingLotteryConfirmStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingLotteryConfirmStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingLotteryConfirmStatus>>>
export type GetInterviewSchedulingLotteryConfirmStatusQueryError = unknown


/**
 * @summary Returns the current confirm status for a lottery run
 */

export function useGetInterviewSchedulingLotteryConfirmStatus<TData = Awaited<ReturnType<typeof getInterviewSchedulingLotteryConfirmStatus>>, TError = unknown>(
 universityEventId: number,
    lotteryRunId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingLotteryConfirmStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingLotteryConfirmStatusQueryOptions(universityEventId,lotteryRunId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Returns lottery results object for an event
 */
export const getInterviewSchedulingLotteryMatches = (
    universityEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingLotteryResultResponse[]>(
      {url: `/interviewSchedulingAdmin/lottery/getLotteryMatches/${universityEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingLotteryMatchesQueryKey = (universityEventId: number,) => {
    return [`/interviewSchedulingAdmin/lottery/getLotteryMatches/${universityEventId}`] as const;
    }

    
export const getGetInterviewSchedulingLotteryMatchesQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingLotteryMatches>>, TError = unknown>(universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingLotteryMatches>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingLotteryMatchesQueryKey(universityEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingLotteryMatches>>> = ({ signal }) => getInterviewSchedulingLotteryMatches(universityEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingLotteryMatches>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingLotteryMatchesQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingLotteryMatches>>>
export type GetInterviewSchedulingLotteryMatchesQueryError = unknown


/**
 * @summary Returns lottery results object for an event
 */

export function useGetInterviewSchedulingLotteryMatches<TData = Awaited<ReturnType<typeof getInterviewSchedulingLotteryMatches>>, TError = unknown>(
 universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingLotteryMatches>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingLotteryMatchesQueryOptions(universityEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Currently not used anywhere in the frontend
 * @summary Return a response object of all statuses for an event
 */
export const getInterviewSchedulingLotteryStatusSummary = (
    universityEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingLotteryStatusSummaryResponse>(
      {url: `/interviewSchedulingAdmin/lottery/getLotteryStatusSummary/${universityEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingLotteryStatusSummaryQueryKey = (universityEventId: number,) => {
    return [`/interviewSchedulingAdmin/lottery/getLotteryStatusSummary/${universityEventId}`] as const;
    }

    
export const getGetInterviewSchedulingLotteryStatusSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingLotteryStatusSummary>>, TError = unknown>(universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingLotteryStatusSummary>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingLotteryStatusSummaryQueryKey(universityEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingLotteryStatusSummary>>> = ({ signal }) => getInterviewSchedulingLotteryStatusSummary(universityEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingLotteryStatusSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingLotteryStatusSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingLotteryStatusSummary>>>
export type GetInterviewSchedulingLotteryStatusSummaryQueryError = unknown


/**
 * @summary Return a response object of all statuses for an event
 */

export function useGetInterviewSchedulingLotteryStatusSummary<TData = Awaited<ReturnType<typeof getInterviewSchedulingLotteryStatusSummary>>, TError = unknown>(
 universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingLotteryStatusSummary>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingLotteryStatusSummaryQueryOptions(universityEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Statuses include `NOT_STARTED`, `RUNNING`, `FAILED`, `COMPLETE`
 * @summary Returns the current status of a lottery run
 */
export const getInterviewSchedulingLotteryRunStatus = (
    universityEventId: number,
    lotteryRunId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetInterviewSchedulingLotteryRunStatus200>(
      {url: `/interviewSchedulingAdmin/lottery/runStatus/${universityEventId}/${lotteryRunId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingLotteryRunStatusQueryKey = (universityEventId: number,
    lotteryRunId: number,) => {
    return [`/interviewSchedulingAdmin/lottery/runStatus/${universityEventId}/${lotteryRunId}`] as const;
    }

    
export const getGetInterviewSchedulingLotteryRunStatusQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingLotteryRunStatus>>, TError = unknown>(universityEventId: number,
    lotteryRunId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingLotteryRunStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingLotteryRunStatusQueryKey(universityEventId,lotteryRunId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingLotteryRunStatus>>> = ({ signal }) => getInterviewSchedulingLotteryRunStatus(universityEventId,lotteryRunId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityEventId && lotteryRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingLotteryRunStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingLotteryRunStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingLotteryRunStatus>>>
export type GetInterviewSchedulingLotteryRunStatusQueryError = unknown


/**
 * @summary Returns the current status of a lottery run
 */

export function useGetInterviewSchedulingLotteryRunStatus<TData = Awaited<ReturnType<typeof getInterviewSchedulingLotteryRunStatus>>, TError = unknown>(
 universityEventId: number,
    lotteryRunId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingLotteryRunStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingLotteryRunStatusQueryOptions(universityEventId,lotteryRunId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary This endpoint would be used to run the opt-in lottery
 */
export const startInterviewSchedulingMiniLottery = (
    universityEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/interviewSchedulingAdmin/lottery/startMiniLottery/${universityEventId}`, method: 'POST', signal
    },
      );
    }
  


export const getStartInterviewSchedulingMiniLotteryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startInterviewSchedulingMiniLottery>>, TError,{universityEventId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof startInterviewSchedulingMiniLottery>>, TError,{universityEventId: number}, TContext> => {
    
const mutationKey = ['startInterviewSchedulingMiniLottery'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startInterviewSchedulingMiniLottery>>, {universityEventId: number}> = (props) => {
          const {universityEventId} = props ?? {};

          return  startInterviewSchedulingMiniLottery(universityEventId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartInterviewSchedulingMiniLotteryMutationResult = NonNullable<Awaited<ReturnType<typeof startInterviewSchedulingMiniLottery>>>
    
    export type StartInterviewSchedulingMiniLotteryMutationError = unknown

    /**
 * @summary This endpoint would be used to run the opt-in lottery
 */
export const useStartInterviewSchedulingMiniLottery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startInterviewSchedulingMiniLottery>>, TError,{universityEventId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof startInterviewSchedulingMiniLottery>>,
        TError,
        {universityEventId: number},
        TContext
      > => {

      const mutationOptions = getStartInterviewSchedulingMiniLotteryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * This action can be ran a total of three times
 * @summary Runs the "regular" lottery, which is different from the opt-in/mini lottery
 */
export const startInterviewSchedulingRegularLottery = (
    universityEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/interviewSchedulingAdmin/lottery/startRegularLottery/${universityEventId}`, method: 'POST', signal
    },
      );
    }
  


export const getStartInterviewSchedulingRegularLotteryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startInterviewSchedulingRegularLottery>>, TError,{universityEventId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof startInterviewSchedulingRegularLottery>>, TError,{universityEventId: number}, TContext> => {
    
const mutationKey = ['startInterviewSchedulingRegularLottery'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startInterviewSchedulingRegularLottery>>, {universityEventId: number}> = (props) => {
          const {universityEventId} = props ?? {};

          return  startInterviewSchedulingRegularLottery(universityEventId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartInterviewSchedulingRegularLotteryMutationResult = NonNullable<Awaited<ReturnType<typeof startInterviewSchedulingRegularLottery>>>
    
    export type StartInterviewSchedulingRegularLotteryMutationError = unknown

    /**
 * @summary Runs the "regular" lottery, which is different from the opt-in/mini lottery
 */
export const useStartInterviewSchedulingRegularLottery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startInterviewSchedulingRegularLottery>>, TError,{universityEventId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof startInterviewSchedulingRegularLottery>>,
        TError,
        {universityEventId: number},
        TContext
      > => {

      const mutationOptions = getStartInterviewSchedulingRegularLotteryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const manuallyRegisterEmployerForInterviewSchedulingEvent = (
    universityEventId: number,
    universityManuallyAddEmployerRequest: UniversityManuallyAddEmployerRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/manualRegistration/employer/${universityEventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: universityManuallyAddEmployerRequest, signal
    },
      );
    }
  


export const getManuallyRegisterEmployerForInterviewSchedulingEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof manuallyRegisterEmployerForInterviewSchedulingEvent>>, TError,{universityEventId: number;data: UniversityManuallyAddEmployerRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof manuallyRegisterEmployerForInterviewSchedulingEvent>>, TError,{universityEventId: number;data: UniversityManuallyAddEmployerRequest}, TContext> => {
    
const mutationKey = ['manuallyRegisterEmployerForInterviewSchedulingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof manuallyRegisterEmployerForInterviewSchedulingEvent>>, {universityEventId: number;data: UniversityManuallyAddEmployerRequest}> = (props) => {
          const {universityEventId,data} = props ?? {};

          return  manuallyRegisterEmployerForInterviewSchedulingEvent(universityEventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ManuallyRegisterEmployerForInterviewSchedulingEventMutationResult = NonNullable<Awaited<ReturnType<typeof manuallyRegisterEmployerForInterviewSchedulingEvent>>>
    export type ManuallyRegisterEmployerForInterviewSchedulingEventMutationBody = UniversityManuallyAddEmployerRequest
    export type ManuallyRegisterEmployerForInterviewSchedulingEventMutationError = unknown

    export const useManuallyRegisterEmployerForInterviewSchedulingEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof manuallyRegisterEmployerForInterviewSchedulingEvent>>, TError,{universityEventId: number;data: UniversityManuallyAddEmployerRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof manuallyRegisterEmployerForInterviewSchedulingEvent>>,
        TError,
        {universityEventId: number;data: UniversityManuallyAddEmployerRequest},
        TContext
      > => {

      const mutationOptions = getManuallyRegisterEmployerForInterviewSchedulingEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const manuallyRegisterStudentForInterviewSchedulingEvent = (
    universityEventId: number,
    universityManuallyAddStudentRequest: UniversityManuallyAddStudentRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/manualRegistration/student/${universityEventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: universityManuallyAddStudentRequest, signal
    },
      );
    }
  


export const getManuallyRegisterStudentForInterviewSchedulingEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof manuallyRegisterStudentForInterviewSchedulingEvent>>, TError,{universityEventId: number;data: UniversityManuallyAddStudentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof manuallyRegisterStudentForInterviewSchedulingEvent>>, TError,{universityEventId: number;data: UniversityManuallyAddStudentRequest}, TContext> => {
    
const mutationKey = ['manuallyRegisterStudentForInterviewSchedulingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof manuallyRegisterStudentForInterviewSchedulingEvent>>, {universityEventId: number;data: UniversityManuallyAddStudentRequest}> = (props) => {
          const {universityEventId,data} = props ?? {};

          return  manuallyRegisterStudentForInterviewSchedulingEvent(universityEventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ManuallyRegisterStudentForInterviewSchedulingEventMutationResult = NonNullable<Awaited<ReturnType<typeof manuallyRegisterStudentForInterviewSchedulingEvent>>>
    export type ManuallyRegisterStudentForInterviewSchedulingEventMutationBody = UniversityManuallyAddStudentRequest
    export type ManuallyRegisterStudentForInterviewSchedulingEventMutationError = unknown

    export const useManuallyRegisterStudentForInterviewSchedulingEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof manuallyRegisterStudentForInterviewSchedulingEvent>>, TError,{universityEventId: number;data: UniversityManuallyAddStudentRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof manuallyRegisterStudentForInterviewSchedulingEvent>>,
        TError,
        {universityEventId: number;data: UniversityManuallyAddStudentRequest},
        TContext
      > => {

      const mutationOptions = getManuallyRegisterStudentForInterviewSchedulingEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getRegistrationLinks = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<RegistrationLinksResponse>(
      {url: `/interviewSchedulingAdmin/registrationLinks/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetRegistrationLinksQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/registrationLinks/${eventId}`] as const;
    }

    
export const getGetRegistrationLinksQueryOptions = <TData = Awaited<ReturnType<typeof getRegistrationLinks>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistrationLinks>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistrationLinksQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistrationLinks>>> = ({ signal }) => getRegistrationLinks(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegistrationLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegistrationLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistrationLinks>>>
export type GetRegistrationLinksQueryError = unknown



export function useGetRegistrationLinks<TData = Awaited<ReturnType<typeof getRegistrationLinks>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistrationLinks>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRegistrationLinksQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const cancelInterviewSchedulingAutoScheduler = (
    universityEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingAdmin/scheduler/cancel/${universityEventId}`, method: 'POST', signal
    },
      );
    }
  


export const getCancelInterviewSchedulingAutoSchedulerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelInterviewSchedulingAutoScheduler>>, TError,{universityEventId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelInterviewSchedulingAutoScheduler>>, TError,{universityEventId: number}, TContext> => {
    
const mutationKey = ['cancelInterviewSchedulingAutoScheduler'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelInterviewSchedulingAutoScheduler>>, {universityEventId: number}> = (props) => {
          const {universityEventId} = props ?? {};

          return  cancelInterviewSchedulingAutoScheduler(universityEventId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelInterviewSchedulingAutoSchedulerMutationResult = NonNullable<Awaited<ReturnType<typeof cancelInterviewSchedulingAutoScheduler>>>
    
    export type CancelInterviewSchedulingAutoSchedulerMutationError = unknown

    export const useCancelInterviewSchedulingAutoScheduler = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelInterviewSchedulingAutoScheduler>>, TError,{universityEventId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelInterviewSchedulingAutoScheduler>>,
        TError,
        {universityEventId: number},
        TContext
      > => {

      const mutationOptions = getCancelInterviewSchedulingAutoSchedulerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const emailInterviewSchedulingCandidateSchedulesToOthers = (
    universityEventId: number,
    interviewSchedulingUniversitySendEmailsToOthersRequest: InterviewSchedulingUniversitySendEmailsToOthersRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/scheduler/emailCandidateSchedulesToOthers/${universityEventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingUniversitySendEmailsToOthersRequest, signal
    },
      );
    }
  


export const getEmailInterviewSchedulingCandidateSchedulesToOthersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailInterviewSchedulingCandidateSchedulesToOthers>>, TError,{universityEventId: number;data: InterviewSchedulingUniversitySendEmailsToOthersRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof emailInterviewSchedulingCandidateSchedulesToOthers>>, TError,{universityEventId: number;data: InterviewSchedulingUniversitySendEmailsToOthersRequest}, TContext> => {
    
const mutationKey = ['emailInterviewSchedulingCandidateSchedulesToOthers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof emailInterviewSchedulingCandidateSchedulesToOthers>>, {universityEventId: number;data: InterviewSchedulingUniversitySendEmailsToOthersRequest}> = (props) => {
          const {universityEventId,data} = props ?? {};

          return  emailInterviewSchedulingCandidateSchedulesToOthers(universityEventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EmailInterviewSchedulingCandidateSchedulesToOthersMutationResult = NonNullable<Awaited<ReturnType<typeof emailInterviewSchedulingCandidateSchedulesToOthers>>>
    export type EmailInterviewSchedulingCandidateSchedulesToOthersMutationBody = InterviewSchedulingUniversitySendEmailsToOthersRequest
    export type EmailInterviewSchedulingCandidateSchedulesToOthersMutationError = unknown

    export const useEmailInterviewSchedulingCandidateSchedulesToOthers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailInterviewSchedulingCandidateSchedulesToOthers>>, TError,{universityEventId: number;data: InterviewSchedulingUniversitySendEmailsToOthersRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof emailInterviewSchedulingCandidateSchedulesToOthers>>,
        TError,
        {universityEventId: number;data: InterviewSchedulingUniversitySendEmailsToOthersRequest},
        TContext
      > => {

      const mutationOptions = getEmailInterviewSchedulingCandidateSchedulesToOthersMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const emailInterviewSchedulingInterviewerSchedulesToOthers = (
    universityEventId: number,
    interviewSchedulingUniversitySendEmailsToOthersRequest: InterviewSchedulingUniversitySendEmailsToOthersRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/scheduler/emailInterviewerSchedulesToOthers/${universityEventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingUniversitySendEmailsToOthersRequest, signal
    },
      );
    }
  


export const getEmailInterviewSchedulingInterviewerSchedulesToOthersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailInterviewSchedulingInterviewerSchedulesToOthers>>, TError,{universityEventId: number;data: InterviewSchedulingUniversitySendEmailsToOthersRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof emailInterviewSchedulingInterviewerSchedulesToOthers>>, TError,{universityEventId: number;data: InterviewSchedulingUniversitySendEmailsToOthersRequest}, TContext> => {
    
const mutationKey = ['emailInterviewSchedulingInterviewerSchedulesToOthers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof emailInterviewSchedulingInterviewerSchedulesToOthers>>, {universityEventId: number;data: InterviewSchedulingUniversitySendEmailsToOthersRequest}> = (props) => {
          const {universityEventId,data} = props ?? {};

          return  emailInterviewSchedulingInterviewerSchedulesToOthers(universityEventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EmailInterviewSchedulingInterviewerSchedulesToOthersMutationResult = NonNullable<Awaited<ReturnType<typeof emailInterviewSchedulingInterviewerSchedulesToOthers>>>
    export type EmailInterviewSchedulingInterviewerSchedulesToOthersMutationBody = InterviewSchedulingUniversitySendEmailsToOthersRequest
    export type EmailInterviewSchedulingInterviewerSchedulesToOthersMutationError = unknown

    export const useEmailInterviewSchedulingInterviewerSchedulesToOthers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailInterviewSchedulingInterviewerSchedulesToOthers>>, TError,{universityEventId: number;data: InterviewSchedulingUniversitySendEmailsToOthersRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof emailInterviewSchedulingInterviewerSchedulesToOthers>>,
        TError,
        {universityEventId: number;data: InterviewSchedulingUniversitySendEmailsToOthersRequest},
        TContext
      > => {

      const mutationOptions = getEmailInterviewSchedulingInterviewerSchedulesToOthersMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getInterviewSchedulingVideoChatLinks = (
    universityEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingUniversityLinksResponse>(
      {url: `/interviewSchedulingAdmin/scheduler/links/${universityEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingVideoChatLinksQueryKey = (universityEventId: number,) => {
    return [`/interviewSchedulingAdmin/scheduler/links/${universityEventId}`] as const;
    }

    
export const getGetInterviewSchedulingVideoChatLinksQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingVideoChatLinks>>, TError = unknown>(universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingVideoChatLinks>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingVideoChatLinksQueryKey(universityEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingVideoChatLinks>>> = ({ signal }) => getInterviewSchedulingVideoChatLinks(universityEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingVideoChatLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingVideoChatLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingVideoChatLinks>>>
export type GetInterviewSchedulingVideoChatLinksQueryError = unknown



export function useGetInterviewSchedulingVideoChatLinks<TData = Awaited<ReturnType<typeof getInterviewSchedulingVideoChatLinks>>, TError = unknown>(
 universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingVideoChatLinks>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingVideoChatLinksQueryOptions(universityEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getNotificationStatusesForInterviewSchedulingEvent = (
    universityEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingNotificationStatusesResponse>(
      {url: `/interviewSchedulingAdmin/scheduler/notifications/${universityEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetNotificationStatusesForInterviewSchedulingEventQueryKey = (universityEventId: number,) => {
    return [`/interviewSchedulingAdmin/scheduler/notifications/${universityEventId}`] as const;
    }

    
export const getGetNotificationStatusesForInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationStatusesForInterviewSchedulingEvent>>, TError = unknown>(universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationStatusesForInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationStatusesForInterviewSchedulingEventQueryKey(universityEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationStatusesForInterviewSchedulingEvent>>> = ({ signal }) => getNotificationStatusesForInterviewSchedulingEvent(universityEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationStatusesForInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationStatusesForInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationStatusesForInterviewSchedulingEvent>>>
export type GetNotificationStatusesForInterviewSchedulingEventQueryError = unknown



export function useGetNotificationStatusesForInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof getNotificationStatusesForInterviewSchedulingEvent>>, TError = unknown>(
 universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationStatusesForInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetNotificationStatusesForInterviewSchedulingEventQueryOptions(universityEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const notifyInterviewSchedulingCandidates = (
    universityEventId: number,
    interviewSchedulingUniversityNotifyIdsRequest: InterviewSchedulingUniversityNotifyIdsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/scheduler/notifyCandidates/${universityEventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingUniversityNotifyIdsRequest, signal
    },
      );
    }
  


export const getNotifyInterviewSchedulingCandidatesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyInterviewSchedulingCandidates>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityNotifyIdsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notifyInterviewSchedulingCandidates>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityNotifyIdsRequest}, TContext> => {
    
const mutationKey = ['notifyInterviewSchedulingCandidates'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notifyInterviewSchedulingCandidates>>, {universityEventId: number;data: InterviewSchedulingUniversityNotifyIdsRequest}> = (props) => {
          const {universityEventId,data} = props ?? {};

          return  notifyInterviewSchedulingCandidates(universityEventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotifyInterviewSchedulingCandidatesMutationResult = NonNullable<Awaited<ReturnType<typeof notifyInterviewSchedulingCandidates>>>
    export type NotifyInterviewSchedulingCandidatesMutationBody = InterviewSchedulingUniversityNotifyIdsRequest
    export type NotifyInterviewSchedulingCandidatesMutationError = unknown

    export const useNotifyInterviewSchedulingCandidates = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyInterviewSchedulingCandidates>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityNotifyIdsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof notifyInterviewSchedulingCandidates>>,
        TError,
        {universityEventId: number;data: InterviewSchedulingUniversityNotifyIdsRequest},
        TContext
      > => {

      const mutationOptions = getNotifyInterviewSchedulingCandidatesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const notifyInterviewSchedulingGroup = (
    universityEventId: number,
    interviewSchedulingUniversityNotifyGroupRequest: InterviewSchedulingUniversityNotifyGroupRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/scheduler/notifyGroup/${universityEventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingUniversityNotifyGroupRequest, signal
    },
      );
    }
  


export const getNotifyInterviewSchedulingGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyInterviewSchedulingGroup>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityNotifyGroupRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notifyInterviewSchedulingGroup>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityNotifyGroupRequest}, TContext> => {
    
const mutationKey = ['notifyInterviewSchedulingGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notifyInterviewSchedulingGroup>>, {universityEventId: number;data: InterviewSchedulingUniversityNotifyGroupRequest}> = (props) => {
          const {universityEventId,data} = props ?? {};

          return  notifyInterviewSchedulingGroup(universityEventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotifyInterviewSchedulingGroupMutationResult = NonNullable<Awaited<ReturnType<typeof notifyInterviewSchedulingGroup>>>
    export type NotifyInterviewSchedulingGroupMutationBody = InterviewSchedulingUniversityNotifyGroupRequest
    export type NotifyInterviewSchedulingGroupMutationError = unknown

    export const useNotifyInterviewSchedulingGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyInterviewSchedulingGroup>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityNotifyGroupRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof notifyInterviewSchedulingGroup>>,
        TError,
        {universityEventId: number;data: InterviewSchedulingUniversityNotifyGroupRequest},
        TContext
      > => {

      const mutationOptions = getNotifyInterviewSchedulingGroupMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const notifyInterviewSchedulingInterviewers = (
    universityEventId: number,
    interviewSchedulingUniversityNotifyIdsRequest: InterviewSchedulingUniversityNotifyIdsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/scheduler/notifyInterviewers/${universityEventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingUniversityNotifyIdsRequest, signal
    },
      );
    }
  


export const getNotifyInterviewSchedulingInterviewersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyInterviewSchedulingInterviewers>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityNotifyIdsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notifyInterviewSchedulingInterviewers>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityNotifyIdsRequest}, TContext> => {
    
const mutationKey = ['notifyInterviewSchedulingInterviewers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notifyInterviewSchedulingInterviewers>>, {universityEventId: number;data: InterviewSchedulingUniversityNotifyIdsRequest}> = (props) => {
          const {universityEventId,data} = props ?? {};

          return  notifyInterviewSchedulingInterviewers(universityEventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotifyInterviewSchedulingInterviewersMutationResult = NonNullable<Awaited<ReturnType<typeof notifyInterviewSchedulingInterviewers>>>
    export type NotifyInterviewSchedulingInterviewersMutationBody = InterviewSchedulingUniversityNotifyIdsRequest
    export type NotifyInterviewSchedulingInterviewersMutationError = unknown

    export const useNotifyInterviewSchedulingInterviewers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyInterviewSchedulingInterviewers>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityNotifyIdsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof notifyInterviewSchedulingInterviewers>>,
        TError,
        {universityEventId: number;data: InterviewSchedulingUniversityNotifyIdsRequest},
        TContext
      > => {

      const mutationOptions = getNotifyInterviewSchedulingInterviewersMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const notifyInterviewSchedulingSchedules = (
    universityEventId: number,
    interviewSchedulingUniversityNotifySchedulesFinalScheduleRequest: InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/scheduler/notifySchedules/${universityEventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingUniversityNotifySchedulesFinalScheduleRequest, signal
    },
      );
    }
  


export const getNotifyInterviewSchedulingSchedulesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyInterviewSchedulingSchedules>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notifyInterviewSchedulingSchedules>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequest}, TContext> => {
    
const mutationKey = ['notifyInterviewSchedulingSchedules'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notifyInterviewSchedulingSchedules>>, {universityEventId: number;data: InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequest}> = (props) => {
          const {universityEventId,data} = props ?? {};

          return  notifyInterviewSchedulingSchedules(universityEventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotifyInterviewSchedulingSchedulesMutationResult = NonNullable<Awaited<ReturnType<typeof notifyInterviewSchedulingSchedules>>>
    export type NotifyInterviewSchedulingSchedulesMutationBody = InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequest
    export type NotifyInterviewSchedulingSchedulesMutationError = unknown

    export const useNotifyInterviewSchedulingSchedules = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyInterviewSchedulingSchedules>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof notifyInterviewSchedulingSchedules>>,
        TError,
        {universityEventId: number;data: InterviewSchedulingUniversityNotifySchedulesFinalScheduleRequest},
        TContext
      > => {

      const mutationOptions = getNotifyInterviewSchedulingSchedulesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const startInterviewSchedulingAutoScheduler = (
    universityEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingAdmin/scheduler/start/${universityEventId}`, method: 'POST', signal
    },
      );
    }
  


export const getStartInterviewSchedulingAutoSchedulerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startInterviewSchedulingAutoScheduler>>, TError,{universityEventId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof startInterviewSchedulingAutoScheduler>>, TError,{universityEventId: number}, TContext> => {
    
const mutationKey = ['startInterviewSchedulingAutoScheduler'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startInterviewSchedulingAutoScheduler>>, {universityEventId: number}> = (props) => {
          const {universityEventId} = props ?? {};

          return  startInterviewSchedulingAutoScheduler(universityEventId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartInterviewSchedulingAutoSchedulerMutationResult = NonNullable<Awaited<ReturnType<typeof startInterviewSchedulingAutoScheduler>>>
    
    export type StartInterviewSchedulingAutoSchedulerMutationError = unknown

    export const useStartInterviewSchedulingAutoScheduler = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startInterviewSchedulingAutoScheduler>>, TError,{universityEventId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof startInterviewSchedulingAutoScheduler>>,
        TError,
        {universityEventId: number},
        TContext
      > => {

      const mutationOptions = getStartInterviewSchedulingAutoSchedulerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getInterviewSchedulingAutoSchedulerStatus = (
    universityEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetInterviewSchedulingAutoSchedulerStatus200>(
      {url: `/interviewSchedulingAdmin/scheduler/status/${universityEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingAutoSchedulerStatusQueryKey = (universityEventId: number,) => {
    return [`/interviewSchedulingAdmin/scheduler/status/${universityEventId}`] as const;
    }

    
export const getGetInterviewSchedulingAutoSchedulerStatusQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingAutoSchedulerStatus>>, TError = unknown>(universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingAutoSchedulerStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingAutoSchedulerStatusQueryKey(universityEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingAutoSchedulerStatus>>> = ({ signal }) => getInterviewSchedulingAutoSchedulerStatus(universityEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingAutoSchedulerStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingAutoSchedulerStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingAutoSchedulerStatus>>>
export type GetInterviewSchedulingAutoSchedulerStatusQueryError = unknown



export function useGetInterviewSchedulingAutoSchedulerStatus<TData = Awaited<ReturnType<typeof getInterviewSchedulingAutoSchedulerStatus>>, TError = unknown>(
 universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingAutoSchedulerStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingAutoSchedulerStatusQueryOptions(universityEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const assignUniversityInterviewSchedulingEmployerSchedules = (
    universityEventId: number,
    interviewSchedulingUniversityEmployerAssignSchedulesRequest: InterviewSchedulingUniversityEmployerAssignSchedulesRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/schedules/assignments/assignSchedules/${universityEventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingUniversityEmployerAssignSchedulesRequest, signal
    },
      );
    }
  


export const getAssignUniversityInterviewSchedulingEmployerSchedulesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignUniversityInterviewSchedulingEmployerSchedules>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityEmployerAssignSchedulesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof assignUniversityInterviewSchedulingEmployerSchedules>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityEmployerAssignSchedulesRequest}, TContext> => {
    
const mutationKey = ['assignUniversityInterviewSchedulingEmployerSchedules'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignUniversityInterviewSchedulingEmployerSchedules>>, {universityEventId: number;data: InterviewSchedulingUniversityEmployerAssignSchedulesRequest}> = (props) => {
          const {universityEventId,data} = props ?? {};

          return  assignUniversityInterviewSchedulingEmployerSchedules(universityEventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssignUniversityInterviewSchedulingEmployerSchedulesMutationResult = NonNullable<Awaited<ReturnType<typeof assignUniversityInterviewSchedulingEmployerSchedules>>>
    export type AssignUniversityInterviewSchedulingEmployerSchedulesMutationBody = InterviewSchedulingUniversityEmployerAssignSchedulesRequest
    export type AssignUniversityInterviewSchedulingEmployerSchedulesMutationError = unknown

    export const useAssignUniversityInterviewSchedulingEmployerSchedules = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignUniversityInterviewSchedulingEmployerSchedules>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityEmployerAssignSchedulesRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignUniversityInterviewSchedulingEmployerSchedules>>,
        TError,
        {universityEventId: number;data: InterviewSchedulingUniversityEmployerAssignSchedulesRequest},
        TContext
      > => {

      const mutationOptions = getAssignUniversityInterviewSchedulingEmployerSchedulesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getUniversityInterviewSchedulingEmployerScheduleAssignments = (
    universityEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingUniversityEmployerScheduleAssignmentResponse[]>(
      {url: `/interviewSchedulingAdmin/schedules/assignments/assignedSchedules/${universityEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUniversityInterviewSchedulingEmployerScheduleAssignmentsQueryKey = (universityEventId: number,) => {
    return [`/interviewSchedulingAdmin/schedules/assignments/assignedSchedules/${universityEventId}`] as const;
    }

    
export const getGetUniversityInterviewSchedulingEmployerScheduleAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerScheduleAssignments>>, TError = unknown>(universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerScheduleAssignments>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUniversityInterviewSchedulingEmployerScheduleAssignmentsQueryKey(universityEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerScheduleAssignments>>> = ({ signal }) => getUniversityInterviewSchedulingEmployerScheduleAssignments(universityEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerScheduleAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUniversityInterviewSchedulingEmployerScheduleAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerScheduleAssignments>>>
export type GetUniversityInterviewSchedulingEmployerScheduleAssignmentsQueryError = unknown



export function useGetUniversityInterviewSchedulingEmployerScheduleAssignments<TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerScheduleAssignments>>, TError = unknown>(
 universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerScheduleAssignments>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUniversityInterviewSchedulingEmployerScheduleAssignmentsQueryOptions(universityEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUniversityInterviewSchedulingEmployerScheduleNotifications = (
    universityEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingUniversityEmployerScheduleNotificationResponse[]>(
      {url: `/interviewSchedulingAdmin/schedules/assignments/notifiedSchedules/${universityEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUniversityInterviewSchedulingEmployerScheduleNotificationsQueryKey = (universityEventId: number,) => {
    return [`/interviewSchedulingAdmin/schedules/assignments/notifiedSchedules/${universityEventId}`] as const;
    }

    
export const getGetUniversityInterviewSchedulingEmployerScheduleNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerScheduleNotifications>>, TError = unknown>(universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerScheduleNotifications>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUniversityInterviewSchedulingEmployerScheduleNotificationsQueryKey(universityEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerScheduleNotifications>>> = ({ signal }) => getUniversityInterviewSchedulingEmployerScheduleNotifications(universityEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerScheduleNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUniversityInterviewSchedulingEmployerScheduleNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerScheduleNotifications>>>
export type GetUniversityInterviewSchedulingEmployerScheduleNotificationsQueryError = unknown



export function useGetUniversityInterviewSchedulingEmployerScheduleNotifications<TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerScheduleNotifications>>, TError = unknown>(
 universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerScheduleNotifications>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUniversityInterviewSchedulingEmployerScheduleNotificationsQueryOptions(universityEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sendNotificationsForUniversityInterviewSchedulingEmployerSchedules = (
    universityEventId: number,
    interviewSchedulingUniversityEmployerNotifySchedulesRequest: InterviewSchedulingUniversityEmployerNotifySchedulesRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/schedules/assignments/sendNotifications/${universityEventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingUniversityEmployerNotifySchedulesRequest, signal
    },
      );
    }
  


export const getSendNotificationsForUniversityInterviewSchedulingEmployerSchedulesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendNotificationsForUniversityInterviewSchedulingEmployerSchedules>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityEmployerNotifySchedulesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendNotificationsForUniversityInterviewSchedulingEmployerSchedules>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityEmployerNotifySchedulesRequest}, TContext> => {
    
const mutationKey = ['sendNotificationsForUniversityInterviewSchedulingEmployerSchedules'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendNotificationsForUniversityInterviewSchedulingEmployerSchedules>>, {universityEventId: number;data: InterviewSchedulingUniversityEmployerNotifySchedulesRequest}> = (props) => {
          const {universityEventId,data} = props ?? {};

          return  sendNotificationsForUniversityInterviewSchedulingEmployerSchedules(universityEventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendNotificationsForUniversityInterviewSchedulingEmployerSchedulesMutationResult = NonNullable<Awaited<ReturnType<typeof sendNotificationsForUniversityInterviewSchedulingEmployerSchedules>>>
    export type SendNotificationsForUniversityInterviewSchedulingEmployerSchedulesMutationBody = InterviewSchedulingUniversityEmployerNotifySchedulesRequest
    export type SendNotificationsForUniversityInterviewSchedulingEmployerSchedulesMutationError = unknown

    export const useSendNotificationsForUniversityInterviewSchedulingEmployerSchedules = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendNotificationsForUniversityInterviewSchedulingEmployerSchedules>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityEmployerNotifySchedulesRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendNotificationsForUniversityInterviewSchedulingEmployerSchedules>>,
        TError,
        {universityEventId: number;data: InterviewSchedulingUniversityEmployerNotifySchedulesRequest},
        TContext
      > => {

      const mutationOptions = getSendNotificationsForUniversityInterviewSchedulingEmployerSchedulesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const unassignUniversityInterviewSchedulingEmployerSchedules = (
    universityEventId: number,
    interviewSchedulingUniversityEmployerUnassignSchedulesRequest: InterviewSchedulingUniversityEmployerUnassignSchedulesRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/schedules/assignments/unassignSchedules/${universityEventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingUniversityEmployerUnassignSchedulesRequest, signal
    },
      );
    }
  


export const getUnassignUniversityInterviewSchedulingEmployerSchedulesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignUniversityInterviewSchedulingEmployerSchedules>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityEmployerUnassignSchedulesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unassignUniversityInterviewSchedulingEmployerSchedules>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityEmployerUnassignSchedulesRequest}, TContext> => {
    
const mutationKey = ['unassignUniversityInterviewSchedulingEmployerSchedules'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unassignUniversityInterviewSchedulingEmployerSchedules>>, {universityEventId: number;data: InterviewSchedulingUniversityEmployerUnassignSchedulesRequest}> = (props) => {
          const {universityEventId,data} = props ?? {};

          return  unassignUniversityInterviewSchedulingEmployerSchedules(universityEventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnassignUniversityInterviewSchedulingEmployerSchedulesMutationResult = NonNullable<Awaited<ReturnType<typeof unassignUniversityInterviewSchedulingEmployerSchedules>>>
    export type UnassignUniversityInterviewSchedulingEmployerSchedulesMutationBody = InterviewSchedulingUniversityEmployerUnassignSchedulesRequest
    export type UnassignUniversityInterviewSchedulingEmployerSchedulesMutationError = unknown

    export const useUnassignUniversityInterviewSchedulingEmployerSchedules = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignUniversityInterviewSchedulingEmployerSchedules>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityEmployerUnassignSchedulesRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof unassignUniversityInterviewSchedulingEmployerSchedules>>,
        TError,
        {universityEventId: number;data: InterviewSchedulingUniversityEmployerUnassignSchedulesRequest},
        TContext
      > => {

      const mutationOptions = getUnassignUniversityInterviewSchedulingEmployerSchedulesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getUniversityInterviewSchedulingEmployerSchedulesForAssignmentPage = (
    universityEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingUniversityEmployerScheduleOverviewResponse[]>(
      {url: `/interviewSchedulingAdmin/schedules/assignments/${universityEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUniversityInterviewSchedulingEmployerSchedulesForAssignmentPageQueryKey = (universityEventId: number,) => {
    return [`/interviewSchedulingAdmin/schedules/assignments/${universityEventId}`] as const;
    }

    
export const getGetUniversityInterviewSchedulingEmployerSchedulesForAssignmentPageQueryOptions = <TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerSchedulesForAssignmentPage>>, TError = unknown>(universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerSchedulesForAssignmentPage>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUniversityInterviewSchedulingEmployerSchedulesForAssignmentPageQueryKey(universityEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerSchedulesForAssignmentPage>>> = ({ signal }) => getUniversityInterviewSchedulingEmployerSchedulesForAssignmentPage(universityEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerSchedulesForAssignmentPage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUniversityInterviewSchedulingEmployerSchedulesForAssignmentPageQueryResult = NonNullable<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerSchedulesForAssignmentPage>>>
export type GetUniversityInterviewSchedulingEmployerSchedulesForAssignmentPageQueryError = unknown



export function useGetUniversityInterviewSchedulingEmployerSchedulesForAssignmentPage<TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerSchedulesForAssignmentPage>>, TError = unknown>(
 universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerSchedulesForAssignmentPage>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUniversityInterviewSchedulingEmployerSchedulesForAssignmentPageQueryOptions(universityEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUniversityInterviewSchedulingEmployerSchedulesWithAssignments = (
    universityEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingUniversityEmployerScheduleWithAssignmentResponse[]>(
      {url: `/interviewSchedulingAdmin/schedules/schedulesWithAssignments/${universityEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUniversityInterviewSchedulingEmployerSchedulesWithAssignmentsQueryKey = (universityEventId: number,) => {
    return [`/interviewSchedulingAdmin/schedules/schedulesWithAssignments/${universityEventId}`] as const;
    }

    
export const getGetUniversityInterviewSchedulingEmployerSchedulesWithAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerSchedulesWithAssignments>>, TError = unknown>(universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerSchedulesWithAssignments>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUniversityInterviewSchedulingEmployerSchedulesWithAssignmentsQueryKey(universityEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerSchedulesWithAssignments>>> = ({ signal }) => getUniversityInterviewSchedulingEmployerSchedulesWithAssignments(universityEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerSchedulesWithAssignments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUniversityInterviewSchedulingEmployerSchedulesWithAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerSchedulesWithAssignments>>>
export type GetUniversityInterviewSchedulingEmployerSchedulesWithAssignmentsQueryError = unknown



export function useGetUniversityInterviewSchedulingEmployerSchedulesWithAssignments<TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerSchedulesWithAssignments>>, TError = unknown>(
 universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEmployerSchedulesWithAssignments>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUniversityInterviewSchedulingEmployerSchedulesWithAssignmentsQueryOptions(universityEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInterviewSchedulingEventSchedulesStatus = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingUniversityEmployerScheduleStatusResponse>(
      {url: `/interviewSchedulingAdmin/schedules/status/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingEventSchedulesStatusQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/schedules/status/${eventId}`] as const;
    }

    
export const getGetInterviewSchedulingEventSchedulesStatusQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingEventSchedulesStatus>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingEventSchedulesStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingEventSchedulesStatusQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingEventSchedulesStatus>>> = ({ signal }) => getInterviewSchedulingEventSchedulesStatus(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingEventSchedulesStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingEventSchedulesStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingEventSchedulesStatus>>>
export type GetInterviewSchedulingEventSchedulesStatusQueryError = unknown



export function useGetInterviewSchedulingEventSchedulesStatus<TData = Awaited<ReturnType<typeof getInterviewSchedulingEventSchedulesStatus>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingEventSchedulesStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingEventSchedulesStatusQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateScheduleStatusForInterviewSchedulingEvent = (
    employerEventId: number,
    scheduleId: number,
    updateInterviewSchedulingEmployerScheduleStatus: UpdateInterviewSchedulingEmployerScheduleStatus,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/schedules/${employerEventId}/${scheduleId}/status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateInterviewSchedulingEmployerScheduleStatus, signal
    },
      );
    }
  


export const getUpdateScheduleStatusForInterviewSchedulingEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScheduleStatusForInterviewSchedulingEvent>>, TError,{employerEventId: number;scheduleId: number;data: UpdateInterviewSchedulingEmployerScheduleStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateScheduleStatusForInterviewSchedulingEvent>>, TError,{employerEventId: number;scheduleId: number;data: UpdateInterviewSchedulingEmployerScheduleStatus}, TContext> => {
    
const mutationKey = ['updateScheduleStatusForInterviewSchedulingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateScheduleStatusForInterviewSchedulingEvent>>, {employerEventId: number;scheduleId: number;data: UpdateInterviewSchedulingEmployerScheduleStatus}> = (props) => {
          const {employerEventId,scheduleId,data} = props ?? {};

          return  updateScheduleStatusForInterviewSchedulingEvent(employerEventId,scheduleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateScheduleStatusForInterviewSchedulingEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateScheduleStatusForInterviewSchedulingEvent>>>
    export type UpdateScheduleStatusForInterviewSchedulingEventMutationBody = UpdateInterviewSchedulingEmployerScheduleStatus
    export type UpdateScheduleStatusForInterviewSchedulingEventMutationError = unknown

    export const useUpdateScheduleStatusForInterviewSchedulingEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScheduleStatusForInterviewSchedulingEvent>>, TError,{employerEventId: number;scheduleId: number;data: UpdateInterviewSchedulingEmployerScheduleStatus}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateScheduleStatusForInterviewSchedulingEvent>>,
        TError,
        {employerEventId: number;scheduleId: number;data: UpdateInterviewSchedulingEmployerScheduleStatus},
        TContext
      > => {

      const mutationOptions = getUpdateScheduleStatusForInterviewSchedulingEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getUniversityInterviewSchedulingEventSchedules = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingEmployerSchedulesResponse>(
      {url: `/interviewSchedulingAdmin/schedules/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUniversityInterviewSchedulingEventSchedulesQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/schedules/${eventId}`] as const;
    }

    
export const getGetUniversityInterviewSchedulingEventSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventSchedules>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventSchedules>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUniversityInterviewSchedulingEventSchedulesQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventSchedules>>> = ({ signal }) => getUniversityInterviewSchedulingEventSchedules(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventSchedules>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUniversityInterviewSchedulingEventSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventSchedules>>>
export type GetUniversityInterviewSchedulingEventSchedulesQueryError = unknown



export function useGetUniversityInterviewSchedulingEventSchedules<TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventSchedules>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventSchedules>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUniversityInterviewSchedulingEventSchedulesQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sendInterviewSchedulingAlternatePeriodHasStartedEmail = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingAdmin/sendAlternatePeriodHasStartedEmail/${eventId}`, method: 'POST', signal
    },
      );
    }
  


export const getSendInterviewSchedulingAlternatePeriodHasStartedEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInterviewSchedulingAlternatePeriodHasStartedEmail>>, TError,{eventId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendInterviewSchedulingAlternatePeriodHasStartedEmail>>, TError,{eventId: number}, TContext> => {
    
const mutationKey = ['sendInterviewSchedulingAlternatePeriodHasStartedEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendInterviewSchedulingAlternatePeriodHasStartedEmail>>, {eventId: number}> = (props) => {
          const {eventId} = props ?? {};

          return  sendInterviewSchedulingAlternatePeriodHasStartedEmail(eventId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendInterviewSchedulingAlternatePeriodHasStartedEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendInterviewSchedulingAlternatePeriodHasStartedEmail>>>
    
    export type SendInterviewSchedulingAlternatePeriodHasStartedEmailMutationError = unknown

    export const useSendInterviewSchedulingAlternatePeriodHasStartedEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInterviewSchedulingAlternatePeriodHasStartedEmail>>, TError,{eventId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendInterviewSchedulingAlternatePeriodHasStartedEmail>>,
        TError,
        {eventId: number},
        TContext
      > => {

      const mutationOptions = getSendInterviewSchedulingAlternatePeriodHasStartedEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendInterviewSchedulingApplicationDeadlineReminderEmail = (
    eventId: number,
    sendStudentApplicationDeadlineReminderEmailRequest: SendStudentApplicationDeadlineReminderEmailRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingAdmin/sendApplicationDeadlineReminderEmail/${eventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendStudentApplicationDeadlineReminderEmailRequest, signal
    },
      );
    }
  


export const getSendInterviewSchedulingApplicationDeadlineReminderEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInterviewSchedulingApplicationDeadlineReminderEmail>>, TError,{eventId: number;data: SendStudentApplicationDeadlineReminderEmailRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendInterviewSchedulingApplicationDeadlineReminderEmail>>, TError,{eventId: number;data: SendStudentApplicationDeadlineReminderEmailRequest}, TContext> => {
    
const mutationKey = ['sendInterviewSchedulingApplicationDeadlineReminderEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendInterviewSchedulingApplicationDeadlineReminderEmail>>, {eventId: number;data: SendStudentApplicationDeadlineReminderEmailRequest}> = (props) => {
          const {eventId,data} = props ?? {};

          return  sendInterviewSchedulingApplicationDeadlineReminderEmail(eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendInterviewSchedulingApplicationDeadlineReminderEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendInterviewSchedulingApplicationDeadlineReminderEmail>>>
    export type SendInterviewSchedulingApplicationDeadlineReminderEmailMutationBody = SendStudentApplicationDeadlineReminderEmailRequest
    export type SendInterviewSchedulingApplicationDeadlineReminderEmailMutationError = unknown

    export const useSendInterviewSchedulingApplicationDeadlineReminderEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInterviewSchedulingApplicationDeadlineReminderEmail>>, TError,{eventId: number;data: SendStudentApplicationDeadlineReminderEmailRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendInterviewSchedulingApplicationDeadlineReminderEmail>>,
        TError,
        {eventId: number;data: SendStudentApplicationDeadlineReminderEmailRequest},
        TContext
      > => {

      const mutationOptions = getSendInterviewSchedulingApplicationDeadlineReminderEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendInterviewSchedulingEmployerDecisionsAreAvailableEmail = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingAdmin/sendEmployerDecisionsAreAvailableEmail/${eventId}`, method: 'POST', signal
    },
      );
    }
  


export const getSendInterviewSchedulingEmployerDecisionsAreAvailableEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInterviewSchedulingEmployerDecisionsAreAvailableEmail>>, TError,{eventId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendInterviewSchedulingEmployerDecisionsAreAvailableEmail>>, TError,{eventId: number}, TContext> => {
    
const mutationKey = ['sendInterviewSchedulingEmployerDecisionsAreAvailableEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendInterviewSchedulingEmployerDecisionsAreAvailableEmail>>, {eventId: number}> = (props) => {
          const {eventId} = props ?? {};

          return  sendInterviewSchedulingEmployerDecisionsAreAvailableEmail(eventId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendInterviewSchedulingEmployerDecisionsAreAvailableEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendInterviewSchedulingEmployerDecisionsAreAvailableEmail>>>
    
    export type SendInterviewSchedulingEmployerDecisionsAreAvailableEmailMutationError = unknown

    export const useSendInterviewSchedulingEmployerDecisionsAreAvailableEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInterviewSchedulingEmployerDecisionsAreAvailableEmail>>, TError,{eventId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendInterviewSchedulingEmployerDecisionsAreAvailableEmail>>,
        TError,
        {eventId: number},
        TContext
      > => {

      const mutationOptions = getSendInterviewSchedulingEmployerDecisionsAreAvailableEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendInterviewerInformationRequestEmail = (
    eventId: number,
    sendInterviewInformationEmailRequest: SendInterviewInformationEmailRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/sendInterviewerInfoRequestEmail/${eventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendInterviewInformationEmailRequest, signal
    },
      );
    }
  


export const getSendInterviewerInformationRequestEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInterviewerInformationRequestEmail>>, TError,{eventId: number;data: SendInterviewInformationEmailRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendInterviewerInformationRequestEmail>>, TError,{eventId: number;data: SendInterviewInformationEmailRequest}, TContext> => {
    
const mutationKey = ['sendInterviewerInformationRequestEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendInterviewerInformationRequestEmail>>, {eventId: number;data: SendInterviewInformationEmailRequest}> = (props) => {
          const {eventId,data} = props ?? {};

          return  sendInterviewerInformationRequestEmail(eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendInterviewerInformationRequestEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendInterviewerInformationRequestEmail>>>
    export type SendInterviewerInformationRequestEmailMutationBody = SendInterviewInformationEmailRequest
    export type SendInterviewerInformationRequestEmailMutationError = unknown

    export const useSendInterviewerInformationRequestEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInterviewerInformationRequestEmail>>, TError,{eventId: number;data: SendInterviewInformationEmailRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendInterviewerInformationRequestEmail>>,
        TError,
        {eventId: number;data: SendInterviewInformationEmailRequest},
        TContext
      > => {

      const mutationOptions = getSendInterviewerInformationRequestEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendRegistrationEmail = (
    eventId: number,
    sendInterviewSchedulingEmailRequest: SendInterviewSchedulingEmailRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingAdmin/sendRegistrationEmail/${eventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendInterviewSchedulingEmailRequest, signal
    },
      );
    }
  


export const getSendRegistrationEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRegistrationEmail>>, TError,{eventId: number;data: SendInterviewSchedulingEmailRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendRegistrationEmail>>, TError,{eventId: number;data: SendInterviewSchedulingEmailRequest}, TContext> => {
    
const mutationKey = ['sendRegistrationEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendRegistrationEmail>>, {eventId: number;data: SendInterviewSchedulingEmailRequest}> = (props) => {
          const {eventId,data} = props ?? {};

          return  sendRegistrationEmail(eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendRegistrationEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendRegistrationEmail>>>
    export type SendRegistrationEmailMutationBody = SendInterviewSchedulingEmailRequest
    export type SendRegistrationEmailMutationError = unknown

    export const useSendRegistrationEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRegistrationEmail>>, TError,{eventId: number;data: SendInterviewSchedulingEmailRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendRegistrationEmail>>,
        TError,
        {eventId: number;data: SendInterviewSchedulingEmailRequest},
        TContext
      > => {

      const mutationOptions = getSendRegistrationEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendReminderEmail = (
    eventId: number,
    sendEmployerRegistrationReminderEmailRequest: SendEmployerRegistrationReminderEmailRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingAdmin/sendReminderEmail/${eventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendEmployerRegistrationReminderEmailRequest, signal
    },
      );
    }
  


export const getSendReminderEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendReminderEmail>>, TError,{eventId: number;data: SendEmployerRegistrationReminderEmailRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendReminderEmail>>, TError,{eventId: number;data: SendEmployerRegistrationReminderEmailRequest}, TContext> => {
    
const mutationKey = ['sendReminderEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendReminderEmail>>, {eventId: number;data: SendEmployerRegistrationReminderEmailRequest}> = (props) => {
          const {eventId,data} = props ?? {};

          return  sendReminderEmail(eventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendReminderEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendReminderEmail>>>
    export type SendReminderEmailMutationBody = SendEmployerRegistrationReminderEmailRequest
    export type SendReminderEmailMutationError = unknown

    export const useSendReminderEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendReminderEmail>>, TError,{eventId: number;data: SendEmployerRegistrationReminderEmailRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendReminderEmail>>,
        TError,
        {eventId: number;data: SendEmployerRegistrationReminderEmailRequest},
        TContext
      > => {

      const mutationOptions = getSendReminderEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendInterviewSchedulingStudentApplicationsAreAvailableEmail = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingAdmin/sendStudentApplicationsAreAvailableEmail/${eventId}`, method: 'POST', signal
    },
      );
    }
  


export const getSendInterviewSchedulingStudentApplicationsAreAvailableEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInterviewSchedulingStudentApplicationsAreAvailableEmail>>, TError,{eventId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendInterviewSchedulingStudentApplicationsAreAvailableEmail>>, TError,{eventId: number}, TContext> => {
    
const mutationKey = ['sendInterviewSchedulingStudentApplicationsAreAvailableEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendInterviewSchedulingStudentApplicationsAreAvailableEmail>>, {eventId: number}> = (props) => {
          const {eventId} = props ?? {};

          return  sendInterviewSchedulingStudentApplicationsAreAvailableEmail(eventId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendInterviewSchedulingStudentApplicationsAreAvailableEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendInterviewSchedulingStudentApplicationsAreAvailableEmail>>>
    
    export type SendInterviewSchedulingStudentApplicationsAreAvailableEmailMutationError = unknown

    export const useSendInterviewSchedulingStudentApplicationsAreAvailableEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInterviewSchedulingStudentApplicationsAreAvailableEmail>>, TError,{eventId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendInterviewSchedulingStudentApplicationsAreAvailableEmail>>,
        TError,
        {eventId: number},
        TContext
      > => {

      const mutationOptions = getSendInterviewSchedulingStudentApplicationsAreAvailableEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendInterviewSchedulingStudentYourEventPageEmail = (
    eventId: number,
    recruitId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingAdmin/sendStudentYourEventPageEmail/${eventId}/${recruitId}`, method: 'POST', signal
    },
      );
    }
  


export const getSendInterviewSchedulingStudentYourEventPageEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInterviewSchedulingStudentYourEventPageEmail>>, TError,{eventId: number;recruitId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendInterviewSchedulingStudentYourEventPageEmail>>, TError,{eventId: number;recruitId: number}, TContext> => {
    
const mutationKey = ['sendInterviewSchedulingStudentYourEventPageEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendInterviewSchedulingStudentYourEventPageEmail>>, {eventId: number;recruitId: number}> = (props) => {
          const {eventId,recruitId} = props ?? {};

          return  sendInterviewSchedulingStudentYourEventPageEmail(eventId,recruitId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendInterviewSchedulingStudentYourEventPageEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendInterviewSchedulingStudentYourEventPageEmail>>>
    
    export type SendInterviewSchedulingStudentYourEventPageEmailMutationError = unknown

    export const useSendInterviewSchedulingStudentYourEventPageEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendInterviewSchedulingStudentYourEventPageEmail>>, TError,{eventId: number;recruitId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendInterviewSchedulingStudentYourEventPageEmail>>,
        TError,
        {eventId: number;recruitId: number},
        TContext
      > => {

      const mutationOptions = getSendInterviewSchedulingStudentYourEventPageEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * @summary Get current event creation step statuses
 */
export const getInterviewSchedulingStepStatusResponse = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingStepStatusResponse>(
      {url: `/interviewSchedulingAdmin/stepStatus/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingStepStatusResponseQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/stepStatus/${eventId}`] as const;
    }

    
export const getGetInterviewSchedulingStepStatusResponseQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingStepStatusResponse>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStepStatusResponse>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingStepStatusResponseQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingStepStatusResponse>>> = ({ signal }) => getInterviewSchedulingStepStatusResponse(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStepStatusResponse>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingStepStatusResponseQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingStepStatusResponse>>>
export type GetInterviewSchedulingStepStatusResponseQueryError = unknown


/**
 * @summary Get current event creation step statuses
 */

export function useGetInterviewSchedulingStepStatusResponse<TData = Awaited<ReturnType<typeof getInterviewSchedulingStepStatusResponse>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStepStatusResponse>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingStepStatusResponseQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUniversityInterviewSchedulingStudentApplications = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingUniversityStudentApplicationListResponse>(
      {url: `/interviewSchedulingAdmin/studentApplication/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUniversityInterviewSchedulingStudentApplicationsQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/studentApplication/${eventId}`] as const;
    }

    
export const getGetUniversityInterviewSchedulingStudentApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingStudentApplications>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingStudentApplications>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUniversityInterviewSchedulingStudentApplicationsQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUniversityInterviewSchedulingStudentApplications>>> = ({ signal }) => getUniversityInterviewSchedulingStudentApplications(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingStudentApplications>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUniversityInterviewSchedulingStudentApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof getUniversityInterviewSchedulingStudentApplications>>>
export type GetUniversityInterviewSchedulingStudentApplicationsQueryError = unknown



export function useGetUniversityInterviewSchedulingStudentApplications<TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingStudentApplications>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingStudentApplications>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUniversityInterviewSchedulingStudentApplicationsQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUniversityInterviewSchedulingStudents = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingUniversityStudentResponse[]>(
      {url: `/interviewSchedulingAdmin/students/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUniversityInterviewSchedulingStudentsQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/students/${eventId}`] as const;
    }

    
export const getGetUniversityInterviewSchedulingStudentsQueryOptions = <TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingStudents>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingStudents>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUniversityInterviewSchedulingStudentsQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUniversityInterviewSchedulingStudents>>> = ({ signal }) => getUniversityInterviewSchedulingStudents(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingStudents>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUniversityInterviewSchedulingStudentsQueryResult = NonNullable<Awaited<ReturnType<typeof getUniversityInterviewSchedulingStudents>>>
export type GetUniversityInterviewSchedulingStudentsQueryError = unknown



export function useGetUniversityInterviewSchedulingStudents<TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingStudents>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingStudents>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUniversityInterviewSchedulingStudentsQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getEventSummary = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingUniversityEventSummaryResponse>(
      {url: `/interviewSchedulingAdmin/summary/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEventSummaryQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/summary/${eventId}`] as const;
    }

    
export const getGetEventSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getEventSummary>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventSummary>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventSummaryQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventSummary>>> = ({ signal }) => getEventSummary(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getEventSummary>>>
export type GetEventSummaryQueryError = unknown



export function useGetEventSummary<TData = Awaited<ReturnType<typeof getEventSummary>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventSummary>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventSummaryQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Submit/Update date-times for step 3
 */
export const submitEventTimeline = (
    interviewSchedulingEventTimelineRequest: InterviewSchedulingEventTimelineRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/interviewSchedulingAdmin/timeline`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingEventTimelineRequest, signal
    },
      );
    }
  


export const getSubmitEventTimelineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEventTimeline>>, TError,{data: InterviewSchedulingEventTimelineRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitEventTimeline>>, TError,{data: InterviewSchedulingEventTimelineRequest}, TContext> => {
    
const mutationKey = ['submitEventTimeline'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitEventTimeline>>, {data: InterviewSchedulingEventTimelineRequest}> = (props) => {
          const {data} = props ?? {};

          return  submitEventTimeline(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitEventTimelineMutationResult = NonNullable<Awaited<ReturnType<typeof submitEventTimeline>>>
    export type SubmitEventTimelineMutationBody = InterviewSchedulingEventTimelineRequest
    export type SubmitEventTimelineMutationError = unknown

    /**
 * @summary Submit/Update date-times for step 3
 */
export const useSubmitEventTimeline = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEventTimeline>>, TError,{data: InterviewSchedulingEventTimelineRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitEventTimeline>>,
        TError,
        {data: InterviewSchedulingEventTimelineRequest},
        TContext
      > => {

      const mutationOptions = getSubmitEventTimelineMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
/**
 * @summary Get existing date-times for step 3
 */
export const getEventTimeline = (
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EventTimelineResponse>(
      {url: `/interviewSchedulingAdmin/timeline/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEventTimelineQueryKey = (eventId: number,) => {
    return [`/interviewSchedulingAdmin/timeline/${eventId}`] as const;
    }

    
export const getGetEventTimelineQueryOptions = <TData = Awaited<ReturnType<typeof getEventTimeline>>, TError = unknown>(eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventTimeline>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventTimelineQueryKey(eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventTimeline>>> = ({ signal }) => getEventTimeline(eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventTimeline>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventTimelineQueryResult = NonNullable<Awaited<ReturnType<typeof getEventTimeline>>>
export type GetEventTimelineQueryError = unknown


/**
 * @summary Get existing date-times for step 3
 */

export function useGetEventTimeline<TData = Awaited<ReturnType<typeof getEventTimeline>>, TError = unknown>(
 eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventTimeline>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventTimelineQueryOptions(eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getTimeslotsForInterviewSchedulingEvent = (
    universityEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingUniversityGetTimeslotsResponse>(
      {url: `/interviewSchedulingAdmin/timeslots/${universityEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetTimeslotsForInterviewSchedulingEventQueryKey = (universityEventId: number,) => {
    return [`/interviewSchedulingAdmin/timeslots/${universityEventId}`] as const;
    }

    
export const getGetTimeslotsForInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof getTimeslotsForInterviewSchedulingEvent>>, TError = unknown>(universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTimeslotsForInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTimeslotsForInterviewSchedulingEventQueryKey(universityEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimeslotsForInterviewSchedulingEvent>>> = ({ signal }) => getTimeslotsForInterviewSchedulingEvent(universityEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTimeslotsForInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTimeslotsForInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof getTimeslotsForInterviewSchedulingEvent>>>
export type GetTimeslotsForInterviewSchedulingEventQueryError = unknown



export function useGetTimeslotsForInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof getTimeslotsForInterviewSchedulingEvent>>, TError = unknown>(
 universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTimeslotsForInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTimeslotsForInterviewSchedulingEventQueryOptions(universityEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const editTimeslotsForInterviewSchedulingEvent = (
    universityEventId: number,
    interviewSchedulingUniversityEditTimeslotsRequest: InterviewSchedulingUniversityEditTimeslotsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingAdmin/timeslots/${universityEventId}/edit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingUniversityEditTimeslotsRequest, signal
    },
      );
    }
  


export const getEditTimeslotsForInterviewSchedulingEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editTimeslotsForInterviewSchedulingEvent>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityEditTimeslotsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof editTimeslotsForInterviewSchedulingEvent>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityEditTimeslotsRequest}, TContext> => {
    
const mutationKey = ['editTimeslotsForInterviewSchedulingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editTimeslotsForInterviewSchedulingEvent>>, {universityEventId: number;data: InterviewSchedulingUniversityEditTimeslotsRequest}> = (props) => {
          const {universityEventId,data} = props ?? {};

          return  editTimeslotsForInterviewSchedulingEvent(universityEventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EditTimeslotsForInterviewSchedulingEventMutationResult = NonNullable<Awaited<ReturnType<typeof editTimeslotsForInterviewSchedulingEvent>>>
    export type EditTimeslotsForInterviewSchedulingEventMutationBody = InterviewSchedulingUniversityEditTimeslotsRequest
    export type EditTimeslotsForInterviewSchedulingEventMutationError = unknown

    export const useEditTimeslotsForInterviewSchedulingEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editTimeslotsForInterviewSchedulingEvent>>, TError,{universityEventId: number;data: InterviewSchedulingUniversityEditTimeslotsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof editTimeslotsForInterviewSchedulingEvent>>,
        TError,
        {universityEventId: number;data: InterviewSchedulingUniversityEditTimeslotsRequest},
        TContext
      > => {

      const mutationOptions = getEditTimeslotsForInterviewSchedulingEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getInterviewersForInterviewSchedulingEvent = (
    universityEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingUniversityInterviewerResponse[]>(
      {url: `/interviewSchedulingAdmin/timeslots/${universityEventId}/interviewers`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewersForInterviewSchedulingEventQueryKey = (universityEventId: number,) => {
    return [`/interviewSchedulingAdmin/timeslots/${universityEventId}/interviewers`] as const;
    }

    
export const getGetInterviewersForInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewersForInterviewSchedulingEvent>>, TError = unknown>(universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewersForInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewersForInterviewSchedulingEventQueryKey(universityEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewersForInterviewSchedulingEvent>>> = ({ signal }) => getInterviewersForInterviewSchedulingEvent(universityEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(universityEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewersForInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewersForInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewersForInterviewSchedulingEvent>>>
export type GetInterviewersForInterviewSchedulingEventQueryError = unknown



export function useGetInterviewersForInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof getInterviewersForInterviewSchedulingEvent>>, TError = unknown>(
 universityEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewersForInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewersForInterviewSchedulingEventQueryOptions(universityEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Validate time-block information on submit of the Create and Edit time-blocks modal for Step 2
 */
export const validateInterviewSchedulingBlock = (
    interviewSchedulingBlockRequest: InterviewSchedulingBlockRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingGenerateTimeslotsResponse>(
      {url: `/interviewSchedulingAdmin/validateBlock`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingBlockRequest, signal
    },
      );
    }
  


export const getValidateInterviewSchedulingBlockMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateInterviewSchedulingBlock>>, TError,{data: InterviewSchedulingBlockRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof validateInterviewSchedulingBlock>>, TError,{data: InterviewSchedulingBlockRequest}, TContext> => {
    
const mutationKey = ['validateInterviewSchedulingBlock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateInterviewSchedulingBlock>>, {data: InterviewSchedulingBlockRequest}> = (props) => {
          const {data} = props ?? {};

          return  validateInterviewSchedulingBlock(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ValidateInterviewSchedulingBlockMutationResult = NonNullable<Awaited<ReturnType<typeof validateInterviewSchedulingBlock>>>
    export type ValidateInterviewSchedulingBlockMutationBody = InterviewSchedulingBlockRequest
    export type ValidateInterviewSchedulingBlockMutationError = unknown

    /**
 * @summary Validate time-block information on submit of the Create and Edit time-blocks modal for Step 2
 */
export const useValidateInterviewSchedulingBlock = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateInterviewSchedulingBlock>>, TError,{data: InterviewSchedulingBlockRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof validateInterviewSchedulingBlock>>,
        TError,
        {data: InterviewSchedulingBlockRequest},
        TContext
      > => {

      const mutationOptions = getValidateInterviewSchedulingBlockMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const validateInterviewSchedulingEmployerContactEmail = (
    validateEmployerContactEmailRequest: ValidateEmployerContactEmailRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ValidateInterviewSchedulingEmployerContactEmail200>(
      {url: `/interviewSchedulingAdmin/validateContactEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: validateEmployerContactEmailRequest, signal
    },
      );
    }
  


export const getValidateInterviewSchedulingEmployerContactEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateInterviewSchedulingEmployerContactEmail>>, TError,{data: ValidateEmployerContactEmailRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof validateInterviewSchedulingEmployerContactEmail>>, TError,{data: ValidateEmployerContactEmailRequest}, TContext> => {
    
const mutationKey = ['validateInterviewSchedulingEmployerContactEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateInterviewSchedulingEmployerContactEmail>>, {data: ValidateEmployerContactEmailRequest}> = (props) => {
          const {data} = props ?? {};

          return  validateInterviewSchedulingEmployerContactEmail(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ValidateInterviewSchedulingEmployerContactEmailMutationResult = NonNullable<Awaited<ReturnType<typeof validateInterviewSchedulingEmployerContactEmail>>>
    export type ValidateInterviewSchedulingEmployerContactEmailMutationBody = ValidateEmployerContactEmailRequest
    export type ValidateInterviewSchedulingEmployerContactEmailMutationError = unknown

    export const useValidateInterviewSchedulingEmployerContactEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateInterviewSchedulingEmployerContactEmail>>, TError,{data: ValidateEmployerContactEmailRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof validateInterviewSchedulingEmployerContactEmail>>,
        TError,
        {data: ValidateEmployerContactEmailRequest},
        TContext
      > => {

      const mutationOptions = getValidateInterviewSchedulingEmployerContactEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendScheduledEmails = (
    orgId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingEmailScheduler/sendEmails/${orgId}`, method: 'GET', signal
    },
      );
    }
  

export const getSendScheduledEmailsQueryKey = (orgId: number,) => {
    return [`/interviewSchedulingEmailScheduler/sendEmails/${orgId}`] as const;
    }

    
export const getSendScheduledEmailsQueryOptions = <TData = Awaited<ReturnType<typeof sendScheduledEmails>>, TError = unknown>(orgId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sendScheduledEmails>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSendScheduledEmailsQueryKey(orgId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sendScheduledEmails>>> = ({ signal }) => sendScheduledEmails(orgId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sendScheduledEmails>>, TError, TData> & { queryKey: QueryKey }
}

export type SendScheduledEmailsQueryResult = NonNullable<Awaited<ReturnType<typeof sendScheduledEmails>>>
export type SendScheduledEmailsQueryError = unknown



export function useSendScheduledEmails<TData = Awaited<ReturnType<typeof sendScheduledEmails>>, TError = unknown>(
 orgId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sendScheduledEmails>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSendScheduledEmailsQueryOptions(orgId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminUsersForEmployerInterviewSchedulingEvent = (
    employerEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAdminUsersResponse>(
      {url: `/interviewSchedulingEmployerEvent/adminUsers/${employerEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAdminUsersForEmployerInterviewSchedulingEventQueryKey = (employerEventId: number,) => {
    return [`/interviewSchedulingEmployerEvent/adminUsers/${employerEventId}`] as const;
    }

    
export const getGetAdminUsersForEmployerInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUsersForEmployerInterviewSchedulingEvent>>, TError = unknown>(employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersForEmployerInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUsersForEmployerInterviewSchedulingEventQueryKey(employerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUsersForEmployerInterviewSchedulingEvent>>> = ({ signal }) => getAdminUsersForEmployerInterviewSchedulingEvent(employerEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersForEmployerInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUsersForEmployerInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUsersForEmployerInterviewSchedulingEvent>>>
export type GetAdminUsersForEmployerInterviewSchedulingEventQueryError = unknown



export function useGetAdminUsersForEmployerInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof getAdminUsersForEmployerInterviewSchedulingEvent>>, TError = unknown>(
 employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersForEmployerInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminUsersForEmployerInterviewSchedulingEventQueryOptions(employerEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const fetchDepartmentsForEmployerInterviewSchedulingEvent = (
    employerEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DepartmentResponse[]>(
      {url: `/interviewSchedulingEmployerEvent/department/${employerEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getFetchDepartmentsForEmployerInterviewSchedulingEventQueryKey = (employerEventId: number,) => {
    return [`/interviewSchedulingEmployerEvent/department/${employerEventId}`] as const;
    }

    
export const getFetchDepartmentsForEmployerInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof fetchDepartmentsForEmployerInterviewSchedulingEvent>>, TError = unknown>(employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchDepartmentsForEmployerInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchDepartmentsForEmployerInterviewSchedulingEventQueryKey(employerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchDepartmentsForEmployerInterviewSchedulingEvent>>> = ({ signal }) => fetchDepartmentsForEmployerInterviewSchedulingEvent(employerEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchDepartmentsForEmployerInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchDepartmentsForEmployerInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof fetchDepartmentsForEmployerInterviewSchedulingEvent>>>
export type FetchDepartmentsForEmployerInterviewSchedulingEventQueryError = unknown



export function useFetchDepartmentsForEmployerInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof fetchDepartmentsForEmployerInterviewSchedulingEvent>>, TError = unknown>(
 employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchDepartmentsForEmployerInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchDepartmentsForEmployerInterviewSchedulingEventQueryOptions(employerEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUniversityInterviewSchedulingEventDetailsFromEmployerSide = (
    eid: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingEmployerEventDetailsResponse>(
      {url: `/interviewSchedulingEmployerEvent/details/${eid}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUniversityInterviewSchedulingEventDetailsFromEmployerSideQueryKey = (eid: number,) => {
    return [`/interviewSchedulingEmployerEvent/details/${eid}`] as const;
    }

    
export const getGetUniversityInterviewSchedulingEventDetailsFromEmployerSideQueryOptions = <TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventDetailsFromEmployerSide>>, TError = unknown>(eid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventDetailsFromEmployerSide>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUniversityInterviewSchedulingEventDetailsFromEmployerSideQueryKey(eid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventDetailsFromEmployerSide>>> = ({ signal }) => getUniversityInterviewSchedulingEventDetailsFromEmployerSide(eid, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventDetailsFromEmployerSide>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUniversityInterviewSchedulingEventDetailsFromEmployerSideQueryResult = NonNullable<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventDetailsFromEmployerSide>>>
export type GetUniversityInterviewSchedulingEventDetailsFromEmployerSideQueryError = unknown



export function useGetUniversityInterviewSchedulingEventDetailsFromEmployerSide<TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventDetailsFromEmployerSide>>, TError = unknown>(
 eid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventDetailsFromEmployerSide>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUniversityInterviewSchedulingEventDetailsFromEmployerSideQueryOptions(eid,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const fetchEmploymentTypesForEmployerInterviewSchedulingEvent = (
    employerEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmploymentTypeResponse[]>(
      {url: `/interviewSchedulingEmployerEvent/employmentType/${employerEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getFetchEmploymentTypesForEmployerInterviewSchedulingEventQueryKey = (employerEventId: number,) => {
    return [`/interviewSchedulingEmployerEvent/employmentType/${employerEventId}`] as const;
    }

    
export const getFetchEmploymentTypesForEmployerInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof fetchEmploymentTypesForEmployerInterviewSchedulingEvent>>, TError = unknown>(employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchEmploymentTypesForEmployerInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchEmploymentTypesForEmployerInterviewSchedulingEventQueryKey(employerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchEmploymentTypesForEmployerInterviewSchedulingEvent>>> = ({ signal }) => fetchEmploymentTypesForEmployerInterviewSchedulingEvent(employerEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchEmploymentTypesForEmployerInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchEmploymentTypesForEmployerInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof fetchEmploymentTypesForEmployerInterviewSchedulingEvent>>>
export type FetchEmploymentTypesForEmployerInterviewSchedulingEventQueryError = unknown



export function useFetchEmploymentTypesForEmployerInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof fetchEmploymentTypesForEmployerInterviewSchedulingEvent>>, TError = unknown>(
 employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchEmploymentTypesForEmployerInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchEmploymentTypesForEmployerInterviewSchedulingEventQueryOptions(employerEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAllInterviewersInOrgForInterviewSchedulingEvent = (
    employerEid: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingUserDTO[]>(
      {url: `/interviewSchedulingEmployerEvent/getAllInterviewersInOrg/${employerEid}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAllInterviewersInOrgForInterviewSchedulingEventQueryKey = (employerEid: number,) => {
    return [`/interviewSchedulingEmployerEvent/getAllInterviewersInOrg/${employerEid}`] as const;
    }

    
export const getGetAllInterviewersInOrgForInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof getAllInterviewersInOrgForInterviewSchedulingEvent>>, TError = unknown>(employerEid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllInterviewersInOrgForInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllInterviewersInOrgForInterviewSchedulingEventQueryKey(employerEid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllInterviewersInOrgForInterviewSchedulingEvent>>> = ({ signal }) => getAllInterviewersInOrgForInterviewSchedulingEvent(employerEid, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllInterviewersInOrgForInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllInterviewersInOrgForInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof getAllInterviewersInOrgForInterviewSchedulingEvent>>>
export type GetAllInterviewersInOrgForInterviewSchedulingEventQueryError = unknown



export function useGetAllInterviewersInOrgForInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof getAllInterviewersInOrgForInterviewSchedulingEvent>>, TError = unknown>(
 employerEid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllInterviewersInOrgForInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAllInterviewersInOrgForInterviewSchedulingEventQueryOptions(employerEid,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInterviewSchedulingInterviewerScheduleLinks = (
    employerEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingInterviewerScheduleLink[]>(
      {url: `/interviewSchedulingEmployerEvent/interviewerScheduleLinks/${employerEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingInterviewerScheduleLinksQueryKey = (employerEventId: number,) => {
    return [`/interviewSchedulingEmployerEvent/interviewerScheduleLinks/${employerEventId}`] as const;
    }

    
export const getGetInterviewSchedulingInterviewerScheduleLinksQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingInterviewerScheduleLinks>>, TError = unknown>(employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingInterviewerScheduleLinks>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingInterviewerScheduleLinksQueryKey(employerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingInterviewerScheduleLinks>>> = ({ signal }) => getInterviewSchedulingInterviewerScheduleLinks(employerEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingInterviewerScheduleLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingInterviewerScheduleLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingInterviewerScheduleLinks>>>
export type GetInterviewSchedulingInterviewerScheduleLinksQueryError = unknown



export function useGetInterviewSchedulingInterviewerScheduleLinks<TData = Awaited<ReturnType<typeof getInterviewSchedulingInterviewerScheduleLinks>>, TError = unknown>(
 employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingInterviewerScheduleLinks>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingInterviewerScheduleLinksQueryOptions(employerEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAllLawSchoolsForEmployerInterviewSchedulingEvent = (
    employerEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/interviewSchedulingEmployerEvent/lawSchool/${employerEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAllLawSchoolsForEmployerInterviewSchedulingEventQueryKey = (employerEventId: number,) => {
    return [`/interviewSchedulingEmployerEvent/lawSchool/${employerEventId}`] as const;
    }

    
export const getGetAllLawSchoolsForEmployerInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof getAllLawSchoolsForEmployerInterviewSchedulingEvent>>, TError = unknown>(employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllLawSchoolsForEmployerInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllLawSchoolsForEmployerInterviewSchedulingEventQueryKey(employerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllLawSchoolsForEmployerInterviewSchedulingEvent>>> = ({ signal }) => getAllLawSchoolsForEmployerInterviewSchedulingEvent(employerEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllLawSchoolsForEmployerInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllLawSchoolsForEmployerInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof getAllLawSchoolsForEmployerInterviewSchedulingEvent>>>
export type GetAllLawSchoolsForEmployerInterviewSchedulingEventQueryError = unknown



export function useGetAllLawSchoolsForEmployerInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof getAllLawSchoolsForEmployerInterviewSchedulingEvent>>, TError = unknown>(
 employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllLawSchoolsForEmployerInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAllLawSchoolsForEmployerInterviewSchedulingEventQueryOptions(employerEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getLotteryStudentMatchesForEmployerSchedule = (
    employerEventId: number,
    scheduleId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LotteryMatchForEmployerScheduleResponse[]>(
      {url: `/interviewSchedulingEmployerEvent/lotteryMatches/${employerEventId}/${scheduleId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetLotteryStudentMatchesForEmployerScheduleQueryKey = (employerEventId: number,
    scheduleId: number,) => {
    return [`/interviewSchedulingEmployerEvent/lotteryMatches/${employerEventId}/${scheduleId}`] as const;
    }

    
export const getGetLotteryStudentMatchesForEmployerScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getLotteryStudentMatchesForEmployerSchedule>>, TError = unknown>(employerEventId: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLotteryStudentMatchesForEmployerSchedule>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLotteryStudentMatchesForEmployerScheduleQueryKey(employerEventId,scheduleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLotteryStudentMatchesForEmployerSchedule>>> = ({ signal }) => getLotteryStudentMatchesForEmployerSchedule(employerEventId,scheduleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId && scheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLotteryStudentMatchesForEmployerSchedule>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLotteryStudentMatchesForEmployerScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getLotteryStudentMatchesForEmployerSchedule>>>
export type GetLotteryStudentMatchesForEmployerScheduleQueryError = unknown



export function useGetLotteryStudentMatchesForEmployerSchedule<TData = Awaited<ReturnType<typeof getLotteryStudentMatchesForEmployerSchedule>>, TError = unknown>(
 employerEventId: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLotteryStudentMatchesForEmployerSchedule>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLotteryStudentMatchesForEmployerScheduleQueryOptions(employerEventId,scheduleId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getLotteryStudentUnmatchedBidsForEmployerSchedule = (
    employerEventId: number,
    scheduleId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LotteryUnmatchedBidsForEmployerScheduleResponse[]>(
      {url: `/interviewSchedulingEmployerEvent/lotteryUnmatchedBids/${employerEventId}/${scheduleId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetLotteryStudentUnmatchedBidsForEmployerScheduleQueryKey = (employerEventId: number,
    scheduleId: number,) => {
    return [`/interviewSchedulingEmployerEvent/lotteryUnmatchedBids/${employerEventId}/${scheduleId}`] as const;
    }

    
export const getGetLotteryStudentUnmatchedBidsForEmployerScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getLotteryStudentUnmatchedBidsForEmployerSchedule>>, TError = unknown>(employerEventId: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLotteryStudentUnmatchedBidsForEmployerSchedule>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLotteryStudentUnmatchedBidsForEmployerScheduleQueryKey(employerEventId,scheduleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLotteryStudentUnmatchedBidsForEmployerSchedule>>> = ({ signal }) => getLotteryStudentUnmatchedBidsForEmployerSchedule(employerEventId,scheduleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId && scheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLotteryStudentUnmatchedBidsForEmployerSchedule>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLotteryStudentUnmatchedBidsForEmployerScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getLotteryStudentUnmatchedBidsForEmployerSchedule>>>
export type GetLotteryStudentUnmatchedBidsForEmployerScheduleQueryError = unknown



export function useGetLotteryStudentUnmatchedBidsForEmployerSchedule<TData = Awaited<ReturnType<typeof getLotteryStudentUnmatchedBidsForEmployerSchedule>>, TError = unknown>(
 employerEventId: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLotteryStudentUnmatchedBidsForEmployerSchedule>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLotteryStudentUnmatchedBidsForEmployerScheduleQueryOptions(employerEventId,scheduleId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createNewEmployerInterviewerFromInterviewSchedulingEvent = (
    eid: number,
    createUserRequest: CreateUserRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/interviewSchedulingEmployerEvent/newInterviewer/${eid}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserRequest, signal
    },
      );
    }
  


export const getCreateNewEmployerInterviewerFromInterviewSchedulingEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewEmployerInterviewerFromInterviewSchedulingEvent>>, TError,{eid: number;data: CreateUserRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createNewEmployerInterviewerFromInterviewSchedulingEvent>>, TError,{eid: number;data: CreateUserRequest}, TContext> => {
    
const mutationKey = ['createNewEmployerInterviewerFromInterviewSchedulingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNewEmployerInterviewerFromInterviewSchedulingEvent>>, {eid: number;data: CreateUserRequest}> = (props) => {
          const {eid,data} = props ?? {};

          return  createNewEmployerInterviewerFromInterviewSchedulingEvent(eid,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateNewEmployerInterviewerFromInterviewSchedulingEventMutationResult = NonNullable<Awaited<ReturnType<typeof createNewEmployerInterviewerFromInterviewSchedulingEvent>>>
    export type CreateNewEmployerInterviewerFromInterviewSchedulingEventMutationBody = CreateUserRequest
    export type CreateNewEmployerInterviewerFromInterviewSchedulingEventMutationError = unknown

    export const useCreateNewEmployerInterviewerFromInterviewSchedulingEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewEmployerInterviewerFromInterviewSchedulingEvent>>, TError,{eid: number;data: CreateUserRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createNewEmployerInterviewerFromInterviewSchedulingEvent>>,
        TError,
        {eid: number;data: CreateUserRequest},
        TContext
      > => {

      const mutationOptions = getCreateNewEmployerInterviewerFromInterviewSchedulingEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchOfficesForEmployerInterviewSchedulingEvent = (
    employerEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OfficeResponse[]>(
      {url: `/interviewSchedulingEmployerEvent/office/${employerEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getFetchOfficesForEmployerInterviewSchedulingEventQueryKey = (employerEventId: number,) => {
    return [`/interviewSchedulingEmployerEvent/office/${employerEventId}`] as const;
    }

    
export const getFetchOfficesForEmployerInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof fetchOfficesForEmployerInterviewSchedulingEvent>>, TError = unknown>(employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOfficesForEmployerInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchOfficesForEmployerInterviewSchedulingEventQueryKey(employerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchOfficesForEmployerInterviewSchedulingEvent>>> = ({ signal }) => fetchOfficesForEmployerInterviewSchedulingEvent(employerEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchOfficesForEmployerInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchOfficesForEmployerInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof fetchOfficesForEmployerInterviewSchedulingEvent>>>
export type FetchOfficesForEmployerInterviewSchedulingEventQueryError = unknown



export function useFetchOfficesForEmployerInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof fetchOfficesForEmployerInterviewSchedulingEvent>>, TError = unknown>(
 employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOfficesForEmployerInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchOfficesForEmployerInterviewSchedulingEventQueryOptions(employerEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createOfficesForEmployerInterviewSchedulingEvent = (
    employerEventId: number,
    createOfficesRequest: CreateOfficesRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingEmployerEvent/office/${employerEventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOfficesRequest, signal
    },
      );
    }
  


export const getCreateOfficesForEmployerInterviewSchedulingEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOfficesForEmployerInterviewSchedulingEvent>>, TError,{employerEventId: number;data: CreateOfficesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createOfficesForEmployerInterviewSchedulingEvent>>, TError,{employerEventId: number;data: CreateOfficesRequest}, TContext> => {
    
const mutationKey = ['createOfficesForEmployerInterviewSchedulingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOfficesForEmployerInterviewSchedulingEvent>>, {employerEventId: number;data: CreateOfficesRequest}> = (props) => {
          const {employerEventId,data} = props ?? {};

          return  createOfficesForEmployerInterviewSchedulingEvent(employerEventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateOfficesForEmployerInterviewSchedulingEventMutationResult = NonNullable<Awaited<ReturnType<typeof createOfficesForEmployerInterviewSchedulingEvent>>>
    export type CreateOfficesForEmployerInterviewSchedulingEventMutationBody = CreateOfficesRequest
    export type CreateOfficesForEmployerInterviewSchedulingEventMutationError = unknown

    export const useCreateOfficesForEmployerInterviewSchedulingEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOfficesForEmployerInterviewSchedulingEvent>>, TError,{employerEventId: number;data: CreateOfficesRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOfficesForEmployerInterviewSchedulingEvent>>,
        TError,
        {employerEventId: number;data: CreateOfficesRequest},
        TContext
      > => {

      const mutationOptions = getCreateOfficesForEmployerInterviewSchedulingEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchPositionsForEmployerInterviewSchedulingEvent = (
    employerEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PositionResponse[]>(
      {url: `/interviewSchedulingEmployerEvent/position/${employerEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getFetchPositionsForEmployerInterviewSchedulingEventQueryKey = (employerEventId: number,) => {
    return [`/interviewSchedulingEmployerEvent/position/${employerEventId}`] as const;
    }

    
export const getFetchPositionsForEmployerInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof fetchPositionsForEmployerInterviewSchedulingEvent>>, TError = unknown>(employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchPositionsForEmployerInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchPositionsForEmployerInterviewSchedulingEventQueryKey(employerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchPositionsForEmployerInterviewSchedulingEvent>>> = ({ signal }) => fetchPositionsForEmployerInterviewSchedulingEvent(employerEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchPositionsForEmployerInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchPositionsForEmployerInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof fetchPositionsForEmployerInterviewSchedulingEvent>>>
export type FetchPositionsForEmployerInterviewSchedulingEventQueryError = unknown



export function useFetchPositionsForEmployerInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof fetchPositionsForEmployerInterviewSchedulingEvent>>, TError = unknown>(
 employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchPositionsForEmployerInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchPositionsForEmployerInterviewSchedulingEventQueryOptions(employerEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPreselectMatchedUnmatchedForEmployerSchedule = (
    employerEventId: number,
    scheduleId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PreselectMatchedUnmatchedForEmployerScheduleResponse[]>(
      {url: `/interviewSchedulingEmployerEvent/preselectStudentMatchedAndUnmatched/${employerEventId}/${scheduleId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetPreselectMatchedUnmatchedForEmployerScheduleQueryKey = (employerEventId: number,
    scheduleId: number,) => {
    return [`/interviewSchedulingEmployerEvent/preselectStudentMatchedAndUnmatched/${employerEventId}/${scheduleId}`] as const;
    }

    
export const getGetPreselectMatchedUnmatchedForEmployerScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getPreselectMatchedUnmatchedForEmployerSchedule>>, TError = unknown>(employerEventId: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPreselectMatchedUnmatchedForEmployerSchedule>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPreselectMatchedUnmatchedForEmployerScheduleQueryKey(employerEventId,scheduleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreselectMatchedUnmatchedForEmployerSchedule>>> = ({ signal }) => getPreselectMatchedUnmatchedForEmployerSchedule(employerEventId,scheduleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId && scheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPreselectMatchedUnmatchedForEmployerSchedule>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPreselectMatchedUnmatchedForEmployerScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getPreselectMatchedUnmatchedForEmployerSchedule>>>
export type GetPreselectMatchedUnmatchedForEmployerScheduleQueryError = unknown



export function useGetPreselectMatchedUnmatchedForEmployerSchedule<TData = Awaited<ReturnType<typeof getPreselectMatchedUnmatchedForEmployerSchedule>>, TError = unknown>(
 employerEventId: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPreselectMatchedUnmatchedForEmployerSchedule>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPreselectMatchedUnmatchedForEmployerScheduleQueryOptions(employerEventId,scheduleId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUniversityInterviewSchedulingEventSchedulesFromEmployerSide = (
    eid: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmployerScheduleOverviewResponse[]>(
      {url: `/interviewSchedulingEmployerEvent/schedules/${eid}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUniversityInterviewSchedulingEventSchedulesFromEmployerSideQueryKey = (eid: number,) => {
    return [`/interviewSchedulingEmployerEvent/schedules/${eid}`] as const;
    }

    
export const getGetUniversityInterviewSchedulingEventSchedulesFromEmployerSideQueryOptions = <TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, TError = unknown>(eid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUniversityInterviewSchedulingEventSchedulesFromEmployerSideQueryKey(eid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>> = ({ signal }) => getUniversityInterviewSchedulingEventSchedulesFromEmployerSide(eid, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUniversityInterviewSchedulingEventSchedulesFromEmployerSideQueryResult = NonNullable<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>>
export type GetUniversityInterviewSchedulingEventSchedulesFromEmployerSideQueryError = unknown



export function useGetUniversityInterviewSchedulingEventSchedulesFromEmployerSide<TData = Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, TError = unknown>(
 eid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUniversityInterviewSchedulingEventSchedulesFromEmployerSideQueryOptions(eid,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createUniversityInterviewSchedulingEventSchedulesFromEmployerSide = (
    eid: number,
    interviewSchedulingCreateEmployerSchedulesRequest: InterviewSchedulingCreateEmployerSchedulesRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingCreateEmployerSchedulesResponse>(
      {url: `/interviewSchedulingEmployerEvent/schedules/${eid}/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingCreateEmployerSchedulesRequest, signal
    },
      );
    }
  


export const getCreateUniversityInterviewSchedulingEventSchedulesFromEmployerSideMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, TError,{eid: number;data: InterviewSchedulingCreateEmployerSchedulesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, TError,{eid: number;data: InterviewSchedulingCreateEmployerSchedulesRequest}, TContext> => {
    
const mutationKey = ['createUniversityInterviewSchedulingEventSchedulesFromEmployerSide'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, {eid: number;data: InterviewSchedulingCreateEmployerSchedulesRequest}> = (props) => {
          const {eid,data} = props ?? {};

          return  createUniversityInterviewSchedulingEventSchedulesFromEmployerSide(eid,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUniversityInterviewSchedulingEventSchedulesFromEmployerSideMutationResult = NonNullable<Awaited<ReturnType<typeof createUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>>
    export type CreateUniversityInterviewSchedulingEventSchedulesFromEmployerSideMutationBody = InterviewSchedulingCreateEmployerSchedulesRequest
    export type CreateUniversityInterviewSchedulingEventSchedulesFromEmployerSideMutationError = unknown

    export const useCreateUniversityInterviewSchedulingEventSchedulesFromEmployerSide = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, TError,{eid: number;data: InterviewSchedulingCreateEmployerSchedulesRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>,
        TError,
        {eid: number;data: InterviewSchedulingCreateEmployerSchedulesRequest},
        TContext
      > => {

      const mutationOptions = getCreateUniversityInterviewSchedulingEventSchedulesFromEmployerSideMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const deleteUniversityInterviewSchedulingEventSchedulesFromEmployerSide = (
    eid: number,
    interviewSchedulingDeleteEmployerSchedulesRequest: InterviewSchedulingDeleteEmployerSchedulesRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingEmployerEvent/schedules/${eid}/delete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingDeleteEmployerSchedulesRequest, signal
    },
      );
    }
  


export const getDeleteUniversityInterviewSchedulingEventSchedulesFromEmployerSideMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, TError,{eid: number;data: InterviewSchedulingDeleteEmployerSchedulesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, TError,{eid: number;data: InterviewSchedulingDeleteEmployerSchedulesRequest}, TContext> => {
    
const mutationKey = ['deleteUniversityInterviewSchedulingEventSchedulesFromEmployerSide'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, {eid: number;data: InterviewSchedulingDeleteEmployerSchedulesRequest}> = (props) => {
          const {eid,data} = props ?? {};

          return  deleteUniversityInterviewSchedulingEventSchedulesFromEmployerSide(eid,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUniversityInterviewSchedulingEventSchedulesFromEmployerSideMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>>
    export type DeleteUniversityInterviewSchedulingEventSchedulesFromEmployerSideMutationBody = InterviewSchedulingDeleteEmployerSchedulesRequest
    export type DeleteUniversityInterviewSchedulingEventSchedulesFromEmployerSideMutationError = unknown

    export const useDeleteUniversityInterviewSchedulingEventSchedulesFromEmployerSide = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, TError,{eid: number;data: InterviewSchedulingDeleteEmployerSchedulesRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>,
        TError,
        {eid: number;data: InterviewSchedulingDeleteEmployerSchedulesRequest},
        TContext
      > => {

      const mutationOptions = getDeleteUniversityInterviewSchedulingEventSchedulesFromEmployerSideMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const updateUniversityInterviewSchedulingEventSchedulesFromEmployerSide = (
    eid: number,
    interviewSchedulingUpdateEmployerSchedulesRequest: InterviewSchedulingUpdateEmployerSchedulesRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingEmployerEvent/schedules/${eid}/update`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingUpdateEmployerSchedulesRequest, signal
    },
      );
    }
  


export const getUpdateUniversityInterviewSchedulingEventSchedulesFromEmployerSideMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, TError,{eid: number;data: InterviewSchedulingUpdateEmployerSchedulesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, TError,{eid: number;data: InterviewSchedulingUpdateEmployerSchedulesRequest}, TContext> => {
    
const mutationKey = ['updateUniversityInterviewSchedulingEventSchedulesFromEmployerSide'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, {eid: number;data: InterviewSchedulingUpdateEmployerSchedulesRequest}> = (props) => {
          const {eid,data} = props ?? {};

          return  updateUniversityInterviewSchedulingEventSchedulesFromEmployerSide(eid,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUniversityInterviewSchedulingEventSchedulesFromEmployerSideMutationResult = NonNullable<Awaited<ReturnType<typeof updateUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>>
    export type UpdateUniversityInterviewSchedulingEventSchedulesFromEmployerSideMutationBody = InterviewSchedulingUpdateEmployerSchedulesRequest
    export type UpdateUniversityInterviewSchedulingEventSchedulesFromEmployerSideMutationError = unknown

    export const useUpdateUniversityInterviewSchedulingEventSchedulesFromEmployerSide = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>, TError,{eid: number;data: InterviewSchedulingUpdateEmployerSchedulesRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateUniversityInterviewSchedulingEventSchedulesFromEmployerSide>>,
        TError,
        {eid: number;data: InterviewSchedulingUpdateEmployerSchedulesRequest},
        TContext
      > => {

      const mutationOptions = getUpdateUniversityInterviewSchedulingEventSchedulesFromEmployerSideMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getEmployerSubmittedInformationForInterviewSchedulingEvent = (
    eid: number,
    scheduleId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmployerFullScheduleResponse>(
      {url: `/interviewSchedulingEmployerEvent/schedules/${eid}/${scheduleId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEmployerSubmittedInformationForInterviewSchedulingEventQueryKey = (eid: number,
    scheduleId: number,) => {
    return [`/interviewSchedulingEmployerEvent/schedules/${eid}/${scheduleId}`] as const;
    }

    
export const getGetEmployerSubmittedInformationForInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerSubmittedInformationForInterviewSchedulingEvent>>, TError = unknown>(eid: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerSubmittedInformationForInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerSubmittedInformationForInterviewSchedulingEventQueryKey(eid,scheduleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerSubmittedInformationForInterviewSchedulingEvent>>> = ({ signal }) => getEmployerSubmittedInformationForInterviewSchedulingEvent(eid,scheduleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eid && scheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerSubmittedInformationForInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployerSubmittedInformationForInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerSubmittedInformationForInterviewSchedulingEvent>>>
export type GetEmployerSubmittedInformationForInterviewSchedulingEventQueryError = unknown



export function useGetEmployerSubmittedInformationForInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof getEmployerSubmittedInformationForInterviewSchedulingEvent>>, TError = unknown>(
 eid: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerSubmittedInformationForInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmployerSubmittedInformationForInterviewSchedulingEventQueryOptions(eid,scheduleId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const submitEmployerQuestionAnswersForInterviewSchedulingEvent = (
    eid: number,
    scheduleId: number,
    employerInterviewScheduleQuestionAnswerRequest: EmployerInterviewScheduleQuestionAnswerRequest[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingEmployerEvent/schedules/${eid}/${scheduleId}/employerAnswers/update`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: employerInterviewScheduleQuestionAnswerRequest, signal
    },
      );
    }
  


export const getSubmitEmployerQuestionAnswersForInterviewSchedulingEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployerQuestionAnswersForInterviewSchedulingEvent>>, TError,{eid: number;scheduleId: number;data: EmployerInterviewScheduleQuestionAnswerRequest[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitEmployerQuestionAnswersForInterviewSchedulingEvent>>, TError,{eid: number;scheduleId: number;data: EmployerInterviewScheduleQuestionAnswerRequest[]}, TContext> => {
    
const mutationKey = ['submitEmployerQuestionAnswersForInterviewSchedulingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitEmployerQuestionAnswersForInterviewSchedulingEvent>>, {eid: number;scheduleId: number;data: EmployerInterviewScheduleQuestionAnswerRequest[]}> = (props) => {
          const {eid,scheduleId,data} = props ?? {};

          return  submitEmployerQuestionAnswersForInterviewSchedulingEvent(eid,scheduleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitEmployerQuestionAnswersForInterviewSchedulingEventMutationResult = NonNullable<Awaited<ReturnType<typeof submitEmployerQuestionAnswersForInterviewSchedulingEvent>>>
    export type SubmitEmployerQuestionAnswersForInterviewSchedulingEventMutationBody = EmployerInterviewScheduleQuestionAnswerRequest[]
    export type SubmitEmployerQuestionAnswersForInterviewSchedulingEventMutationError = unknown

    export const useSubmitEmployerQuestionAnswersForInterviewSchedulingEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployerQuestionAnswersForInterviewSchedulingEvent>>, TError,{eid: number;scheduleId: number;data: EmployerInterviewScheduleQuestionAnswerRequest[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitEmployerQuestionAnswersForInterviewSchedulingEvent>>,
        TError,
        {eid: number;scheduleId: number;data: EmployerInterviewScheduleQuestionAnswerRequest[]},
        TContext
      > => {

      const mutationOptions = getSubmitEmployerQuestionAnswersForInterviewSchedulingEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const submitEmployerInterviewOptionsForInterviewSchedulingEvent = (
    eid: number,
    scheduleId: number,
    employerScheduleUpdateInterviewOptionsRequest: EmployerScheduleUpdateInterviewOptionsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingEmployerEvent/schedules/${eid}/${scheduleId}/interviewOptions/update`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: employerScheduleUpdateInterviewOptionsRequest, signal
    },
      );
    }
  


export const getSubmitEmployerInterviewOptionsForInterviewSchedulingEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployerInterviewOptionsForInterviewSchedulingEvent>>, TError,{eid: number;scheduleId: number;data: EmployerScheduleUpdateInterviewOptionsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitEmployerInterviewOptionsForInterviewSchedulingEvent>>, TError,{eid: number;scheduleId: number;data: EmployerScheduleUpdateInterviewOptionsRequest}, TContext> => {
    
const mutationKey = ['submitEmployerInterviewOptionsForInterviewSchedulingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitEmployerInterviewOptionsForInterviewSchedulingEvent>>, {eid: number;scheduleId: number;data: EmployerScheduleUpdateInterviewOptionsRequest}> = (props) => {
          const {eid,scheduleId,data} = props ?? {};

          return  submitEmployerInterviewOptionsForInterviewSchedulingEvent(eid,scheduleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitEmployerInterviewOptionsForInterviewSchedulingEventMutationResult = NonNullable<Awaited<ReturnType<typeof submitEmployerInterviewOptionsForInterviewSchedulingEvent>>>
    export type SubmitEmployerInterviewOptionsForInterviewSchedulingEventMutationBody = EmployerScheduleUpdateInterviewOptionsRequest
    export type SubmitEmployerInterviewOptionsForInterviewSchedulingEventMutationError = unknown

    export const useSubmitEmployerInterviewOptionsForInterviewSchedulingEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployerInterviewOptionsForInterviewSchedulingEvent>>, TError,{eid: number;scheduleId: number;data: EmployerScheduleUpdateInterviewOptionsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitEmployerInterviewOptionsForInterviewSchedulingEvent>>,
        TError,
        {eid: number;scheduleId: number;data: EmployerScheduleUpdateInterviewOptionsRequest},
        TContext
      > => {

      const mutationOptions = getSubmitEmployerInterviewOptionsForInterviewSchedulingEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const submitEmployerJobInformationForInterviewSchedulingEvent = (
    eid: number,
    scheduleId: number,
    employerScheduleJobInformation: EmployerScheduleJobInformation,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingEmployerEvent/schedules/${eid}/${scheduleId}/jobInformation/update`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: employerScheduleJobInformation, signal
    },
      );
    }
  


export const getSubmitEmployerJobInformationForInterviewSchedulingEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployerJobInformationForInterviewSchedulingEvent>>, TError,{eid: number;scheduleId: number;data: EmployerScheduleJobInformation}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitEmployerJobInformationForInterviewSchedulingEvent>>, TError,{eid: number;scheduleId: number;data: EmployerScheduleJobInformation}, TContext> => {
    
const mutationKey = ['submitEmployerJobInformationForInterviewSchedulingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitEmployerJobInformationForInterviewSchedulingEvent>>, {eid: number;scheduleId: number;data: EmployerScheduleJobInformation}> = (props) => {
          const {eid,scheduleId,data} = props ?? {};

          return  submitEmployerJobInformationForInterviewSchedulingEvent(eid,scheduleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitEmployerJobInformationForInterviewSchedulingEventMutationResult = NonNullable<Awaited<ReturnType<typeof submitEmployerJobInformationForInterviewSchedulingEvent>>>
    export type SubmitEmployerJobInformationForInterviewSchedulingEventMutationBody = EmployerScheduleJobInformation
    export type SubmitEmployerJobInformationForInterviewSchedulingEventMutationError = unknown

    export const useSubmitEmployerJobInformationForInterviewSchedulingEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployerJobInformationForInterviewSchedulingEvent>>, TError,{eid: number;scheduleId: number;data: EmployerScheduleJobInformation}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitEmployerJobInformationForInterviewSchedulingEvent>>,
        TError,
        {eid: number;scheduleId: number;data: EmployerScheduleJobInformation},
        TContext
      > => {

      const mutationOptions = getSubmitEmployerJobInformationForInterviewSchedulingEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getEmployerInterviewScheduleStatuses = (
    employerEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmployerInterviewScheduleStatusResponse[]>(
      {url: `/interviewSchedulingEmployerEvent/schedules/${employerEventId}/status`, method: 'GET', signal
    },
      );
    }
  

export const getGetEmployerInterviewScheduleStatusesQueryKey = (employerEventId: number,) => {
    return [`/interviewSchedulingEmployerEvent/schedules/${employerEventId}/status`] as const;
    }

    
export const getGetEmployerInterviewScheduleStatusesQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerInterviewScheduleStatuses>>, TError = unknown>(employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerInterviewScheduleStatuses>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerInterviewScheduleStatusesQueryKey(employerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerInterviewScheduleStatuses>>> = ({ signal }) => getEmployerInterviewScheduleStatuses(employerEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerInterviewScheduleStatuses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployerInterviewScheduleStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerInterviewScheduleStatuses>>>
export type GetEmployerInterviewScheduleStatusesQueryError = unknown



export function useGetEmployerInterviewScheduleStatuses<TData = Awaited<ReturnType<typeof getEmployerInterviewScheduleStatuses>>, TError = unknown>(
 employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerInterviewScheduleStatuses>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmployerInterviewScheduleStatusesQueryOptions(employerEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const fetchAdditionalScheduleInfoForEmployerInterviewSchedulingEvent = (
    employerEventId: number,
    scheduleId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/interviewSchedulingEmployerEvent/schedules/${employerEventId}/${scheduleId}/additionalScheduleInfo`, method: 'GET', signal
    },
      );
    }
  

export const getFetchAdditionalScheduleInfoForEmployerInterviewSchedulingEventQueryKey = (employerEventId: number,
    scheduleId: number,) => {
    return [`/interviewSchedulingEmployerEvent/schedules/${employerEventId}/${scheduleId}/additionalScheduleInfo`] as const;
    }

    
export const getFetchAdditionalScheduleInfoForEmployerInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof fetchAdditionalScheduleInfoForEmployerInterviewSchedulingEvent>>, TError = unknown>(employerEventId: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchAdditionalScheduleInfoForEmployerInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchAdditionalScheduleInfoForEmployerInterviewSchedulingEventQueryKey(employerEventId,scheduleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchAdditionalScheduleInfoForEmployerInterviewSchedulingEvent>>> = ({ signal }) => fetchAdditionalScheduleInfoForEmployerInterviewSchedulingEvent(employerEventId,scheduleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId && scheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchAdditionalScheduleInfoForEmployerInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchAdditionalScheduleInfoForEmployerInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof fetchAdditionalScheduleInfoForEmployerInterviewSchedulingEvent>>>
export type FetchAdditionalScheduleInfoForEmployerInterviewSchedulingEventQueryError = unknown



export function useFetchAdditionalScheduleInfoForEmployerInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof fetchAdditionalScheduleInfoForEmployerInterviewSchedulingEvent>>, TError = unknown>(
 employerEventId: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchAdditionalScheduleInfoForEmployerInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchAdditionalScheduleInfoForEmployerInterviewSchedulingEventQueryOptions(employerEventId,scheduleId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateAdditionalScheduleInfoForEmployerInterviewSchedulingEvent = (
    employerEventId: number,
    scheduleId: number,
    updateInterviewSchedulingAdditionalScheduleInformationSection: UpdateInterviewSchedulingAdditionalScheduleInformationSection,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingEmployerEvent/schedules/${employerEventId}/${scheduleId}/additionalScheduleInfo`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateInterviewSchedulingAdditionalScheduleInformationSection, signal
    },
      );
    }
  


export const getUpdateAdditionalScheduleInfoForEmployerInterviewSchedulingEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdditionalScheduleInfoForEmployerInterviewSchedulingEvent>>, TError,{employerEventId: number;scheduleId: number;data: UpdateInterviewSchedulingAdditionalScheduleInformationSection}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAdditionalScheduleInfoForEmployerInterviewSchedulingEvent>>, TError,{employerEventId: number;scheduleId: number;data: UpdateInterviewSchedulingAdditionalScheduleInformationSection}, TContext> => {
    
const mutationKey = ['updateAdditionalScheduleInfoForEmployerInterviewSchedulingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdditionalScheduleInfoForEmployerInterviewSchedulingEvent>>, {employerEventId: number;scheduleId: number;data: UpdateInterviewSchedulingAdditionalScheduleInformationSection}> = (props) => {
          const {employerEventId,scheduleId,data} = props ?? {};

          return  updateAdditionalScheduleInfoForEmployerInterviewSchedulingEvent(employerEventId,scheduleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdditionalScheduleInfoForEmployerInterviewSchedulingEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdditionalScheduleInfoForEmployerInterviewSchedulingEvent>>>
    export type UpdateAdditionalScheduleInfoForEmployerInterviewSchedulingEventMutationBody = UpdateInterviewSchedulingAdditionalScheduleInformationSection
    export type UpdateAdditionalScheduleInfoForEmployerInterviewSchedulingEventMutationError = unknown

    export const useUpdateAdditionalScheduleInfoForEmployerInterviewSchedulingEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdditionalScheduleInfoForEmployerInterviewSchedulingEvent>>, TError,{employerEventId: number;scheduleId: number;data: UpdateInterviewSchedulingAdditionalScheduleInformationSection}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdditionalScheduleInfoForEmployerInterviewSchedulingEvent>>,
        TError,
        {employerEventId: number;scheduleId: number;data: UpdateInterviewSchedulingAdditionalScheduleInformationSection},
        TContext
      > => {

      const mutationOptions = getUpdateAdditionalScheduleInfoForEmployerInterviewSchedulingEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const upsertScheduleSettings = (
    employerEventId: number,
    scheduleId: number,
    scheduleSettingsRequest: ScheduleSettingsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingEmployerEvent/schedules/${employerEventId}/${scheduleId}/scheduleOptions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scheduleSettingsRequest, signal
    },
      );
    }
  


export const getUpsertScheduleSettingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertScheduleSettings>>, TError,{employerEventId: number;scheduleId: number;data: ScheduleSettingsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertScheduleSettings>>, TError,{employerEventId: number;scheduleId: number;data: ScheduleSettingsRequest}, TContext> => {
    
const mutationKey = ['upsertScheduleSettings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertScheduleSettings>>, {employerEventId: number;scheduleId: number;data: ScheduleSettingsRequest}> = (props) => {
          const {employerEventId,scheduleId,data} = props ?? {};

          return  upsertScheduleSettings(employerEventId,scheduleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertScheduleSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof upsertScheduleSettings>>>
    export type UpsertScheduleSettingsMutationBody = ScheduleSettingsRequest
    export type UpsertScheduleSettingsMutationError = unknown

    export const useUpsertScheduleSettings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertScheduleSettings>>, TError,{employerEventId: number;scheduleId: number;data: ScheduleSettingsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertScheduleSettings>>,
        TError,
        {employerEventId: number;scheduleId: number;data: ScheduleSettingsRequest},
        TContext
      > => {

      const mutationOptions = getUpsertScheduleSettingsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const submitScheduleForInterviewSchedulingEvent = (
    employerEventId: number,
    scheduleId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingEmployerEvent/schedules/${employerEventId}/${scheduleId}/submit`, method: 'POST', signal
    },
      );
    }
  


export const getSubmitScheduleForInterviewSchedulingEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitScheduleForInterviewSchedulingEvent>>, TError,{employerEventId: number;scheduleId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitScheduleForInterviewSchedulingEvent>>, TError,{employerEventId: number;scheduleId: number}, TContext> => {
    
const mutationKey = ['submitScheduleForInterviewSchedulingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitScheduleForInterviewSchedulingEvent>>, {employerEventId: number;scheduleId: number}> = (props) => {
          const {employerEventId,scheduleId} = props ?? {};

          return  submitScheduleForInterviewSchedulingEvent(employerEventId,scheduleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitScheduleForInterviewSchedulingEventMutationResult = NonNullable<Awaited<ReturnType<typeof submitScheduleForInterviewSchedulingEvent>>>
    
    export type SubmitScheduleForInterviewSchedulingEventMutationError = unknown

    export const useSubmitScheduleForInterviewSchedulingEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitScheduleForInterviewSchedulingEvent>>, TError,{employerEventId: number;scheduleId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitScheduleForInterviewSchedulingEvent>>,
        TError,
        {employerEventId: number;scheduleId: number},
        TContext
      > => {

      const mutationOptions = getSubmitScheduleForInterviewSchedulingEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchStaticOfficesListForEmployerInterviewSchedulingEvent = (
    employerEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/interviewSchedulingEmployerEvent/staticOffice/${employerEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getFetchStaticOfficesListForEmployerInterviewSchedulingEventQueryKey = (employerEventId: number,) => {
    return [`/interviewSchedulingEmployerEvent/staticOffice/${employerEventId}`] as const;
    }

    
export const getFetchStaticOfficesListForEmployerInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof fetchStaticOfficesListForEmployerInterviewSchedulingEvent>>, TError = unknown>(employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchStaticOfficesListForEmployerInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchStaticOfficesListForEmployerInterviewSchedulingEventQueryKey(employerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchStaticOfficesListForEmployerInterviewSchedulingEvent>>> = ({ signal }) => fetchStaticOfficesListForEmployerInterviewSchedulingEvent(employerEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchStaticOfficesListForEmployerInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchStaticOfficesListForEmployerInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof fetchStaticOfficesListForEmployerInterviewSchedulingEvent>>>
export type FetchStaticOfficesListForEmployerInterviewSchedulingEventQueryError = unknown



export function useFetchStaticOfficesListForEmployerInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof fetchStaticOfficesListForEmployerInterviewSchedulingEvent>>, TError = unknown>(
 employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchStaticOfficesListForEmployerInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchStaticOfficesListForEmployerInterviewSchedulingEventQueryOptions(employerEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const fetchStaticPracticeAreasListForEmployerInterviewSchedulingEvent = (
    employerEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/interviewSchedulingEmployerEvent/staticPracticeArea/${employerEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getFetchStaticPracticeAreasListForEmployerInterviewSchedulingEventQueryKey = (employerEventId: number,) => {
    return [`/interviewSchedulingEmployerEvent/staticPracticeArea/${employerEventId}`] as const;
    }

    
export const getFetchStaticPracticeAreasListForEmployerInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof fetchStaticPracticeAreasListForEmployerInterviewSchedulingEvent>>, TError = unknown>(employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchStaticPracticeAreasListForEmployerInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchStaticPracticeAreasListForEmployerInterviewSchedulingEventQueryKey(employerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchStaticPracticeAreasListForEmployerInterviewSchedulingEvent>>> = ({ signal }) => fetchStaticPracticeAreasListForEmployerInterviewSchedulingEvent(employerEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchStaticPracticeAreasListForEmployerInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchStaticPracticeAreasListForEmployerInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof fetchStaticPracticeAreasListForEmployerInterviewSchedulingEvent>>>
export type FetchStaticPracticeAreasListForEmployerInterviewSchedulingEventQueryError = unknown



export function useFetchStaticPracticeAreasListForEmployerInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof fetchStaticPracticeAreasListForEmployerInterviewSchedulingEvent>>, TError = unknown>(
 employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchStaticPracticeAreasListForEmployerInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchStaticPracticeAreasListForEmployerInterviewSchedulingEventQueryOptions(employerEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const bulkDownloadStudentDocumentsForInterviewSchedulingJob = (
    employerEventId: number,
    scheduleId: number,
    interviewSchedulingBulkExportStudentJobApplicationDocumentsRequest: InterviewSchedulingBulkExportStudentJobApplicationDocumentsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingEmployerEvent/studentApplication/bulkDownloadDocuments/${employerEventId}/${scheduleId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: interviewSchedulingBulkExportStudentJobApplicationDocumentsRequest, signal
    },
      );
    }
  


export const getBulkDownloadStudentDocumentsForInterviewSchedulingJobMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDownloadStudentDocumentsForInterviewSchedulingJob>>, TError,{employerEventId: number;scheduleId: number;data: InterviewSchedulingBulkExportStudentJobApplicationDocumentsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkDownloadStudentDocumentsForInterviewSchedulingJob>>, TError,{employerEventId: number;scheduleId: number;data: InterviewSchedulingBulkExportStudentJobApplicationDocumentsRequest}, TContext> => {
    
const mutationKey = ['bulkDownloadStudentDocumentsForInterviewSchedulingJob'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDownloadStudentDocumentsForInterviewSchedulingJob>>, {employerEventId: number;scheduleId: number;data: InterviewSchedulingBulkExportStudentJobApplicationDocumentsRequest}> = (props) => {
          const {employerEventId,scheduleId,data} = props ?? {};

          return  bulkDownloadStudentDocumentsForInterviewSchedulingJob(employerEventId,scheduleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkDownloadStudentDocumentsForInterviewSchedulingJobMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDownloadStudentDocumentsForInterviewSchedulingJob>>>
    export type BulkDownloadStudentDocumentsForInterviewSchedulingJobMutationBody = InterviewSchedulingBulkExportStudentJobApplicationDocumentsRequest
    export type BulkDownloadStudentDocumentsForInterviewSchedulingJobMutationError = unknown

    export const useBulkDownloadStudentDocumentsForInterviewSchedulingJob = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDownloadStudentDocumentsForInterviewSchedulingJob>>, TError,{employerEventId: number;scheduleId: number;data: InterviewSchedulingBulkExportStudentJobApplicationDocumentsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkDownloadStudentDocumentsForInterviewSchedulingJob>>,
        TError,
        {employerEventId: number;scheduleId: number;data: InterviewSchedulingBulkExportStudentJobApplicationDocumentsRequest},
        TContext
      > => {

      const mutationOptions = getBulkDownloadStudentDocumentsForInterviewSchedulingJobMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getInterviewSchedulingStudentApplicationListDetails = (
    employerEventId: number,
    scheduleId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingEmployerApplicationListDetailsResponse>(
      {url: `/interviewSchedulingEmployerEvent/studentApplication/details/${employerEventId}/${scheduleId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingStudentApplicationListDetailsQueryKey = (employerEventId: number,
    scheduleId: number,) => {
    return [`/interviewSchedulingEmployerEvent/studentApplication/details/${employerEventId}/${scheduleId}`] as const;
    }

    
export const getGetInterviewSchedulingStudentApplicationListDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentApplicationListDetails>>, TError = unknown>(employerEventId: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentApplicationListDetails>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingStudentApplicationListDetailsQueryKey(employerEventId,scheduleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingStudentApplicationListDetails>>> = ({ signal }) => getInterviewSchedulingStudentApplicationListDetails(employerEventId,scheduleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId && scheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentApplicationListDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingStudentApplicationListDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingStudentApplicationListDetails>>>
export type GetInterviewSchedulingStudentApplicationListDetailsQueryError = unknown



export function useGetInterviewSchedulingStudentApplicationListDetails<TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentApplicationListDetails>>, TError = unknown>(
 employerEventId: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentApplicationListDetails>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingStudentApplicationListDetailsQueryOptions(employerEventId,scheduleId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getStudentInvitationStatusesForEmployerInterviewSchedulingEvent = (
    employerEventId: number,
    scheduleId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingEmployerScheduleInvitationStatusResponse[]>(
      {url: `/interviewSchedulingEmployerEvent/studentApplication/invitationStatus/${employerEventId}/${scheduleId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetStudentInvitationStatusesForEmployerInterviewSchedulingEventQueryKey = (employerEventId: number,
    scheduleId: number,) => {
    return [`/interviewSchedulingEmployerEvent/studentApplication/invitationStatus/${employerEventId}/${scheduleId}`] as const;
    }

    
export const getGetStudentInvitationStatusesForEmployerInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof getStudentInvitationStatusesForEmployerInterviewSchedulingEvent>>, TError = unknown>(employerEventId: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStudentInvitationStatusesForEmployerInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStudentInvitationStatusesForEmployerInterviewSchedulingEventQueryKey(employerEventId,scheduleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudentInvitationStatusesForEmployerInterviewSchedulingEvent>>> = ({ signal }) => getStudentInvitationStatusesForEmployerInterviewSchedulingEvent(employerEventId,scheduleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId && scheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStudentInvitationStatusesForEmployerInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStudentInvitationStatusesForEmployerInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof getStudentInvitationStatusesForEmployerInterviewSchedulingEvent>>>
export type GetStudentInvitationStatusesForEmployerInterviewSchedulingEventQueryError = unknown



export function useGetStudentInvitationStatusesForEmployerInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof getStudentInvitationStatusesForEmployerInterviewSchedulingEvent>>, TError = unknown>(
 employerEventId: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStudentInvitationStatusesForEmployerInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStudentInvitationStatusesForEmployerInterviewSchedulingEventQueryOptions(employerEventId,scheduleId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateStudentInvitationStatusForEmployerInterviewSchedulingEvent = (
    employerEventId: number,
    scheduleId: number,
    updateInterviewSchedulingEmployerScheduleInvitationStatus: UpdateInterviewSchedulingEmployerScheduleInvitationStatus,
 ) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingEmployerEvent/studentApplication/invitationStatus/${employerEventId}/${scheduleId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateInterviewSchedulingEmployerScheduleInvitationStatus
    },
      );
    }
  


export const getUpdateStudentInvitationStatusForEmployerInterviewSchedulingEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStudentInvitationStatusForEmployerInterviewSchedulingEvent>>, TError,{employerEventId: number;scheduleId: number;data: UpdateInterviewSchedulingEmployerScheduleInvitationStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateStudentInvitationStatusForEmployerInterviewSchedulingEvent>>, TError,{employerEventId: number;scheduleId: number;data: UpdateInterviewSchedulingEmployerScheduleInvitationStatus}, TContext> => {
    
const mutationKey = ['updateStudentInvitationStatusForEmployerInterviewSchedulingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStudentInvitationStatusForEmployerInterviewSchedulingEvent>>, {employerEventId: number;scheduleId: number;data: UpdateInterviewSchedulingEmployerScheduleInvitationStatus}> = (props) => {
          const {employerEventId,scheduleId,data} = props ?? {};

          return  updateStudentInvitationStatusForEmployerInterviewSchedulingEvent(employerEventId,scheduleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateStudentInvitationStatusForEmployerInterviewSchedulingEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateStudentInvitationStatusForEmployerInterviewSchedulingEvent>>>
    export type UpdateStudentInvitationStatusForEmployerInterviewSchedulingEventMutationBody = UpdateInterviewSchedulingEmployerScheduleInvitationStatus
    export type UpdateStudentInvitationStatusForEmployerInterviewSchedulingEventMutationError = unknown

    export const useUpdateStudentInvitationStatusForEmployerInterviewSchedulingEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStudentInvitationStatusForEmployerInterviewSchedulingEvent>>, TError,{employerEventId: number;scheduleId: number;data: UpdateInterviewSchedulingEmployerScheduleInvitationStatus}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateStudentInvitationStatusForEmployerInterviewSchedulingEvent>>,
        TError,
        {employerEventId: number;scheduleId: number;data: UpdateInterviewSchedulingEmployerScheduleInvitationStatus},
        TContext
      > => {

      const mutationOptions = getUpdateStudentInvitationStatusForEmployerInterviewSchedulingEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const updateSelectionSubmissionStatusForEmployerInterviewSchedule = (
    employerEventId: number,
    scheduleId: number,
 ) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingEmployerEvent/studentApplication/selections/${employerEventId}/${scheduleId}`, method: 'PUT'
    },
      );
    }
  


export const getUpdateSelectionSubmissionStatusForEmployerInterviewScheduleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSelectionSubmissionStatusForEmployerInterviewSchedule>>, TError,{employerEventId: number;scheduleId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSelectionSubmissionStatusForEmployerInterviewSchedule>>, TError,{employerEventId: number;scheduleId: number}, TContext> => {
    
const mutationKey = ['updateSelectionSubmissionStatusForEmployerInterviewSchedule'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSelectionSubmissionStatusForEmployerInterviewSchedule>>, {employerEventId: number;scheduleId: number}> = (props) => {
          const {employerEventId,scheduleId} = props ?? {};

          return  updateSelectionSubmissionStatusForEmployerInterviewSchedule(employerEventId,scheduleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSelectionSubmissionStatusForEmployerInterviewScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof updateSelectionSubmissionStatusForEmployerInterviewSchedule>>>
    
    export type UpdateSelectionSubmissionStatusForEmployerInterviewScheduleMutationError = unknown

    export const useUpdateSelectionSubmissionStatusForEmployerInterviewSchedule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSelectionSubmissionStatusForEmployerInterviewSchedule>>, TError,{employerEventId: number;scheduleId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSelectionSubmissionStatusForEmployerInterviewSchedule>>,
        TError,
        {employerEventId: number;scheduleId: number},
        TContext
      > => {

      const mutationOptions = getUpdateSelectionSubmissionStatusForEmployerInterviewScheduleMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getInterviewSchedulingStudentApplications = (
    employerEventId: number,
    scheduleId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InterviewSchedulingStudentApplicationResponse[]>(
      {url: `/interviewSchedulingEmployerEvent/studentApplication/${employerEventId}/${scheduleId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInterviewSchedulingStudentApplicationsQueryKey = (employerEventId: number,
    scheduleId: number,) => {
    return [`/interviewSchedulingEmployerEvent/studentApplication/${employerEventId}/${scheduleId}`] as const;
    }

    
export const getGetInterviewSchedulingStudentApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentApplications>>, TError = unknown>(employerEventId: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentApplications>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewSchedulingStudentApplicationsQueryKey(employerEventId,scheduleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewSchedulingStudentApplications>>> = ({ signal }) => getInterviewSchedulingStudentApplications(employerEventId,scheduleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId && scheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentApplications>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInterviewSchedulingStudentApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewSchedulingStudentApplications>>>
export type GetInterviewSchedulingStudentApplicationsQueryError = unknown



export function useGetInterviewSchedulingStudentApplications<TData = Awaited<ReturnType<typeof getInterviewSchedulingStudentApplications>>, TError = unknown>(
 employerEventId: number,
    scheduleId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInterviewSchedulingStudentApplications>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInterviewSchedulingStudentApplicationsQueryOptions(employerEventId,scheduleId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSupportingDocumentsForEmployerInterviewSchedulingEvent = (
    employerEventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SupportingDocumentResponse[]>(
      {url: `/interviewSchedulingEmployerEvent/supportingDocuments/${employerEventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetSupportingDocumentsForEmployerInterviewSchedulingEventQueryKey = (employerEventId: number,) => {
    return [`/interviewSchedulingEmployerEvent/supportingDocuments/${employerEventId}`] as const;
    }

    
export const getGetSupportingDocumentsForEmployerInterviewSchedulingEventQueryOptions = <TData = Awaited<ReturnType<typeof getSupportingDocumentsForEmployerInterviewSchedulingEvent>>, TError = unknown>(employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportingDocumentsForEmployerInterviewSchedulingEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportingDocumentsForEmployerInterviewSchedulingEventQueryKey(employerEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportingDocumentsForEmployerInterviewSchedulingEvent>>> = ({ signal }) => getSupportingDocumentsForEmployerInterviewSchedulingEvent(employerEventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupportingDocumentsForEmployerInterviewSchedulingEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupportingDocumentsForEmployerInterviewSchedulingEventQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportingDocumentsForEmployerInterviewSchedulingEvent>>>
export type GetSupportingDocumentsForEmployerInterviewSchedulingEventQueryError = unknown



export function useGetSupportingDocumentsForEmployerInterviewSchedulingEvent<TData = Awaited<ReturnType<typeof getSupportingDocumentsForEmployerInterviewSchedulingEvent>>, TError = unknown>(
 employerEventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportingDocumentsForEmployerInterviewSchedulingEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSupportingDocumentsForEmployerInterviewSchedulingEventQueryOptions(employerEventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getEmployerInterviewSchedulingEventSubmittedOptions = (
    eid: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmployerInterviewSchedulingSubmittedOptionsResponse>(
      {url: `/interviewSchedulingEmployerEvent/toggles/${eid}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEmployerInterviewSchedulingEventSubmittedOptionsQueryKey = (eid: number,) => {
    return [`/interviewSchedulingEmployerEvent/toggles/${eid}`] as const;
    }

    
export const getGetEmployerInterviewSchedulingEventSubmittedOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerInterviewSchedulingEventSubmittedOptions>>, TError = unknown>(eid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerInterviewSchedulingEventSubmittedOptions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerInterviewSchedulingEventSubmittedOptionsQueryKey(eid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerInterviewSchedulingEventSubmittedOptions>>> = ({ signal }) => getEmployerInterviewSchedulingEventSubmittedOptions(eid, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerInterviewSchedulingEventSubmittedOptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployerInterviewSchedulingEventSubmittedOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerInterviewSchedulingEventSubmittedOptions>>>
export type GetEmployerInterviewSchedulingEventSubmittedOptionsQueryError = unknown



export function useGetEmployerInterviewSchedulingEventSubmittedOptions<TData = Awaited<ReturnType<typeof getEmployerInterviewSchedulingEventSubmittedOptions>>, TError = unknown>(
 eid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerInterviewSchedulingEventSubmittedOptions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmployerInterviewSchedulingEventSubmittedOptionsQueryOptions(eid,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const submitEmployerInterviewSchedulingMultipleInterviewsEnabled = (
    eid: number,
    employerInterviewSchedulingOptionToggleRequest: EmployerInterviewSchedulingOptionToggleRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/interviewSchedulingEmployerEvent/toggles/${eid}/multipleInterviews`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: employerInterviewSchedulingOptionToggleRequest, signal
    },
      );
    }
  


export const getSubmitEmployerInterviewSchedulingMultipleInterviewsEnabledMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployerInterviewSchedulingMultipleInterviewsEnabled>>, TError,{eid: number;data: EmployerInterviewSchedulingOptionToggleRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitEmployerInterviewSchedulingMultipleInterviewsEnabled>>, TError,{eid: number;data: EmployerInterviewSchedulingOptionToggleRequest}, TContext> => {
    
const mutationKey = ['submitEmployerInterviewSchedulingMultipleInterviewsEnabled'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitEmployerInterviewSchedulingMultipleInterviewsEnabled>>, {eid: number;data: EmployerInterviewSchedulingOptionToggleRequest}> = (props) => {
          const {eid,data} = props ?? {};

          return  submitEmployerInterviewSchedulingMultipleInterviewsEnabled(eid,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitEmployerInterviewSchedulingMultipleInterviewsEnabledMutationResult = NonNullable<Awaited<ReturnType<typeof submitEmployerInterviewSchedulingMultipleInterviewsEnabled>>>
    export type SubmitEmployerInterviewSchedulingMultipleInterviewsEnabledMutationBody = EmployerInterviewSchedulingOptionToggleRequest
    export type SubmitEmployerInterviewSchedulingMultipleInterviewsEnabledMutationError = unknown

    export const useSubmitEmployerInterviewSchedulingMultipleInterviewsEnabled = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployerInterviewSchedulingMultipleInterviewsEnabled>>, TError,{eid: number;data: EmployerInterviewSchedulingOptionToggleRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitEmployerInterviewSchedulingMultipleInterviewsEnabled>>,
        TError,
        {eid: number;data: EmployerInterviewSchedulingOptionToggleRequest},
        TContext
      > => {

      const mutationOptions = getSubmitEmployerInterviewSchedulingMultipleInterviewsEnabledMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const navigateToUniversityEventLandingPageOnEmployerSide = (
    orgFriendlyName: string,
    employerExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingEmployerEvent/universityEventLink/${orgFriendlyName}/${employerExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getNavigateToUniversityEventLandingPageOnEmployerSideQueryKey = (orgFriendlyName: string,
    employerExtension: string,) => {
    return [`/interviewSchedulingEmployerEvent/universityEventLink/${orgFriendlyName}/${employerExtension}`] as const;
    }

    
export const getNavigateToUniversityEventLandingPageOnEmployerSideQueryOptions = <TData = Awaited<ReturnType<typeof navigateToUniversityEventLandingPageOnEmployerSide>>, TError = unknown>(orgFriendlyName: string,
    employerExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof navigateToUniversityEventLandingPageOnEmployerSide>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNavigateToUniversityEventLandingPageOnEmployerSideQueryKey(orgFriendlyName,employerExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof navigateToUniversityEventLandingPageOnEmployerSide>>> = ({ signal }) => navigateToUniversityEventLandingPageOnEmployerSide(orgFriendlyName,employerExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgFriendlyName && employerExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof navigateToUniversityEventLandingPageOnEmployerSide>>, TError, TData> & { queryKey: QueryKey }
}

export type NavigateToUniversityEventLandingPageOnEmployerSideQueryResult = NonNullable<Awaited<ReturnType<typeof navigateToUniversityEventLandingPageOnEmployerSide>>>
export type NavigateToUniversityEventLandingPageOnEmployerSideQueryError = unknown



export function useNavigateToUniversityEventLandingPageOnEmployerSide<TData = Awaited<ReturnType<typeof navigateToUniversityEventLandingPageOnEmployerSide>>, TError = unknown>(
 orgFriendlyName: string,
    employerExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof navigateToUniversityEventLandingPageOnEmployerSide>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getNavigateToUniversityEventLandingPageOnEmployerSideQueryOptions(orgFriendlyName,employerExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const navigateToEmployerSetupBasedOnCustomerStatus = (
    orgFriendlyName: string,
    employerExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/interviewSchedulingEmployerLogin/employerSetup/${orgFriendlyName}/${employerExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getNavigateToEmployerSetupBasedOnCustomerStatusQueryKey = (orgFriendlyName: string,
    employerExtension: string,) => {
    return [`/interviewSchedulingEmployerLogin/employerSetup/${orgFriendlyName}/${employerExtension}`] as const;
    }

    
export const getNavigateToEmployerSetupBasedOnCustomerStatusQueryOptions = <TData = Awaited<ReturnType<typeof navigateToEmployerSetupBasedOnCustomerStatus>>, TError = unknown>(orgFriendlyName: string,
    employerExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof navigateToEmployerSetupBasedOnCustomerStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNavigateToEmployerSetupBasedOnCustomerStatusQueryKey(orgFriendlyName,employerExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof navigateToEmployerSetupBasedOnCustomerStatus>>> = ({ signal }) => navigateToEmployerSetupBasedOnCustomerStatus(orgFriendlyName,employerExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgFriendlyName && employerExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof navigateToEmployerSetupBasedOnCustomerStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type NavigateToEmployerSetupBasedOnCustomerStatusQueryResult = NonNullable<Awaited<ReturnType<typeof navigateToEmployerSetupBasedOnCustomerStatus>>>
export type NavigateToEmployerSetupBasedOnCustomerStatusQueryError = unknown



export function useNavigateToEmployerSetupBasedOnCustomerStatus<TData = Awaited<ReturnType<typeof navigateToEmployerSetupBasedOnCustomerStatus>>, TError = unknown>(
 orgFriendlyName: string,
    employerExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof navigateToEmployerSetupBasedOnCustomerStatus>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getNavigateToEmployerSetupBasedOnCustomerStatusQueryOptions(orgFriendlyName,employerExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const registerWithEmail = (
    validateEmployerRequest: ValidateEmployerRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ValidateEmployerResponse>(
      {url: `/interviewSchedulingEmployerLogin/register/employer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: validateEmployerRequest, signal
    },
      );
    }
  


export const getRegisterWithEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerWithEmail>>, TError,{data: ValidateEmployerRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof registerWithEmail>>, TError,{data: ValidateEmployerRequest}, TContext> => {
    
const mutationKey = ['registerWithEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerWithEmail>>, {data: ValidateEmployerRequest}> = (props) => {
          const {data} = props ?? {};

          return  registerWithEmail(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterWithEmailMutationResult = NonNullable<Awaited<ReturnType<typeof registerWithEmail>>>
    export type RegisterWithEmailMutationBody = ValidateEmployerRequest
    export type RegisterWithEmailMutationError = unknown

    export const useRegisterWithEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerWithEmail>>, TError,{data: ValidateEmployerRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof registerWithEmail>>,
        TError,
        {data: ValidateEmployerRequest},
        TContext
      > => {

      const mutationOptions = getRegisterWithEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const createNewUser = (
    newMemberRequest: NewMemberRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/interviewSchedulingEmployerLogin/register/member`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newMemberRequest, signal
    },
      );
    }
  


export const getCreateNewUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewUser>>, TError,{data: NewMemberRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createNewUser>>, TError,{data: NewMemberRequest}, TContext> => {
    
const mutationKey = ['createNewUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNewUser>>, {data: NewMemberRequest}> = (props) => {
          const {data} = props ?? {};

          return  createNewUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateNewUserMutationResult = NonNullable<Awaited<ReturnType<typeof createNewUser>>>
    export type CreateNewUserMutationBody = NewMemberRequest
    export type CreateNewUserMutationError = unknown

    export const useCreateNewUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewUser>>, TError,{data: NewMemberRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createNewUser>>,
        TError,
        {data: NewMemberRequest},
        TContext
      > => {

      const mutationOptions = getCreateNewUserMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const createNewOrg = (
    newOrgRequest: NewOrgRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/interviewSchedulingEmployerLogin/register/org`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newOrgRequest, signal
    },
      );
    }
  


export const getCreateNewOrgMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewOrg>>, TError,{data: NewOrgRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createNewOrg>>, TError,{data: NewOrgRequest}, TContext> => {
    
const mutationKey = ['createNewOrg'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNewOrg>>, {data: NewOrgRequest}> = (props) => {
          const {data} = props ?? {};

          return  createNewOrg(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateNewOrgMutationResult = NonNullable<Awaited<ReturnType<typeof createNewOrg>>>
    export type CreateNewOrgMutationBody = NewOrgRequest
    export type CreateNewOrgMutationError = unknown

    export const useCreateNewOrg = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewOrg>>, TError,{data: NewOrgRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createNewOrg>>,
        TError,
        {data: NewOrgRequest},
        TContext
      > => {

      const mutationOptions = getCreateNewOrgMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getEmployerEmailFromTempEmployerExtension = (
    eventId: number,
    tempEmployerExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/interviewSchedulingEmployerLogin/register/${eventId}/email/${tempEmployerExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEmployerEmailFromTempEmployerExtensionQueryKey = (eventId: number,
    tempEmployerExtension: string,) => {
    return [`/interviewSchedulingEmployerLogin/register/${eventId}/email/${tempEmployerExtension}`] as const;
    }

    
export const getGetEmployerEmailFromTempEmployerExtensionQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerEmailFromTempEmployerExtension>>, TError = unknown>(eventId: number,
    tempEmployerExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerEmailFromTempEmployerExtension>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerEmailFromTempEmployerExtensionQueryKey(eventId,tempEmployerExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerEmailFromTempEmployerExtension>>> = ({ signal }) => getEmployerEmailFromTempEmployerExtension(eventId,tempEmployerExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId && tempEmployerExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerEmailFromTempEmployerExtension>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployerEmailFromTempEmployerExtensionQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerEmailFromTempEmployerExtension>>>
export type GetEmployerEmailFromTempEmployerExtensionQueryError = unknown



export function useGetEmployerEmailFromTempEmployerExtension<TData = Awaited<ReturnType<typeof getEmployerEmailFromTempEmployerExtension>>, TError = unknown>(
 eventId: number,
    tempEmployerExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerEmailFromTempEmployerExtension>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmployerEmailFromTempEmployerExtensionQueryOptions(eventId,tempEmployerExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getEventDetailsForNonAdmin = (
    employerRegistrationExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EventDetailsNonAdminResponse>(
      {url: `/interviewSchedulingNonAdmin/details/${employerRegistrationExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEventDetailsForNonAdminQueryKey = (employerRegistrationExtension: string,) => {
    return [`/interviewSchedulingNonAdmin/details/${employerRegistrationExtension}`] as const;
    }

    
export const getGetEventDetailsForNonAdminQueryOptions = <TData = Awaited<ReturnType<typeof getEventDetailsForNonAdmin>>, TError = unknown>(employerRegistrationExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventDetailsForNonAdmin>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventDetailsForNonAdminQueryKey(employerRegistrationExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventDetailsForNonAdmin>>> = ({ signal }) => getEventDetailsForNonAdmin(employerRegistrationExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employerRegistrationExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventDetailsForNonAdmin>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventDetailsForNonAdminQueryResult = NonNullable<Awaited<ReturnType<typeof getEventDetailsForNonAdmin>>>
export type GetEventDetailsForNonAdminQueryError = unknown



export function useGetEventDetailsForNonAdmin<TData = Awaited<ReturnType<typeof getEventDetailsForNonAdmin>>, TError = unknown>(
 employerRegistrationExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventDetailsForNonAdmin>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventDetailsForNonAdminQueryOptions(employerRegistrationExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getEventDetailsForStudent = (
    eventId: number,
    orgFriendlyName: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<StudentEventDetailsNonAdminResponse>(
      {url: `/interviewSchedulingNonAdmin/student/details/${eventId}/${orgFriendlyName}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEventDetailsForStudentQueryKey = (eventId: number,
    orgFriendlyName: string,) => {
    return [`/interviewSchedulingNonAdmin/student/details/${eventId}/${orgFriendlyName}`] as const;
    }

    
export const getGetEventDetailsForStudentQueryOptions = <TData = Awaited<ReturnType<typeof getEventDetailsForStudent>>, TError = unknown>(eventId: number,
    orgFriendlyName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventDetailsForStudent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventDetailsForStudentQueryKey(eventId,orgFriendlyName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventDetailsForStudent>>> = ({ signal }) => getEventDetailsForStudent(eventId,orgFriendlyName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId && orgFriendlyName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventDetailsForStudent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventDetailsForStudentQueryResult = NonNullable<Awaited<ReturnType<typeof getEventDetailsForStudent>>>
export type GetEventDetailsForStudentQueryError = unknown



export function useGetEventDetailsForStudent<TData = Awaited<ReturnType<typeof getEventDetailsForStudent>>, TError = unknown>(
 eventId: number,
    orgFriendlyName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventDetailsForStudent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventDetailsForStudentQueryOptions(eventId,orgFriendlyName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getStudentInformation = (
    eventId: number,
    orgFriendlyName: string,
    rattendeeExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<StudentInfoResponse>(
      {url: `/interviewSchedulingNonAdmin/student/recruit/details/${eventId}/${orgFriendlyName}/${rattendeeExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetStudentInformationQueryKey = (eventId: number,
    orgFriendlyName: string,
    rattendeeExtension: string,) => {
    return [`/interviewSchedulingNonAdmin/student/recruit/details/${eventId}/${orgFriendlyName}/${rattendeeExtension}`] as const;
    }

    
export const getGetStudentInformationQueryOptions = <TData = Awaited<ReturnType<typeof getStudentInformation>>, TError = unknown>(eventId: number,
    orgFriendlyName: string,
    rattendeeExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStudentInformation>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStudentInformationQueryKey(eventId,orgFriendlyName,rattendeeExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudentInformation>>> = ({ signal }) => getStudentInformation(eventId,orgFriendlyName,rattendeeExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eventId && orgFriendlyName && rattendeeExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStudentInformation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStudentInformationQueryResult = NonNullable<Awaited<ReturnType<typeof getStudentInformation>>>
export type GetStudentInformationQueryError = unknown



export function useGetStudentInformation<TData = Awaited<ReturnType<typeof getStudentInformation>>, TError = unknown>(
 eventId: number,
    orgFriendlyName: string,
    rattendeeExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStudentInformation>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStudentInformationQueryOptions(eventId,orgFriendlyName,rattendeeExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const saveStudent = (
    rattendeeExtension: string,
    saveStudentInfoRequest: SaveStudentInfoRequest,
 ) => {
      
      
      return customInstance<string>(
      {url: `/interviewSchedulingNonAdmin/student/recruit/save/${rattendeeExtension}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveStudentInfoRequest
    },
      );
    }
  


export const getSaveStudentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveStudent>>, TError,{rattendeeExtension: string;data: SaveStudentInfoRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveStudent>>, TError,{rattendeeExtension: string;data: SaveStudentInfoRequest}, TContext> => {
    
const mutationKey = ['saveStudent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveStudent>>, {rattendeeExtension: string;data: SaveStudentInfoRequest}> = (props) => {
          const {rattendeeExtension,data} = props ?? {};

          return  saveStudent(rattendeeExtension,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveStudentMutationResult = NonNullable<Awaited<ReturnType<typeof saveStudent>>>
    export type SaveStudentMutationBody = SaveStudentInfoRequest
    export type SaveStudentMutationError = unknown

    export const useSaveStudent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveStudent>>, TError,{rattendeeExtension: string;data: SaveStudentInfoRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveStudent>>,
        TError,
        {rattendeeExtension: string;data: SaveStudentInfoRequest},
        TContext
      > => {

      const mutationOptions = getSaveStudentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getClassificationPresets = (
    orgFriendlyName: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/interviewSchedulingNonAdmin/student/${orgFriendlyName}/class`, method: 'GET', signal
    },
      );
    }
  

export const getGetClassificationPresetsQueryKey = (orgFriendlyName: string,) => {
    return [`/interviewSchedulingNonAdmin/student/${orgFriendlyName}/class`] as const;
    }

    
export const getGetClassificationPresetsQueryOptions = <TData = Awaited<ReturnType<typeof getClassificationPresets>>, TError = unknown>(orgFriendlyName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClassificationPresets>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClassificationPresetsQueryKey(orgFriendlyName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClassificationPresets>>> = ({ signal }) => getClassificationPresets(orgFriendlyName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgFriendlyName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClassificationPresets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClassificationPresetsQueryResult = NonNullable<Awaited<ReturnType<typeof getClassificationPresets>>>
export type GetClassificationPresetsQueryError = unknown



export function useGetClassificationPresets<TData = Awaited<ReturnType<typeof getClassificationPresets>>, TError = unknown>(
 orgFriendlyName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClassificationPresets>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClassificationPresetsQueryOptions(orgFriendlyName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createJobApp = (
    jobAppRequest: JobAppRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/job-app/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: jobAppRequest, signal
    },
      );
    }
  


export const getCreateJobAppMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobApp>>, TError,{data: JobAppRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createJobApp>>, TError,{data: JobAppRequest}, TContext> => {
    
const mutationKey = ['createJobApp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createJobApp>>, {data: JobAppRequest}> = (props) => {
          const {data} = props ?? {};

          return  createJobApp(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateJobAppMutationResult = NonNullable<Awaited<ReturnType<typeof createJobApp>>>
    export type CreateJobAppMutationBody = JobAppRequest
    export type CreateJobAppMutationError = unknown

    export const useCreateJobApp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobApp>>, TError,{data: JobAppRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createJobApp>>,
        TError,
        {data: JobAppRequest},
        TContext
      > => {

      const mutationOptions = getCreateJobAppMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const exportJobAppsForWorkday = (
    exportJobAppWorkdayRequest: ExportJobAppWorkdayRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/job-app/export/workday`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportJobAppWorkdayRequest, signal
    },
      );
    }
  


export const getExportJobAppsForWorkdayMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportJobAppsForWorkday>>, TError,{data: ExportJobAppWorkdayRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportJobAppsForWorkday>>, TError,{data: ExportJobAppWorkdayRequest}, TContext> => {
    
const mutationKey = ['exportJobAppsForWorkday'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportJobAppsForWorkday>>, {data: ExportJobAppWorkdayRequest}> = (props) => {
          const {data} = props ?? {};

          return  exportJobAppsForWorkday(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportJobAppsForWorkdayMutationResult = NonNullable<Awaited<ReturnType<typeof exportJobAppsForWorkday>>>
    export type ExportJobAppsForWorkdayMutationBody = ExportJobAppWorkdayRequest
    export type ExportJobAppsForWorkdayMutationError = unknown

    export const useExportJobAppsForWorkday = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportJobAppsForWorkday>>, TError,{data: ExportJobAppWorkdayRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportJobAppsForWorkday>>,
        TError,
        {data: ExportJobAppWorkdayRequest},
        TContext
      > => {

      const mutationOptions = getExportJobAppsForWorkdayMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const upsertJobAppAddressInformation = (
    jobAppId: number,
    jobAppAddressInformationRequest: JobAppAddressInformationRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/job-app/job-apps/${jobAppId}/address-information`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: jobAppAddressInformationRequest, signal
    },
      );
    }
  


export const getUpsertJobAppAddressInformationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppAddressInformation>>, TError,{jobAppId: number;data: JobAppAddressInformationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppAddressInformation>>, TError,{jobAppId: number;data: JobAppAddressInformationRequest}, TContext> => {
    
const mutationKey = ['upsertJobAppAddressInformation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertJobAppAddressInformation>>, {jobAppId: number;data: JobAppAddressInformationRequest}> = (props) => {
          const {jobAppId,data} = props ?? {};

          return  upsertJobAppAddressInformation(jobAppId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertJobAppAddressInformationMutationResult = NonNullable<Awaited<ReturnType<typeof upsertJobAppAddressInformation>>>
    export type UpsertJobAppAddressInformationMutationBody = JobAppAddressInformationRequest
    export type UpsertJobAppAddressInformationMutationError = unknown

    export const useUpsertJobAppAddressInformation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppAddressInformation>>, TError,{jobAppId: number;data: JobAppAddressInformationRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertJobAppAddressInformation>>,
        TError,
        {jobAppId: number;data: JobAppAddressInformationRequest},
        TContext
      > => {

      const mutationOptions = getUpsertJobAppAddressInformationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const upsertJobAppEducationHistory = (
    jobAppId: number,
    jobAppEducationHistoryRequest: JobAppEducationHistoryRequest[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/job-app/job-apps/${jobAppId}/education-history`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: jobAppEducationHistoryRequest, signal
    },
      );
    }
  


export const getUpsertJobAppEducationHistoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppEducationHistory>>, TError,{jobAppId: number;data: JobAppEducationHistoryRequest[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppEducationHistory>>, TError,{jobAppId: number;data: JobAppEducationHistoryRequest[]}, TContext> => {
    
const mutationKey = ['upsertJobAppEducationHistory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertJobAppEducationHistory>>, {jobAppId: number;data: JobAppEducationHistoryRequest[]}> = (props) => {
          const {jobAppId,data} = props ?? {};

          return  upsertJobAppEducationHistory(jobAppId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertJobAppEducationHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof upsertJobAppEducationHistory>>>
    export type UpsertJobAppEducationHistoryMutationBody = JobAppEducationHistoryRequest[]
    export type UpsertJobAppEducationHistoryMutationError = unknown

    export const useUpsertJobAppEducationHistory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppEducationHistory>>, TError,{jobAppId: number;data: JobAppEducationHistoryRequest[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertJobAppEducationHistory>>,
        TError,
        {jobAppId: number;data: JobAppEducationHistoryRequest[]},
        TContext
      > => {

      const mutationOptions = getUpsertJobAppEducationHistoryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const deleteJobAppDocuments = (
    jobAppId: number,
    deleteJobAppDocumentsBody: number[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/job-app/job-apps/${jobAppId}/job-app-documents/delete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: deleteJobAppDocumentsBody, signal
    },
      );
    }
  


export const getDeleteJobAppDocumentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJobAppDocuments>>, TError,{jobAppId: number;data: number[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteJobAppDocuments>>, TError,{jobAppId: number;data: number[]}, TContext> => {
    
const mutationKey = ['deleteJobAppDocuments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteJobAppDocuments>>, {jobAppId: number;data: number[]}> = (props) => {
          const {jobAppId,data} = props ?? {};

          return  deleteJobAppDocuments(jobAppId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteJobAppDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteJobAppDocuments>>>
    export type DeleteJobAppDocumentsMutationBody = number[]
    export type DeleteJobAppDocumentsMutationError = unknown

    export const useDeleteJobAppDocuments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJobAppDocuments>>, TError,{jobAppId: number;data: number[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteJobAppDocuments>>,
        TError,
        {jobAppId: number;data: number[]},
        TContext
      > => {

      const mutationOptions = getDeleteJobAppDocumentsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const upsertJobAppPersonalInformation = (
    jobAppId: number,
    jobAppPersonalInformationRequest: JobAppPersonalInformationRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/job-app/job-apps/${jobAppId}/personal-information`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: jobAppPersonalInformationRequest, signal
    },
      );
    }
  


export const getUpsertJobAppPersonalInformationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppPersonalInformation>>, TError,{jobAppId: number;data: JobAppPersonalInformationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppPersonalInformation>>, TError,{jobAppId: number;data: JobAppPersonalInformationRequest}, TContext> => {
    
const mutationKey = ['upsertJobAppPersonalInformation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertJobAppPersonalInformation>>, {jobAppId: number;data: JobAppPersonalInformationRequest}> = (props) => {
          const {jobAppId,data} = props ?? {};

          return  upsertJobAppPersonalInformation(jobAppId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertJobAppPersonalInformationMutationResult = NonNullable<Awaited<ReturnType<typeof upsertJobAppPersonalInformation>>>
    export type UpsertJobAppPersonalInformationMutationBody = JobAppPersonalInformationRequest
    export type UpsertJobAppPersonalInformationMutationError = unknown

    export const useUpsertJobAppPersonalInformation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppPersonalInformation>>, TError,{jobAppId: number;data: JobAppPersonalInformationRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertJobAppPersonalInformation>>,
        TError,
        {jobAppId: number;data: JobAppPersonalInformationRequest},
        TContext
      > => {

      const mutationOptions = getUpsertJobAppPersonalInformationMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const upsertJobAppQuestionAnswers = (
    jobAppId: number,
    jobAppQuestionAnswerRequest: JobAppQuestionAnswerRequest[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/job-app/job-apps/${jobAppId}/question-answers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: jobAppQuestionAnswerRequest, signal
    },
      );
    }
  


export const getUpsertJobAppQuestionAnswersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppQuestionAnswers>>, TError,{jobAppId: number;data: JobAppQuestionAnswerRequest[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppQuestionAnswers>>, TError,{jobAppId: number;data: JobAppQuestionAnswerRequest[]}, TContext> => {
    
const mutationKey = ['upsertJobAppQuestionAnswers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertJobAppQuestionAnswers>>, {jobAppId: number;data: JobAppQuestionAnswerRequest[]}> = (props) => {
          const {jobAppId,data} = props ?? {};

          return  upsertJobAppQuestionAnswers(jobAppId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertJobAppQuestionAnswersMutationResult = NonNullable<Awaited<ReturnType<typeof upsertJobAppQuestionAnswers>>>
    export type UpsertJobAppQuestionAnswersMutationBody = JobAppQuestionAnswerRequest[]
    export type UpsertJobAppQuestionAnswersMutationError = unknown

    export const useUpsertJobAppQuestionAnswers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppQuestionAnswers>>, TError,{jobAppId: number;data: JobAppQuestionAnswerRequest[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertJobAppQuestionAnswers>>,
        TError,
        {jobAppId: number;data: JobAppQuestionAnswerRequest[]},
        TContext
      > => {

      const mutationOptions = getUpsertJobAppQuestionAnswersMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const upsertJobAppSelfIdQuestionAnswer = (
    jobAppId: number,
    jobAppSelfIdQuestionAnswerRequest: JobAppSelfIdQuestionAnswerRequest[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/job-app/job-apps/${jobAppId}/self-id-question-answers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: jobAppSelfIdQuestionAnswerRequest, signal
    },
      );
    }
  


export const getUpsertJobAppSelfIdQuestionAnswerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppSelfIdQuestionAnswer>>, TError,{jobAppId: number;data: JobAppSelfIdQuestionAnswerRequest[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppSelfIdQuestionAnswer>>, TError,{jobAppId: number;data: JobAppSelfIdQuestionAnswerRequest[]}, TContext> => {
    
const mutationKey = ['upsertJobAppSelfIdQuestionAnswer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertJobAppSelfIdQuestionAnswer>>, {jobAppId: number;data: JobAppSelfIdQuestionAnswerRequest[]}> = (props) => {
          const {jobAppId,data} = props ?? {};

          return  upsertJobAppSelfIdQuestionAnswer(jobAppId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertJobAppSelfIdQuestionAnswerMutationResult = NonNullable<Awaited<ReturnType<typeof upsertJobAppSelfIdQuestionAnswer>>>
    export type UpsertJobAppSelfIdQuestionAnswerMutationBody = JobAppSelfIdQuestionAnswerRequest[]
    export type UpsertJobAppSelfIdQuestionAnswerMutationError = unknown

    export const useUpsertJobAppSelfIdQuestionAnswer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppSelfIdQuestionAnswer>>, TError,{jobAppId: number;data: JobAppSelfIdQuestionAnswerRequest[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertJobAppSelfIdQuestionAnswer>>,
        TError,
        {jobAppId: number;data: JobAppSelfIdQuestionAnswerRequest[]},
        TContext
      > => {

      const mutationOptions = getUpsertJobAppSelfIdQuestionAnswerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const upsertJobAppWorkHistory = (
    jobAppId: number,
    jobAppWorkHistoryRequest: JobAppWorkHistoryRequest[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/job-app/job-apps/${jobAppId}/work-history`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: jobAppWorkHistoryRequest, signal
    },
      );
    }
  


export const getUpsertJobAppWorkHistoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppWorkHistory>>, TError,{jobAppId: number;data: JobAppWorkHistoryRequest[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppWorkHistory>>, TError,{jobAppId: number;data: JobAppWorkHistoryRequest[]}, TContext> => {
    
const mutationKey = ['upsertJobAppWorkHistory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertJobAppWorkHistory>>, {jobAppId: number;data: JobAppWorkHistoryRequest[]}> = (props) => {
          const {jobAppId,data} = props ?? {};

          return  upsertJobAppWorkHistory(jobAppId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertJobAppWorkHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof upsertJobAppWorkHistory>>>
    export type UpsertJobAppWorkHistoryMutationBody = JobAppWorkHistoryRequest[]
    export type UpsertJobAppWorkHistoryMutationError = unknown

    export const useUpsertJobAppWorkHistory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppWorkHistory>>, TError,{jobAppId: number;data: JobAppWorkHistoryRequest[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertJobAppWorkHistory>>,
        TError,
        {jobAppId: number;data: JobAppWorkHistoryRequest[]},
        TContext
      > => {

      const mutationOptions = getUpsertJobAppWorkHistoryMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const upsertJobAppAgencyContactId = (
    jobAppId: number,
    agencyContactId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/job-app/job-apps/${jobAppId}/${agencyContactId}`, method: 'POST', signal
    },
      );
    }
  


export const getUpsertJobAppAgencyContactIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppAgencyContactId>>, TError,{jobAppId: number;agencyContactId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppAgencyContactId>>, TError,{jobAppId: number;agencyContactId: number}, TContext> => {
    
const mutationKey = ['upsertJobAppAgencyContactId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertJobAppAgencyContactId>>, {jobAppId: number;agencyContactId: number}> = (props) => {
          const {jobAppId,agencyContactId} = props ?? {};

          return  upsertJobAppAgencyContactId(jobAppId,agencyContactId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertJobAppAgencyContactIdMutationResult = NonNullable<Awaited<ReturnType<typeof upsertJobAppAgencyContactId>>>
    
    export type UpsertJobAppAgencyContactIdMutationError = unknown

    export const useUpsertJobAppAgencyContactId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertJobAppAgencyContactId>>, TError,{jobAppId: number;agencyContactId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertJobAppAgencyContactId>>,
        TError,
        {jobAppId: number;agencyContactId: number},
        TContext
      > => {

      const mutationOptions = getUpsertJobAppAgencyContactIdMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getJobAppsByJob = (
    jobId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<JobAppResponse[]>(
      {url: `/job-app/job/${jobId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetJobAppsByJobQueryKey = (jobId: string,) => {
    return [`/job-app/job/${jobId}`] as const;
    }

    
export const getGetJobAppsByJobQueryOptions = <TData = Awaited<ReturnType<typeof getJobAppsByJob>>, TError = unknown>(jobId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobAppsByJob>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobAppsByJobQueryKey(jobId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobAppsByJob>>> = ({ signal }) => getJobAppsByJob(jobId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobAppsByJob>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobAppsByJobQueryResult = NonNullable<Awaited<ReturnType<typeof getJobAppsByJob>>>
export type GetJobAppsByJobQueryError = unknown



export function useGetJobAppsByJob<TData = Awaited<ReturnType<typeof getJobAppsByJob>>, TError = unknown>(
 jobId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobAppsByJob>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetJobAppsByJobQueryOptions(jobId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getJobAppDocuments = (
    jobAppId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<JobAppDocumentListResponse>(
      {url: `/job-app/jobAppDocuments/${jobAppId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetJobAppDocumentsQueryKey = (jobAppId: number,) => {
    return [`/job-app/jobAppDocuments/${jobAppId}`] as const;
    }

    
export const getGetJobAppDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getJobAppDocuments>>, TError = unknown>(jobAppId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobAppDocuments>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobAppDocumentsQueryKey(jobAppId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobAppDocuments>>> = ({ signal }) => getJobAppDocuments(jobAppId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(jobAppId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobAppDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobAppDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getJobAppDocuments>>>
export type GetJobAppDocumentsQueryError = unknown



export function useGetJobAppDocuments<TData = Awaited<ReturnType<typeof getJobAppDocuments>>, TError = unknown>(
 jobAppId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobAppDocuments>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetJobAppDocumentsQueryOptions(jobAppId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const jobJobAppDocumentDownloadLink = (
    jobAppId: number,
    jobAppDocumentId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/job-app/jobAppDocuments/${jobAppId}/${jobAppDocumentId}`, method: 'GET', signal
    },
      );
    }
  

export const getJobJobAppDocumentDownloadLinkQueryKey = (jobAppId: number,
    jobAppDocumentId: number,) => {
    return [`/job-app/jobAppDocuments/${jobAppId}/${jobAppDocumentId}`] as const;
    }

    
export const getJobJobAppDocumentDownloadLinkQueryOptions = <TData = Awaited<ReturnType<typeof jobJobAppDocumentDownloadLink>>, TError = unknown>(jobAppId: number,
    jobAppDocumentId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof jobJobAppDocumentDownloadLink>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobJobAppDocumentDownloadLinkQueryKey(jobAppId,jobAppDocumentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobJobAppDocumentDownloadLink>>> = ({ signal }) => jobJobAppDocumentDownloadLink(jobAppId,jobAppDocumentId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(jobAppId && jobAppDocumentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobJobAppDocumentDownloadLink>>, TError, TData> & { queryKey: QueryKey }
}

export type JobJobAppDocumentDownloadLinkQueryResult = NonNullable<Awaited<ReturnType<typeof jobJobAppDocumentDownloadLink>>>
export type JobJobAppDocumentDownloadLinkQueryError = unknown



export function useJobJobAppDocumentDownloadLink<TData = Awaited<ReturnType<typeof jobJobAppDocumentDownloadLink>>, TError = unknown>(
 jobAppId: number,
    jobAppDocumentId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof jobJobAppDocumentDownloadLink>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getJobJobAppDocumentDownloadLinkQueryOptions(jobAppId,jobAppDocumentId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const manuallyCreateNewRecruitForJob = (
    newCandidateDTO: NewCandidateDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CandidateResponse>(
      {url: `/job-app/newRecruit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newCandidateDTO, signal
    },
      );
    }
  


export const getManuallyCreateNewRecruitForJobMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof manuallyCreateNewRecruitForJob>>, TError,{data: NewCandidateDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof manuallyCreateNewRecruitForJob>>, TError,{data: NewCandidateDTO}, TContext> => {
    
const mutationKey = ['manuallyCreateNewRecruitForJob'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof manuallyCreateNewRecruitForJob>>, {data: NewCandidateDTO}> = (props) => {
          const {data} = props ?? {};

          return  manuallyCreateNewRecruitForJob(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ManuallyCreateNewRecruitForJobMutationResult = NonNullable<Awaited<ReturnType<typeof manuallyCreateNewRecruitForJob>>>
    export type ManuallyCreateNewRecruitForJobMutationBody = NewCandidateDTO
    export type ManuallyCreateNewRecruitForJobMutationError = unknown

    export const useManuallyCreateNewRecruitForJob = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof manuallyCreateNewRecruitForJob>>, TError,{data: NewCandidateDTO}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof manuallyCreateNewRecruitForJob>>,
        TError,
        {data: NewCandidateDTO},
        TContext
      > => {

      const mutationOptions = getManuallyCreateNewRecruitForJobMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const updateJobAppApplicationSource = (
    jobAppOverviewRequest: JobAppOverviewRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/job-app/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: jobAppOverviewRequest
    },
      );
    }
  


export const getUpdateJobAppApplicationSourceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobAppApplicationSource>>, TError,{data: JobAppOverviewRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateJobAppApplicationSource>>, TError,{data: JobAppOverviewRequest}, TContext> => {
    
const mutationKey = ['updateJobAppApplicationSource'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJobAppApplicationSource>>, {data: JobAppOverviewRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateJobAppApplicationSource(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobAppApplicationSourceMutationResult = NonNullable<Awaited<ReturnType<typeof updateJobAppApplicationSource>>>
    export type UpdateJobAppApplicationSourceMutationBody = JobAppOverviewRequest
    export type UpdateJobAppApplicationSourceMutationError = unknown

    export const useUpdateJobAppApplicationSource = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobAppApplicationSource>>, TError,{data: JobAppOverviewRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateJobAppApplicationSource>>,
        TError,
        {data: JobAppOverviewRequest},
        TContext
      > => {

      const mutationOptions = getUpdateJobAppApplicationSourceMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const uploadJobAppDocument = (
    jobAppDocumentUploadRequest: JobAppDocumentUploadRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(jobAppDocumentUploadRequest.copyFromMostRecentDocument !== undefined) {
 formData.append('copyFromMostRecentDocument', jobAppDocumentUploadRequest.copyFromMostRecentDocument.toString())
 }
if(jobAppDocumentUploadRequest.document !== undefined) {
 formData.append('document', jobAppDocumentUploadRequest.document)
 }
if(jobAppDocumentUploadRequest.jobAppId !== undefined) {
 formData.append('jobAppId', jobAppDocumentUploadRequest.jobAppId.toString())
 }
if(jobAppDocumentUploadRequest.orgcustomdocumentsId !== undefined) {
 formData.append('orgcustomdocumentsId', jobAppDocumentUploadRequest.orgcustomdocumentsId.toString())
 }

      return customInstance<GenericResponse>(
      {url: `/job-app/uploadJobAppDocument`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadJobAppDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadJobAppDocument>>, TError,{data: JobAppDocumentUploadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadJobAppDocument>>, TError,{data: JobAppDocumentUploadRequest}, TContext> => {
    
const mutationKey = ['uploadJobAppDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadJobAppDocument>>, {data: JobAppDocumentUploadRequest}> = (props) => {
          const {data} = props ?? {};

          return  uploadJobAppDocument(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadJobAppDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadJobAppDocument>>>
    export type UploadJobAppDocumentMutationBody = JobAppDocumentUploadRequest
    export type UploadJobAppDocumentMutationError = unknown

    export const useUploadJobAppDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadJobAppDocument>>, TError,{data: JobAppDocumentUploadRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadJobAppDocument>>,
        TError,
        {data: JobAppDocumentUploadRequest},
        TContext
      > => {

      const mutationOptions = getUploadJobAppDocumentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getJobApp = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<JobAppResponse>(
      {url: `/job-app/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetJobAppQueryKey = (id: string,) => {
    return [`/job-app/${id}`] as const;
    }

    
export const getGetJobAppQueryOptions = <TData = Awaited<ReturnType<typeof getJobApp>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobApp>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobAppQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobApp>>> = ({ signal }) => getJobApp(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobApp>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobAppQueryResult = NonNullable<Awaited<ReturnType<typeof getJobApp>>>
export type GetJobAppQueryError = unknown



export function useGetJobApp<TData = Awaited<ReturnType<typeof getJobApp>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobApp>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetJobAppQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteJobApp = (
    jobAppId: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/job-app/${jobAppId}/delete`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteJobAppMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJobApp>>, TError,{jobAppId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteJobApp>>, TError,{jobAppId: number}, TContext> => {
    
const mutationKey = ['deleteJobApp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteJobApp>>, {jobAppId: number}> = (props) => {
          const {jobAppId} = props ?? {};

          return  deleteJobApp(jobAppId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteJobAppMutationResult = NonNullable<Awaited<ReturnType<typeof deleteJobApp>>>
    
    export type DeleteJobAppMutationError = unknown

    export const useDeleteJobApp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJobApp>>, TError,{jobAppId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteJobApp>>,
        TError,
        {jobAppId: number},
        TContext
      > => {

      const mutationOptions = getDeleteJobAppMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const createJobApps = (
    jobId: number,
    jobAppRequest: JobAppRequest[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/job-app/${jobId}/bulk-create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: jobAppRequest, signal
    },
      );
    }
  


export const getCreateJobAppsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobApps>>, TError,{jobId: number;data: JobAppRequest[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createJobApps>>, TError,{jobId: number;data: JobAppRequest[]}, TContext> => {
    
const mutationKey = ['createJobApps'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createJobApps>>, {jobId: number;data: JobAppRequest[]}> = (props) => {
          const {jobId,data} = props ?? {};

          return  createJobApps(jobId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateJobAppsMutationResult = NonNullable<Awaited<ReturnType<typeof createJobApps>>>
    export type CreateJobAppsMutationBody = JobAppRequest[]
    export type CreateJobAppsMutationError = unknown

    export const useCreateJobApps = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobApps>>, TError,{jobId: number;data: JobAppRequest[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createJobApps>>,
        TError,
        {jobId: number;data: JobAppRequest[]},
        TContext
      > => {

      const mutationOptions = getCreateJobAppsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const exportJobAppsDocuments = (
    jobId: number,
    orgDocumentId: number,
    exportJobAppsDocumentsBody: number[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/job-app/${jobId}/jobAppDocuments/${orgDocumentId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportJobAppsDocumentsBody, signal
    },
      );
    }
  


export const getExportJobAppsDocumentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportJobAppsDocuments>>, TError,{jobId: number;orgDocumentId: number;data: number[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportJobAppsDocuments>>, TError,{jobId: number;orgDocumentId: number;data: number[]}, TContext> => {
    
const mutationKey = ['exportJobAppsDocuments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportJobAppsDocuments>>, {jobId: number;orgDocumentId: number;data: number[]}> = (props) => {
          const {jobId,orgDocumentId,data} = props ?? {};

          return  exportJobAppsDocuments(jobId,orgDocumentId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportJobAppsDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof exportJobAppsDocuments>>>
    export type ExportJobAppsDocumentsMutationBody = number[]
    export type ExportJobAppsDocumentsMutationError = unknown

    export const useExportJobAppsDocuments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportJobAppsDocuments>>, TError,{jobId: number;orgDocumentId: number;data: number[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportJobAppsDocuments>>,
        TError,
        {jobId: number;orgDocumentId: number;data: number[]},
        TContext
      > => {

      const mutationOptions = getExportJobAppsDocumentsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const updateJobAppStatus = (
    jobId: number,
    changeStatusRequest: ChangeStatusRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/job-app/${jobId}/status/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changeStatusRequest
    },
      );
    }
  


export const getUpdateJobAppStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobAppStatus>>, TError,{jobId: number;data: ChangeStatusRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateJobAppStatus>>, TError,{jobId: number;data: ChangeStatusRequest}, TContext> => {
    
const mutationKey = ['updateJobAppStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJobAppStatus>>, {jobId: number;data: ChangeStatusRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  updateJobAppStatus(jobId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobAppStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateJobAppStatus>>>
    export type UpdateJobAppStatusMutationBody = ChangeStatusRequest
    export type UpdateJobAppStatusMutationError = unknown

    export const useUpdateJobAppStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobAppStatus>>, TError,{jobId: number;data: ChangeStatusRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateJobAppStatus>>,
        TError,
        {jobId: number;data: ChangeStatusRequest},
        TContext
      > => {

      const mutationOptions = getUpdateJobAppStatusMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const bulkUpdateJobAppStatuses = (
    jobId: number,
    bulkUpdateAppsRequest: BulkUpdateAppsRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/job-app/${jobId}/status/updates`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: bulkUpdateAppsRequest
    },
      );
    }
  


export const getBulkUpdateJobAppStatusesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateJobAppStatuses>>, TError,{jobId: number;data: BulkUpdateAppsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateJobAppStatuses>>, TError,{jobId: number;data: BulkUpdateAppsRequest}, TContext> => {
    
const mutationKey = ['bulkUpdateJobAppStatuses'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkUpdateJobAppStatuses>>, {jobId: number;data: BulkUpdateAppsRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  bulkUpdateJobAppStatuses(jobId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkUpdateJobAppStatusesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkUpdateJobAppStatuses>>>
    export type BulkUpdateJobAppStatusesMutationBody = BulkUpdateAppsRequest
    export type BulkUpdateJobAppStatusesMutationError = unknown

    export const useBulkUpdateJobAppStatuses = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateJobAppStatuses>>, TError,{jobId: number;data: BulkUpdateAppsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkUpdateJobAppStatuses>>,
        TError,
        {jobId: number;data: BulkUpdateAppsRequest},
        TContext
      > => {

      const mutationOptions = getBulkUpdateJobAppStatusesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const bulkUpdateJobAppSources = (
    jobId: number,
    bulkUpdateAppsSourcesRequest: BulkUpdateAppsSourcesRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/job-app/${jobId}/update/sources`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: bulkUpdateAppsSourcesRequest
    },
      );
    }
  


export const getBulkUpdateJobAppSourcesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateJobAppSources>>, TError,{jobId: number;data: BulkUpdateAppsSourcesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateJobAppSources>>, TError,{jobId: number;data: BulkUpdateAppsSourcesRequest}, TContext> => {
    
const mutationKey = ['bulkUpdateJobAppSources'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkUpdateJobAppSources>>, {jobId: number;data: BulkUpdateAppsSourcesRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  bulkUpdateJobAppSources(jobId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkUpdateJobAppSourcesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkUpdateJobAppSources>>>
    export type BulkUpdateJobAppSourcesMutationBody = BulkUpdateAppsSourcesRequest
    export type BulkUpdateJobAppSourcesMutationError = unknown

    export const useBulkUpdateJobAppSources = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUpdateJobAppSources>>, TError,{jobId: number;data: BulkUpdateAppsSourcesRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkUpdateJobAppSources>>,
        TError,
        {jobId: number;data: BulkUpdateAppsSourcesRequest},
        TContext
      > => {

      const mutationOptions = getBulkUpdateJobAppSourcesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchJobCandidateDocuments = (
    sectionId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<JobCandidateDocumentResponse[]>(
      {url: `/job-candidate-controller/${sectionId}`, method: 'GET', signal
    },
      );
    }
  

export const getFetchJobCandidateDocumentsQueryKey = (sectionId: number,) => {
    return [`/job-candidate-controller/${sectionId}`] as const;
    }

    
export const getFetchJobCandidateDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof fetchJobCandidateDocuments>>, TError = unknown>(sectionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchJobCandidateDocuments>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchJobCandidateDocumentsQueryKey(sectionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchJobCandidateDocuments>>> = ({ signal }) => fetchJobCandidateDocuments(sectionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sectionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchJobCandidateDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchJobCandidateDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof fetchJobCandidateDocuments>>>
export type FetchJobCandidateDocumentsQueryError = unknown



export function useFetchJobCandidateDocuments<TData = Awaited<ReturnType<typeof fetchJobCandidateDocuments>>, TError = unknown>(
 sectionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchJobCandidateDocuments>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchJobCandidateDocumentsQueryOptions(sectionId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createJobPipeline = (
    jobPipelineRequest: JobPipelineRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/job-pipelines`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: jobPipelineRequest, signal
    },
      );
    }
  


export const getCreateJobPipelineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobPipeline>>, TError,{data: JobPipelineRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createJobPipeline>>, TError,{data: JobPipelineRequest}, TContext> => {
    
const mutationKey = ['createJobPipeline'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createJobPipeline>>, {data: JobPipelineRequest}> = (props) => {
          const {data} = props ?? {};

          return  createJobPipeline(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateJobPipelineMutationResult = NonNullable<Awaited<ReturnType<typeof createJobPipeline>>>
    export type CreateJobPipelineMutationBody = JobPipelineRequest
    export type CreateJobPipelineMutationError = unknown

    export const useCreateJobPipeline = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobPipeline>>, TError,{data: JobPipelineRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createJobPipeline>>,
        TError,
        {data: JobPipelineRequest},
        TContext
      > => {

      const mutationOptions = getCreateJobPipelineMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const exportCandidateDataCSV = (
    exportCandidateDataCSVBody: string[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/job/candidate/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportCandidateDataCSVBody, signal
    },
      );
    }
  


export const getExportCandidateDataCSVMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportCandidateDataCSV>>, TError,{data: string[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportCandidateDataCSV>>, TError,{data: string[]}, TContext> => {
    
const mutationKey = ['exportCandidateDataCSV'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportCandidateDataCSV>>, {data: string[]}> = (props) => {
          const {data} = props ?? {};

          return  exportCandidateDataCSV(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportCandidateDataCSVMutationResult = NonNullable<Awaited<ReturnType<typeof exportCandidateDataCSV>>>
    export type ExportCandidateDataCSVMutationBody = string[]
    export type ExportCandidateDataCSVMutationError = unknown

    export const useExportCandidateDataCSV = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportCandidateDataCSV>>, TError,{data: string[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportCandidateDataCSV>>,
        TError,
        {data: string[]},
        TContext
      > => {

      const mutationOptions = getExportCandidateDataCSVMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const createJob = (
    jobRequest: JobRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/job/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: jobRequest, signal
    },
      );
    }
  


export const getCreateJobMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJob>>, TError,{data: JobRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createJob>>, TError,{data: JobRequest}, TContext> => {
    
const mutationKey = ['createJob'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createJob>>, {data: JobRequest}> = (props) => {
          const {data} = props ?? {};

          return  createJob(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateJobMutationResult = NonNullable<Awaited<ReturnType<typeof createJob>>>
    export type CreateJobMutationBody = JobRequest
    export type CreateJobMutationError = unknown

    export const useCreateJob = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJob>>, TError,{data: JobRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createJob>>,
        TError,
        {data: JobRequest},
        TContext
      > => {

      const mutationOptions = getCreateJobMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getOrgJobs = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<JobOverviewResponse[]>(
      {url: `/job/overviews`, method: 'GET', signal
    },
      );
    }
  

export const getGetOrgJobsQueryKey = () => {
    return [`/job/overviews`] as const;
    }

    
export const getGetOrgJobsQueryOptions = <TData = Awaited<ReturnType<typeof getOrgJobs>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgJobs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgJobsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgJobs>>> = ({ signal }) => getOrgJobs(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgJobs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgJobs>>>
export type GetOrgJobsQueryError = unknown



export function useGetOrgJobs<TData = Awaited<ReturnType<typeof getOrgJobs>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgJobs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrgJobsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const exportLawSchoolConversionReportCSV = (
    exportLawSchoolConversionReportCSVBody: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/job/statuses/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportLawSchoolConversionReportCSVBody, signal
    },
      );
    }
  


export const getExportLawSchoolConversionReportCSVMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportLawSchoolConversionReportCSV>>, TError,{data: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportLawSchoolConversionReportCSV>>, TError,{data: string}, TContext> => {
    
const mutationKey = ['exportLawSchoolConversionReportCSV'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportLawSchoolConversionReportCSV>>, {data: string}> = (props) => {
          const {data} = props ?? {};

          return  exportLawSchoolConversionReportCSV(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportLawSchoolConversionReportCSVMutationResult = NonNullable<Awaited<ReturnType<typeof exportLawSchoolConversionReportCSV>>>
    export type ExportLawSchoolConversionReportCSVMutationBody = string
    export type ExportLawSchoolConversionReportCSVMutationError = unknown

    export const useExportLawSchoolConversionReportCSV = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportLawSchoolConversionReportCSV>>, TError,{data: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportLawSchoolConversionReportCSV>>,
        TError,
        {data: string},
        TContext
      > => {

      const mutationOptions = getExportLawSchoolConversionReportCSVMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const exportJobAppBySourceConversionReport = (
    exportJobAppBySourceConversionReportBody: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/job/statuses/source/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportJobAppBySourceConversionReportBody, signal
    },
      );
    }
  


export const getExportJobAppBySourceConversionReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportJobAppBySourceConversionReport>>, TError,{data: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportJobAppBySourceConversionReport>>, TError,{data: string}, TContext> => {
    
const mutationKey = ['exportJobAppBySourceConversionReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportJobAppBySourceConversionReport>>, {data: string}> = (props) => {
          const {data} = props ?? {};

          return  exportJobAppBySourceConversionReport(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportJobAppBySourceConversionReportMutationResult = NonNullable<Awaited<ReturnType<typeof exportJobAppBySourceConversionReport>>>
    export type ExportJobAppBySourceConversionReportMutationBody = string
    export type ExportJobAppBySourceConversionReportMutationError = unknown

    export const useExportJobAppBySourceConversionReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportJobAppBySourceConversionReport>>, TError,{data: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportJobAppBySourceConversionReport>>,
        TError,
        {data: string},
        TContext
      > => {

      const mutationOptions = getExportJobAppBySourceConversionReportMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const updateJob = (
    jobRequest: JobRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/job/update/overview`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: jobRequest
    },
      );
    }
  


export const getUpdateJobMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJob>>, TError,{data: JobRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateJob>>, TError,{data: JobRequest}, TContext> => {
    
const mutationKey = ['updateJob'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJob>>, {data: JobRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateJob(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobMutationResult = NonNullable<Awaited<ReturnType<typeof updateJob>>>
    export type UpdateJobMutationBody = JobRequest
    export type UpdateJobMutationError = unknown

    export const useUpdateJob = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJob>>, TError,{data: JobRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateJob>>,
        TError,
        {data: JobRequest},
        TContext
      > => {

      const mutationOptions = getUpdateJobMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const updateJobSchema = (
    jobSchemaRequest: JobSchemaRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/job/update/schema`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: jobSchemaRequest
    },
      );
    }
  


export const getUpdateJobSchemaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobSchema>>, TError,{data: JobSchemaRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateJobSchema>>, TError,{data: JobSchemaRequest}, TContext> => {
    
const mutationKey = ['updateJobSchema'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJobSchema>>, {data: JobSchemaRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateJobSchema(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobSchemaMutationResult = NonNullable<Awaited<ReturnType<typeof updateJobSchema>>>
    export type UpdateJobSchemaMutationBody = JobSchemaRequest
    export type UpdateJobSchemaMutationError = unknown

    export const useUpdateJobSchema = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobSchema>>, TError,{data: JobSchemaRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateJobSchema>>,
        TError,
        {data: JobSchemaRequest},
        TContext
      > => {

      const mutationOptions = getUpdateJobSchemaMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const duplicateJob = (
    duplicateJobId: number,
    jobRequest: JobRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/job/${duplicateJobId}/duplicate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: jobRequest, signal
    },
      );
    }
  


export const getDuplicateJobMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateJob>>, TError,{duplicateJobId: number;data: JobRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof duplicateJob>>, TError,{duplicateJobId: number;data: JobRequest}, TContext> => {
    
const mutationKey = ['duplicateJob'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateJob>>, {duplicateJobId: number;data: JobRequest}> = (props) => {
          const {duplicateJobId,data} = props ?? {};

          return  duplicateJob(duplicateJobId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DuplicateJobMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateJob>>>
    export type DuplicateJobMutationBody = JobRequest
    export type DuplicateJobMutationError = unknown

    export const useDuplicateJob = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateJob>>, TError,{duplicateJobId: number;data: JobRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof duplicateJob>>,
        TError,
        {duplicateJobId: number;data: JobRequest},
        TContext
      > => {

      const mutationOptions = getDuplicateJobMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getJob = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<JobOverviewResponse>(
      {url: `/job/${id}/overview`, method: 'GET', signal
    },
      );
    }
  

export const getGetJobQueryKey = (id: string,) => {
    return [`/job/${id}/overview`] as const;
    }

    
export const getGetJobQueryOptions = <TData = Awaited<ReturnType<typeof getJob>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJob>>> = ({ signal }) => getJob(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobQueryResult = NonNullable<Awaited<ReturnType<typeof getJob>>>
export type GetJobQueryError = unknown



export function useGetJob<TData = Awaited<ReturnType<typeof getJob>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetJobQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getJobPipeline = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<JobPipelineResponse>(
      {url: `/job/${id}/pipelines`, method: 'GET', signal
    },
      );
    }
  

export const getGetJobPipelineQueryKey = (id: number,) => {
    return [`/job/${id}/pipelines`] as const;
    }

    
export const getGetJobPipelineQueryOptions = <TData = Awaited<ReturnType<typeof getJobPipeline>>, TError = unknown>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobPipeline>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobPipelineQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobPipeline>>> = ({ signal }) => getJobPipeline(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobPipeline>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobPipelineQueryResult = NonNullable<Awaited<ReturnType<typeof getJobPipeline>>>
export type GetJobPipelineQueryError = unknown



export function useGetJobPipeline<TData = Awaited<ReturnType<typeof getJobPipeline>>, TError = unknown>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobPipeline>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetJobPipelineQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getJobSchema = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<JobSchemaResponse>(
      {url: `/job/${id}/schema`, method: 'GET', signal
    },
      );
    }
  

export const getGetJobSchemaQueryKey = (id: number,) => {
    return [`/job/${id}/schema`] as const;
    }

    
export const getGetJobSchemaQueryOptions = <TData = Awaited<ReturnType<typeof getJobSchema>>, TError = unknown>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobSchema>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobSchemaQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobSchema>>> = ({ signal }) => getJobSchema(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobSchema>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobSchemaQueryResult = NonNullable<Awaited<ReturnType<typeof getJobSchema>>>
export type GetJobSchemaQueryError = unknown



export function useGetJobSchema<TData = Awaited<ReturnType<typeof getJobSchema>>, TError = unknown>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobSchema>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetJobSchemaQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteJob = (
    jobId: number,
 ) => {
      
      
      return customInstance<boolean>(
      {url: `/job/${jobId}/delete`, method: 'PUT'
    },
      );
    }
  


export const getDeleteJobMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJob>>, TError,{jobId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteJob>>, TError,{jobId: number}, TContext> => {
    
const mutationKey = ['deleteJob'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteJob>>, {jobId: number}> = (props) => {
          const {jobId} = props ?? {};

          return  deleteJob(jobId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteJobMutationResult = NonNullable<Awaited<ReturnType<typeof deleteJob>>>
    
    export type DeleteJobMutationError = unknown

    export const useDeleteJob = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJob>>, TError,{jobId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteJob>>,
        TError,
        {jobId: number},
        TContext
      > => {

      const mutationOptions = getDeleteJobMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const exportJobAppsCSV = (
    jobId: number,
    exportJobAppsCSVBody: string[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/job/${jobId}/jobDetails/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportJobAppsCSVBody, signal
    },
      );
    }
  


export const getExportJobAppsCSVMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportJobAppsCSV>>, TError,{jobId: number;data: string[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportJobAppsCSV>>, TError,{jobId: number;data: string[]}, TContext> => {
    
const mutationKey = ['exportJobAppsCSV'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportJobAppsCSV>>, {jobId: number;data: string[]}> = (props) => {
          const {jobId,data} = props ?? {};

          return  exportJobAppsCSV(jobId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportJobAppsCSVMutationResult = NonNullable<Awaited<ReturnType<typeof exportJobAppsCSV>>>
    export type ExportJobAppsCSVMutationBody = string[]
    export type ExportJobAppsCSVMutationError = unknown

    export const useExportJobAppsCSV = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportJobAppsCSV>>, TError,{jobId: number;data: string[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportJobAppsCSV>>,
        TError,
        {jobId: number;data: string[]},
        TContext
      > => {

      const mutationOptions = getExportJobAppsCSVMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const exportStatusActivityReportCSV = (
    jobId: number,
    statusActivityReportExportRequest: StatusActivityReportExportRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/job/${jobId}/jobDetails/export/activityReport`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: statusActivityReportExportRequest, signal
    },
      );
    }
  


export const getExportStatusActivityReportCSVMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportStatusActivityReportCSV>>, TError,{jobId: number;data: StatusActivityReportExportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportStatusActivityReportCSV>>, TError,{jobId: number;data: StatusActivityReportExportRequest}, TContext> => {
    
const mutationKey = ['exportStatusActivityReportCSV'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportStatusActivityReportCSV>>, {jobId: number;data: StatusActivityReportExportRequest}> = (props) => {
          const {jobId,data} = props ?? {};

          return  exportStatusActivityReportCSV(jobId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportStatusActivityReportCSVMutationResult = NonNullable<Awaited<ReturnType<typeof exportStatusActivityReportCSV>>>
    export type ExportStatusActivityReportCSVMutationBody = StatusActivityReportExportRequest
    export type ExportStatusActivityReportCSVMutationError = unknown

    export const useExportStatusActivityReportCSV = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportStatusActivityReportCSV>>, TError,{jobId: number;data: StatusActivityReportExportRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportStatusActivityReportCSV>>,
        TError,
        {jobId: number;data: StatusActivityReportExportRequest},
        TContext
      > => {

      const mutationOptions = getExportStatusActivityReportCSVMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const logoutMember = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserLogoutResponse>(
      {url: `/member-signin/member-logout`, method: 'POST', signal
    },
      );
    }
  


export const getLogoutMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutMember>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof logoutMember>>, TError,void, TContext> => {
    
const mutationKey = ['logoutMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutMember>>, void> = () => {
          

          return  logoutMember()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutMemberMutationResult = NonNullable<Awaited<ReturnType<typeof logoutMember>>>
    
    export type LogoutMemberMutationError = unknown

    export const useLogoutMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutMember>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof logoutMember>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getLogoutMemberMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const sendSignInMagicLink = (
    params: SendSignInMagicLinkParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/member-signin/send-signin-email`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getSendSignInMagicLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSignInMagicLink>>, TError,{params: SendSignInMagicLinkParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendSignInMagicLink>>, TError,{params: SendSignInMagicLinkParams}, TContext> => {
    
const mutationKey = ['sendSignInMagicLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendSignInMagicLink>>, {params: SendSignInMagicLinkParams}> = (props) => {
          const {params} = props ?? {};

          return  sendSignInMagicLink(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendSignInMagicLinkMutationResult = NonNullable<Awaited<ReturnType<typeof sendSignInMagicLink>>>
    
    export type SendSignInMagicLinkMutationError = unknown

    export const useSendSignInMagicLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSignInMagicLink>>, TError,{params: SendSignInMagicLinkParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendSignInMagicLink>>,
        TError,
        {params: SendSignInMagicLinkParams},
        TContext
      > => {

      const mutationOptions = getSendSignInMagicLinkMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const memberSignIn = (
    orgFriendlyName: string,
    magicLinkId: number,
    userId: number,
    redirectUrl: string,
    token: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/member-signin/signin/${orgFriendlyName}/${magicLinkId}/${userId}/${redirectUrl}/${token}`, method: 'GET', signal
    },
      );
    }
  

export const getMemberSignInQueryKey = (orgFriendlyName: string,
    magicLinkId: number,
    userId: number,
    redirectUrl: string,
    token: string,) => {
    return [`/member-signin/signin/${orgFriendlyName}/${magicLinkId}/${userId}/${redirectUrl}/${token}`] as const;
    }

    
export const getMemberSignInQueryOptions = <TData = Awaited<ReturnType<typeof memberSignIn>>, TError = unknown>(orgFriendlyName: string,
    magicLinkId: number,
    userId: number,
    redirectUrl: string,
    token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof memberSignIn>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMemberSignInQueryKey(orgFriendlyName,magicLinkId,userId,redirectUrl,token);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof memberSignIn>>> = ({ signal }) => memberSignIn(orgFriendlyName,magicLinkId,userId,redirectUrl,token, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgFriendlyName && magicLinkId && userId && redirectUrl && token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof memberSignIn>>, TError, TData> & { queryKey: QueryKey }
}

export type MemberSignInQueryResult = NonNullable<Awaited<ReturnType<typeof memberSignIn>>>
export type MemberSignInQueryError = unknown



export function useMemberSignIn<TData = Awaited<ReturnType<typeof memberSignIn>>, TError = unknown>(
 orgFriendlyName: string,
    magicLinkId: number,
    userId: number,
    redirectUrl: string,
    token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof memberSignIn>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMemberSignInQueryOptions(orgFriendlyName,magicLinkId,userId,redirectUrl,token,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const addOrgDoc = (
    docName: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/networkingAdmin/addOrgDoc/${docName}`, method: 'POST', signal
    },
      );
    }
  


export const getAddOrgDocMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrgDoc>>, TError,{docName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addOrgDoc>>, TError,{docName: string}, TContext> => {
    
const mutationKey = ['addOrgDoc'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addOrgDoc>>, {docName: string}> = (props) => {
          const {docName} = props ?? {};

          return  addOrgDoc(docName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddOrgDocMutationResult = NonNullable<Awaited<ReturnType<typeof addOrgDoc>>>
    
    export type AddOrgDocMutationError = unknown

    export const useAddOrgDoc = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrgDoc>>, TError,{docName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof addOrgDoc>>,
        TError,
        {docName: string},
        TContext
      > => {

      const mutationOptions = getAddOrgDocMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const createEditNetworkingEmails = (
    createEditNetworkingEmailsRequest: CreateEditNetworkingEmailsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateEditNetworkingEmailsResponse>(
      {url: `/networkingAdmin/createEditEmails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createEditNetworkingEmailsRequest, signal
    },
      );
    }
  


export const getCreateEditNetworkingEmailsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEditNetworkingEmails>>, TError,{data: CreateEditNetworkingEmailsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createEditNetworkingEmails>>, TError,{data: CreateEditNetworkingEmailsRequest}, TContext> => {
    
const mutationKey = ['createEditNetworkingEmails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEditNetworkingEmails>>, {data: CreateEditNetworkingEmailsRequest}> = (props) => {
          const {data} = props ?? {};

          return  createEditNetworkingEmails(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateEditNetworkingEmailsMutationResult = NonNullable<Awaited<ReturnType<typeof createEditNetworkingEmails>>>
    export type CreateEditNetworkingEmailsMutationBody = CreateEditNetworkingEmailsRequest
    export type CreateEditNetworkingEmailsMutationError = unknown

    export const useCreateEditNetworkingEmails = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEditNetworkingEmails>>, TError,{data: CreateEditNetworkingEmailsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createEditNetworkingEmails>>,
        TError,
        {data: CreateEditNetworkingEmailsRequest},
        TContext
      > => {

      const mutationOptions = getCreateEditNetworkingEmailsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const createEditNetworkingEvent = (
    createEditNetworkingEventRequest: CreateEditNetworkingEventRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateEditNetworkingEventResponse>(
      {url: `/networkingAdmin/createEditSerendipitousEvent`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createEditNetworkingEventRequest, signal
    },
      );
    }
  


export const getCreateEditNetworkingEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEditNetworkingEvent>>, TError,{data: CreateEditNetworkingEventRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createEditNetworkingEvent>>, TError,{data: CreateEditNetworkingEventRequest}, TContext> => {
    
const mutationKey = ['createEditNetworkingEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEditNetworkingEvent>>, {data: CreateEditNetworkingEventRequest}> = (props) => {
          const {data} = props ?? {};

          return  createEditNetworkingEvent(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateEditNetworkingEventMutationResult = NonNullable<Awaited<ReturnType<typeof createEditNetworkingEvent>>>
    export type CreateEditNetworkingEventMutationBody = CreateEditNetworkingEventRequest
    export type CreateEditNetworkingEventMutationError = unknown

    export const useCreateEditNetworkingEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEditNetworkingEvent>>, TError,{data: CreateEditNetworkingEventRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createEditNetworkingEvent>>,
        TError,
        {data: CreateEditNetworkingEventRequest},
        TContext
      > => {

      const mutationOptions = getCreateEditNetworkingEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const createEditNetworkingRooms = (
    createEditNetworkingRoomsRequest: CreateEditNetworkingRoomsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateEditNetworkingRoomsResponse>(
      {url: `/networkingAdmin/createEditSerendipitousRooms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createEditNetworkingRoomsRequest, signal
    },
      );
    }
  


export const getCreateEditNetworkingRoomsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEditNetworkingRooms>>, TError,{data: CreateEditNetworkingRoomsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createEditNetworkingRooms>>, TError,{data: CreateEditNetworkingRoomsRequest}, TContext> => {
    
const mutationKey = ['createEditNetworkingRooms'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEditNetworkingRooms>>, {data: CreateEditNetworkingRoomsRequest}> = (props) => {
          const {data} = props ?? {};

          return  createEditNetworkingRooms(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateEditNetworkingRoomsMutationResult = NonNullable<Awaited<ReturnType<typeof createEditNetworkingRooms>>>
    export type CreateEditNetworkingRoomsMutationBody = CreateEditNetworkingRoomsRequest
    export type CreateEditNetworkingRoomsMutationError = unknown

    export const useCreateEditNetworkingRooms = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEditNetworkingRooms>>, TError,{data: CreateEditNetworkingRoomsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createEditNetworkingRooms>>,
        TError,
        {data: CreateEditNetworkingRoomsRequest},
        TContext
      > => {

      const mutationOptions = getCreateEditNetworkingRoomsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const createNewEmployerUser = (
    attendeeDTO: AttendeeDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/networkingAdmin/createNewEmployerUser`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: attendeeDTO, signal
    },
      );
    }
  


export const getCreateNewEmployerUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewEmployerUser>>, TError,{data: AttendeeDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createNewEmployerUser>>, TError,{data: AttendeeDTO}, TContext> => {
    
const mutationKey = ['createNewEmployerUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNewEmployerUser>>, {data: AttendeeDTO}> = (props) => {
          const {data} = props ?? {};

          return  createNewEmployerUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateNewEmployerUserMutationResult = NonNullable<Awaited<ReturnType<typeof createNewEmployerUser>>>
    export type CreateNewEmployerUserMutationBody = AttendeeDTO
    export type CreateNewEmployerUserMutationError = unknown

    export const useCreateNewEmployerUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewEmployerUser>>, TError,{data: AttendeeDTO}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createNewEmployerUser>>,
        TError,
        {data: AttendeeDTO},
        TContext
      > => {

      const mutationOptions = getCreateNewEmployerUserMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const createNewRecruit = (
    newCandidateDTO: NewCandidateDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/networkingAdmin/createNewRecruit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newCandidateDTO, signal
    },
      );
    }
  


export const getCreateNewRecruitMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewRecruit>>, TError,{data: NewCandidateDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createNewRecruit>>, TError,{data: NewCandidateDTO}, TContext> => {
    
const mutationKey = ['createNewRecruit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNewRecruit>>, {data: NewCandidateDTO}> = (props) => {
          const {data} = props ?? {};

          return  createNewRecruit(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateNewRecruitMutationResult = NonNullable<Awaited<ReturnType<typeof createNewRecruit>>>
    export type CreateNewRecruitMutationBody = NewCandidateDTO
    export type CreateNewRecruitMutationError = unknown

    export const useCreateNewRecruit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNewRecruit>>, TError,{data: NewCandidateDTO}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createNewRecruit>>,
        TError,
        {data: NewCandidateDTO},
        TContext
      > => {

      const mutationOptions = getCreateNewRecruitMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const downloadStudentDocAdmin = (
    downloadDocumentRequest: DownloadDocumentRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/networkingAdmin/downloadStudentDoc`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: downloadDocumentRequest, signal
    },
      );
    }
  


export const getDownloadStudentDocAdminMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof downloadStudentDocAdmin>>, TError,{data: DownloadDocumentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof downloadStudentDocAdmin>>, TError,{data: DownloadDocumentRequest}, TContext> => {
    
const mutationKey = ['downloadStudentDocAdmin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof downloadStudentDocAdmin>>, {data: DownloadDocumentRequest}> = (props) => {
          const {data} = props ?? {};

          return  downloadStudentDocAdmin(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DownloadStudentDocAdminMutationResult = NonNullable<Awaited<ReturnType<typeof downloadStudentDocAdmin>>>
    export type DownloadStudentDocAdminMutationBody = DownloadDocumentRequest
    export type DownloadStudentDocAdminMutationError = unknown

    export const useDownloadStudentDocAdmin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof downloadStudentDocAdmin>>, TError,{data: DownloadDocumentRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof downloadStudentDocAdmin>>,
        TError,
        {data: DownloadDocumentRequest},
        TContext
      > => {

      const mutationOptions = getDownloadStudentDocAdminMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getAdminUsers = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAdminUsersResponse>(
      {url: `/networkingAdmin/getAdminUsers`, method: 'GET', signal
    },
      );
    }
  

export const getGetAdminUsersQueryKey = () => {
    return [`/networkingAdmin/getAdminUsers`] as const;
    }

    
export const getGetAdminUsersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUsers>>> = ({ signal }) => getAdminUsers(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUsers>>>
export type GetAdminUsersQueryError = unknown



export function useGetAdminUsers<TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminUsersQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getDocsForOrg = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<Orgcustomdocuments[]>(
      {url: `/networkingAdmin/getDocsForOrg`, method: 'GET', signal
    },
      );
    }
  

export const getGetDocsForOrgQueryKey = () => {
    return [`/networkingAdmin/getDocsForOrg`] as const;
    }

    
export const getGetDocsForOrgQueryOptions = <TData = Awaited<ReturnType<typeof getDocsForOrg>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDocsForOrg>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocsForOrgQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocsForOrg>>> = ({ signal }) => getDocsForOrg(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocsForOrg>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDocsForOrgQueryResult = NonNullable<Awaited<ReturnType<typeof getDocsForOrg>>>
export type GetDocsForOrgQueryError = unknown



export function useGetDocsForOrg<TData = Awaited<ReturnType<typeof getDocsForOrg>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDocsForOrg>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDocsForOrgQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getEmployerUsers = (
    eid: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEmployerUsersResponse>(
      {url: `/networkingAdmin/getEmployerUsers/${eid}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEmployerUsersQueryKey = (eid: number,) => {
    return [`/networkingAdmin/getEmployerUsers/${eid}`] as const;
    }

    
export const getGetEmployerUsersQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerUsers>>, TError = unknown>(eid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerUsers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerUsersQueryKey(eid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerUsers>>> = ({ signal }) => getEmployerUsers(eid, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployerUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerUsers>>>
export type GetEmployerUsersQueryError = unknown



export function useGetEmployerUsers<TData = Awaited<ReturnType<typeof getEmployerUsers>>, TError = unknown>(
 eid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerUsers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmployerUsersQueryOptions(eid,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUniversityEmployers = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetUniversityEmployersResponse>(
      {url: `/networkingAdmin/getEmployersForUniversity`, method: 'GET', signal
    },
      );
    }
  

export const getGetUniversityEmployersQueryKey = () => {
    return [`/networkingAdmin/getEmployersForUniversity`] as const;
    }

    
export const getGetUniversityEmployersQueryOptions = <TData = Awaited<ReturnType<typeof getUniversityEmployers>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityEmployers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUniversityEmployersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUniversityEmployers>>> = ({ signal }) => getUniversityEmployers(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUniversityEmployers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUniversityEmployersQueryResult = NonNullable<Awaited<ReturnType<typeof getUniversityEmployers>>>
export type GetUniversityEmployersQueryError = unknown



export function useGetUniversityEmployers<TData = Awaited<ReturnType<typeof getUniversityEmployers>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityEmployers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUniversityEmployersQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSerendipitousEvent = (
    params: GetSerendipitousEventParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetNetworkingEventResponse>(
      {url: `/networkingAdmin/getSerendipitousEvent`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetSerendipitousEventQueryKey = (params: GetSerendipitousEventParams,) => {
    return [`/networkingAdmin/getSerendipitousEvent`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSerendipitousEventQueryOptions = <TData = Awaited<ReturnType<typeof getSerendipitousEvent>>, TError = unknown>(params: GetSerendipitousEventParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSerendipitousEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSerendipitousEventQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSerendipitousEvent>>> = ({ signal }) => getSerendipitousEvent(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSerendipitousEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSerendipitousEventQueryResult = NonNullable<Awaited<ReturnType<typeof getSerendipitousEvent>>>
export type GetSerendipitousEventQueryError = unknown



export function useGetSerendipitousEvent<TData = Awaited<ReturnType<typeof getSerendipitousEvent>>, TError = unknown>(
 params: GetSerendipitousEventParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSerendipitousEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSerendipitousEventQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getStudentUsers = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetStudentsResponse>(
      {url: `/networkingAdmin/getStudentUsers`, method: 'GET', signal
    },
      );
    }
  

export const getGetStudentUsersQueryKey = () => {
    return [`/networkingAdmin/getStudentUsers`] as const;
    }

    
export const getGetStudentUsersQueryOptions = <TData = Awaited<ReturnType<typeof getStudentUsers>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStudentUsers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStudentUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudentUsers>>> = ({ signal }) => getStudentUsers(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStudentUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStudentUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getStudentUsers>>>
export type GetStudentUsersQueryError = unknown



export function useGetStudentUsers<TData = Awaited<ReturnType<typeof getStudentUsers>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStudentUsers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStudentUsersQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const registerEmployersForUniversity = (
    eid: number,
    addEmployerRequest: AddEmployerRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/networkingAdmin/registerEmployersForUniversity/${eid}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addEmployerRequest, signal
    },
      );
    }
  


export const getRegisterEmployersForUniversityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerEmployersForUniversity>>, TError,{eid: number;data: AddEmployerRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof registerEmployersForUniversity>>, TError,{eid: number;data: AddEmployerRequest}, TContext> => {
    
const mutationKey = ['registerEmployersForUniversity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerEmployersForUniversity>>, {eid: number;data: AddEmployerRequest}> = (props) => {
          const {eid,data} = props ?? {};

          return  registerEmployersForUniversity(eid,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterEmployersForUniversityMutationResult = NonNullable<Awaited<ReturnType<typeof registerEmployersForUniversity>>>
    export type RegisterEmployersForUniversityMutationBody = AddEmployerRequest
    export type RegisterEmployersForUniversityMutationError = unknown

    export const useRegisterEmployersForUniversity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerEmployersForUniversity>>, TError,{eid: number;data: AddEmployerRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof registerEmployersForUniversity>>,
        TError,
        {eid: number;data: AddEmployerRequest},
        TContext
      > => {

      const mutationOptions = getRegisterEmployersForUniversityMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getAllAttendees = (
    eid: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAllAttendees>(
      {url: `/networkingAdmin/${eid}/getAllAttendees`, method: 'GET', signal
    },
      );
    }
  

export const getGetAllAttendeesQueryKey = (eid: string,) => {
    return [`/networkingAdmin/${eid}/getAllAttendees`] as const;
    }

    
export const getGetAllAttendeesQueryOptions = <TData = Awaited<ReturnType<typeof getAllAttendees>>, TError = unknown>(eid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllAttendees>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllAttendeesQueryKey(eid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAttendees>>> = ({ signal }) => getAllAttendees(eid, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(eid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllAttendees>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllAttendeesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAttendees>>>
export type GetAllAttendeesQueryError = unknown



export function useGetAllAttendees<TData = Awaited<ReturnType<typeof getAllAttendees>>, TError = unknown>(
 eid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllAttendees>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAllAttendeesQueryOptions(eid,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateRoomLogoForSerendipitousEvent = (
    universityEventId: number,
    updateNetworkingEventRoomLogoRequest: UpdateNetworkingEventRoomLogoRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(updateNetworkingEventRoomLogoRequest.imageFile !== undefined) {
 formData.append('imageFile', updateNetworkingEventRoomLogoRequest.imageFile)
 }

      return customInstance<string>(
      {url: `/networkingAdmin/${universityEventId}/addRoomLogo`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUpdateRoomLogoForSerendipitousEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRoomLogoForSerendipitousEvent>>, TError,{universityEventId: number;data: UpdateNetworkingEventRoomLogoRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateRoomLogoForSerendipitousEvent>>, TError,{universityEventId: number;data: UpdateNetworkingEventRoomLogoRequest}, TContext> => {
    
const mutationKey = ['updateRoomLogoForSerendipitousEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRoomLogoForSerendipitousEvent>>, {universityEventId: number;data: UpdateNetworkingEventRoomLogoRequest}> = (props) => {
          const {universityEventId,data} = props ?? {};

          return  updateRoomLogoForSerendipitousEvent(universityEventId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateRoomLogoForSerendipitousEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateRoomLogoForSerendipitousEvent>>>
    export type UpdateRoomLogoForSerendipitousEventMutationBody = UpdateNetworkingEventRoomLogoRequest
    export type UpdateRoomLogoForSerendipitousEventMutationError = unknown

    export const useUpdateRoomLogoForSerendipitousEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRoomLogoForSerendipitousEvent>>, TError,{universityEventId: number;data: UpdateNetworkingEventRoomLogoRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateRoomLogoForSerendipitousEvent>>,
        TError,
        {universityEventId: number;data: UpdateNetworkingEventRoomLogoRequest},
        TContext
      > => {

      const mutationOptions = getUpdateRoomLogoForSerendipitousEventMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getEventDetailsForEmployer = (
    org: string,
    eid: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEventDetailsForEmployerResponse>(
      {url: `/networkingEmployer/employer/${org}/${eid}/eventDetails`, method: 'GET', signal
    },
      );
    }
  

export const getGetEventDetailsForEmployerQueryKey = (org: string,
    eid: number,) => {
    return [`/networkingEmployer/employer/${org}/${eid}/eventDetails`] as const;
    }

    
export const getGetEventDetailsForEmployerQueryOptions = <TData = Awaited<ReturnType<typeof getEventDetailsForEmployer>>, TError = unknown>(org: string,
    eid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventDetailsForEmployer>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventDetailsForEmployerQueryKey(org,eid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventDetailsForEmployer>>> = ({ signal }) => getEventDetailsForEmployer(org,eid, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventDetailsForEmployer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventDetailsForEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof getEventDetailsForEmployer>>>
export type GetEventDetailsForEmployerQueryError = unknown



export function useGetEventDetailsForEmployer<TData = Awaited<ReturnType<typeof getEventDetailsForEmployer>>, TError = unknown>(
 org: string,
    eid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventDetailsForEmployer>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventDetailsForEmployerQueryOptions(org,eid,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const sendEmail = (
    org: string,
    eid: number,
    eidExtension: string,
    sendEmailRequest: SendEmailRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/networkingEmployer/employer/${org}/${eid}/sendEmail/${eidExtension}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendEmailRequest, signal
    },
      );
    }
  


export const getSendEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmail>>, TError,{org: string;eid: number;eidExtension: string;data: SendEmailRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendEmail>>, TError,{org: string;eid: number;eidExtension: string;data: SendEmailRequest}, TContext> => {
    
const mutationKey = ['sendEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendEmail>>, {org: string;eid: number;eidExtension: string;data: SendEmailRequest}> = (props) => {
          const {org,eid,eidExtension,data} = props ?? {};

          return  sendEmail(org,eid,eidExtension,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendEmail>>>
    export type SendEmailMutationBody = SendEmailRequest
    export type SendEmailMutationError = unknown

    export const useSendEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmail>>, TError,{org: string;eid: number;eidExtension: string;data: SendEmailRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendEmail>>,
        TError,
        {org: string;eid: number;eidExtension: string;data: SendEmailRequest},
        TContext
      > => {

      const mutationOptions = getSendEmailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getAttendeeDetails = (
    org: string,
    eid: number,
    userExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAttendeeDetailsResponse>(
      {url: `/networkingEmployer/employer/${org}/${eid}/user/${userExtension}/attendeeDetails`, method: 'GET', signal
    },
      );
    }
  

export const getGetAttendeeDetailsQueryKey = (org: string,
    eid: number,
    userExtension: string,) => {
    return [`/networkingEmployer/employer/${org}/${eid}/user/${userExtension}/attendeeDetails`] as const;
    }

    
export const getGetAttendeeDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getAttendeeDetails>>, TError = unknown>(org: string,
    eid: number,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAttendeeDetails>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttendeeDetailsQueryKey(org,eid,userExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttendeeDetails>>> = ({ signal }) => getAttendeeDetails(org,eid,userExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && userExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttendeeDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAttendeeDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getAttendeeDetails>>>
export type GetAttendeeDetailsQueryError = unknown



export function useGetAttendeeDetails<TData = Awaited<ReturnType<typeof getAttendeeDetails>>, TError = unknown>(
 org: string,
    eid: number,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAttendeeDetails>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAttendeeDetailsQueryOptions(org,eid,userExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const submitAttendeeDetails = (
    org: string,
    eid: number,
    userExtension: string,
    submitAttendeeDetailsRequest: SubmitAttendeeDetailsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/networkingEmployer/employer/${org}/${eid}/user/${userExtension}/attendeeDetails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitAttendeeDetailsRequest, signal
    },
      );
    }
  


export const getSubmitAttendeeDetailsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAttendeeDetails>>, TError,{org: string;eid: number;userExtension: string;data: SubmitAttendeeDetailsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitAttendeeDetails>>, TError,{org: string;eid: number;userExtension: string;data: SubmitAttendeeDetailsRequest}, TContext> => {
    
const mutationKey = ['submitAttendeeDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitAttendeeDetails>>, {org: string;eid: number;userExtension: string;data: SubmitAttendeeDetailsRequest}> = (props) => {
          const {org,eid,userExtension,data} = props ?? {};

          return  submitAttendeeDetails(org,eid,userExtension,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitAttendeeDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof submitAttendeeDetails>>>
    export type SubmitAttendeeDetailsMutationBody = SubmitAttendeeDetailsRequest
    export type SubmitAttendeeDetailsMutationError = unknown

    export const useSubmitAttendeeDetails = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAttendeeDetails>>, TError,{org: string;eid: number;userExtension: string;data: SubmitAttendeeDetailsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitAttendeeDetails>>,
        TError,
        {org: string;eid: number;userExtension: string;data: SubmitAttendeeDetailsRequest},
        TContext
      > => {

      const mutationOptions = getSubmitAttendeeDetailsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getEmployerDetails = (
    org: string,
    eid: number,
    userExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEmployerDetailsResponse>(
      {url: `/networkingEmployer/employer/${org}/${eid}/user/${userExtension}/employerDetails`, method: 'GET', signal
    },
      );
    }
  

export const getGetEmployerDetailsQueryKey = (org: string,
    eid: number,
    userExtension: string,) => {
    return [`/networkingEmployer/employer/${org}/${eid}/user/${userExtension}/employerDetails`] as const;
    }

    
export const getGetEmployerDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerDetails>>, TError = unknown>(org: string,
    eid: number,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerDetails>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerDetailsQueryKey(org,eid,userExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerDetails>>> = ({ signal }) => getEmployerDetails(org,eid,userExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && userExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployerDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerDetails>>>
export type GetEmployerDetailsQueryError = unknown



export function useGetEmployerDetails<TData = Awaited<ReturnType<typeof getEmployerDetails>>, TError = unknown>(
 org: string,
    eid: number,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerDetails>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmployerDetailsQueryOptions(org,eid,userExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const submitEmployerDetails = (
    org: string,
    eid: number,
    userExtension: string,
    submitEmployerDetailsRequest: SubmitEmployerDetailsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/networkingEmployer/employer/${org}/${eid}/user/${userExtension}/employerDetails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitEmployerDetailsRequest, signal
    },
      );
    }
  


export const getSubmitEmployerDetailsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployerDetails>>, TError,{org: string;eid: number;userExtension: string;data: SubmitEmployerDetailsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitEmployerDetails>>, TError,{org: string;eid: number;userExtension: string;data: SubmitEmployerDetailsRequest}, TContext> => {
    
const mutationKey = ['submitEmployerDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitEmployerDetails>>, {org: string;eid: number;userExtension: string;data: SubmitEmployerDetailsRequest}> = (props) => {
          const {org,eid,userExtension,data} = props ?? {};

          return  submitEmployerDetails(org,eid,userExtension,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitEmployerDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof submitEmployerDetails>>>
    export type SubmitEmployerDetailsMutationBody = SubmitEmployerDetailsRequest
    export type SubmitEmployerDetailsMutationError = unknown

    export const useSubmitEmployerDetails = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitEmployerDetails>>, TError,{org: string;eid: number;userExtension: string;data: SubmitEmployerDetailsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitEmployerDetails>>,
        TError,
        {org: string;eid: number;userExtension: string;data: SubmitEmployerDetailsRequest},
        TContext
      > => {

      const mutationOptions = getSubmitEmployerDetailsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getUserDetails = (
    org: string,
    eid: number,
    userExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetUserDetailsResponse>(
      {url: `/networkingEmployer/employer/${org}/${eid}/user/${userExtension}/userDetails`, method: 'GET', signal
    },
      );
    }
  

export const getGetUserDetailsQueryKey = (org: string,
    eid: number,
    userExtension: string,) => {
    return [`/networkingEmployer/employer/${org}/${eid}/user/${userExtension}/userDetails`] as const;
    }

    
export const getGetUserDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getUserDetails>>, TError = unknown>(org: string,
    eid: number,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserDetailsQueryKey(org,eid,userExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserDetails>>> = ({ signal }) => getUserDetails(org,eid,userExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && userExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserDetails>>>
export type GetUserDetailsQueryError = unknown



export function useGetUserDetails<TData = Awaited<ReturnType<typeof getUserDetails>>, TError = unknown>(
 org: string,
    eid: number,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserDetailsQueryOptions(org,eid,userExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const submitUserDetails = (
    org: string,
    eid: number,
    userExtension: string,
    submitUserDetailsRequest: SubmitUserDetailsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/networkingEmployer/employer/${org}/${eid}/user/${userExtension}/userDetails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitUserDetailsRequest, signal
    },
      );
    }
  


export const getSubmitUserDetailsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitUserDetails>>, TError,{org: string;eid: number;userExtension: string;data: SubmitUserDetailsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitUserDetails>>, TError,{org: string;eid: number;userExtension: string;data: SubmitUserDetailsRequest}, TContext> => {
    
const mutationKey = ['submitUserDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitUserDetails>>, {org: string;eid: number;userExtension: string;data: SubmitUserDetailsRequest}> = (props) => {
          const {org,eid,userExtension,data} = props ?? {};

          return  submitUserDetails(org,eid,userExtension,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitUserDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof submitUserDetails>>>
    export type SubmitUserDetailsMutationBody = SubmitUserDetailsRequest
    export type SubmitUserDetailsMutationError = unknown

    export const useSubmitUserDetails = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitUserDetails>>, TError,{org: string;eid: number;userExtension: string;data: SubmitUserDetailsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitUserDetails>>,
        TError,
        {org: string;eid: number;userExtension: string;data: SubmitUserDetailsRequest},
        TContext
      > => {

      const mutationOptions = getSubmitUserDetailsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getStep = (
    org: string,
    eid: number,
    userExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/networkingEmployer/${org}/employer/${eid}/user/${userExtension}/step`, method: 'GET', signal
    },
      );
    }
  

export const getGetStepQueryKey = (org: string,
    eid: number,
    userExtension: string,) => {
    return [`/networkingEmployer/${org}/employer/${eid}/user/${userExtension}/step`] as const;
    }

    
export const getGetStepQueryOptions = <TData = Awaited<ReturnType<typeof getStep>>, TError = unknown>(org: string,
    eid: number,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStep>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStepQueryKey(org,eid,userExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStep>>> = ({ signal }) => getStep(org,eid,userExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && userExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStep>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStepQueryResult = NonNullable<Awaited<ReturnType<typeof getStep>>>
export type GetStepQueryError = unknown



export function useGetStep<TData = Awaited<ReturnType<typeof getStep>>, TError = unknown>(
 org: string,
    eid: number,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStep>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStepQueryOptions(org,eid,userExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const downloadStudentDocEmployer = (
    org: string,
    eid: string,
    extension: string,
    downloadDocumentRequest: DownloadDocumentRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/networkingEmployer/${org}/${eid}/document/${extension}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: downloadDocumentRequest, signal
    },
      );
    }
  


export const getDownloadStudentDocEmployerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof downloadStudentDocEmployer>>, TError,{org: string;eid: string;extension: string;data: DownloadDocumentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof downloadStudentDocEmployer>>, TError,{org: string;eid: string;extension: string;data: DownloadDocumentRequest}, TContext> => {
    
const mutationKey = ['downloadStudentDocEmployer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof downloadStudentDocEmployer>>, {org: string;eid: string;extension: string;data: DownloadDocumentRequest}> = (props) => {
          const {org,eid,extension,data} = props ?? {};

          return  downloadStudentDocEmployer(org,eid,extension,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DownloadStudentDocEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof downloadStudentDocEmployer>>>
    export type DownloadStudentDocEmployerMutationBody = DownloadDocumentRequest
    export type DownloadStudentDocEmployerMutationError = unknown

    export const useDownloadStudentDocEmployer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof downloadStudentDocEmployer>>, TError,{org: string;eid: string;extension: string;data: DownloadDocumentRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof downloadStudentDocEmployer>>,
        TError,
        {org: string;eid: string;extension: string;data: DownloadDocumentRequest},
        TContext
      > => {

      const mutationOptions = getDownloadStudentDocEmployerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getEmployerEventExpired = (
    org: string,
    eid: string,
    userExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<IsEventExpiredResponse>(
      {url: `/networkingEmployer/${org}/${eid}/eventExpired/${userExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEmployerEventExpiredQueryKey = (org: string,
    eid: string,
    userExtension: string,) => {
    return [`/networkingEmployer/${org}/${eid}/eventExpired/${userExtension}`] as const;
    }

    
export const getGetEmployerEventExpiredQueryOptions = <TData = Awaited<ReturnType<typeof getEmployerEventExpired>>, TError = unknown>(org: string,
    eid: string,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerEventExpired>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerEventExpiredQueryKey(org,eid,userExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployerEventExpired>>> = ({ signal }) => getEmployerEventExpired(org,eid,userExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && userExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployerEventExpired>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmployerEventExpiredQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployerEventExpired>>>
export type GetEmployerEventExpiredQueryError = unknown



export function useGetEmployerEventExpired<TData = Awaited<ReturnType<typeof getEmployerEventExpired>>, TError = unknown>(
 org: string,
    eid: string,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmployerEventExpired>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmployerEventExpiredQueryOptions(org,eid,userExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAllAttendeesAsEmployer = (
    org: string,
    eid: string,
    userExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAllAttendees>(
      {url: `/networkingEmployer/${org}/${eid}/getAllAttendeesAsEmployer/${userExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAllAttendeesAsEmployerQueryKey = (org: string,
    eid: string,
    userExtension: string,) => {
    return [`/networkingEmployer/${org}/${eid}/getAllAttendeesAsEmployer/${userExtension}`] as const;
    }

    
export const getGetAllAttendeesAsEmployerQueryOptions = <TData = Awaited<ReturnType<typeof getAllAttendeesAsEmployer>>, TError = unknown>(org: string,
    eid: string,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllAttendeesAsEmployer>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllAttendeesAsEmployerQueryKey(org,eid,userExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAttendeesAsEmployer>>> = ({ signal }) => getAllAttendeesAsEmployer(org,eid,userExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && userExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllAttendeesAsEmployer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllAttendeesAsEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAttendeesAsEmployer>>>
export type GetAllAttendeesAsEmployerQueryError = unknown



export function useGetAllAttendeesAsEmployer<TData = Awaited<ReturnType<typeof getAllAttendeesAsEmployer>>, TError = unknown>(
 org: string,
    eid: string,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllAttendeesAsEmployer>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAllAttendeesAsEmployerQueryOptions(org,eid,userExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getDailyMeetingTokenAsEmployer = (
    org: string,
    eid: string,
    userExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DailyMeetingTokenResponse>(
      {url: `/networkingEmployer/${org}/${eid}/getDailyMeetingToken/${userExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetDailyMeetingTokenAsEmployerQueryKey = (org: string,
    eid: string,
    userExtension: string,) => {
    return [`/networkingEmployer/${org}/${eid}/getDailyMeetingToken/${userExtension}`] as const;
    }

    
export const getGetDailyMeetingTokenAsEmployerQueryOptions = <TData = Awaited<ReturnType<typeof getDailyMeetingTokenAsEmployer>>, TError = unknown>(org: string,
    eid: string,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDailyMeetingTokenAsEmployer>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDailyMeetingTokenAsEmployerQueryKey(org,eid,userExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDailyMeetingTokenAsEmployer>>> = ({ signal }) => getDailyMeetingTokenAsEmployer(org,eid,userExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && userExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDailyMeetingTokenAsEmployer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDailyMeetingTokenAsEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof getDailyMeetingTokenAsEmployer>>>
export type GetDailyMeetingTokenAsEmployerQueryError = unknown



export function useGetDailyMeetingTokenAsEmployer<TData = Awaited<ReturnType<typeof getDailyMeetingTokenAsEmployer>>, TError = unknown>(
 org: string,
    eid: string,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDailyMeetingTokenAsEmployer>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDailyMeetingTokenAsEmployerQueryOptions(org,eid,userExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSerendipitousAllEmployersAllRooms = (
    org: string,
    eid: string,
    userExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetNetworkingEventAllAttendeesAllRooms>(
      {url: `/networkingEmployer/${org}/${eid}/getSerendipitousAllEmployersAllRooms/${userExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetSerendipitousAllEmployersAllRoomsQueryKey = (org: string,
    eid: string,
    userExtension: string,) => {
    return [`/networkingEmployer/${org}/${eid}/getSerendipitousAllEmployersAllRooms/${userExtension}`] as const;
    }

    
export const getGetSerendipitousAllEmployersAllRoomsQueryOptions = <TData = Awaited<ReturnType<typeof getSerendipitousAllEmployersAllRooms>>, TError = unknown>(org: string,
    eid: string,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSerendipitousAllEmployersAllRooms>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSerendipitousAllEmployersAllRoomsQueryKey(org,eid,userExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSerendipitousAllEmployersAllRooms>>> = ({ signal }) => getSerendipitousAllEmployersAllRooms(org,eid,userExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && userExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSerendipitousAllEmployersAllRooms>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSerendipitousAllEmployersAllRoomsQueryResult = NonNullable<Awaited<ReturnType<typeof getSerendipitousAllEmployersAllRooms>>>
export type GetSerendipitousAllEmployersAllRoomsQueryError = unknown



export function useGetSerendipitousAllEmployersAllRooms<TData = Awaited<ReturnType<typeof getSerendipitousAllEmployersAllRooms>>, TError = unknown>(
 org: string,
    eid: string,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSerendipitousAllEmployersAllRooms>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSerendipitousAllEmployersAllRoomsQueryOptions(org,eid,userExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSerendipitousEmployerEvent = (
    org: string,
    eid: string,
    userExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetNetworkingEventResponseForAttendee>(
      {url: `/networkingEmployer/${org}/${eid}/getSerendipitousEmployerEvent/${userExtension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetSerendipitousEmployerEventQueryKey = (org: string,
    eid: string,
    userExtension: string,) => {
    return [`/networkingEmployer/${org}/${eid}/getSerendipitousEmployerEvent/${userExtension}`] as const;
    }

    
export const getGetSerendipitousEmployerEventQueryOptions = <TData = Awaited<ReturnType<typeof getSerendipitousEmployerEvent>>, TError = unknown>(org: string,
    eid: string,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSerendipitousEmployerEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSerendipitousEmployerEventQueryKey(org,eid,userExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSerendipitousEmployerEvent>>> = ({ signal }) => getSerendipitousEmployerEvent(org,eid,userExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && userExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSerendipitousEmployerEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSerendipitousEmployerEventQueryResult = NonNullable<Awaited<ReturnType<typeof getSerendipitousEmployerEvent>>>
export type GetSerendipitousEmployerEventQueryError = unknown



export function useGetSerendipitousEmployerEvent<TData = Awaited<ReturnType<typeof getSerendipitousEmployerEvent>>, TError = unknown>(
 org: string,
    eid: string,
    userExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSerendipitousEmployerEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSerendipitousEmployerEventQueryOptions(org,eid,userExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getStudentEventDetails = (
    org: string,
    eid: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetEventDetailsForStudentResponse>(
      {url: `/networkingStudent/${org}/${eid}/eventDetails`, method: 'GET', signal
    },
      );
    }
  

export const getGetStudentEventDetailsQueryKey = (org: string,
    eid: number,) => {
    return [`/networkingStudent/${org}/${eid}/eventDetails`] as const;
    }

    
export const getGetStudentEventDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getStudentEventDetails>>, TError = unknown>(org: string,
    eid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStudentEventDetails>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStudentEventDetailsQueryKey(org,eid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudentEventDetails>>> = ({ signal }) => getStudentEventDetails(org,eid, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStudentEventDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStudentEventDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getStudentEventDetails>>>
export type GetStudentEventDetailsQueryError = unknown



export function useGetStudentEventDetails<TData = Awaited<ReturnType<typeof getStudentEventDetails>>, TError = unknown>(
 org: string,
    eid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStudentEventDetails>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStudentEventDetailsQueryOptions(org,eid,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getStudentEventExpired = (
    org: string,
    eid: string,
    extension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<IsEventExpiredResponse>(
      {url: `/networkingStudent/${org}/${eid}/eventExpired/${extension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetStudentEventExpiredQueryKey = (org: string,
    eid: string,
    extension: string,) => {
    return [`/networkingStudent/${org}/${eid}/eventExpired/${extension}`] as const;
    }

    
export const getGetStudentEventExpiredQueryOptions = <TData = Awaited<ReturnType<typeof getStudentEventExpired>>, TError = unknown>(org: string,
    eid: string,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStudentEventExpired>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStudentEventExpiredQueryKey(org,eid,extension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudentEventExpired>>> = ({ signal }) => getStudentEventExpired(org,eid,extension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && extension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStudentEventExpired>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStudentEventExpiredQueryResult = NonNullable<Awaited<ReturnType<typeof getStudentEventExpired>>>
export type GetStudentEventExpiredQueryError = unknown



export function useGetStudentEventExpired<TData = Awaited<ReturnType<typeof getStudentEventExpired>>, TError = unknown>(
 org: string,
    eid: string,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStudentEventExpired>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStudentEventExpiredQueryOptions(org,eid,extension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAllAttendeesAsStudent = (
    org: string,
    eid: string,
    extension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetAllAttendeesAsStudent>(
      {url: `/networkingStudent/${org}/${eid}/getAllAttendeesAsStudent/${extension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAllAttendeesAsStudentQueryKey = (org: string,
    eid: string,
    extension: string,) => {
    return [`/networkingStudent/${org}/${eid}/getAllAttendeesAsStudent/${extension}`] as const;
    }

    
export const getGetAllAttendeesAsStudentQueryOptions = <TData = Awaited<ReturnType<typeof getAllAttendeesAsStudent>>, TError = unknown>(org: string,
    eid: string,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllAttendeesAsStudent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllAttendeesAsStudentQueryKey(org,eid,extension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllAttendeesAsStudent>>> = ({ signal }) => getAllAttendeesAsStudent(org,eid,extension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && extension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllAttendeesAsStudent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllAttendeesAsStudentQueryResult = NonNullable<Awaited<ReturnType<typeof getAllAttendeesAsStudent>>>
export type GetAllAttendeesAsStudentQueryError = unknown



export function useGetAllAttendeesAsStudent<TData = Awaited<ReturnType<typeof getAllAttendeesAsStudent>>, TError = unknown>(
 org: string,
    eid: string,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllAttendeesAsStudent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAllAttendeesAsStudentQueryOptions(org,eid,extension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAllUploadedDocsForStudent = (
    org: string,
    eid: string,
    extension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetStudentDocumentsResponse[]>(
      {url: `/networkingStudent/${org}/${eid}/getAllUploadedDocsForStudent/${extension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAllUploadedDocsForStudentQueryKey = (org: string,
    eid: string,
    extension: string,) => {
    return [`/networkingStudent/${org}/${eid}/getAllUploadedDocsForStudent/${extension}`] as const;
    }

    
export const getGetAllUploadedDocsForStudentQueryOptions = <TData = Awaited<ReturnType<typeof getAllUploadedDocsForStudent>>, TError = unknown>(org: string,
    eid: string,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllUploadedDocsForStudent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllUploadedDocsForStudentQueryKey(org,eid,extension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllUploadedDocsForStudent>>> = ({ signal }) => getAllUploadedDocsForStudent(org,eid,extension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && extension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllUploadedDocsForStudent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllUploadedDocsForStudentQueryResult = NonNullable<Awaited<ReturnType<typeof getAllUploadedDocsForStudent>>>
export type GetAllUploadedDocsForStudentQueryError = unknown



export function useGetAllUploadedDocsForStudent<TData = Awaited<ReturnType<typeof getAllUploadedDocsForStudent>>, TError = unknown>(
 org: string,
    eid: string,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAllUploadedDocsForStudent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAllUploadedDocsForStudentQueryOptions(org,eid,extension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getDailyMeetingTokenAsStudent = (
    org: string,
    eid: string,
    extension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DailyMeetingTokenResponse>(
      {url: `/networkingStudent/${org}/${eid}/getDailyMeetingToken/${extension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetDailyMeetingTokenAsStudentQueryKey = (org: string,
    eid: string,
    extension: string,) => {
    return [`/networkingStudent/${org}/${eid}/getDailyMeetingToken/${extension}`] as const;
    }

    
export const getGetDailyMeetingTokenAsStudentQueryOptions = <TData = Awaited<ReturnType<typeof getDailyMeetingTokenAsStudent>>, TError = unknown>(org: string,
    eid: string,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDailyMeetingTokenAsStudent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDailyMeetingTokenAsStudentQueryKey(org,eid,extension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDailyMeetingTokenAsStudent>>> = ({ signal }) => getDailyMeetingTokenAsStudent(org,eid,extension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && extension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDailyMeetingTokenAsStudent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDailyMeetingTokenAsStudentQueryResult = NonNullable<Awaited<ReturnType<typeof getDailyMeetingTokenAsStudent>>>
export type GetDailyMeetingTokenAsStudentQueryError = unknown



export function useGetDailyMeetingTokenAsStudent<TData = Awaited<ReturnType<typeof getDailyMeetingTokenAsStudent>>, TError = unknown>(
 org: string,
    eid: string,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDailyMeetingTokenAsStudent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDailyMeetingTokenAsStudentQueryOptions(org,eid,extension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSerendipitousAllStudentsAllRooms = (
    org: string,
    eid: string,
    extension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetNetworkingEventAllAttendeesAllRooms>(
      {url: `/networkingStudent/${org}/${eid}/getSerendipitousAllStudentsAllRooms/${extension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetSerendipitousAllStudentsAllRoomsQueryKey = (org: string,
    eid: string,
    extension: string,) => {
    return [`/networkingStudent/${org}/${eid}/getSerendipitousAllStudentsAllRooms/${extension}`] as const;
    }

    
export const getGetSerendipitousAllStudentsAllRoomsQueryOptions = <TData = Awaited<ReturnType<typeof getSerendipitousAllStudentsAllRooms>>, TError = unknown>(org: string,
    eid: string,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSerendipitousAllStudentsAllRooms>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSerendipitousAllStudentsAllRoomsQueryKey(org,eid,extension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSerendipitousAllStudentsAllRooms>>> = ({ signal }) => getSerendipitousAllStudentsAllRooms(org,eid,extension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && extension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSerendipitousAllStudentsAllRooms>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSerendipitousAllStudentsAllRoomsQueryResult = NonNullable<Awaited<ReturnType<typeof getSerendipitousAllStudentsAllRooms>>>
export type GetSerendipitousAllStudentsAllRoomsQueryError = unknown



export function useGetSerendipitousAllStudentsAllRooms<TData = Awaited<ReturnType<typeof getSerendipitousAllStudentsAllRooms>>, TError = unknown>(
 org: string,
    eid: string,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSerendipitousAllStudentsAllRooms>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSerendipitousAllStudentsAllRoomsQueryOptions(org,eid,extension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSerendipitousStudentEvent = (
    org: string,
    eid: string,
    extension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetNetworkingEventResponseForAttendee>(
      {url: `/networkingStudent/${org}/${eid}/getSerendipitousStudentEvent/${extension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetSerendipitousStudentEventQueryKey = (org: string,
    eid: string,
    extension: string,) => {
    return [`/networkingStudent/${org}/${eid}/getSerendipitousStudentEvent/${extension}`] as const;
    }

    
export const getGetSerendipitousStudentEventQueryOptions = <TData = Awaited<ReturnType<typeof getSerendipitousStudentEvent>>, TError = unknown>(org: string,
    eid: string,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSerendipitousStudentEvent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSerendipitousStudentEventQueryKey(org,eid,extension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSerendipitousStudentEvent>>> = ({ signal }) => getSerendipitousStudentEvent(org,eid,extension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && extension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSerendipitousStudentEvent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSerendipitousStudentEventQueryResult = NonNullable<Awaited<ReturnType<typeof getSerendipitousStudentEvent>>>
export type GetSerendipitousStudentEventQueryError = unknown



export function useGetSerendipitousStudentEvent<TData = Awaited<ReturnType<typeof getSerendipitousStudentEvent>>, TError = unknown>(
 org: string,
    eid: string,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSerendipitousStudentEvent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSerendipitousStudentEventQueryOptions(org,eid,extension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getStudentDetails = (
    org: string,
    eid: number,
    extension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CandidateDTO>(
      {url: `/networkingStudent/${org}/${eid}/myDetails/${extension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetStudentDetailsQueryKey = (org: string,
    eid: number,
    extension: string,) => {
    return [`/networkingStudent/${org}/${eid}/myDetails/${extension}`] as const;
    }

    
export const getGetStudentDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getStudentDetails>>, TError = unknown>(org: string,
    eid: number,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStudentDetails>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStudentDetailsQueryKey(org,eid,extension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudentDetails>>> = ({ signal }) => getStudentDetails(org,eid,extension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && extension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStudentDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStudentDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getStudentDetails>>>
export type GetStudentDetailsQueryError = unknown



export function useGetStudentDetails<TData = Awaited<ReturnType<typeof getStudentDetails>>, TError = unknown>(
 org: string,
    eid: number,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStudentDetails>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStudentDetailsQueryOptions(org,eid,extension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const submitStudentDetails = (
    org: string,
    eid: number,
    extension: string,
    studentDetailsRequest: StudentDetailsRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(studentDetailsRequest.deleteImage !== undefined) {
 formData.append('deleteImage', studentDetailsRequest.deleteImage.toString())
 }
if(studentDetailsRequest.document !== undefined) {
 formData.append('document', studentDetailsRequest.document)
 }
if(studentDetailsRequest.firstName !== undefined) {
 formData.append('firstName', studentDetailsRequest.firstName)
 }
if(studentDetailsRequest.lastName !== undefined) {
 formData.append('lastName', studentDetailsRequest.lastName)
 }
if(studentDetailsRequest.linkedin !== undefined) {
 formData.append('linkedin', studentDetailsRequest.linkedin)
 }
if(studentDetailsRequest.phone !== undefined) {
 formData.append('phone', studentDetailsRequest.phone)
 }
if(studentDetailsRequest.sendConfirmationEmail !== undefined) {
 formData.append('sendConfirmationEmail', studentDetailsRequest.sendConfirmationEmail.toString())
 }

      return customInstance<GenericResponse>(
      {url: `/networkingStudent/${org}/${eid}/myDetails/${extension}`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getSubmitStudentDetailsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitStudentDetails>>, TError,{org: string;eid: number;extension: string;data: StudentDetailsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitStudentDetails>>, TError,{org: string;eid: number;extension: string;data: StudentDetailsRequest}, TContext> => {
    
const mutationKey = ['submitStudentDetails'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitStudentDetails>>, {org: string;eid: number;extension: string;data: StudentDetailsRequest}> = (props) => {
          const {org,eid,extension,data} = props ?? {};

          return  submitStudentDetails(org,eid,extension,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitStudentDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof submitStudentDetails>>>
    export type SubmitStudentDetailsMutationBody = StudentDetailsRequest
    export type SubmitStudentDetailsMutationError = unknown

    export const useSubmitStudentDetails = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitStudentDetails>>, TError,{org: string;eid: number;extension: string;data: StudentDetailsRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitStudentDetails>>,
        TError,
        {org: string;eid: number;extension: string;data: StudentDetailsRequest},
        TContext
      > => {

      const mutationOptions = getSubmitStudentDetailsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const uploadSupportingDocuments = (
    org: string,
    eid: number,
    extension: string,
    uploadDocumentRequestDTO: UploadDocumentRequestDTO,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(uploadDocumentRequestDTO.eventCustomDocId !== undefined) {
 formData.append('eventCustomDocId', uploadDocumentRequestDTO.eventCustomDocId.toString())
 }
if(uploadDocumentRequestDTO.file !== undefined) {
 formData.append('file', uploadDocumentRequestDTO.file)
 }
if(uploadDocumentRequestDTO.orgDocId !== undefined) {
 formData.append('orgDocId', uploadDocumentRequestDTO.orgDocId.toString())
 }

      return customInstance<GenericResponse>(
      {url: `/networkingStudent/${org}/${eid}/uploadSupportingDocuments/${extension}`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadSupportingDocumentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadSupportingDocuments>>, TError,{org: string;eid: number;extension: string;data: UploadDocumentRequestDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadSupportingDocuments>>, TError,{org: string;eid: number;extension: string;data: UploadDocumentRequestDTO}, TContext> => {
    
const mutationKey = ['uploadSupportingDocuments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadSupportingDocuments>>, {org: string;eid: number;extension: string;data: UploadDocumentRequestDTO}> = (props) => {
          const {org,eid,extension,data} = props ?? {};

          return  uploadSupportingDocuments(org,eid,extension,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadSupportingDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof uploadSupportingDocuments>>>
    export type UploadSupportingDocumentsMutationBody = UploadDocumentRequestDTO
    export type UploadSupportingDocumentsMutationError = unknown

    export const useUploadSupportingDocuments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadSupportingDocuments>>, TError,{org: string;eid: number;extension: string;data: UploadDocumentRequestDTO}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadSupportingDocuments>>,
        TError,
        {org: string;eid: number;extension: string;data: UploadDocumentRequestDTO},
        TContext
      > => {

      const mutationOptions = getUploadSupportingDocumentsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchOffices = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<OfficeResponse[]>(
      {url: `/offices`, method: 'GET', signal
    },
      );
    }
  

export const getFetchOfficesQueryKey = () => {
    return [`/offices`] as const;
    }

    
export const getFetchOfficesQueryOptions = <TData = Awaited<ReturnType<typeof fetchOffices>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOffices>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchOfficesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchOffices>>> = ({ signal }) => fetchOffices(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchOffices>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchOfficesQueryResult = NonNullable<Awaited<ReturnType<typeof fetchOffices>>>
export type FetchOfficesQueryError = unknown



export function useFetchOffices<TData = Awaited<ReturnType<typeof fetchOffices>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOffices>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchOfficesQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createOffices = (
    createOfficesRequest: CreateOfficesRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/offices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOfficesRequest, signal
    },
      );
    }
  


export const getCreateOfficesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOffices>>, TError,{data: CreateOfficesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createOffices>>, TError,{data: CreateOfficesRequest}, TContext> => {
    
const mutationKey = ['createOffices'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOffices>>, {data: CreateOfficesRequest}> = (props) => {
          const {data} = props ?? {};

          return  createOffices(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateOfficesMutationResult = NonNullable<Awaited<ReturnType<typeof createOffices>>>
    export type CreateOfficesMutationBody = CreateOfficesRequest
    export type CreateOfficesMutationError = unknown

    export const useCreateOffices = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOffices>>, TError,{data: CreateOfficesRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOffices>>,
        TError,
        {data: CreateOfficesRequest},
        TContext
      > => {

      const mutationOptions = getCreateOfficesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchStaticOfficesList = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/officesStaticList`, method: 'GET', signal
    },
      );
    }
  

export const getFetchStaticOfficesListQueryKey = () => {
    return [`/officesStaticList`] as const;
    }

    
export const getFetchStaticOfficesListQueryOptions = <TData = Awaited<ReturnType<typeof fetchStaticOfficesList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchStaticOfficesList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchStaticOfficesListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchStaticOfficesList>>> = ({ signal }) => fetchStaticOfficesList(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchStaticOfficesList>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchStaticOfficesListQueryResult = NonNullable<Awaited<ReturnType<typeof fetchStaticOfficesList>>>
export type FetchStaticOfficesListQueryError = unknown



export function useFetchStaticOfficesList<TData = Awaited<ReturnType<typeof fetchStaticOfficesList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchStaticOfficesList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchStaticOfficesListQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const fetchOrgApplicationQuestions = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrgQuestionResponse[]>(
      {url: `/org-application-questions`, method: 'GET', signal
    },
      );
    }
  

export const getFetchOrgApplicationQuestionsQueryKey = () => {
    return [`/org-application-questions`] as const;
    }

    
export const getFetchOrgApplicationQuestionsQueryOptions = <TData = Awaited<ReturnType<typeof fetchOrgApplicationQuestions>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgApplicationQuestions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchOrgApplicationQuestionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchOrgApplicationQuestions>>> = ({ signal }) => fetchOrgApplicationQuestions(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchOrgApplicationQuestions>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchOrgApplicationQuestionsQueryResult = NonNullable<Awaited<ReturnType<typeof fetchOrgApplicationQuestions>>>
export type FetchOrgApplicationQuestionsQueryError = unknown



export function useFetchOrgApplicationQuestions<TData = Awaited<ReturnType<typeof fetchOrgApplicationQuestions>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgApplicationQuestions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchOrgApplicationQuestionsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createOrgApplicationQuestion = (
    orgQuestionRequest: OrgQuestionRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/org-application-questions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: orgQuestionRequest, signal
    },
      );
    }
  


export const getCreateOrgApplicationQuestionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgApplicationQuestion>>, TError,{data: OrgQuestionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createOrgApplicationQuestion>>, TError,{data: OrgQuestionRequest}, TContext> => {
    
const mutationKey = ['createOrgApplicationQuestion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrgApplicationQuestion>>, {data: OrgQuestionRequest}> = (props) => {
          const {data} = props ?? {};

          return  createOrgApplicationQuestion(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateOrgApplicationQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof createOrgApplicationQuestion>>>
    export type CreateOrgApplicationQuestionMutationBody = OrgQuestionRequest
    export type CreateOrgApplicationQuestionMutationError = unknown

    export const useCreateOrgApplicationQuestion = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgApplicationQuestion>>, TError,{data: OrgQuestionRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOrgApplicationQuestion>>,
        TError,
        {data: OrgQuestionRequest},
        TContext
      > => {

      const mutationOptions = getCreateOrgApplicationQuestionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const updateOrgApplicationQuestion = (
    orgQuestionRequest: OrgQuestionRequest,
 ) => {
      
      
      return customInstance<number>(
      {url: `/org-application-questions`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: orgQuestionRequest
    },
      );
    }
  


export const getUpdateOrgApplicationQuestionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgApplicationQuestion>>, TError,{data: OrgQuestionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOrgApplicationQuestion>>, TError,{data: OrgQuestionRequest}, TContext> => {
    
const mutationKey = ['updateOrgApplicationQuestion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrgApplicationQuestion>>, {data: OrgQuestionRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateOrgApplicationQuestion(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrgApplicationQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrgApplicationQuestion>>>
    export type UpdateOrgApplicationQuestionMutationBody = OrgQuestionRequest
    export type UpdateOrgApplicationQuestionMutationError = unknown

    export const useUpdateOrgApplicationQuestion = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgApplicationQuestion>>, TError,{data: OrgQuestionRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOrgApplicationQuestion>>,
        TError,
        {data: OrgQuestionRequest},
        TContext
      > => {

      const mutationOptions = getUpdateOrgApplicationQuestionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const deleteOrgApplicationQuestion = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/org-application-questions/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteOrgApplicationQuestionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgApplicationQuestion>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrgApplicationQuestion>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['deleteOrgApplicationQuestion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrgApplicationQuestion>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteOrgApplicationQuestion(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrgApplicationQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrgApplicationQuestion>>>
    
    export type DeleteOrgApplicationQuestionMutationError = unknown

    export const useDeleteOrgApplicationQuestion = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgApplicationQuestion>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrgApplicationQuestion>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteOrgApplicationQuestionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchOrgAppQuestionJobCount = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/org-application-questions/${id}/job-count`, method: 'GET', signal
    },
      );
    }
  

export const getFetchOrgAppQuestionJobCountQueryKey = (id: number,) => {
    return [`/org-application-questions/${id}/job-count`] as const;
    }

    
export const getFetchOrgAppQuestionJobCountQueryOptions = <TData = Awaited<ReturnType<typeof fetchOrgAppQuestionJobCount>>, TError = unknown>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgAppQuestionJobCount>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchOrgAppQuestionJobCountQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchOrgAppQuestionJobCount>>> = ({ signal }) => fetchOrgAppQuestionJobCount(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchOrgAppQuestionJobCount>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchOrgAppQuestionJobCountQueryResult = NonNullable<Awaited<ReturnType<typeof fetchOrgAppQuestionJobCount>>>
export type FetchOrgAppQuestionJobCountQueryError = unknown



export function useFetchOrgAppQuestionJobCount<TData = Awaited<ReturnType<typeof fetchOrgAppQuestionJobCount>>, TError = unknown>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgAppQuestionJobCount>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchOrgAppQuestionJobCountQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const findTagsByOrgId = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrgTagDto[]>(
      {url: `/org-tags`, method: 'GET', signal
    },
      );
    }
  

export const getFindTagsByOrgIdQueryKey = () => {
    return [`/org-tags`] as const;
    }

    
export const getFindTagsByOrgIdQueryOptions = <TData = Awaited<ReturnType<typeof findTagsByOrgId>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof findTagsByOrgId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindTagsByOrgIdQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof findTagsByOrgId>>> = ({ signal }) => findTagsByOrgId(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findTagsByOrgId>>, TError, TData> & { queryKey: QueryKey }
}

export type FindTagsByOrgIdQueryResult = NonNullable<Awaited<ReturnType<typeof findTagsByOrgId>>>
export type FindTagsByOrgIdQueryError = unknown



export function useFindTagsByOrgId<TData = Awaited<ReturnType<typeof findTagsByOrgId>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof findTagsByOrgId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFindTagsByOrgIdQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const submitOrgTag = (
    orgTagRequest: OrgTagRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/org-tags`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: orgTagRequest, signal
    },
      );
    }
  


export const getSubmitOrgTagMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitOrgTag>>, TError,{data: OrgTagRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitOrgTag>>, TError,{data: OrgTagRequest}, TContext> => {
    
const mutationKey = ['submitOrgTag'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitOrgTag>>, {data: OrgTagRequest}> = (props) => {
          const {data} = props ?? {};

          return  submitOrgTag(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitOrgTagMutationResult = NonNullable<Awaited<ReturnType<typeof submitOrgTag>>>
    export type SubmitOrgTagMutationBody = OrgTagRequest
    export type SubmitOrgTagMutationError = unknown

    export const useSubmitOrgTag = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitOrgTag>>, TError,{data: OrgTagRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitOrgTag>>,
        TError,
        {data: OrgTagRequest},
        TContext
      > => {

      const mutationOptions = getSubmitOrgTagMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const findTagsByOrgFriendlyName = (
    orgFriendlyName: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrgTagDto[]>(
      {url: `/org-tags/${orgFriendlyName}/data`, method: 'GET', signal
    },
      );
    }
  

export const getFindTagsByOrgFriendlyNameQueryKey = (orgFriendlyName: string,) => {
    return [`/org-tags/${orgFriendlyName}/data`] as const;
    }

    
export const getFindTagsByOrgFriendlyNameQueryOptions = <TData = Awaited<ReturnType<typeof findTagsByOrgFriendlyName>>, TError = unknown>(orgFriendlyName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof findTagsByOrgFriendlyName>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindTagsByOrgFriendlyNameQueryKey(orgFriendlyName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof findTagsByOrgFriendlyName>>> = ({ signal }) => findTagsByOrgFriendlyName(orgFriendlyName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgFriendlyName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findTagsByOrgFriendlyName>>, TError, TData> & { queryKey: QueryKey }
}

export type FindTagsByOrgFriendlyNameQueryResult = NonNullable<Awaited<ReturnType<typeof findTagsByOrgFriendlyName>>>
export type FindTagsByOrgFriendlyNameQueryError = unknown



export function useFindTagsByOrgFriendlyName<TData = Awaited<ReturnType<typeof findTagsByOrgFriendlyName>>, TError = unknown>(
 orgFriendlyName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof findTagsByOrgFriendlyName>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFindTagsByOrgFriendlyNameQueryOptions(orgFriendlyName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const findTagsByEventEID = (
    org: string,
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrgTagDto[]>(
      {url: `/org-tags/${org}/${eventId}/data`, method: 'GET', signal
    },
      );
    }
  

export const getFindTagsByEventEIDQueryKey = (org: string,
    eventId: number,) => {
    return [`/org-tags/${org}/${eventId}/data`] as const;
    }

    
export const getFindTagsByEventEIDQueryOptions = <TData = Awaited<ReturnType<typeof findTagsByEventEID>>, TError = unknown>(org: string,
    eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof findTagsByEventEID>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindTagsByEventEIDQueryKey(org,eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof findTagsByEventEID>>> = ({ signal }) => findTagsByEventEID(org,eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findTagsByEventEID>>, TError, TData> & { queryKey: QueryKey }
}

export type FindTagsByEventEIDQueryResult = NonNullable<Awaited<ReturnType<typeof findTagsByEventEID>>>
export type FindTagsByEventEIDQueryError = unknown



export function useFindTagsByEventEID<TData = Awaited<ReturnType<typeof findTagsByEventEID>>, TError = unknown>(
 org: string,
    eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof findTagsByEventEID>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFindTagsByEventEIDQueryOptions(org,eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteOrgTag = (
    tagId: number,
 ) => {
      
      
      return customInstance<number>(
      {url: `/org-tags/${tagId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteOrgTagMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgTag>>, TError,{tagId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrgTag>>, TError,{tagId: number}, TContext> => {
    
const mutationKey = ['deleteOrgTag'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrgTag>>, {tagId: number}> = (props) => {
          const {tagId} = props ?? {};

          return  deleteOrgTag(tagId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrgTagMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrgTag>>>
    
    export type DeleteOrgTagMutationError = unknown

    export const useDeleteOrgTag = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgTag>>, TError,{tagId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrgTag>>,
        TError,
        {tagId: number},
        TContext
      > => {

      const mutationOptions = getDeleteOrgTagMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchOrgAtsEnabled = (
    params: FetchOrgAtsEnabledParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/organizations/ats-enabled`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getFetchOrgAtsEnabledQueryKey = (params: FetchOrgAtsEnabledParams,) => {
    return [`/organizations/ats-enabled`, ...(params ? [params]: [])] as const;
    }

    
export const getFetchOrgAtsEnabledQueryOptions = <TData = Awaited<ReturnType<typeof fetchOrgAtsEnabled>>, TError = unknown>(params: FetchOrgAtsEnabledParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgAtsEnabled>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchOrgAtsEnabledQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchOrgAtsEnabled>>> = ({ signal }) => fetchOrgAtsEnabled(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchOrgAtsEnabled>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchOrgAtsEnabledQueryResult = NonNullable<Awaited<ReturnType<typeof fetchOrgAtsEnabled>>>
export type FetchOrgAtsEnabledQueryError = unknown



export function useFetchOrgAtsEnabled<TData = Awaited<ReturnType<typeof fetchOrgAtsEnabled>>, TError = unknown>(
 params: FetchOrgAtsEnabledParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgAtsEnabled>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchOrgAtsEnabledQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const fetchOrgColor = (
    params: FetchOrgColorParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/organizations/color`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getFetchOrgColorQueryKey = (params: FetchOrgColorParams,) => {
    return [`/organizations/color`, ...(params ? [params]: [])] as const;
    }

    
export const getFetchOrgColorQueryOptions = <TData = Awaited<ReturnType<typeof fetchOrgColor>>, TError = unknown>(params: FetchOrgColorParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgColor>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchOrgColorQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchOrgColor>>> = ({ signal }) => fetchOrgColor(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchOrgColor>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchOrgColorQueryResult = NonNullable<Awaited<ReturnType<typeof fetchOrgColor>>>
export type FetchOrgColorQueryError = unknown



export function useFetchOrgColor<TData = Awaited<ReturnType<typeof fetchOrgColor>>, TError = unknown>(
 params: FetchOrgColorParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgColor>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchOrgColorQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const fetchOrgDisplayName = (
    params: FetchOrgDisplayNameParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/organizations/display-name`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getFetchOrgDisplayNameQueryKey = (params: FetchOrgDisplayNameParams,) => {
    return [`/organizations/display-name`, ...(params ? [params]: [])] as const;
    }

    
export const getFetchOrgDisplayNameQueryOptions = <TData = Awaited<ReturnType<typeof fetchOrgDisplayName>>, TError = unknown>(params: FetchOrgDisplayNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgDisplayName>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchOrgDisplayNameQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchOrgDisplayName>>> = ({ signal }) => fetchOrgDisplayName(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchOrgDisplayName>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchOrgDisplayNameQueryResult = NonNullable<Awaited<ReturnType<typeof fetchOrgDisplayName>>>
export type FetchOrgDisplayNameQueryError = unknown



export function useFetchOrgDisplayName<TData = Awaited<ReturnType<typeof fetchOrgDisplayName>>, TError = unknown>(
 params: FetchOrgDisplayNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgDisplayName>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchOrgDisplayNameQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const fetchOrgIsGovernmentContractor = (
    params: FetchOrgIsGovernmentContractorParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/organizations/is-government-contractor`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getFetchOrgIsGovernmentContractorQueryKey = (params: FetchOrgIsGovernmentContractorParams,) => {
    return [`/organizations/is-government-contractor`, ...(params ? [params]: [])] as const;
    }

    
export const getFetchOrgIsGovernmentContractorQueryOptions = <TData = Awaited<ReturnType<typeof fetchOrgIsGovernmentContractor>>, TError = unknown>(params: FetchOrgIsGovernmentContractorParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgIsGovernmentContractor>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchOrgIsGovernmentContractorQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchOrgIsGovernmentContractor>>> = ({ signal }) => fetchOrgIsGovernmentContractor(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchOrgIsGovernmentContractor>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchOrgIsGovernmentContractorQueryResult = NonNullable<Awaited<ReturnType<typeof fetchOrgIsGovernmentContractor>>>
export type FetchOrgIsGovernmentContractorQueryError = unknown



export function useFetchOrgIsGovernmentContractor<TData = Awaited<ReturnType<typeof fetchOrgIsGovernmentContractor>>, TError = unknown>(
 params: FetchOrgIsGovernmentContractorParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgIsGovernmentContractor>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchOrgIsGovernmentContractorQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @deprecated
 */
export const fetchOrgLogoLink = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/organizations/logo`, method: 'GET', signal
    },
      );
    }
  

export const getFetchOrgLogoLinkQueryKey = () => {
    return [`/organizations/logo`] as const;
    }

    
export const getFetchOrgLogoLinkQueryOptions = <TData = Awaited<ReturnType<typeof fetchOrgLogoLink>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgLogoLink>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchOrgLogoLinkQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchOrgLogoLink>>> = ({ signal }) => fetchOrgLogoLink(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchOrgLogoLink>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchOrgLogoLinkQueryResult = NonNullable<Awaited<ReturnType<typeof fetchOrgLogoLink>>>
export type FetchOrgLogoLinkQueryError = unknown


/**
 * @deprecated
 */

export function useFetchOrgLogoLink<TData = Awaited<ReturnType<typeof fetchOrgLogoLink>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgLogoLink>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchOrgLogoLinkQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const fetchOrgLogoLinkv2 = (
    params: FetchOrgLogoLinkv2Params,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/organizations/v2/logo`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getFetchOrgLogoLinkv2QueryKey = (params: FetchOrgLogoLinkv2Params,) => {
    return [`/organizations/v2/logo`, ...(params ? [params]: [])] as const;
    }

    
export const getFetchOrgLogoLinkv2QueryOptions = <TData = Awaited<ReturnType<typeof fetchOrgLogoLinkv2>>, TError = unknown>(params: FetchOrgLogoLinkv2Params, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgLogoLinkv2>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchOrgLogoLinkv2QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchOrgLogoLinkv2>>> = ({ signal }) => fetchOrgLogoLinkv2(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchOrgLogoLinkv2>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchOrgLogoLinkv2QueryResult = NonNullable<Awaited<ReturnType<typeof fetchOrgLogoLinkv2>>>
export type FetchOrgLogoLinkv2QueryError = unknown



export function useFetchOrgLogoLinkv2<TData = Awaited<ReturnType<typeof fetchOrgLogoLinkv2>>, TError = unknown>(
 params: FetchOrgLogoLinkv2Params, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchOrgLogoLinkv2>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchOrgLogoLinkv2QueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPet = (
    params: GetPetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Pet>(
      {url: `/pet`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetPetQueryKey = (params: GetPetParams,) => {
    return [`/pet`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPetQueryOptions = <TData = Awaited<ReturnType<typeof getPet>>, TError = unknown>(params: GetPetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPet>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPet>>> = ({ signal }) => getPet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPetQueryResult = NonNullable<Awaited<ReturnType<typeof getPet>>>
export type GetPetQueryError = unknown



export function useGetPet<TData = Awaited<ReturnType<typeof getPet>>, TError = unknown>(
 params: GetPetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPet>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPetQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const upsertPet = (
    params: UpsertPetParams,
 ) => {
      
      
      return customInstance<void>(
      {url: `/pet`, method: 'PUT',
        params
    },
      );
    }
  


export const getUpsertPetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertPet>>, TError,{params: UpsertPetParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertPet>>, TError,{params: UpsertPetParams}, TContext> => {
    
const mutationKey = ['upsertPet'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertPet>>, {params: UpsertPetParams}> = (props) => {
          const {params} = props ?? {};

          return  upsertPet(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertPetMutationResult = NonNullable<Awaited<ReturnType<typeof upsertPet>>>
    
    export type UpsertPetMutationError = unknown

    export const useUpsertPet = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertPet>>, TError,{params: UpsertPetParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertPet>>,
        TError,
        {params: UpsertPetParams},
        TContext
      > => {

      const mutationOptions = getUpsertPetMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const ping = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/ping`, method: 'GET', signal
    },
      );
    }
  

export const getPingQueryKey = () => {
    return [`/ping`] as const;
    }

    
export const getPingQueryOptions = <TData = Awaited<ReturnType<typeof ping>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ping>>> = ({ signal }) => ping(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData> & { queryKey: QueryKey }
}

export type PingQueryResult = NonNullable<Awaited<ReturnType<typeof ping>>>
export type PingQueryError = unknown



export function usePing<TData = Awaited<ReturnType<typeof ping>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPingQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updatePipelineTemplateBucket = (
    pipelineTemplateBucketRequest: PipelineTemplateBucketRequest,
 ) => {
      
      
      return customInstance<number>(
      {url: `/pipeline-template-buckets`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: pipelineTemplateBucketRequest
    },
      );
    }
  


export const getUpdatePipelineTemplateBucketMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePipelineTemplateBucket>>, TError,{data: PipelineTemplateBucketRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePipelineTemplateBucket>>, TError,{data: PipelineTemplateBucketRequest}, TContext> => {
    
const mutationKey = ['updatePipelineTemplateBucket'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePipelineTemplateBucket>>, {data: PipelineTemplateBucketRequest}> = (props) => {
          const {data} = props ?? {};

          return  updatePipelineTemplateBucket(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePipelineTemplateBucketMutationResult = NonNullable<Awaited<ReturnType<typeof updatePipelineTemplateBucket>>>
    export type UpdatePipelineTemplateBucketMutationBody = PipelineTemplateBucketRequest
    export type UpdatePipelineTemplateBucketMutationError = unknown

    export const useUpdatePipelineTemplateBucket = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePipelineTemplateBucket>>, TError,{data: PipelineTemplateBucketRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePipelineTemplateBucket>>,
        TError,
        {data: PipelineTemplateBucketRequest},
        TContext
      > => {

      const mutationOptions = getUpdatePipelineTemplateBucketMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const searchPipelineTemplateOverviews = (
    pipelineTemplateSearchRequest: PipelineTemplateSearchRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PipelineTemplateOverviewResponse[]>(
      {url: `/pipeline-template-overviews/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pipelineTemplateSearchRequest, signal
    },
      );
    }
  


export const getSearchPipelineTemplateOverviewsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchPipelineTemplateOverviews>>, TError,{data: PipelineTemplateSearchRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof searchPipelineTemplateOverviews>>, TError,{data: PipelineTemplateSearchRequest}, TContext> => {
    
const mutationKey = ['searchPipelineTemplateOverviews'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchPipelineTemplateOverviews>>, {data: PipelineTemplateSearchRequest}> = (props) => {
          const {data} = props ?? {};

          return  searchPipelineTemplateOverviews(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SearchPipelineTemplateOverviewsMutationResult = NonNullable<Awaited<ReturnType<typeof searchPipelineTemplateOverviews>>>
    export type SearchPipelineTemplateOverviewsMutationBody = PipelineTemplateSearchRequest
    export type SearchPipelineTemplateOverviewsMutationError = unknown

    export const useSearchPipelineTemplateOverviews = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchPipelineTemplateOverviews>>, TError,{data: PipelineTemplateSearchRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof searchPipelineTemplateOverviews>>,
        TError,
        {data: PipelineTemplateSearchRequest},
        TContext
      > => {

      const mutationOptions = getSearchPipelineTemplateOverviewsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchPipelineTemplateOverviews = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PipelineTemplateOverviewResponse[]>(
      {url: `/pipeline-templates`, method: 'GET', signal
    },
      );
    }
  

export const getFetchPipelineTemplateOverviewsQueryKey = () => {
    return [`/pipeline-templates`] as const;
    }

    
export const getFetchPipelineTemplateOverviewsQueryOptions = <TData = Awaited<ReturnType<typeof fetchPipelineTemplateOverviews>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchPipelineTemplateOverviews>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchPipelineTemplateOverviewsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchPipelineTemplateOverviews>>> = ({ signal }) => fetchPipelineTemplateOverviews(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchPipelineTemplateOverviews>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchPipelineTemplateOverviewsQueryResult = NonNullable<Awaited<ReturnType<typeof fetchPipelineTemplateOverviews>>>
export type FetchPipelineTemplateOverviewsQueryError = unknown



export function useFetchPipelineTemplateOverviews<TData = Awaited<ReturnType<typeof fetchPipelineTemplateOverviews>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchPipelineTemplateOverviews>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchPipelineTemplateOverviewsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createPipelineTemplate = (
    pipelineTemplateRequest: PipelineTemplateRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/pipeline-templates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pipelineTemplateRequest, signal
    },
      );
    }
  


export const getCreatePipelineTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPipelineTemplate>>, TError,{data: PipelineTemplateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPipelineTemplate>>, TError,{data: PipelineTemplateRequest}, TContext> => {
    
const mutationKey = ['createPipelineTemplate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPipelineTemplate>>, {data: PipelineTemplateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createPipelineTemplate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePipelineTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createPipelineTemplate>>>
    export type CreatePipelineTemplateMutationBody = PipelineTemplateRequest
    export type CreatePipelineTemplateMutationError = unknown

    export const useCreatePipelineTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPipelineTemplate>>, TError,{data: PipelineTemplateRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPipelineTemplate>>,
        TError,
        {data: PipelineTemplateRequest},
        TContext
      > => {

      const mutationOptions = getCreatePipelineTemplateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const updatePipelineTemplate = (
    pipelineTemplateRequest: PipelineTemplateRequest,
 ) => {
      
      
      return customInstance<number>(
      {url: `/pipeline-templates`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: pipelineTemplateRequest
    },
      );
    }
  


export const getUpdatePipelineTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePipelineTemplate>>, TError,{data: PipelineTemplateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePipelineTemplate>>, TError,{data: PipelineTemplateRequest}, TContext> => {
    
const mutationKey = ['updatePipelineTemplate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePipelineTemplate>>, {data: PipelineTemplateRequest}> = (props) => {
          const {data} = props ?? {};

          return  updatePipelineTemplate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePipelineTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updatePipelineTemplate>>>
    export type UpdatePipelineTemplateMutationBody = PipelineTemplateRequest
    export type UpdatePipelineTemplateMutationError = unknown

    export const useUpdatePipelineTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePipelineTemplate>>, TError,{data: PipelineTemplateRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePipelineTemplate>>,
        TError,
        {data: PipelineTemplateRequest},
        TContext
      > => {

      const mutationOptions = getUpdatePipelineTemplateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const diffCheckJobPipelines = (
    pipelineTemplateJobPipelineDiffRequest: PipelineTemplateJobPipelineDiffRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PipelineTemplateJobPipelineDiffResponse>(
      {url: `/pipeline-templates/job-pipelines-diff`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pipelineTemplateJobPipelineDiffRequest, signal
    },
      );
    }
  


export const getDiffCheckJobPipelinesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof diffCheckJobPipelines>>, TError,{data: PipelineTemplateJobPipelineDiffRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof diffCheckJobPipelines>>, TError,{data: PipelineTemplateJobPipelineDiffRequest}, TContext> => {
    
const mutationKey = ['diffCheckJobPipelines'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof diffCheckJobPipelines>>, {data: PipelineTemplateJobPipelineDiffRequest}> = (props) => {
          const {data} = props ?? {};

          return  diffCheckJobPipelines(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DiffCheckJobPipelinesMutationResult = NonNullable<Awaited<ReturnType<typeof diffCheckJobPipelines>>>
    export type DiffCheckJobPipelinesMutationBody = PipelineTemplateJobPipelineDiffRequest
    export type DiffCheckJobPipelinesMutationError = unknown

    export const useDiffCheckJobPipelines = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof diffCheckJobPipelines>>, TError,{data: PipelineTemplateJobPipelineDiffRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof diffCheckJobPipelines>>,
        TError,
        {data: PipelineTemplateJobPipelineDiffRequest},
        TContext
      > => {

      const mutationOptions = getDiffCheckJobPipelinesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const findPipelineTemplateStepsRequiringResolution = (
    pipelineTemplateJobPipelineDiffRequest: PipelineTemplateJobPipelineDiffRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CorePipelineStepResponse[]>(
      {url: `/pipeline-templates/steps-needing-resolution`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pipelineTemplateJobPipelineDiffRequest, signal
    },
      );
    }
  


export const getFindPipelineTemplateStepsRequiringResolutionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof findPipelineTemplateStepsRequiringResolution>>, TError,{data: PipelineTemplateJobPipelineDiffRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof findPipelineTemplateStepsRequiringResolution>>, TError,{data: PipelineTemplateJobPipelineDiffRequest}, TContext> => {
    
const mutationKey = ['findPipelineTemplateStepsRequiringResolution'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof findPipelineTemplateStepsRequiringResolution>>, {data: PipelineTemplateJobPipelineDiffRequest}> = (props) => {
          const {data} = props ?? {};

          return  findPipelineTemplateStepsRequiringResolution(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FindPipelineTemplateStepsRequiringResolutionMutationResult = NonNullable<Awaited<ReturnType<typeof findPipelineTemplateStepsRequiringResolution>>>
    export type FindPipelineTemplateStepsRequiringResolutionMutationBody = PipelineTemplateJobPipelineDiffRequest
    export type FindPipelineTemplateStepsRequiringResolutionMutationError = unknown

    export const useFindPipelineTemplateStepsRequiringResolution = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof findPipelineTemplateStepsRequiringResolution>>, TError,{data: PipelineTemplateJobPipelineDiffRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof findPipelineTemplateStepsRequiringResolution>>,
        TError,
        {data: PipelineTemplateJobPipelineDiffRequest},
        TContext
      > => {

      const mutationOptions = getFindPipelineTemplateStepsRequiringResolutionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const syncPipelineTemplateToJobPipelines = (
    pipelineTemplateSyncRequest: PipelineTemplateSyncRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/pipeline-templates/sync-job-pipelines`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pipelineTemplateSyncRequest, signal
    },
      );
    }
  


export const getSyncPipelineTemplateToJobPipelinesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncPipelineTemplateToJobPipelines>>, TError,{data: PipelineTemplateSyncRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof syncPipelineTemplateToJobPipelines>>, TError,{data: PipelineTemplateSyncRequest}, TContext> => {
    
const mutationKey = ['syncPipelineTemplateToJobPipelines'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncPipelineTemplateToJobPipelines>>, {data: PipelineTemplateSyncRequest}> = (props) => {
          const {data} = props ?? {};

          return  syncPipelineTemplateToJobPipelines(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SyncPipelineTemplateToJobPipelinesMutationResult = NonNullable<Awaited<ReturnType<typeof syncPipelineTemplateToJobPipelines>>>
    export type SyncPipelineTemplateToJobPipelinesMutationBody = PipelineTemplateSyncRequest
    export type SyncPipelineTemplateToJobPipelinesMutationError = unknown

    export const useSyncPipelineTemplateToJobPipelines = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncPipelineTemplateToJobPipelines>>, TError,{data: PipelineTemplateSyncRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncPipelineTemplateToJobPipelines>>,
        TError,
        {data: PipelineTemplateSyncRequest},
        TContext
      > => {

      const mutationOptions = getSyncPipelineTemplateToJobPipelinesMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const deletePipelineTemplate = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/pipeline-templates/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeletePipelineTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePipelineTemplate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePipelineTemplate>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['deletePipelineTemplate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePipelineTemplate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePipelineTemplate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePipelineTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deletePipelineTemplate>>>
    
    export type DeletePipelineTemplateMutationError = unknown

    export const useDeletePipelineTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePipelineTemplate>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePipelineTemplate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeletePipelineTemplateMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchPipelineTemplate = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PipelineTemplateResponse>(
      {url: `/pipeline-templates/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getFetchPipelineTemplateQueryKey = (id: number,) => {
    return [`/pipeline-templates/${id}`] as const;
    }

    
export const getFetchPipelineTemplateQueryOptions = <TData = Awaited<ReturnType<typeof fetchPipelineTemplate>>, TError = unknown>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchPipelineTemplate>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchPipelineTemplateQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchPipelineTemplate>>> = ({ signal }) => fetchPipelineTemplate(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchPipelineTemplate>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchPipelineTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof fetchPipelineTemplate>>>
export type FetchPipelineTemplateQueryError = unknown



export function useFetchPipelineTemplate<TData = Awaited<ReturnType<typeof fetchPipelineTemplate>>, TError = unknown>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchPipelineTemplate>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchPipelineTemplateQueryOptions(id,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createPosition = (
    positionRequest: PositionRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/position`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: positionRequest, signal
    },
      );
    }
  


export const getCreatePositionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPosition>>, TError,{data: PositionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPosition>>, TError,{data: PositionRequest}, TContext> => {
    
const mutationKey = ['createPosition'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPosition>>, {data: PositionRequest}> = (props) => {
          const {data} = props ?? {};

          return  createPosition(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePositionMutationResult = NonNullable<Awaited<ReturnType<typeof createPosition>>>
    export type CreatePositionMutationBody = PositionRequest
    export type CreatePositionMutationError = unknown

    export const useCreatePosition = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPosition>>, TError,{data: PositionRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPosition>>,
        TError,
        {data: PositionRequest},
        TContext
      > => {

      const mutationOptions = getCreatePositionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const deletePosition = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/position/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeletePositionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePosition>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePosition>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['deletePosition'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePosition>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePosition(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePositionMutationResult = NonNullable<Awaited<ReturnType<typeof deletePosition>>>
    
    export type DeletePositionMutationError = unknown

    export const useDeletePosition = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePosition>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePosition>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeletePositionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const fetchPositions = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PositionResponse[]>(
      {url: `/positions`, method: 'GET', signal
    },
      );
    }
  

export const getFetchPositionsQueryKey = () => {
    return [`/positions`] as const;
    }

    
export const getFetchPositionsQueryOptions = <TData = Awaited<ReturnType<typeof fetchPositions>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchPositions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchPositionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchPositions>>> = ({ signal }) => fetchPositions(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchPositions>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchPositionsQueryResult = NonNullable<Awaited<ReturnType<typeof fetchPositions>>>
export type FetchPositionsQueryError = unknown



export function useFetchPositions<TData = Awaited<ReturnType<typeof fetchPositions>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchPositions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchPositionsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const fetchStaticPracticeAreasList = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/practiceAreasStaticList`, method: 'GET', signal
    },
      );
    }
  

export const getFetchStaticPracticeAreasListQueryKey = () => {
    return [`/practiceAreasStaticList`] as const;
    }

    
export const getFetchStaticPracticeAreasListQueryOptions = <TData = Awaited<ReturnType<typeof fetchStaticPracticeAreasList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchStaticPracticeAreasList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchStaticPracticeAreasListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchStaticPracticeAreasList>>> = ({ signal }) => fetchStaticPracticeAreasList(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchStaticPracticeAreasList>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchStaticPracticeAreasListQueryResult = NonNullable<Awaited<ReturnType<typeof fetchStaticPracticeAreasList>>>
export type FetchStaticPracticeAreasListQueryError = unknown



export function useFetchStaticPracticeAreasList<TData = Awaited<ReturnType<typeof fetchStaticPracticeAreasList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchStaticPracticeAreasList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchStaticPracticeAreasListQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCareerPageJobs = (
    orgName: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CareersPageJobOverviewResponse[]>(
      {url: `/public-jobs/${orgName}/career-page-jobs`, method: 'GET', signal
    },
      );
    }
  

export const getGetCareerPageJobsQueryKey = (orgName: string,) => {
    return [`/public-jobs/${orgName}/career-page-jobs`] as const;
    }

    
export const getGetCareerPageJobsQueryOptions = <TData = Awaited<ReturnType<typeof getCareerPageJobs>>, TError = unknown>(orgName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCareerPageJobs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCareerPageJobsQueryKey(orgName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCareerPageJobs>>> = ({ signal }) => getCareerPageJobs(orgName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCareerPageJobs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCareerPageJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getCareerPageJobs>>>
export type GetCareerPageJobsQueryError = unknown



export function useGetCareerPageJobs<TData = Awaited<ReturnType<typeof getCareerPageJobs>>, TError = unknown>(
 orgName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCareerPageJobs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCareerPageJobsQueryOptions(orgName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCareerPageJobDetails = (
    orgName: string,
    jobExtension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CareersPageJobDetailsResponse>(
      {url: `/public-jobs/${orgName}/career-page-jobs/${jobExtension}/job-details`, method: 'GET', signal
    },
      );
    }
  

export const getGetCareerPageJobDetailsQueryKey = (orgName: string,
    jobExtension: string,) => {
    return [`/public-jobs/${orgName}/career-page-jobs/${jobExtension}/job-details`] as const;
    }

    
export const getGetCareerPageJobDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getCareerPageJobDetails>>, TError = unknown>(orgName: string,
    jobExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCareerPageJobDetails>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCareerPageJobDetailsQueryKey(orgName,jobExtension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCareerPageJobDetails>>> = ({ signal }) => getCareerPageJobDetails(orgName,jobExtension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgName && jobExtension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCareerPageJobDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCareerPageJobDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getCareerPageJobDetails>>>
export type GetCareerPageJobDetailsQueryError = unknown



export function useGetCareerPageJobDetails<TData = Awaited<ReturnType<typeof getCareerPageJobDetails>>, TError = unknown>(
 orgName: string,
    jobExtension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCareerPageJobDetails>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCareerPageJobDetailsQueryOptions(orgName,jobExtension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCandidatePublic = (
    org: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CandidateResponse>(
      {url: `/public/candidate/${org}`, method: 'GET', signal
    },
      );
    }
  

export const getGetCandidatePublicQueryKey = (org: string,) => {
    return [`/public/candidate/${org}`] as const;
    }

    
export const getGetCandidatePublicQueryOptions = <TData = Awaited<ReturnType<typeof getCandidatePublic>>, TError = unknown>(org: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCandidatePublic>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidatePublicQueryKey(org);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidatePublic>>> = ({ signal }) => getCandidatePublic(org, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCandidatePublic>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCandidatePublicQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidatePublic>>>
export type GetCandidatePublicQueryError = unknown



export function useGetCandidatePublic<TData = Awaited<ReturnType<typeof getCandidatePublic>>, TError = unknown>(
 org: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCandidatePublic>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCandidatePublicQueryOptions(org,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getJobApplicantForAgencyContact = (
    org: string,
    jobId: number,
    recruitId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CandidateResponse>(
      {url: `/public/candidate/${org}/applicant/${jobId}/${recruitId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetJobApplicantForAgencyContactQueryKey = (org: string,
    jobId: number,
    recruitId: number,) => {
    return [`/public/candidate/${org}/applicant/${jobId}/${recruitId}`] as const;
    }

    
export const getGetJobApplicantForAgencyContactQueryOptions = <TData = Awaited<ReturnType<typeof getJobApplicantForAgencyContact>>, TError = unknown>(org: string,
    jobId: number,
    recruitId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobApplicantForAgencyContact>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobApplicantForAgencyContactQueryKey(org,jobId,recruitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobApplicantForAgencyContact>>> = ({ signal }) => getJobApplicantForAgencyContact(org,jobId,recruitId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && jobId && recruitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobApplicantForAgencyContact>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJobApplicantForAgencyContactQueryResult = NonNullable<Awaited<ReturnType<typeof getJobApplicantForAgencyContact>>>
export type GetJobApplicantForAgencyContactQueryError = unknown



export function useGetJobApplicantForAgencyContact<TData = Awaited<ReturnType<typeof getJobApplicantForAgencyContact>>, TError = unknown>(
 org: string,
    jobId: number,
    recruitId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJobApplicantForAgencyContact>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetJobApplicantForAgencyContactQueryOptions(org,jobId,recruitId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getEventPublicById = (
    org: string,
    eventId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PublicEventResponse>(
      {url: `/public/events/${org}/${eventId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEventPublicByIdQueryKey = (org: string,
    eventId: number,) => {
    return [`/public/events/${org}/${eventId}`] as const;
    }

    
export const getGetEventPublicByIdQueryOptions = <TData = Awaited<ReturnType<typeof getEventPublicById>>, TError = unknown>(org: string,
    eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventPublicById>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventPublicByIdQueryKey(org,eventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventPublicById>>> = ({ signal }) => getEventPublicById(org,eventId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventPublicById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventPublicByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEventPublicById>>>
export type GetEventPublicByIdQueryError = unknown



export function useGetEventPublicById<TData = Awaited<ReturnType<typeof getEventPublicById>>, TError = unknown>(
 org: string,
    eventId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventPublicById>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventPublicByIdQueryOptions(org,eventId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const firmProfileViewLimit = (
    orgFriendlyName: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<FirmProfileViewLimitResponse>(
      {url: `/public/guest/firm-profile-view-limit/${orgFriendlyName}`, method: 'GET', signal
    },
      );
    }
  

export const getFirmProfileViewLimitQueryKey = (orgFriendlyName: string,) => {
    return [`/public/guest/firm-profile-view-limit/${orgFriendlyName}`] as const;
    }

    
export const getFirmProfileViewLimitQueryOptions = <TData = Awaited<ReturnType<typeof firmProfileViewLimit>>, TError = unknown>(orgFriendlyName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof firmProfileViewLimit>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFirmProfileViewLimitQueryKey(orgFriendlyName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof firmProfileViewLimit>>> = ({ signal }) => firmProfileViewLimit(orgFriendlyName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgFriendlyName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof firmProfileViewLimit>>, TError, TData> & { queryKey: QueryKey }
}

export type FirmProfileViewLimitQueryResult = NonNullable<Awaited<ReturnType<typeof firmProfileViewLimit>>>
export type FirmProfileViewLimitQueryError = unknown



export function useFirmProfileViewLimit<TData = Awaited<ReturnType<typeof firmProfileViewLimit>>, TError = unknown>(
 orgFriendlyName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof firmProfileViewLimit>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFirmProfileViewLimitQueryOptions(orgFriendlyName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const fetchQualifyingQuestionsWithCandidateAnswers = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<QualifyingQuestionWithCandidateAnswersDto[]>(
      {url: `/qualifying-questions/data`, method: 'GET', signal
    },
      );
    }
  

export const getFetchQualifyingQuestionsWithCandidateAnswersQueryKey = () => {
    return [`/qualifying-questions/data`] as const;
    }

    
export const getFetchQualifyingQuestionsWithCandidateAnswersQueryOptions = <TData = Awaited<ReturnType<typeof fetchQualifyingQuestionsWithCandidateAnswers>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchQualifyingQuestionsWithCandidateAnswers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchQualifyingQuestionsWithCandidateAnswersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchQualifyingQuestionsWithCandidateAnswers>>> = ({ signal }) => fetchQualifyingQuestionsWithCandidateAnswers(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchQualifyingQuestionsWithCandidateAnswers>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchQualifyingQuestionsWithCandidateAnswersQueryResult = NonNullable<Awaited<ReturnType<typeof fetchQualifyingQuestionsWithCandidateAnswers>>>
export type FetchQualifyingQuestionsWithCandidateAnswersQueryError = unknown



export function useFetchQualifyingQuestionsWithCandidateAnswers<TData = Awaited<ReturnType<typeof fetchQualifyingQuestionsWithCandidateAnswers>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchQualifyingQuestionsWithCandidateAnswers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchQualifyingQuestionsWithCandidateAnswersQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const upsertSelfIdQuestion = (
    orgSelfIdQuestionRequest: OrgSelfIdQuestionRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/self-id`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: orgSelfIdQuestionRequest, signal
    },
      );
    }
  


export const getUpsertSelfIdQuestionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertSelfIdQuestion>>, TError,{data: OrgSelfIdQuestionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof upsertSelfIdQuestion>>, TError,{data: OrgSelfIdQuestionRequest}, TContext> => {
    
const mutationKey = ['upsertSelfIdQuestion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertSelfIdQuestion>>, {data: OrgSelfIdQuestionRequest}> = (props) => {
          const {data} = props ?? {};

          return  upsertSelfIdQuestion(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertSelfIdQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof upsertSelfIdQuestion>>>
    export type UpsertSelfIdQuestionMutationBody = OrgSelfIdQuestionRequest
    export type UpsertSelfIdQuestionMutationError = unknown

    export const useUpsertSelfIdQuestion = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertSelfIdQuestion>>, TError,{data: OrgSelfIdQuestionRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertSelfIdQuestion>>,
        TError,
        {data: OrgSelfIdQuestionRequest},
        TContext
      > => {

      const mutationOptions = getUpsertSelfIdQuestionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const exportCandidatesSelfIdCSV = (
    exportCandidatesSelfIdCSVBody: string[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/self-id/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportCandidatesSelfIdCSVBody, signal
    },
      );
    }
  


export const getExportCandidatesSelfIdCSVMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportCandidatesSelfIdCSV>>, TError,{data: string[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportCandidatesSelfIdCSV>>, TError,{data: string[]}, TContext> => {
    
const mutationKey = ['exportCandidatesSelfIdCSV'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportCandidatesSelfIdCSV>>, {data: string[]}> = (props) => {
          const {data} = props ?? {};

          return  exportCandidatesSelfIdCSV(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportCandidatesSelfIdCSVMutationResult = NonNullable<Awaited<ReturnType<typeof exportCandidatesSelfIdCSV>>>
    export type ExportCandidatesSelfIdCSVMutationBody = string[]
    export type ExportCandidatesSelfIdCSVMutationError = unknown

    export const useExportCandidatesSelfIdCSV = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportCandidatesSelfIdCSV>>, TError,{data: string[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportCandidatesSelfIdCSV>>,
        TError,
        {data: string[]},
        TContext
      > => {

      const mutationOptions = getExportCandidatesSelfIdCSVMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const exportGovernmentSelfIdCSV = (
    exportGovernmentSelfIdCSVBody: string[],
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/self-id/government-export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportGovernmentSelfIdCSVBody, signal
    },
      );
    }
  


export const getExportGovernmentSelfIdCSVMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportGovernmentSelfIdCSV>>, TError,{data: string[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportGovernmentSelfIdCSV>>, TError,{data: string[]}, TContext> => {
    
const mutationKey = ['exportGovernmentSelfIdCSV'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportGovernmentSelfIdCSV>>, {data: string[]}> = (props) => {
          const {data} = props ?? {};

          return  exportGovernmentSelfIdCSV(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportGovernmentSelfIdCSVMutationResult = NonNullable<Awaited<ReturnType<typeof exportGovernmentSelfIdCSV>>>
    export type ExportGovernmentSelfIdCSVMutationBody = string[]
    export type ExportGovernmentSelfIdCSVMutationError = unknown

    export const useExportGovernmentSelfIdCSV = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportGovernmentSelfIdCSV>>, TError,{data: string[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportGovernmentSelfIdCSV>>,
        TError,
        {data: string[]},
        TContext
      > => {

      const mutationOptions = getExportGovernmentSelfIdCSVMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const removeSelfIdQuestion = (
    questionId: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/self-id/${questionId}`, method: 'DELETE'
    },
      );
    }
  


export const getRemoveSelfIdQuestionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeSelfIdQuestion>>, TError,{questionId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeSelfIdQuestion>>, TError,{questionId: number}, TContext> => {
    
const mutationKey = ['removeSelfIdQuestion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeSelfIdQuestion>>, {questionId: number}> = (props) => {
          const {questionId} = props ?? {};

          return  removeSelfIdQuestion(questionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveSelfIdQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof removeSelfIdQuestion>>>
    
    export type RemoveSelfIdQuestionMutationError = unknown

    export const useRemoveSelfIdQuestion = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeSelfIdQuestion>>, TError,{questionId: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeSelfIdQuestion>>,
        TError,
        {questionId: number},
        TContext
      > => {

      const mutationOptions = getRemoveSelfIdQuestionMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getCandidateSelfIdAnswers = (
    recruitId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CandidateProfileOrgSelfIdQuestionAnswerResponse[]>(
      {url: `/self-id/${recruitId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetCandidateSelfIdAnswersQueryKey = (recruitId: number,) => {
    return [`/self-id/${recruitId}`] as const;
    }

    
export const getGetCandidateSelfIdAnswersQueryOptions = <TData = Awaited<ReturnType<typeof getCandidateSelfIdAnswers>>, TError = unknown>(recruitId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCandidateSelfIdAnswers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCandidateSelfIdAnswersQueryKey(recruitId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCandidateSelfIdAnswers>>> = ({ signal }) => getCandidateSelfIdAnswers(recruitId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(recruitId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCandidateSelfIdAnswers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCandidateSelfIdAnswersQueryResult = NonNullable<Awaited<ReturnType<typeof getCandidateSelfIdAnswers>>>
export type GetCandidateSelfIdAnswersQueryError = unknown



export function useGetCandidateSelfIdAnswers<TData = Awaited<ReturnType<typeof getCandidateSelfIdAnswers>>, TError = unknown>(
 recruitId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCandidateSelfIdAnswers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCandidateSelfIdAnswersQueryOptions(recruitId,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUniversityRecruitmentPolicy = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UniversityRecruitmentPolicyResponse>(
      {url: `/settings/recruitmentPolicy`, method: 'GET', signal
    },
      );
    }
  

export const getGetUniversityRecruitmentPolicyQueryKey = () => {
    return [`/settings/recruitmentPolicy`] as const;
    }

    
export const getGetUniversityRecruitmentPolicyQueryOptions = <TData = Awaited<ReturnType<typeof getUniversityRecruitmentPolicy>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityRecruitmentPolicy>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUniversityRecruitmentPolicyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUniversityRecruitmentPolicy>>> = ({ signal }) => getUniversityRecruitmentPolicy(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUniversityRecruitmentPolicy>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUniversityRecruitmentPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof getUniversityRecruitmentPolicy>>>
export type GetUniversityRecruitmentPolicyQueryError = unknown



export function useGetUniversityRecruitmentPolicy<TData = Awaited<ReturnType<typeof getUniversityRecruitmentPolicy>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUniversityRecruitmentPolicy>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUniversityRecruitmentPolicyQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const submitUniversityRecruitmentPolicy = (
    universityRecruitmentPolicyRequest: UniversityRecruitmentPolicyRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/settings/recruitmentPolicy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: universityRecruitmentPolicyRequest, signal
    },
      );
    }
  


export const getSubmitUniversityRecruitmentPolicyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitUniversityRecruitmentPolicy>>, TError,{data: UniversityRecruitmentPolicyRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitUniversityRecruitmentPolicy>>, TError,{data: UniversityRecruitmentPolicyRequest}, TContext> => {
    
const mutationKey = ['submitUniversityRecruitmentPolicy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitUniversityRecruitmentPolicy>>, {data: UniversityRecruitmentPolicyRequest}> = (props) => {
          const {data} = props ?? {};

          return  submitUniversityRecruitmentPolicy(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitUniversityRecruitmentPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof submitUniversityRecruitmentPolicy>>>
    export type SubmitUniversityRecruitmentPolicyMutationBody = UniversityRecruitmentPolicyRequest
    export type SubmitUniversityRecruitmentPolicyMutationError = unknown

    export const useSubmitUniversityRecruitmentPolicy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitUniversityRecruitmentPolicy>>, TError,{data: UniversityRecruitmentPolicyRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitUniversityRecruitmentPolicy>>,
        TError,
        {data: UniversityRecruitmentPolicyRequest},
        TContext
      > => {

      const mutationOptions = getSubmitUniversityRecruitmentPolicyMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const superAdminUploadFirmProfileBannerImage = (
    uploadFirmProfileBannerImageRequest: UploadFirmProfileBannerImageRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(uploadFirmProfileBannerImageRequest.imageFile !== undefined) {
 formData.append('imageFile', uploadFirmProfileBannerImageRequest.imageFile)
 }
if(uploadFirmProfileBannerImageRequest.orgId !== undefined) {
 formData.append('orgId', uploadFirmProfileBannerImageRequest.orgId.toString())
 }

      return customInstance<string>(
      {url: `/super-admin/firm-profile/image-upload/banner-image`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getSuperAdminUploadFirmProfileBannerImageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof superAdminUploadFirmProfileBannerImage>>, TError,{data: UploadFirmProfileBannerImageRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof superAdminUploadFirmProfileBannerImage>>, TError,{data: UploadFirmProfileBannerImageRequest}, TContext> => {
    
const mutationKey = ['superAdminUploadFirmProfileBannerImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof superAdminUploadFirmProfileBannerImage>>, {data: UploadFirmProfileBannerImageRequest}> = (props) => {
          const {data} = props ?? {};

          return  superAdminUploadFirmProfileBannerImage(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SuperAdminUploadFirmProfileBannerImageMutationResult = NonNullable<Awaited<ReturnType<typeof superAdminUploadFirmProfileBannerImage>>>
    export type SuperAdminUploadFirmProfileBannerImageMutationBody = UploadFirmProfileBannerImageRequest
    export type SuperAdminUploadFirmProfileBannerImageMutationError = unknown

    export const useSuperAdminUploadFirmProfileBannerImage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof superAdminUploadFirmProfileBannerImage>>, TError,{data: UploadFirmProfileBannerImageRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof superAdminUploadFirmProfileBannerImage>>,
        TError,
        {data: UploadFirmProfileBannerImageRequest},
        TContext
      > => {

      const mutationOptions = getSuperAdminUploadFirmProfileBannerImageMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const superAdminUploadFirmProfileCustomSectionCoverImage = (
    uploadFirmProfileBannerImageRequest: UploadFirmProfileBannerImageRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(uploadFirmProfileBannerImageRequest.imageFile !== undefined) {
 formData.append('imageFile', uploadFirmProfileBannerImageRequest.imageFile)
 }
if(uploadFirmProfileBannerImageRequest.orgId !== undefined) {
 formData.append('orgId', uploadFirmProfileBannerImageRequest.orgId.toString())
 }

      return customInstance<string>(
      {url: `/super-admin/firm-profile/image-upload/custom-section-cover-image`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getSuperAdminUploadFirmProfileCustomSectionCoverImageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof superAdminUploadFirmProfileCustomSectionCoverImage>>, TError,{data: UploadFirmProfileBannerImageRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof superAdminUploadFirmProfileCustomSectionCoverImage>>, TError,{data: UploadFirmProfileBannerImageRequest}, TContext> => {
    
const mutationKey = ['superAdminUploadFirmProfileCustomSectionCoverImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof superAdminUploadFirmProfileCustomSectionCoverImage>>, {data: UploadFirmProfileBannerImageRequest}> = (props) => {
          const {data} = props ?? {};

          return  superAdminUploadFirmProfileCustomSectionCoverImage(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SuperAdminUploadFirmProfileCustomSectionCoverImageMutationResult = NonNullable<Awaited<ReturnType<typeof superAdminUploadFirmProfileCustomSectionCoverImage>>>
    export type SuperAdminUploadFirmProfileCustomSectionCoverImageMutationBody = UploadFirmProfileBannerImageRequest
    export type SuperAdminUploadFirmProfileCustomSectionCoverImageMutationError = unknown

    export const useSuperAdminUploadFirmProfileCustomSectionCoverImage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof superAdminUploadFirmProfileCustomSectionCoverImage>>, TError,{data: UploadFirmProfileBannerImageRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof superAdminUploadFirmProfileCustomSectionCoverImage>>,
        TError,
        {data: UploadFirmProfileBannerImageRequest},
        TContext
      > => {

      const mutationOptions = getSuperAdminUploadFirmProfileCustomSectionCoverImageMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const superAdminUploadFirmProfileRichMediaThumbnail = (
    uploadFirmProfileBannerImageRequest: UploadFirmProfileBannerImageRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(uploadFirmProfileBannerImageRequest.imageFile !== undefined) {
 formData.append('imageFile', uploadFirmProfileBannerImageRequest.imageFile)
 }
if(uploadFirmProfileBannerImageRequest.orgId !== undefined) {
 formData.append('orgId', uploadFirmProfileBannerImageRequest.orgId.toString())
 }

      return customInstance<string>(
      {url: `/super-admin/firm-profile/image-upload/rich-media-thumbnail`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getSuperAdminUploadFirmProfileRichMediaThumbnailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof superAdminUploadFirmProfileRichMediaThumbnail>>, TError,{data: UploadFirmProfileBannerImageRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof superAdminUploadFirmProfileRichMediaThumbnail>>, TError,{data: UploadFirmProfileBannerImageRequest}, TContext> => {
    
const mutationKey = ['superAdminUploadFirmProfileRichMediaThumbnail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof superAdminUploadFirmProfileRichMediaThumbnail>>, {data: UploadFirmProfileBannerImageRequest}> = (props) => {
          const {data} = props ?? {};

          return  superAdminUploadFirmProfileRichMediaThumbnail(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SuperAdminUploadFirmProfileRichMediaThumbnailMutationResult = NonNullable<Awaited<ReturnType<typeof superAdminUploadFirmProfileRichMediaThumbnail>>>
    export type SuperAdminUploadFirmProfileRichMediaThumbnailMutationBody = UploadFirmProfileBannerImageRequest
    export type SuperAdminUploadFirmProfileRichMediaThumbnailMutationError = unknown

    export const useSuperAdminUploadFirmProfileRichMediaThumbnail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof superAdminUploadFirmProfileRichMediaThumbnail>>, TError,{data: UploadFirmProfileBannerImageRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof superAdminUploadFirmProfileRichMediaThumbnail>>,
        TError,
        {data: UploadFirmProfileBannerImageRequest},
        TContext
      > => {

      const mutationOptions = getSuperAdminUploadFirmProfileRichMediaThumbnailMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getUserAnalyticsInfo = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserAnalyticsInfoResponse>(
      {url: `/user-analytics-info`, method: 'GET', signal
    },
      );
    }
  

export const getGetUserAnalyticsInfoQueryKey = () => {
    return [`/user-analytics-info`] as const;
    }

    
export const getGetUserAnalyticsInfoQueryOptions = <TData = Awaited<ReturnType<typeof getUserAnalyticsInfo>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserAnalyticsInfo>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAnalyticsInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAnalyticsInfo>>> = ({ signal }) => getUserAnalyticsInfo(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserAnalyticsInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserAnalyticsInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAnalyticsInfo>>>
export type GetUserAnalyticsInfoQueryError = unknown



export function useGetUserAnalyticsInfo<TData = Awaited<ReturnType<typeof getUserAnalyticsInfo>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserAnalyticsInfo>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserAnalyticsInfoQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const fetchUserOverviews = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserOverviewResponse[]>(
      {url: `/user-overviews`, method: 'GET', signal
    },
      );
    }
  

export const getFetchUserOverviewsQueryKey = () => {
    return [`/user-overviews`] as const;
    }

    
export const getFetchUserOverviewsQueryOptions = <TData = Awaited<ReturnType<typeof fetchUserOverviews>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchUserOverviews>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFetchUserOverviewsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchUserOverviews>>> = ({ signal }) => fetchUserOverviews(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fetchUserOverviews>>, TError, TData> & { queryKey: QueryKey }
}

export type FetchUserOverviewsQueryResult = NonNullable<Awaited<ReturnType<typeof fetchUserOverviews>>>
export type FetchUserOverviewsQueryError = unknown



export function useFetchUserOverviews<TData = Awaited<ReturnType<typeof fetchUserOverviews>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof fetchUserOverviews>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFetchUserOverviewsQueryOptions(options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const setWebinarStateAsEmployerSpeaker = (
    org: string,
    eid: number,
    webinarId: number,
    userExtension: string,
    setWebinarStatusRequest: SetWebinarStatusRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/webinar/${org}/${eid}/${webinarId}/changeStateEmployerSpeaker/${userExtension}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setWebinarStatusRequest, signal
    },
      );
    }
  


export const getSetWebinarStateAsEmployerSpeakerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWebinarStateAsEmployerSpeaker>>, TError,{org: string;eid: number;webinarId: number;userExtension: string;data: SetWebinarStatusRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setWebinarStateAsEmployerSpeaker>>, TError,{org: string;eid: number;webinarId: number;userExtension: string;data: SetWebinarStatusRequest}, TContext> => {
    
const mutationKey = ['setWebinarStateAsEmployerSpeaker'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setWebinarStateAsEmployerSpeaker>>, {org: string;eid: number;webinarId: number;userExtension: string;data: SetWebinarStatusRequest}> = (props) => {
          const {org,eid,webinarId,userExtension,data} = props ?? {};

          return  setWebinarStateAsEmployerSpeaker(org,eid,webinarId,userExtension,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetWebinarStateAsEmployerSpeakerMutationResult = NonNullable<Awaited<ReturnType<typeof setWebinarStateAsEmployerSpeaker>>>
    export type SetWebinarStateAsEmployerSpeakerMutationBody = SetWebinarStatusRequest
    export type SetWebinarStateAsEmployerSpeakerMutationError = unknown

    export const useSetWebinarStateAsEmployerSpeaker = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWebinarStateAsEmployerSpeaker>>, TError,{org: string;eid: number;webinarId: number;userExtension: string;data: SetWebinarStatusRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setWebinarStateAsEmployerSpeaker>>,
        TError,
        {org: string;eid: number;webinarId: number;userExtension: string;data: SetWebinarStatusRequest},
        TContext
      > => {

      const mutationOptions = getSetWebinarStateAsEmployerSpeakerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const setWebinarStateAsStudentSpeaker = (
    org: string,
    eid: number,
    webinarId: number,
    extension: string,
    setWebinarStatusRequest: SetWebinarStatusRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/webinar/${org}/${eid}/${webinarId}/changeStateStudentSpeaker/${extension}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setWebinarStatusRequest, signal
    },
      );
    }
  


export const getSetWebinarStateAsStudentSpeakerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWebinarStateAsStudentSpeaker>>, TError,{org: string;eid: number;webinarId: number;extension: string;data: SetWebinarStatusRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setWebinarStateAsStudentSpeaker>>, TError,{org: string;eid: number;webinarId: number;extension: string;data: SetWebinarStatusRequest}, TContext> => {
    
const mutationKey = ['setWebinarStateAsStudentSpeaker'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setWebinarStateAsStudentSpeaker>>, {org: string;eid: number;webinarId: number;extension: string;data: SetWebinarStatusRequest}> = (props) => {
          const {org,eid,webinarId,extension,data} = props ?? {};

          return  setWebinarStateAsStudentSpeaker(org,eid,webinarId,extension,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetWebinarStateAsStudentSpeakerMutationResult = NonNullable<Awaited<ReturnType<typeof setWebinarStateAsStudentSpeaker>>>
    export type SetWebinarStateAsStudentSpeakerMutationBody = SetWebinarStatusRequest
    export type SetWebinarStateAsStudentSpeakerMutationError = unknown

    export const useSetWebinarStateAsStudentSpeaker = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWebinarStateAsStudentSpeaker>>, TError,{org: string;eid: number;webinarId: number;extension: string;data: SetWebinarStatusRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof setWebinarStateAsStudentSpeaker>>,
        TError,
        {org: string;eid: number;webinarId: number;extension: string;data: SetWebinarStatusRequest},
        TContext
      > => {

      const mutationOptions = getSetWebinarStateAsStudentSpeakerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getWebinarDailyMeetingTokenAsEmployer = (
    org: string,
    eid: number,
    webinarId: number,
    extension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DailyMeetingTokenResponse>(
      {url: `/webinar/${org}/${eid}/${webinarId}/createMeetingTokenEmployer/${extension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetWebinarDailyMeetingTokenAsEmployerQueryKey = (org: string,
    eid: number,
    webinarId: number,
    extension: string,) => {
    return [`/webinar/${org}/${eid}/${webinarId}/createMeetingTokenEmployer/${extension}`] as const;
    }

    
export const getGetWebinarDailyMeetingTokenAsEmployerQueryOptions = <TData = Awaited<ReturnType<typeof getWebinarDailyMeetingTokenAsEmployer>>, TError = unknown>(org: string,
    eid: number,
    webinarId: number,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebinarDailyMeetingTokenAsEmployer>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebinarDailyMeetingTokenAsEmployerQueryKey(org,eid,webinarId,extension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebinarDailyMeetingTokenAsEmployer>>> = ({ signal }) => getWebinarDailyMeetingTokenAsEmployer(org,eid,webinarId,extension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && webinarId && extension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebinarDailyMeetingTokenAsEmployer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWebinarDailyMeetingTokenAsEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof getWebinarDailyMeetingTokenAsEmployer>>>
export type GetWebinarDailyMeetingTokenAsEmployerQueryError = unknown



export function useGetWebinarDailyMeetingTokenAsEmployer<TData = Awaited<ReturnType<typeof getWebinarDailyMeetingTokenAsEmployer>>, TError = unknown>(
 org: string,
    eid: number,
    webinarId: number,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebinarDailyMeetingTokenAsEmployer>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWebinarDailyMeetingTokenAsEmployerQueryOptions(org,eid,webinarId,extension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getWebinarDailyMeetingTokenAsStudent = (
    org: string,
    eid: number,
    webinarId: number,
    extension: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DailyMeetingTokenResponse>(
      {url: `/webinar/${org}/${eid}/${webinarId}/createMeetingTokenStudent/${extension}`, method: 'GET', signal
    },
      );
    }
  

export const getGetWebinarDailyMeetingTokenAsStudentQueryKey = (org: string,
    eid: number,
    webinarId: number,
    extension: string,) => {
    return [`/webinar/${org}/${eid}/${webinarId}/createMeetingTokenStudent/${extension}`] as const;
    }

    
export const getGetWebinarDailyMeetingTokenAsStudentQueryOptions = <TData = Awaited<ReturnType<typeof getWebinarDailyMeetingTokenAsStudent>>, TError = unknown>(org: string,
    eid: number,
    webinarId: number,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebinarDailyMeetingTokenAsStudent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebinarDailyMeetingTokenAsStudentQueryKey(org,eid,webinarId,extension);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebinarDailyMeetingTokenAsStudent>>> = ({ signal }) => getWebinarDailyMeetingTokenAsStudent(org,eid,webinarId,extension, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && webinarId && extension), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebinarDailyMeetingTokenAsStudent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWebinarDailyMeetingTokenAsStudentQueryResult = NonNullable<Awaited<ReturnType<typeof getWebinarDailyMeetingTokenAsStudent>>>
export type GetWebinarDailyMeetingTokenAsStudentQueryError = unknown



export function useGetWebinarDailyMeetingTokenAsStudent<TData = Awaited<ReturnType<typeof getWebinarDailyMeetingTokenAsStudent>>, TError = unknown>(
 org: string,
    eid: number,
    webinarId: number,
    extension: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebinarDailyMeetingTokenAsStudent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWebinarDailyMeetingTokenAsStudentQueryOptions(org,eid,webinarId,extension,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getWebinarParticipantsOnPage = (
    org: string,
    eid: number,
    webinarId: number,
    dailyName: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CurrentWebinarParticipantsResponse>(
      {url: `/webinar/${org}/${eid}/${webinarId}/participantsOnPage/${dailyName}`, method: 'GET', signal
    },
      );
    }
  

export const getGetWebinarParticipantsOnPageQueryKey = (org: string,
    eid: number,
    webinarId: number,
    dailyName: string,) => {
    return [`/webinar/${org}/${eid}/${webinarId}/participantsOnPage/${dailyName}`] as const;
    }

    
export const getGetWebinarParticipantsOnPageQueryOptions = <TData = Awaited<ReturnType<typeof getWebinarParticipantsOnPage>>, TError = unknown>(org: string,
    eid: number,
    webinarId: number,
    dailyName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebinarParticipantsOnPage>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebinarParticipantsOnPageQueryKey(org,eid,webinarId,dailyName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebinarParticipantsOnPage>>> = ({ signal }) => getWebinarParticipantsOnPage(org,eid,webinarId,dailyName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && webinarId && dailyName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebinarParticipantsOnPage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWebinarParticipantsOnPageQueryResult = NonNullable<Awaited<ReturnType<typeof getWebinarParticipantsOnPage>>>
export type GetWebinarParticipantsOnPageQueryError = unknown



export function useGetWebinarParticipantsOnPage<TData = Awaited<ReturnType<typeof getWebinarParticipantsOnPage>>, TError = unknown>(
 org: string,
    eid: number,
    webinarId: number,
    dailyName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWebinarParticipantsOnPage>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWebinarParticipantsOnPageQueryOptions(org,eid,webinarId,dailyName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const pingWebinarPageEmployer = (
    org: string,
    eid: number,
    webinarId: number,
    extension: string,
    dailyName: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/webinar/${org}/${eid}/${webinarId}/pingWebinarPageEmployer/${extension}/${dailyName}`, method: 'POST', signal
    },
      );
    }
  


export const getPingWebinarPageEmployerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pingWebinarPageEmployer>>, TError,{org: string;eid: number;webinarId: number;extension: string;dailyName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof pingWebinarPageEmployer>>, TError,{org: string;eid: number;webinarId: number;extension: string;dailyName: string}, TContext> => {
    
const mutationKey = ['pingWebinarPageEmployer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pingWebinarPageEmployer>>, {org: string;eid: number;webinarId: number;extension: string;dailyName: string}> = (props) => {
          const {org,eid,webinarId,extension,dailyName} = props ?? {};

          return  pingWebinarPageEmployer(org,eid,webinarId,extension,dailyName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PingWebinarPageEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof pingWebinarPageEmployer>>>
    
    export type PingWebinarPageEmployerMutationError = unknown

    export const usePingWebinarPageEmployer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pingWebinarPageEmployer>>, TError,{org: string;eid: number;webinarId: number;extension: string;dailyName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof pingWebinarPageEmployer>>,
        TError,
        {org: string;eid: number;webinarId: number;extension: string;dailyName: string},
        TContext
      > => {

      const mutationOptions = getPingWebinarPageEmployerMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const pingWebinarPageStudent = (
    org: string,
    eid: number,
    webinarId: number,
    extension: string,
    dailyName: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenericResponse>(
      {url: `/webinar/${org}/${eid}/${webinarId}/pingWebinarPageStudent/${extension}/${dailyName}`, method: 'POST', signal
    },
      );
    }
  


export const getPingWebinarPageStudentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pingWebinarPageStudent>>, TError,{org: string;eid: number;webinarId: number;extension: string;dailyName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof pingWebinarPageStudent>>, TError,{org: string;eid: number;webinarId: number;extension: string;dailyName: string}, TContext> => {
    
const mutationKey = ['pingWebinarPageStudent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pingWebinarPageStudent>>, {org: string;eid: number;webinarId: number;extension: string;dailyName: string}> = (props) => {
          const {org,eid,webinarId,extension,dailyName} = props ?? {};

          return  pingWebinarPageStudent(org,eid,webinarId,extension,dailyName,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PingWebinarPageStudentMutationResult = NonNullable<Awaited<ReturnType<typeof pingWebinarPageStudent>>>
    
    export type PingWebinarPageStudentMutationError = unknown

    export const usePingWebinarPageStudent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pingWebinarPageStudent>>, TError,{org: string;eid: number;webinarId: number;extension: string;dailyName: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof pingWebinarPageStudent>>,
        TError,
        {org: string;eid: number;webinarId: number;extension: string;dailyName: string},
        TContext
      > => {

      const mutationOptions = getPingWebinarPageStudentMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const getCurrentWebinarState = (
    org: string,
    eid: number,
    webinarId: number,
    dailyName: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CurrentWebinarStateResponse>(
      {url: `/webinar/${org}/${eid}/${webinarId}/state/${dailyName}`, method: 'GET', signal
    },
      );
    }
  

export const getGetCurrentWebinarStateQueryKey = (org: string,
    eid: number,
    webinarId: number,
    dailyName: string,) => {
    return [`/webinar/${org}/${eid}/${webinarId}/state/${dailyName}`] as const;
    }

    
export const getGetCurrentWebinarStateQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentWebinarState>>, TError = unknown>(org: string,
    eid: number,
    webinarId: number,
    dailyName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentWebinarState>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentWebinarStateQueryKey(org,eid,webinarId,dailyName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentWebinarState>>> = ({ signal }) => getCurrentWebinarState(org,eid,webinarId,dailyName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(org && eid && webinarId && dailyName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentWebinarState>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentWebinarStateQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentWebinarState>>>
export type GetCurrentWebinarStateQueryError = unknown



export function useGetCurrentWebinarState<TData = Awaited<ReturnType<typeof getCurrentWebinarState>>, TError = unknown>(
 org: string,
    eid: number,
    webinarId: number,
    dailyName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentWebinarState>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCurrentWebinarStateQueryOptions(org,eid,webinarId,dailyName,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const exportWorkAllocationEvaluations = (
    workAllocationEvaluationExportRequest: WorkAllocationEvaluationExportRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/workAllocation/exports/work-allocation-evaluations-export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workAllocationEvaluationExportRequest, signal
    },
      );
    }
  


export const getExportWorkAllocationEvaluationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportWorkAllocationEvaluations>>, TError,{data: WorkAllocationEvaluationExportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exportWorkAllocationEvaluations>>, TError,{data: WorkAllocationEvaluationExportRequest}, TContext> => {
    
const mutationKey = ['exportWorkAllocationEvaluations'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportWorkAllocationEvaluations>>, {data: WorkAllocationEvaluationExportRequest}> = (props) => {
          const {data} = props ?? {};

          return  exportWorkAllocationEvaluations(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportWorkAllocationEvaluationsMutationResult = NonNullable<Awaited<ReturnType<typeof exportWorkAllocationEvaluations>>>
    export type ExportWorkAllocationEvaluationsMutationBody = WorkAllocationEvaluationExportRequest
    export type ExportWorkAllocationEvaluationsMutationError = unknown

    export const useExportWorkAllocationEvaluations = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportWorkAllocationEvaluations>>, TError,{data: WorkAllocationEvaluationExportRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exportWorkAllocationEvaluations>>,
        TError,
        {data: WorkAllocationEvaluationExportRequest},
        TContext
      > => {

      const mutationOptions = getExportWorkAllocationEvaluationsMutationOptions(options);

      return useMutation(mutationOptions );
    }
    
export const uploadMatterDocument = (
    matterId: number,
    uploadMatterDocumentRequest: UploadMatterDocumentRequest,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(uploadMatterDocumentRequest.documentFileName !== undefined) {
 formData.append('documentFileName', uploadMatterDocumentRequest.documentFileName)
 }
if(uploadMatterDocumentRequest.file !== undefined) {
 formData.append('file', uploadMatterDocumentRequest.file)
 }
if(uploadMatterDocumentRequest.userFileName !== undefined) {
 formData.append('userFileName', uploadMatterDocumentRequest.userFileName)
 }

      return customInstance<string>(
      {url: `/workAllocation/matterDocument/${matterId}/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getUploadMatterDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadMatterDocument>>, TError,{matterId: number;data: UploadMatterDocumentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadMatterDocument>>, TError,{matterId: number;data: UploadMatterDocumentRequest}, TContext> => {
    
const mutationKey = ['uploadMatterDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadMatterDocument>>, {matterId: number;data: UploadMatterDocumentRequest}> = (props) => {
          const {matterId,data} = props ?? {};

          return  uploadMatterDocument(matterId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadMatterDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadMatterDocument>>>
    export type UploadMatterDocumentMutationBody = UploadMatterDocumentRequest
    export type UploadMatterDocumentMutationError = unknown

    export const useUploadMatterDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadMatterDocument>>, TError,{matterId: number;data: UploadMatterDocumentRequest}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadMatterDocument>>,
        TError,
        {matterId: number;data: UploadMatterDocumentRequest},
        TContext
      > => {

      const mutationOptions = getUploadMatterDocumentMutationOptions(options);

      return useMutation(mutationOptions );
    }
